
window.themeInfo = {name: "Testament"};

(function vendorPolyfills() {
  /* For IE 11+ Nodelist forEach Function */
  if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = function (callback, thisArg) {
          thisArg = thisArg || window;
          for (var i = 0; i < this.length; i++) {
              callback.call(thisArg, this[i], i, this);
          }
      };
  }
})();
(function vendorMatchHeight() {
  /*
  * jquery-match-height 0.7.2 by @liabru
  * http://brm.io/jquery-match-height/
  * License MIT
  */
  !function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,n=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),i=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-n(e.css("margin-top")),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(i-a))<=o?r[r.length-1]=s.add(e):r.push(e),i=a}),r},i=function(e){var o={
  byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=i(e);if(o.remove){var n=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(n)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="0.7.2",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
  r._afterUpdate=null,r._rows=a,r._parse=n,r._parseOptions=i,r._apply=function(e,o){var s=i(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),u=h.parents().filter(":hidden");return u.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),u.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0",
  "padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=a(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var a=t(o),i=0;if(s.target)i=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),n=e.css("display");"inline-block"!==n&&"flex"!==n&&"inline-flex"!==n&&(n="block");var a={
  display:n};a[s.property]="",e.css(a),e.outerHeight(!1)>i&&(i=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=n(e.css("border-top-width"))+n(e.css("border-bottom-width")),o+=n(e.css("padding-top"))+n(e.css("padding-bottom"))),e.css(s.property,i-o+"px"))})}),u.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),
  this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),n=o.attr("data-mh")||o.attr("data-match-height");n in e?e[n]=e[n].add(o):e[n]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(n,a){if(a&&"resize"===a.type){var i=t(window).width();if(i===e)return;e=i;
  }n?o===-1&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi);var h=t.fn.on?"on":"bind";t(window)[h]("load",function(t){r._update(!1,t)}),t(window)[h]("resize orientationchange",function(t){r._update(!0,t)})});

})();
(function vendorDoubleTapGo() {
  /*
  Double Tap Go By Osvaldas Valutis, www.osvaldas.info
  Available for use under the MIT License
  */
  ;(function(e,t,n,r){e.fn.doubleTapToGo=function(r){if(!("ontouchstart"in t)&&!navigator.msMaxTouchPoints&&!navigator.userAgent.toLowerCase().match(/windows phone os 7/i))return false;this.each(function(){var t=false;e(this).on("click",function(n){var r=e(this);if(r[0]!=t[0]){n.preventDefault();t=r}});e(n).on("click touchstart MSPointerDown",function(n){var r=true,i=e(n.target).parents();for(var s=0;s<i.length;s++)if(i[s]==t[0])r=false;if(r)t=false})});return this}})(jQuery,window,document);
})();
(function vendorStickyHeader() {
  /* Sticky header */
  jQuery(function($){$(document).ready(function(){var contentButton=[];var contentTop=[];var content=[];var lastScrollTop=0;var scrollDir='';var itemClass='';var itemHover='';var menuSize=null;var stickyHeight=0;var stickyMarginB=0;var currentMarginT=0;var topMargin=0;var vartop;$(window).scroll(function(event){var st=$(this).scrollTop();if(st>lastScrollTop){scrollDir='down'}else{scrollDir='up'}
  lastScrollTop=st});$.fn.stickUp=function(options){$(this).addClass('stuckMenu');var objn=0;if(options!=null){for(var o in options.parts){if(options.parts.hasOwnProperty(o)){content[objn]=options.parts[objn];objn++}}
  if(objn==0){console.log('error:needs arguments')}
  itemClass=options.itemClass;itemHover=options.itemHover;if(options.topMargin!=null){if(options.topMargin=='auto'){topMargin=parseInt($('.stuckMenu').css('margin-top'))}else{if(isNaN(options.topMargin)&&options.topMargin.search("px")>0){topMargin=parseInt(options.topMargin.replace("px",""))}else if(!isNaN(parseInt(options.topMargin))){topMargin=parseInt(options.topMargin)}else{console.log("incorrect argument, ignored.");topMargin=0}}}else{topMargin=0}
  menuSize=$('.'+itemClass).size()}
  stickyHeight=parseInt($(this).height());stickyMarginB=parseInt($(this).css('margin-bottom'));currentMarginT=parseInt($(this).next().closest('div').css('margin-top'));vartop=parseInt($(this).offset().top)};$(document).on('scroll',function(){varscroll=parseInt($(document).scrollTop());if(menuSize!=null){for(var i=0;i<menuSize;i++){contentTop[i]=$('#'+content[i]+'').offset().top;function bottomView(i){contentView=$('#'+content[i]+'').height()*.4;testView=contentTop[i]-contentView;if(varscroll>testView){$('.'+itemClass).removeClass(itemHover);$('.'+itemClass+':eq('+i+')').addClass(itemHover)}else if(varscroll<50){$('.'+itemClass).removeClass(itemHover);$('.'+itemClass+':eq(0)').addClass(itemHover)}}
  if(scrollDir=='down'&&varscroll>contentTop[i]-50&&varscroll<contentTop[i]+50){$('.'+itemClass).removeClass(itemHover);$('.'+itemClass+':eq('+i+')').addClass(itemHover)}
  if(scrollDir=='up'){bottomView(i)}}}
  if(vartop<varscroll+topMargin){$('.stuckMenu').addClass('isStuck');$('.stuckMenu').next().closest('div').css({'margin-top':stickyHeight+stickyMarginB+currentMarginT+'px'},10);$('.stuckMenu').css("position","fixed");$('.isStuck').css({top:'0px'},10,function(){})};if(varscroll+topMargin<vartop){$('.stuckMenu').removeClass('isStuck');$('.stuckMenu').next().closest('div').css({'margin-top':currentMarginT+'px'},10);$('.stuckMenu').css("position","relative")}})})})
})();
(function vendorOwlCarousel() {
  /*	jQuery OwlCarousel v1.31
   *	Copyright (c) 2013 Bartosz Wojciechowski
   *	http://www.owlgraphic.com/owlcarousel
   *	Licensed under MIT
   */
  eval(function(p,a,c,k,e,r){e=function(c){return(c<a?'':e(parseInt(c/a)))+((c=c%a)>35?String.fromCharCode(c+29):c.toString(36))};if(!''.replace(/^/,String)){while(c--)r[e(c)]=k[c]||e(c);k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('7(B 3i.3E!=="9"){3i.3E=9(e){9 t(){}t.5v=e;q 5c t}}(9(e,t,n,r){b i={1J:9(t,n){b r=d;r.$k=e(n);r.6=e.3K({},e.3A.2c.6,r.$k.w(),t);r.29=t;r.3U()},3U:9(){b t=d;7(B t.6.2M==="9"){t.6.2M.P(d,[t.$k])}7(B t.6.2I==="2F"){b n=t.6.2I;9 r(e){7(B t.6.3F==="9"){t.6.3F.P(d,[e])}m{b n="";1C(b r 2f e["h"]){n+=e["h"][r]["1K"]}t.$k.2h(n)}t.2Y()}e.5G(n,r)}m{t.2Y()}},2Y:9(e){b t=d;t.$k.w("h-4p",t.$k.2s("2t")).w("h-4K",t.$k.2s("J"));t.$k.A({2z:0});t.2A=t.6.v;t.4L();t.5R=0;t.1M;t.1P()},1P:9(){b e=d;7(e.$k.1S().S===0){q c}e.1O();e.3H();e.$X=e.$k.1S();e.G=e.$X.S;e.4M();e.$I=e.$k.16(".h-1K");e.$L=e.$k.16(".h-1h");e.2H="Y";e.15=0;e.1W=[0];e.p=0;e.4I();e.4G()},4G:9(){b e=d;e.2V();e.31();e.4D();e.35();e.4C();e.4A();e.2x();e.4z();7(e.6.2w!==c){e.4w(e.6.2w)}7(e.6.Q===j){e.6.Q=5i}e.1e();e.$k.16(".h-1h").A("4v","4r");7(!e.$k.2p(":33")){e.34()}m{e.$k.A("2z",1)}e.56=c;e.2o();7(B e.6.39==="9"){e.6.39.P(d,[e.$k])}},2o:9(){b e=d;7(e.6.1I===j){e.1I()}7(e.6.1A===j){e.1A()}e.4n();7(B e.6.3n==="9"){e.6.3n.P(d,[e.$k])}},3o:9(){b e=d;7(B e.6.3p==="9"){e.6.3p.P(d,[e.$k])}e.34();e.2V();e.31();e.4m();e.35();e.2o();7(B e.6.3t==="9"){e.6.3t.P(d,[e.$k])}},4i:9(e){b t=d;19(9(){t.3o()},0)},34:9(){b e=d;7(e.$k.2p(":33")===c){e.$k.A({2z:0});18(e.1r);18(e.1M)}m{q c}e.1M=4g(9(){7(e.$k.2p(":33")){e.4i();e.$k.4f({2z:1},2J);18(e.1M)}},5O)},4M:9(){b e=d;e.$X.5N(\'<M J="h-1h">\').3G(\'<M J="h-1K"></M>\');e.$k.16(".h-1h").3G(\'<M J="h-1h-4d">\');e.1U=e.$k.16(".h-1h-4d");e.$k.A("4v","4r")},1O:9(){b e=d;b t=e.$k.1V(e.6.1O);b n=e.$k.1V(e.6.28);7(!t){e.$k.K(e.6.1O)}7(!n){e.$k.K(e.6.28)}},2V:9(){b t=d;7(t.6.2Z===c){q c}7(t.6.4b===j){t.6.v=t.2A=1;t.6.17=c;t.6.1q=c;t.6.21=c;t.6.24=c;t.6.25=c;t.6.26=c;q c}b n=e(t.6.4a).1m();7(n>(t.6.1q[0]||t.2A)){t.6.v=t.2A}7(B t.6.17!=="3b"&&t.6.17!==c){t.6.17.5x(9(e,t){q e[0]-t[0]});1C(b r 2f t.6.17){7(B t.6.17[r]!=="3b"&&t.6.17[r][0]<=n){t.6.v=t.6.17[r][1]}}}m{7(n<=t.6.1q[0]&&t.6.1q!==c){t.6.v=t.6.1q[1]}7(n<=t.6.21[0]&&t.6.21!==c){t.6.v=t.6.21[1]}7(n<=t.6.24[0]&&t.6.24!==c){t.6.v=t.6.24[1]}7(n<=t.6.25[0]&&t.6.25!==c){t.6.v=t.6.25[1]}7(n<=t.6.26[0]&&t.6.26!==c){t.6.v=t.6.26[1]}}7(t.6.v>t.G&&t.6.49===j){t.6.v=t.G}},4C:9(){b n=d,r;7(n.6.2Z!==j){q c}b i=e(t).1m();n.3f=9(){7(e(t).1m()!==i){7(n.6.Q!==c){18(n.1r)}5o(r);r=19(9(){i=e(t).1m();n.3o()},n.6.48)}};e(t).47(n.3f)},4m:9(){b e=d;e.2j(e.p);7(e.6.Q!==c){e.3l()}},46:9(){b t=d;b n=0;b r=t.G-t.6.v;t.$I.2i(9(i){b s=e(d);s.A({1m:t.N}).w("h-1K",3q(i));7(i%t.6.v===0||i===r){7(!(i>r)){n+=1}}s.w("h-1L",n)})},45:9(){b e=d;b t=0;b t=e.$I.S*e.N;e.$L.A({1m:t*2,V:0});e.46()},31:9(){b e=d;e.44();e.45();e.43();e.3x()},44:9(){b e=d;e.N=1N.5a(e.$k.1m()/e.6.v)},3x:9(){b e=d;b t=(e.G*e.N-e.6.v*e.N)*-1;7(e.6.v>e.G){e.C=0;t=0;e.3D=0}m{e.C=e.G-e.6.v;e.3D=t}q t},42:9(){q 0},43:9(){b t=d;t.H=[0];t.2C=[];b n=0;b r=0;1C(b i=0;i<t.G;i++){r+=t.N;t.H.2D(-r);7(t.6.14===j){b s=e(t.$I[i]);b o=s.w("h-1L");7(o!==n){t.2C[n]=t.H[i];n=o}}}},4D:9(){b t=d;7(t.6.2b===j||t.6.1s===j){t.D=e(\'<M J="h-4R"/>\').4Q("4P",!t.F.13).5E(t.$k)}7(t.6.1s===j){t.3Z()}7(t.6.2b===j){t.3Y()}},3Y:9(){b t=d;b n=e(\'<M J="h-5h"/>\');t.D.1k(n);t.1w=e("<M/>",{"J":"h-1l",2h:t.6.2T[0]||""});t.1y=e("<M/>",{"J":"h-Y",2h:t.6.2T[1]||""});n.1k(t.1w).1k(t.1y);n.z("2W.D 1Z.D",\'M[J^="h"]\',9(e){e.1n()});n.z("2a.D 2n.D",\'M[J^="h"]\',9(n){n.1n();7(e(d).1V("h-Y")){t.Y()}m{t.1l()}})},3Z:9(){b t=d;t.1o=e(\'<M J="h-1s"/>\');t.D.1k(t.1o);t.1o.z("2a.D 2n.D",".h-1p",9(n){n.1n();7(3q(e(d).w("h-1p"))!==t.p){t.1i(3q(e(d).w("h-1p")),j)}})},3T:9(){b t=d;7(t.6.1s===c){q c}t.1o.2h("");b n=0;b r=t.G-t.G%t.6.v;1C(b i=0;i<t.G;i++){7(i%t.6.v===0){n+=1;7(r===i){b s=t.G-t.6.v}b o=e("<M/>",{"J":"h-1p"});b u=e("<3Q></3Q>",{54:t.6.38===j?n:"","J":t.6.38===j?"h-5l":""});o.1k(u);o.w("h-1p",r===i?s:i);o.w("h-1L",n);t.1o.1k(o)}}t.3a()},3a:9(){b t=d;7(t.6.1s===c){q c}t.1o.16(".h-1p").2i(9(n,r){7(e(d).w("h-1L")===e(t.$I[t.p]).w("h-1L")){t.1o.16(".h-1p").Z("2d");e(d).K("2d")}})},3d:9(){b e=d;7(e.6.2b===c){q c}7(e.6.2e===c){7(e.p===0&&e.C===0){e.1w.K("1b");e.1y.K("1b")}m 7(e.p===0&&e.C!==0){e.1w.K("1b");e.1y.Z("1b")}m 7(e.p===e.C){e.1w.Z("1b");e.1y.K("1b")}m 7(e.p!==0&&e.p!==e.C){e.1w.Z("1b");e.1y.Z("1b")}}},35:9(){b e=d;e.3T();e.3d();7(e.D){7(e.6.v>=e.G){e.D.3N()}m{e.D.3L()}}},5g:9(){b e=d;7(e.D){e.D.3j()}},Y:9(e){b t=d;7(t.1G){q c}t.p+=t.6.14===j?t.6.v:1;7(t.p>t.C+(t.6.14==j?t.6.v-1:0)){7(t.6.2e===j){t.p=0;e="2k"}m{t.p=t.C;q c}}t.1i(t.p,e)},1l:9(e){b t=d;7(t.1G){q c}7(t.6.14===j&&t.p>0&&t.p<t.6.v){t.p=0}m{t.p-=t.6.14===j?t.6.v:1}7(t.p<0){7(t.6.2e===j){t.p=t.C;e="2k"}m{t.p=0;q c}}t.1i(t.p,e)},1i:9(e,t,n){b r=d;7(r.1G){q c}7(B r.6.1F==="9"){r.6.1F.P(d,[r.$k])}7(e>=r.C){e=r.C}m 7(e<=0){e=0}r.p=r.h.p=e;7(r.6.2w!==c&&n!=="4e"&&r.6.v===1&&r.F.1u===j){r.1B(0);7(r.F.1u===j){r.1H(r.H[e])}m{r.1x(r.H[e],1)}r.2q();r.4k();q c}b i=r.H[e];7(r.F.1u===j){r.1T=c;7(t===j){r.1B("1D");19(9(){r.1T=j},r.6.1D)}m 7(t==="2k"){r.1B(r.6.2u);19(9(){r.1T=j},r.6.2u)}m{r.1B("1j");19(9(){r.1T=j},r.6.1j)}r.1H(i)}m{7(t===j){r.1x(i,r.6.1D)}m 7(t==="2k"){r.1x(i,r.6.2u)}m{r.1x(i,r.6.1j)}}r.2q()},2j:9(e){b t=d;7(B t.6.1F==="9"){t.6.1F.P(d,[t.$k])}7(e>=t.C||e===-1){e=t.C}m 7(e<=0){e=0}t.1B(0);7(t.F.1u===j){t.1H(t.H[e])}m{t.1x(t.H[e],1)}t.p=t.h.p=e;t.2q()},2q:9(){b e=d;e.1W.2D(e.p);e.15=e.h.15=e.1W[e.1W.S-2];e.1W.55(0);7(e.15!==e.p){e.3a();e.3d();e.2o();7(e.6.Q!==c){e.3l()}}7(B e.6.3z==="9"&&e.15!==e.p){e.6.3z.P(d,[e.$k])}},W:9(){b e=d;e.3k="W";18(e.1r)},3l:9(){b e=d;7(e.3k!=="W"){e.1e()}},1e:9(){b e=d;e.3k="1e";7(e.6.Q===c){q c}18(e.1r);e.1r=4g(9(){e.Y(j)},e.6.Q)},1B:9(e){b t=d;7(e==="1j"){t.$L.A(t.2y(t.6.1j))}m 7(e==="1D"){t.$L.A(t.2y(t.6.1D))}m 7(B e!=="2F"){t.$L.A(t.2y(e))}},2y:9(e){b t=d;q{"-1R-1a":"2B "+e+"1z 2r","-27-1a":"2B "+e+"1z 2r","-o-1a":"2B "+e+"1z 2r",1a:"2B "+e+"1z 2r"}},3I:9(){q{"-1R-1a":"","-27-1a":"","-o-1a":"",1a:""}},3J:9(e){q{"-1R-O":"1g("+e+"T, E, E)","-27-O":"1g("+e+"T, E, E)","-o-O":"1g("+e+"T, E, E)","-1z-O":"1g("+e+"T, E, E)",O:"1g("+e+"T, E,E)"}},1H:9(e){b t=d;t.$L.A(t.3J(e))},3M:9(e){b t=d;t.$L.A({V:e})},1x:9(e,t){b n=d;n.2g=c;n.$L.W(j,j).4f({V:e},{59:t||n.6.1j,3O:9(){n.2g=j}})},4L:9(){b e=d;b r="1g(E, E, E)",i=n.5f("M");i.2t.3P="  -27-O:"+r+"; -1z-O:"+r+"; -o-O:"+r+"; -1R-O:"+r+"; O:"+r;b s=/1g\\(E, E, E\\)/g,o=i.2t.3P.5k(s),u=o!==1d&&o.S===1;b a="5z"2f t||5C.4U;e.F={1u:u,13:a}},4A:9(){b e=d;7(e.6.22!==c||e.6.23!==c){e.3R();e.3S()}},3H:9(){b e=d;b t=["s","e","x"];e.12={};7(e.6.22===j&&e.6.23===j){t=["2W.h 1Z.h","2P.h 3V.h","2a.h 3W.h 2n.h"]}m 7(e.6.22===c&&e.6.23===j){t=["2W.h","2P.h","2a.h 3W.h"]}m 7(e.6.22===j&&e.6.23===c){t=["1Z.h","3V.h","2n.h"]}e.12["3X"]=t[0];e.12["2O"]=t[1];e.12["2N"]=t[2]},3S:9(){b t=d;t.$k.z("5A.h",9(e){e.1n()});t.$k.z("1Z.40",9(t){q e(t.1f).2p("5F, 5H, 5Q, 5S")})},3R:9(){9 o(e){7(e.2L){q{x:e.2L[0].2K,y:e.2L[0].41}}m{7(e.2K!==r){q{x:e.2K,y:e.41}}m{q{x:e.52,y:e.53}}}}9 u(t){7(t==="z"){e(n).z(i.12["2O"],f);e(n).z(i.12["2N"],l)}m 7(t==="R"){e(n).R(i.12["2O"]);e(n).R(i.12["2N"])}}9 a(n){b n=n.3B||n||t.3w;7(n.5d===3){q c}7(i.G<=i.6.v){q}7(i.2g===c&&!i.6.3v){q c}7(i.1T===c&&!i.6.3v){q c}7(i.6.Q!==c){18(i.1r)}7(i.F.13!==j&&!i.$L.1V("3s")){i.$L.K("3s")}i.11=0;i.U=0;e(d).A(i.3I());b r=e(d).2l();s.3g=r.V;s.3e=o(n).x-r.V;s.3c=o(n).y-r.5y;u("z");s.2m=c;s.30=n.1f||n.4c}9 f(r){b r=r.3B||r||t.3w;i.11=o(r).x-s.3e;i.2S=o(r).y-s.3c;i.U=i.11-s.3g;7(B i.6.2R==="9"&&s.2Q!==j&&i.U!==0){s.2Q=j;i.6.2R.P(i,[i.$k])}7(i.U>8||i.U<-8&&i.F.13===j){r.1n?r.1n():r.5M=c;s.2m=j}7((i.2S>10||i.2S<-10)&&s.2m===c){e(n).R("2P.h")}b u=9(){q i.U/5};b a=9(){q i.3D+i.U/5};i.11=1N.3x(1N.42(i.11,u()),a());7(i.F.1u===j){i.1H(i.11)}m{i.3M(i.11)}}9 l(n){b n=n.3B||n||t.3w;n.1f=n.1f||n.4c;s.2Q=c;7(i.F.13!==j){i.$L.Z("3s")}7(i.U<0){i.1t=i.h.1t="V"}m{i.1t=i.h.1t="2G"}7(i.U!==0){b r=i.4h();i.1i(r,c,"4e");7(s.30===n.1f&&i.F.13!==j){e(n.1f).z("3u.4j",9(t){t.4S();t.4T();t.1n();e(n.1f).R("3u.4j")});b o=e.4O(n.1f,"4V")["3u"];b a=o.4W();o.4X(0,0,a)}}u("R")}b i=d;b s={3e:0,3c:0,4Y:0,3g:0,2l:1d,4Z:1d,50:1d,2m:1d,51:1d,30:1d};i.2g=j;i.$k.z(i.12["3X"],".h-1h",a)},4h:9(){b e=d,t;t=e.4l();7(t>e.C){e.p=e.C;t=e.C}m 7(e.11>=0){t=0;e.p=0}q t},4l:9(){b t=d,n=t.6.14===j?t.2C:t.H,r=t.11,i=1d;e.2i(n,9(s,o){7(r-t.N/20>n[s+1]&&r-t.N/20<o&&t.3m()==="V"){i=o;7(t.6.14===j){t.p=e.4o(i,t.H)}m{t.p=s}}m 7(r+t.N/20<o&&r+t.N/20>(n[s+1]||n[s]-t.N)&&t.3m()==="2G"){7(t.6.14===j){i=n[s+1]||n[n.S-1];t.p=e.4o(i,t.H)}m{i=n[s+1];t.p=s+1}}});q t.p},3m:9(){b e=d,t;7(e.U<0){t="2G";e.2H="Y"}m{t="V";e.2H="1l"}q t},4I:9(){b e=d;e.$k.z("h.Y",9(){e.Y()});e.$k.z("h.1l",9(){e.1l()});e.$k.z("h.1e",9(t,n){e.6.Q=n;e.1e();e.36="1e"});e.$k.z("h.W",9(){e.W();e.36="W"});e.$k.z("h.1i",9(t,n){e.1i(n)});e.$k.z("h.2j",9(t,n){e.2j(n)})},2x:9(){b e=d;7(e.6.2x===j&&e.F.13!==j&&e.6.Q!==c){e.$k.z("57",9(){e.W()});e.$k.z("58",9(){7(e.36!=="W"){e.1e()}})}},1I:9(){b t=d;7(t.6.1I===c){q c}1C(b n=0;n<t.G;n++){b i=e(t.$I[n]);7(i.w("h-1c")==="1c"){4q}b s=i.w("h-1K"),o=i.16(".5b"),u;7(B o.w("1X")!=="2F"){i.w("h-1c","1c");4q}7(i.w("h-1c")===r){o.3N();i.K("4s").w("h-1c","5e")}7(t.6.4t===j){u=s>=t.p}m{u=j}7(u&&s<t.p+t.6.v&&o.S){t.4u(i,o)}}},4u:9(e,t){9 s(){r+=1;7(n.2X(t.2U(0))||i===j){o()}m 7(r<=2v){19(s,2v)}m{o()}}9 o(){e.w("h-1c","1c").Z("4s");t.5j("w-1X");n.6.4x==="4y"?t.5m(5n):t.3L();7(B n.6.3r==="9"){n.6.3r.P(d,[n.$k])}}b n=d,r=0;7(t.5p("5q")==="5r"){t.A("5s-5t","5u("+t.w("1X")+")");b i=j}m{t[0].1X=t.w("1X")}s()},1A:9(){9 s(){i+=1;7(t.2X(n.2U(0))){o()}m 7(i<=2v){19(s,2v)}m{t.1U.A("3h","")}}9 o(){b n=e(t.$I[t.p]).3h();t.1U.A("3h",n+"T");7(!t.1U.1V("1A")){19(9(){t.1U.K("1A")},0)}}b t=d;b n=e(t.$I[t.p]).16("5w");7(n.2U(0)!==r){b i=0;s()}m{o()}},2X:9(e){7(!e.3O){q c}7(B e.4B!=="3b"&&e.4B==0){q c}q j},4n:9(){b t=d;7(t.6.37===j){t.$I.Z("2d")}t.1v=[];1C(b n=t.p;n<t.p+t.6.v;n++){t.1v.2D(n);7(t.6.37===j){e(t.$I[n]).K("2d")}}t.h.1v=t.1v},4w:9(e){b t=d;t.4E="h-"+e+"-5B";t.4F="h-"+e+"-2f"},4k:9(){9 u(e,t){q{2l:"5D",V:e+"T"}}b e=d;e.1G=j;b t=e.4E,n=e.4F,r=e.$I.1E(e.p),i=e.$I.1E(e.15),s=1N.4H(e.H[e.p])+e.H[e.15],o=1N.4H(e.H[e.p])+e.N/2;e.$L.K("h-1Y").A({"-1R-O-1Y":o+"T","-27-4J-1Y":o+"T","4J-1Y":o+"T"});b a="5I 5J 5K 5L";i.A(u(s,10)).K(t).z(a,9(){e.3C=j;i.R(a);e.32(i,t)});r.K(n).z(a,9(){e.2E=j;r.R(a);e.32(r,n)})},32:9(e,t){b n=d;e.A({2l:"",V:""}).Z(t);7(n.3C&&n.2E){n.$L.Z("h-1Y");n.3C=c;n.2E=c;n.1G=c}},4z:9(){b e=d;e.h={29:e.29,5P:e.$k,X:e.$X,I:e.$I,p:e.p,15:e.15,1v:e.1v,13:e.F.13,F:e.F,1t:e.1t}},4N:9(){b r=d;r.$k.R(".h h 1Z.40");e(n).R(".h h");e(t).R("47",r.3f)},1Q:9(){b e=d;7(e.$k.1S().S!==0){e.$L.3y();e.$X.3y().3y();7(e.D){e.D.3j()}}e.4N();e.$k.2s("2t",e.$k.w("h-4p")||"").2s("J",e.$k.w("h-4K"))},5T:9(){b e=d;e.W();18(e.1M);e.1Q();e.$k.5U()},5V:9(t){b n=d;b r=e.3K({},n.29,t);n.1Q();n.1J(r,n.$k)},5W:9(e,t){b n=d,i;7(!e){q c}7(n.$k.1S().S===0){n.$k.1k(e);n.1P();q c}n.1Q();7(t===r||t===-1){i=-1}m{i=t}7(i>=n.$X.S||i===-1){n.$X.1E(-1).5X(e)}m{n.$X.1E(i).5Y(e)}n.1P()},5Z:9(e){b t=d,n;7(t.$k.1S().S===0){q c}7(e===r||e===-1){n=-1}m{n=e}t.1Q();t.$X.1E(n).3j();t.1P()}};e.3A.2c=9(t){q d.2i(9(){7(e(d).w("h-1J")===j){q c}e(d).w("h-1J",j);b n=3i.3E(i);n.1J(t,d);e.w(d,"2c",n)})};e.3A.2c.6={v:5,17:c,1q:[60,4],21:[61,3],24:[62,2],25:c,26:[63,1],4b:c,49:c,1j:2J,1D:64,2u:65,Q:c,2x:c,2b:c,2T:["1l","Y"],2e:j,14:c,1s:j,38:c,2Z:j,48:2J,4a:t,1O:"h-66",28:"h-28",1I:c,4t:j,4x:"4y",1A:c,2I:c,3F:c,3v:j,22:j,23:j,37:c,2w:c,3p:c,3t:c,2M:c,39:c,1F:c,3z:c,3n:c,2R:c,3r:c}})(67,68,69)',62,382,'||||||options|if||function||var|false|this||||owl||true|elem||else|||currentItem|return|||||items|data|||on|css|typeof|maximumItem|owlControls|0px|browser|itemsAmount|positionsInArray|owlItems|class|addClass|owlWrapper|div|itemWidth|transform|apply|autoPlay|off|length|px|newRelativeX|left|stop|userItems|next|removeClass||newPosX|ev_types|isTouch|scrollPerPage|prevItem|find|itemsCustom|clearInterval|setTimeout|transition|disabled|loaded|null|play|target|translate3d|wrapper|goTo|slideSpeed|append|prev|width|preventDefault|paginationWrapper|page|itemsDesktop|autoPlayInterval|pagination|dragDirection|support3d|visibleItems|buttonPrev|css2slide|buttonNext|ms|autoHeight|swapSpeed|for|paginationSpeed|eq|beforeMove|isTransition|transition3d|lazyLoad|init|item|roundPages|checkVisible|Math|baseClass|setVars|unWrap|webkit|children|isCss3Finish|wrapperOuter|hasClass|prevArr|src|origin|mousedown||itemsDesktopSmall|mouseDrag|touchDrag|itemsTablet|itemsTabletSmall|itemsMobile|moz|theme|userOptions|touchend|navigation|owlCarousel|active|rewindNav|in|isCssFinish|html|each|jumpTo|rewind|position|sliding|mouseup|eachMoveUpdate|is|afterGo|ease|attr|style|rewindSpeed|100|transitionStyle|stopOnHover|addCssSpeed|opacity|orignalItems|all|pagesInArray|push|endCurrent|string|right|playDirection|jsonPath|200|pageX|touches|beforeInit|end|move|touchmove|dragging|startDragging|newPosY|navigationText|get|updateItems|touchstart|completeImg|logIn|responsive|targetElement|calculateAll|clearTransStyle|visible|watchVisibility|updateControls|hoverStatus|addClassActive|paginationNumbers|afterInit|checkPagination|undefined|offsetY|checkNavigation|offsetX|resizer|relativePos|height|Object|remove|apStatus|checkAp|moveDirection|afterAction|updateVars|beforeUpdate|Number|afterLazyLoad|grabbing|afterUpdate|click|dragBeforeAnimFinish|event|max|unwrap|afterMove|fn|originalEvent|endPrev|maximumPixels|create|jsonSuccess|wrap|eventTypes|removeTransition|doTranslate|extend|show|css2move|hide|complete|cssText|span|gestures|disabledEvents|updatePagination|loadContent|mousemove|touchcancel|start|buildButtons|buildPagination|disableTextSelect|pageY|min|loops|calculateWidth|appendWrapperSizes|appendItemsSizes|resize|responsiveRefreshRate|itemsScaleUp|responsiveBaseWidth|singleItem|srcElement|outer|drag|animate|setInterval|getNewPosition|reload|disable|singleItemTransition|closestItem|updatePosition|onVisibleItems|inArray|originalStyles|continue|block|loading|lazyFollow|lazyPreload|display|transitionTypes|lazyEffect|fade|owlStatus|moveEvents|naturalWidth|response|buildControls|outClass|inClass|onStartup|abs|customEvents|perspective|originalClasses|checkBrowser|wrapItems|clearEvents|_data|clickable|toggleClass|controls|stopImmediatePropagation|stopPropagation|msMaxTouchPoints|events|pop|splice|baseElWidth|minSwipe|maxSwipe|dargging|clientX|clientY|text|shift|onstartup|mouseover|mouseout|duration|round|lazyOwl|new|which|checked|createElement|destroyControls|buttons|5e3|removeAttr|match|numbers|fadeIn|400|clearTimeout|prop|tagName|DIV|background|image|url|prototype|img|sort|top|ontouchstart|dragstart|out|navigator|relative|appendTo|input|getJSON|textarea|webkitAnimationEnd|oAnimationEnd|MSAnimationEnd|animationend|returnValue|wrapAll|500|baseElement|select|wrapperWidth|option|destroy|removeData|reinit|addItem|after|before|removeItem|1199|979|768|479|800|1e3|carousel|jQuery|window|document'.split('|'),0,{}))

})();
(function vendorCookies() {
  /* Cookies */
  !function(e){"function"==typeof define&&define.amd?define(["jquery"],e):e(jQuery)}(function(e){function n(e){return u.raw?e:encodeURIComponent(e)}function o(e){return u.raw?e:decodeURIComponent(e)}function i(e){return n(u.json?JSON.stringify(e):String(e))}function r(e){0===e.indexOf('"')&&(e=e.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return e=decodeURIComponent(e.replace(c," ")),u.json?JSON.parse(e):e}catch(n){}}function t(n,o){var i=u.raw?n:r(n);return e.isFunction(o)?o(i):i}var c=/\+/g,u=e.cookie=function(r,c,a){if(void 0!==c&&!e.isFunction(c)){if(a=e.extend({},u.defaults,a),"number"==typeof a.expires){var d=a.expires,f=a.expires=new Date;f.setTime(+f+864e5*d)}return document.cookie=[n(r),"=",i(c),a.expires?"; expires="+a.expires.toUTCString():"",a.path?"; path="+a.path:"",a.domain?"; domain="+a.domain:"",a.secure?"; secure":""].join("")}for(var s=r?void 0:{},p=document.cookie?document.cookie.split("; "):[],m=0,v=p.length;v>m;m++){var x=p[m].split("="),k=o(x.shift()),l=x.join("=");if(r&&r===k){s=t(l,c);break}r||void 0===(l=t(l))||(s[k]=l)}return s};u.defaults={},e.removeCookie=function(n,o){return void 0===e.cookie(n)?!1:(e.cookie(n,"",e.extend({},o,{expires:-1})),!e.cookie(n))}});

})();
(function vendorPlaceholder() {
  /* placeholder */
  !function(e,a,t){function l(e){var a={},l=/^jQuery\d+$/;return t.each(e.attributes,function(e,t){t.specified&&!l.test(t.name)&&(a[t.name]=t.value)}),a}function r(e,l){var r=this,o=t(r);if(r.value==o.attr("placeholder")&&o.hasClass("placeholder"))if(o.data("placeholder-password")){if(o=o.hide().next().show().attr("id",o.removeAttr("id").data("placeholder-id")),e===!0)return o[0].value=l;o.focus()}else r.value="",o.removeClass("placeholder"),r==a.activeElement&&r.select()}function o(){var e,a=this,o=t(a),d=this.id;if(""==a.value){if("password"==a.type){if(!o.data("placeholder-textinput")){try{e=o.clone().attr({type:"text"})}catch(c){e=t("<input>").attr(t.extend(l(this),{type:"text"}))}e.removeAttr("name").data({"placeholder-password":!0,"placeholder-id":d}).bind("focus.placeholder",r),o.data({"placeholder-textinput":e,"placeholder-id":d}).before(e)}o=o.removeAttr("id").hide().prev().attr("id",d).show()}o.addClass("placeholder"),o[0].value=o.attr("placeholder")}else o.removeClass("placeholder")}var d,c,n="placeholder"in a.createElement("input"),i="placeholder"in a.createElement("textarea"),h=t.fn,u=t.valHooks;n&&i?(c=h.placeholder=function(){return this},c.input=c.textarea=!0):(c=h.placeholder=function(){var e=this;return e.filter((n?"textarea":":input")+"[placeholder]").not(".placeholder").bind({"focus.placeholder":r,"blur.placeholder":o}).data("placeholder-enabled",!0).trigger("blur.placeholder"),e},c.input=n,c.textarea=i,d={get:function(e){var a=t(e);return a.data("placeholder-enabled")&&a.hasClass("placeholder")?"":e.value},set:function(e,l){var d=t(e);return d.data("placeholder-enabled")?(""==l?(e.value=l,e!=a.activeElement&&o.call(e)):d.hasClass("placeholder")?r.call(e,!0,l)||(e.value=l):e.value=l,d):e.value=l}},n||(u.input=d),i||(u.textarea=d),t(function(){t(a).delegate("form","submit.placeholder",function(){var e=t(".placeholder",this).each(r);setTimeout(function(){e.each(o)},10)})}),t(e).bind("beforeunload.placeholder",function(){t(".placeholder").each(function(){this.value=""})}))}(this,document,jQuery);
})();
(function vendorModernizer() {
  /* Modernizr 2.8.2 (Custom Build) | MIT & BSD
   * Build: http://modernizr.com/download/#-fontface-csstransforms-csstransforms3d-touch-cssclasses-teststyles-testprop-testallprops-prefixes-domprefixes-cssclassprefix:supports!
   */
  ;window.Modernizr=function(a,b,c){function z(a){j.cssText=a}function A(a,b){return z(m.join(a+";")+(b||""))}function B(a,b){return typeof a===b}function C(a,b){return!!~(""+a).indexOf(b)}function D(a,b){for(var d in a){var e=a[d];if(!C(e,"-")&&j[e]!==c)return b=="pfx"?e:!0}return!1}function E(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:B(f,"function")?f.bind(d||b):f}return!1}function F(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+o.join(d+" ")+d).split(" ");return B(b,"string")||B(b,"undefined")?D(e,b):(e=(a+" "+p.join(d+" ")+d).split(" "),E(e,b,c))}var d="2.8.2",e={},f=!0,g=b.documentElement,h="modernizr",i=b.createElement(h),j=i.style,k,l={}.toString,m=" -webkit- -moz- -o- -ms- ".split(" "),n="Webkit Moz O ms",o=n.split(" "),p=n.toLowerCase().split(" "),q={},r={},s={},t=[],u=t.slice,v,w=function(a,c,d,e){var f,i,j,k,l=b.createElement("div"),m=b.body,n=m||b.createElement("body");if(parseInt(d,10))while(d--)j=b.createElement("div"),j.id=e?e[d]:h+(d+1),l.appendChild(j);return f=["&#173;",'<style id="s',h,'">',a,"</style>"].join(""),l.id=h,(m?l:n).innerHTML+=f,n.appendChild(l),m||(n.style.background="",n.style.overflow="hidden",k=g.style.overflow,g.style.overflow="hidden",g.appendChild(n)),i=c(l,a),m?l.parentNode.removeChild(l):(n.parentNode.removeChild(n),g.style.overflow=k),!!i},x={}.hasOwnProperty,y;!B(x,"undefined")&&!B(x.call,"undefined")?y=function(a,b){return x.call(a,b)}:y=function(a,b){return b in a&&B(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=u.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(u.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(u.call(arguments)))};return e}),q.touch=function(){var c;return"ontouchstart"in a||a.DocumentTouch&&b instanceof DocumentTouch?c=!0:w(["@media (",m.join("touch-enabled),("),h,")","{#modernizr{top:9px;position:absolute}}"].join(""),function(a){c=a.offsetTop===9}),c},q.csstransforms=function(){return!!F("transform")},q.csstransforms3d=function(){var a=!!F("perspective");return a&&"webkitPerspective"in g.style&&w("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}",function(b,c){a=b.offsetLeft===9&&b.offsetHeight===3}),a},q.fontface=function(){var a;return w('@font-face {font-family:"font";src:url("https://")}',function(c,d){var e=b.getElementById("smodernizr"),f=e.sheet||e.styleSheet,g=f?f.cssRules&&f.cssRules[0]?f.cssRules[0].cssText:f.cssText||"":"";a=/src/i.test(g)&&g.indexOf(d.split(" ")[0])===0}),a};for(var G in q)y(q,G)&&(v=G.toLowerCase(),e[v]=q[G](),t.push((e[v]?"":"no-")+v));return e.addTest=function(a,b){if(typeof a=="object")for(var d in a)y(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof f!="undefined"&&f&&(g.className+=" supports-"+(b?"":"no-")+a),e[a]=b}return e},z(""),i=k=null,e._version=d,e._prefixes=m,e._domPrefixes=p,e._cssomPrefixes=o,e.testProp=function(a){return D([a])},e.testAllProps=F,e.testStyles=w,g.className=g.className.replace(/(^|\s)no-js(\s|$)/,"$1$2")+(f?" supports-js supports-"+t.join(" supports-"):""),e}(this,this.document);
})();
(function vendorSlideout() {
  /* slideout */
  !function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.Slideout=t()}}(function(){var t,e,n;return function i(t,e,n){function o(r,a){if(!e[r]){if(!t[r]){var u=typeof require=="function"&&require;if(!a&&u)return u(r,!0);if(s)return s(r,!0);var l=new Error("Cannot find module '"+r+"'");throw l.code="MODULE_NOT_FOUND",l}var h=e[r]={exports:{}};t[r][0].call(h.exports,function(e){var n=t[r][1][e];return o(n?n:e)},h,h.exports,i,t,e,n)}return e[r].exports}var s=typeof require=="function"&&require;for(var r=0;r<n.length;r++)o(n[r]);return o}({1:[function(t,e,n){"use strict";var i=t("decouple");var o=t("emitter");var s;var r=false;var a=window.document;var u=a.documentElement;var l=window.navigator.msPointerEnabled;var h={start:l?"MSPointerDown":"touchstart",move:l?"MSPointerMove":"touchmove",end:l?"MSPointerUp":"touchend"};var f=function v(){var t=/^(Webkit|Khtml|Moz|ms|O)(?=[A-Z])/;var e=a.getElementsByTagName("script")[0].style;for(var n in e){if(t.test(n)){return"-"+n.match(t)[0].toLowerCase()+"-"}}if("WebkitOpacity"in e){return"-webkit-"}if("KhtmlOpacity"in e){return"-khtml-"}return""}();function c(t,e){for(var n in e){if(e[n]){t[n]=e[n]}}return t}function p(t,e){t.prototype=c(t.prototype||{},e.prototype)}function d(t){while(t.parentNode){if(t.getAttribute("data-slideout-ignore")!==null){return t}t=t.parentNode}return null}function _(t){t=t||{};this._startOffsetX=0;this._currentOffsetX=0;this._opening=false;this._moved=false;this._opened=false;this._preventOpen=false;this.panel=t.panel;this.menu=t.menu;this._touch=t.touch===undefined?true:t.touch&&true;this._side=t.side||"left";this._easing=t.fx||t.easing||"ease";this._duration=parseInt(t.duration,10)||300;this._tolerance=parseInt(t.tolerance,10)||70;this._padding=this._translateTo=parseInt(t.padding,10)||256;this._orientation=this._side==="right"?-1:1;this._translateTo*=this._orientation;if(!this.panel.classList.contains("slideout-panel")){this.panel.classList.add("slideout-panel")}if(!this.panel.classList.contains("slideout-panel-"+this._side)){this.panel.classList.add("slideout-panel-"+this._side)}if(!this.menu.classList.contains("slideout-menu")){this.menu.classList.add("slideout-menu")}if(!this.menu.classList.contains("slideout-menu-"+this._side)){this.menu.classList.add("slideout-menu-"+this._side)}if(this._touch){this._initTouchEvents()}}p(_,o);_.prototype.open=function(){var t=this;this.emit("beforeopen");if(!u.classList.contains("slideout-open")){u.classList.add("slideout-open")}this._setTransition();this._translateXTo(this._translateTo);this._opened=true;setTimeout(function(){t.panel.style.transition=t.panel.style["-webkit-transition"]="";t.emit("open")},this._duration+50);return this};_.prototype.close=function(){var t=this;if(!this.isOpen()&&!this._opening){return this}this.emit("beforeclose");this._setTransition();this._translateXTo(0);this._opened=false;setTimeout(function(){u.classList.remove("slideout-open");t.panel.style.transition=t.panel.style["-webkit-transition"]=t.panel.style[f+"transform"]=t.panel.style.transform="";t.emit("close")},this._duration+50);return this};_.prototype.toggle=function(){return this.isOpen()?this.close():this.open()};_.prototype.isOpen=function(){return this._opened};_.prototype._translateXTo=function(t){this._currentOffsetX=t;this.panel.style[f+"transform"]=this.panel.style.transform="translateX("+t+"px)";return this};_.prototype._setTransition=function(){this.panel.style[f+"transition"]=this.panel.style.transition=f+"transform "+this._duration+"ms "+this._easing;return this};_.prototype._initTouchEvents=function(){var t=this;this._onScrollFn=i(a,"scroll",function(){if(!t._moved){clearTimeout(s);r=true;s=setTimeout(function(){r=false},250)}});this._preventMove=function(e){if(t._moved){e.preventDefault()}};a.addEventListener(h.move,this._preventMove);this._resetTouchFn=function(e){if(typeof e.touches==="undefined"){return}t._moved=false;t._opening=false;t._startOffsetX=e.touches[0].pageX;t._preventOpen=!t._touch||!t.isOpen()&&t.menu.clientWidth!==0};this.panel.addEventListener(h.start,this._resetTouchFn);this._onTouchCancelFn=function(){t._moved=false;t._opening=false};this.panel.addEventListener("touchcancel",this._onTouchCancelFn);this._onTouchEndFn=function(){if(t._moved){t.emit("translateend");t._opening&&Math.abs(t._currentOffsetX)>t._tolerance?t.open():t.close()}t._moved=false};this.panel.addEventListener(h.end,this._onTouchEndFn);this._onTouchMoveFn=function(e){if(r||t._preventOpen||typeof e.touches==="undefined"||d(e.target)){return}var n=e.touches[0].clientX-t._startOffsetX;var i=t._currentOffsetX=n;if(Math.abs(i)>t._padding){return}if(Math.abs(n)>20){t._opening=true;var o=n*t._orientation;if(t._opened&&o>0||!t._opened&&o<0){return}if(!t._moved){t.emit("translatestart")}if(o<=0){i=n+t._padding*t._orientation;t._opening=false}if(!(t._moved&&u.classList.contains("slideout-open"))){u.classList.add("slideout-open")}t.panel.style[f+"transform"]=t.panel.style.transform="translateX("+i+"px)";t.emit("translate",i);t._moved=true}};this.panel.addEventListener(h.move,this._onTouchMoveFn);return this};_.prototype.enableTouch=function(){this._touch=true;return this};_.prototype.disableTouch=function(){this._touch=false;return this};_.prototype.destroy=function(){this.close();a.removeEventListener(h.move,this._preventMove);this.panel.removeEventListener(h.start,this._resetTouchFn);this.panel.removeEventListener("touchcancel",this._onTouchCancelFn);this.panel.removeEventListener(h.end,this._onTouchEndFn);this.panel.removeEventListener(h.move,this._onTouchMoveFn);a.removeEventListener("scroll",this._onScrollFn);this.open=this.close=function(){};return this};e.exports=_},{decouple:2,emitter:3}],2:[function(t,e,n){"use strict";var i=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||function(t){window.setTimeout(t,1e3/60)}}();function o(t,e,n){var o,s=false;function r(t){o=t;a()}function a(){if(!s){i(u);s=true}}function u(){n.call(t,o);s=false}t.addEventListener(e,r,false);return r}e.exports=o},{}],3:[function(t,e,n){"use strict";var i=function(t,e){if(!(t instanceof e)){throw new TypeError("Cannot call a class as a function")}};n.__esModule=true;var o=function(){function t(){i(this,t)}t.prototype.on=function e(t,n){this._eventCollection=this._eventCollection||{};this._eventCollection[t]=this._eventCollection[t]||[];this._eventCollection[t].push(n);return this};t.prototype.once=function n(t,e){var n=this;function i(){n.off(t,i);e.apply(this,arguments)}i.listener=e;this.on(t,i);return this};t.prototype.off=function o(t,e){var n=undefined;if(!this._eventCollection||!(n=this._eventCollection[t])){return this}n.forEach(function(t,i){if(t===e||t.listener===e){n.splice(i,1)}});if(n.length===0){delete this._eventCollection[t]}return this};t.prototype.emit=function s(t){var e=this;for(var n=arguments.length,i=Array(n>1?n-1:0),o=1;o<n;o++){i[o-1]=arguments[o]}var s=undefined;if(!this._eventCollection||!(s=this._eventCollection[t])){return this}s=s.slice(0);s.forEach(function(t){return t.apply(e,i)});return this};return t}();n["default"]=o;e.exports=n["default"]},{}]},{},[1])(1)});

})();
(function vendorFlickity() {
    /*!
   * Flickity PACKAGED v2.2.1
   * Touch, responsive, flickable carousels
   *
   * Licensed GPLv3 for open source use
   * or Flickity Commercial License for commercial use
   *
   * https://flickity.metafizzy.co
   * Copyright 2015-2019 Metafizzy
   */

  !function(e,i){"function"==typeof define&&define.amd?define("jquery-bridget/jquery-bridget",["jquery"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("jquery")):e.jQueryBridget=i(e,e.jQuery)}(window,function(t,e){"use strict";var i=Array.prototype.slice,n=t.console,d=void 0===n?function(){}:function(t){n.error(t)};function s(h,s,c){(c=c||e||t.jQuery)&&(s.prototype.option||(s.prototype.option=function(t){c.isPlainObject(t)&&(this.options=c.extend(!0,this.options,t))}),c.fn[h]=function(t){return"string"==typeof t?function(t,o,r){var a,l="$()."+h+'("'+o+'")';return t.each(function(t,e){var i=c.data(e,h);if(i){var n=i[o];if(n&&"_"!=o.charAt(0)){var s=n.apply(i,r);a=void 0===a?s:a}else d(l+" is not a valid method")}else d(h+" not initialized. Cannot call methods, i.e. "+l)}),void 0!==a?a:t}(this,t,i.call(arguments,1)):(function(t,n){t.each(function(t,e){var i=c.data(e,h);i?(i.option(n),i._init()):(i=new s(e,n),c.data(e,h,i))})}(this,t),this)},o(c))}function o(t){!t||t&&t.bridget||(t.bridget=s)}return o(e||t.jQuery),s}),function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},n=i[t]=i[t]||[];return-1==n.indexOf(e)&&n.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{};return(i[t]=i[t]||{})[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return-1!=n&&i.splice(n,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){i=i.slice(0),e=e||[];for(var n=this._onceEvents&&this._onceEvents[t],s=0;s<i.length;s++){var o=i[s];n&&n[o]&&(this.off(t,o),delete n[o]),o.apply(this,e)}return this}},e.allOff=function(){delete this._events,delete this._onceEvents},t}),function(t,e){"function"==typeof define&&define.amd?define("get-size/get-size",e):"object"==typeof module&&module.exports?module.exports=e():t.getSize=e()}(window,function(){"use strict";function m(t){var e=parseFloat(t);return-1==t.indexOf("%")&&!isNaN(e)&&e}var i="undefined"==typeof console?function(){}:function(t){console.error(t)},y=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"],b=y.length;function E(t){var e=getComputedStyle(t);return e||i("Style returned "+e+". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"),e}var S,C=!1;function x(t){if(function(){if(!C){C=!0;var t=document.createElement("div");t.style.width="200px",t.style.padding="1px 2px 3px 4px",t.style.borderStyle="solid",t.style.borderWidth="1px 2px 3px 4px",t.style.boxSizing="border-box";var e=document.body||document.documentElement;e.appendChild(t);var i=E(t);S=200==Math.round(m(i.width)),x.isBoxSizeOuter=S,e.removeChild(t)}}(),"string"==typeof t&&(t=document.querySelector(t)),t&&"object"==typeof t&&t.nodeType){var e=E(t);if("none"==e.display)return function(){for(var t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},e=0;e<b;e++){t[y[e]]=0}return t}();var i={};i.width=t.offsetWidth,i.height=t.offsetHeight;for(var n=i.isBorderBox="border-box"==e.boxSizing,s=0;s<b;s++){var o=y[s],r=e[o],a=parseFloat(r);i[o]=isNaN(a)?0:a}var l=i.paddingLeft+i.paddingRight,h=i.paddingTop+i.paddingBottom,c=i.marginLeft+i.marginRight,d=i.marginTop+i.marginBottom,u=i.borderLeftWidth+i.borderRightWidth,f=i.borderTopWidth+i.borderBottomWidth,p=n&&S,g=m(e.width);!1!==g&&(i.width=g+(p?0:l+u));var v=m(e.height);return!1!==v&&(i.height=v+(p?0:h+f)),i.innerWidth=i.width-(l+u),i.innerHeight=i.height-(h+f),i.outerWidth=i.width+c,i.outerHeight=i.height+d,i}}return x}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("desandro-matches-selector/matches-selector",e):"object"==typeof module&&module.exports?module.exports=e():t.matchesSelector=e()}(window,function(){"use strict";var i=function(){var t=window.Element.prototype;if(t.matches)return"matches";if(t.matchesSelector)return"matchesSelector";for(var e=["webkit","moz","ms","o"],i=0;i<e.length;i++){var n=e[i]+"MatchesSelector";if(t[n])return n}}();return function(t,e){return t[i](e)}}),function(e,i){"function"==typeof define&&define.amd?define("fizzy-ui-utils/utils",["desandro-matches-selector/matches-selector"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("desandro-matches-selector")):e.fizzyUIUtils=i(e,e.matchesSelector)}(window,function(h,o){var c={extend:function(t,e){for(var i in e)t[i]=e[i];return t},modulo:function(t,e){return(t%e+e)%e}},e=Array.prototype.slice;c.makeArray=function(t){return Array.isArray(t)?t:null==t?[]:"object"==typeof t&&"number"==typeof t.length?e.call(t):[t]},c.removeFrom=function(t,e){var i=t.indexOf(e);-1!=i&&t.splice(i,1)},c.getParent=function(t,e){for(;t.parentNode&&t!=document.body;)if(t=t.parentNode,o(t,e))return t},c.getQueryElement=function(t){return"string"==typeof t?document.querySelector(t):t},c.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},c.filterFindElements=function(t,n){t=c.makeArray(t);var s=[];return t.forEach(function(t){if(t instanceof HTMLElement)if(n){o(t,n)&&s.push(t);for(var e=t.querySelectorAll(n),i=0;i<e.length;i++)s.push(e[i])}else s.push(t)}),s},c.debounceMethod=function(t,e,n){n=n||100;var s=t.prototype[e],o=e+"Timeout";t.prototype[e]=function(){var t=this[o];clearTimeout(t);var e=arguments,i=this;this[o]=setTimeout(function(){s.apply(i,e),delete i[o]},n)}},c.docReady=function(t){var e=document.readyState;"complete"==e||"interactive"==e?setTimeout(t):document.addEventListener("DOMContentLoaded",t)},c.toDashed=function(t){return t.replace(/(.)([A-Z])/g,function(t,e,i){return e+"-"+i}).toLowerCase()};var d=h.console;return c.htmlInit=function(a,l){c.docReady(function(){var t=c.toDashed(l),s="data-"+t,e=document.querySelectorAll("["+s+"]"),i=document.querySelectorAll(".js-"+t),n=c.makeArray(e).concat(c.makeArray(i)),o=s+"-options",r=h.jQuery;n.forEach(function(e){var t,i=e.getAttribute(s)||e.getAttribute(o);try{t=i&&JSON.parse(i)}catch(t){return void(d&&d.error("Error parsing "+s+" on "+e.className+": "+t))}var n=new a(e,t);r&&r.data(e,l,n)})})},c}),function(e,i){"function"==typeof define&&define.amd?define("flickity/js/cell",["get-size/get-size"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("get-size")):(e.Flickity=e.Flickity||{},e.Flickity.Cell=i(e,e.getSize))}(window,function(t,e){function i(t,e){this.element=t,this.parent=e,this.create()}var n=i.prototype;return n.create=function(){this.element.style.position="absolute",this.element.setAttribute("aria-hidden","true"),this.x=0,this.shift=0},n.destroy=function(){this.unselect(),this.element.style.position="";var t=this.parent.originSide;this.element.style[t]=""},n.getSize=function(){this.size=e(this.element)},n.setPosition=function(t){this.x=t,this.updateTarget(),this.renderPosition(t)},n.updateTarget=n.setDefaultTarget=function(){var t="left"==this.parent.originSide?"marginLeft":"marginRight";this.target=this.x+this.size[t]+this.size.width*this.parent.cellAlign},n.renderPosition=function(t){var e=this.parent.originSide;this.element.style[e]=this.parent.getPositionValue(t)},n.select=function(){this.element.classList.add("is-selected"),this.element.removeAttribute("aria-hidden")},n.unselect=function(){this.element.classList.remove("is-selected"),this.element.setAttribute("aria-hidden","true")},n.wrapShift=function(t){this.shift=t,this.renderPosition(this.x+this.parent.slideableWidth*t)},n.remove=function(){this.element.parentNode.removeChild(this.element)},i}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/slide",e):"object"==typeof module&&module.exports?module.exports=e():(t.Flickity=t.Flickity||{},t.Flickity.Slide=e())}(window,function(){"use strict";function t(t){this.parent=t,this.isOriginLeft="left"==t.originSide,this.cells=[],this.outerWidth=0,this.height=0}var e=t.prototype;return e.addCell=function(t){if(this.cells.push(t),this.outerWidth+=t.size.outerWidth,this.height=Math.max(t.size.outerHeight,this.height),1==this.cells.length){this.x=t.x;var e=this.isOriginLeft?"marginLeft":"marginRight";this.firstMargin=t.size[e]}},e.updateTarget=function(){var t=this.isOriginLeft?"marginRight":"marginLeft",e=this.getLastCell(),i=e?e.size[t]:0,n=this.outerWidth-(this.firstMargin+i);this.target=this.x+this.firstMargin+n*this.parent.cellAlign},e.getLastCell=function(){return this.cells[this.cells.length-1]},e.select=function(){this.cells.forEach(function(t){t.select()})},e.unselect=function(){this.cells.forEach(function(t){t.unselect()})},e.getCellElements=function(){return this.cells.map(function(t){return t.element})},t}),function(e,i){"function"==typeof define&&define.amd?define("flickity/js/animate",["fizzy-ui-utils/utils"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("fizzy-ui-utils")):(e.Flickity=e.Flickity||{},e.Flickity.animatePrototype=i(e,e.fizzyUIUtils))}(window,function(t,e){var i={startAnimation:function(){this.isAnimating||(this.isAnimating=!0,this.restingFrames=0,this.animate())},animate:function(){this.applyDragForce(),this.applySelectedAttraction();var t=this.x;if(this.integratePhysics(),this.positionSlider(),this.settle(t),this.isAnimating){var e=this;requestAnimationFrame(function(){e.animate()})}},positionSlider:function(){var t=this.x;this.options.wrapAround&&1<this.cells.length&&(t=e.modulo(t,this.slideableWidth),t-=this.slideableWidth,this.shiftWrapCells(t)),this.setTranslateX(t,this.isAnimating),this.dispatchScrollEvent()},setTranslateX:function(t,e){t+=this.cursorPosition,t=this.options.rightToLeft?-t:t;var i=this.getPositionValue(t);this.slider.style.transform=e?"translate3d("+i+",0,0)":"translateX("+i+")"},dispatchScrollEvent:function(){var t=this.slides[0];if(t){var e=-this.x-t.target,i=e/this.slidesWidth;this.dispatchEvent("scroll",null,[i,e])}},positionSliderAtSelected:function(){this.cells.length&&(this.x=-this.selectedSlide.target,this.velocity=0,this.positionSlider())},getPositionValue:function(t){return this.options.percentPosition?.01*Math.round(t/this.size.innerWidth*1e4)+"%":Math.round(t)+"px"},settle:function(t){this.isPointerDown||Math.round(100*this.x)!=Math.round(100*t)||this.restingFrames++,2<this.restingFrames&&(this.isAnimating=!1,delete this.isFreeScrolling,this.positionSlider(),this.dispatchEvent("settle",null,[this.selectedIndex]))},shiftWrapCells:function(t){var e=this.cursorPosition+t;this._shiftCells(this.beforeShiftCells,e,-1);var i=this.size.innerWidth-(t+this.slideableWidth+this.cursorPosition);this._shiftCells(this.afterShiftCells,i,1)},_shiftCells:function(t,e,i){for(var n=0;n<t.length;n++){var s=t[n],o=0<e?i:0;s.wrapShift(o),e-=s.size.outerWidth}},_unshiftCells:function(t){if(t&&t.length)for(var e=0;e<t.length;e++)t[e].wrapShift(0)},integratePhysics:function(){this.x+=this.velocity,this.velocity*=this.getFrictionFactor()},applyForce:function(t){this.velocity+=t},getFrictionFactor:function(){return 1-this.options[this.isFreeScrolling?"freeScrollFriction":"friction"]},getRestingPosition:function(){return this.x+this.velocity/(1-this.getFrictionFactor())},applyDragForce:function(){if(this.isDraggable&&this.isPointerDown){var t=this.dragX-this.x-this.velocity;this.applyForce(t)}},applySelectedAttraction:function(){if(!(this.isDraggable&&this.isPointerDown)&&!this.isFreeScrolling&&this.slides.length){var t=(-1*this.selectedSlide.target-this.x)*this.options.selectedAttraction;this.applyForce(t)}}};return i}),function(r,a){if("function"==typeof define&&define.amd)define("flickity/js/flickity",["ev-emitter/ev-emitter","get-size/get-size","fizzy-ui-utils/utils","./cell","./slide","./animate"],function(t,e,i,n,s,o){return a(r,t,e,i,n,s,o)});else if("object"==typeof module&&module.exports)module.exports=a(r,require("ev-emitter"),require("get-size"),require("fizzy-ui-utils"),require("./cell"),require("./slide"),require("./animate"));else{var t=r.Flickity;r.Flickity=a(r,r.EvEmitter,r.getSize,r.fizzyUIUtils,t.Cell,t.Slide,t.animatePrototype)}}(window,function(n,t,e,a,i,r,s){var l=n.jQuery,o=n.getComputedStyle,h=n.console;function c(t,e){for(t=a.makeArray(t);t.length;)e.appendChild(t.shift())}var d=0,u={};function f(t,e){var i=a.getQueryElement(t);if(i){if(this.element=i,this.element.flickityGUID){var n=u[this.element.flickityGUID];return n.option(e),n}l&&(this.$element=l(this.element)),this.options=a.extend({},this.constructor.defaults),this.option(e),this._create()}else h&&h.error("Bad element for Flickity: "+(i||t))}f.defaults={accessibility:!0,cellAlign:"center",freeScrollFriction:.075,friction:.28,namespaceJQueryEvents:!0,percentPosition:!0,resize:!0,selectedAttraction:.025,setGallerySize:!0},f.createMethods=[];var p=f.prototype;a.extend(p,t.prototype),p._create=function(){var t=this.guid=++d;for(var e in this.element.flickityGUID=t,(u[t]=this).selectedIndex=0,this.restingFrames=0,this.x=0,this.velocity=0,this.originSide=this.options.rightToLeft?"right":"left",this.viewport=document.createElement("div"),this.viewport.className="flickity-viewport",this._createSlider(),(this.options.resize||this.options.watchCSS)&&n.addEventListener("resize",this),this.options.on){var i=this.options.on[e];this.on(e,i)}f.createMethods.forEach(function(t){this[t]()},this),this.options.watchCSS?this.watchCSS():this.activate()},p.option=function(t){a.extend(this.options,t)},p.activate=function(){this.isActive||(this.isActive=!0,this.element.classList.add("flickity-enabled"),this.options.rightToLeft&&this.element.classList.add("flickity-rtl"),this.getSize(),c(this._filterFindCellElements(this.element.children),this.slider),this.viewport.appendChild(this.slider),this.element.appendChild(this.viewport),this.reloadCells(),this.options.accessibility&&(this.element.tabIndex=0,this.element.addEventListener("keydown",this)),this.emitEvent("activate"),this.selectInitialIndex(),this.isInitActivated=!0,this.dispatchEvent("ready"))},p._createSlider=function(){var t=document.createElement("div");t.className="flickity-slider",t.style[this.originSide]=0,this.slider=t},p._filterFindCellElements=function(t){return a.filterFindElements(t,this.options.cellSelector)},p.reloadCells=function(){this.cells=this._makeCells(this.slider.children),this.positionCells(),this._getWrapShiftCells(),this.setGallerySize()},p._makeCells=function(t){return this._filterFindCellElements(t).map(function(t){return new i(t,this)},this)},p.getLastCell=function(){return this.cells[this.cells.length-1]},p.getLastSlide=function(){return this.slides[this.slides.length-1]},p.positionCells=function(){this._sizeCells(this.cells),this._positionCells(0)},p._positionCells=function(t){t=t||0,this.maxCellHeight=t&&this.maxCellHeight||0;var e=0;if(0<t){var i=this.cells[t-1];e=i.x+i.size.outerWidth}for(var n=this.cells.length,s=t;s<n;s++){var o=this.cells[s];o.setPosition(e),e+=o.size.outerWidth,this.maxCellHeight=Math.max(o.size.outerHeight,this.maxCellHeight)}this.slideableWidth=e,this.updateSlides(),this._containSlides(),this.slidesWidth=n?this.getLastSlide().target-this.slides[0].target:0},p._sizeCells=function(t){t.forEach(function(t){t.getSize()})},p.updateSlides=function(){if(this.slides=[],this.cells.length){var n=new r(this);this.slides.push(n);var s="left"==this.originSide?"marginRight":"marginLeft",o=this._getCanCellFit();this.cells.forEach(function(t,e){if(n.cells.length){var i=n.outerWidth-n.firstMargin+(t.size.outerWidth-t.size[s]);o.call(this,e,i)||(n.updateTarget(),n=new r(this),this.slides.push(n)),n.addCell(t)}else n.addCell(t)},this),n.updateTarget(),this.updateSelectedSlide()}},p._getCanCellFit=function(){var t=this.options.groupCells;if(!t)return function(){return!1};if("number"==typeof t){var e=parseInt(t,10);return function(t){return t%e!=0}}var i="string"==typeof t&&t.match(/^(\d+)%$/),n=i?parseInt(i[1],10)/100:1;return function(t,e){return e<=(this.size.innerWidth+1)*n}},p._init=p.reposition=function(){this.positionCells(),this.positionSliderAtSelected()},p.getSize=function(){this.size=e(this.element),this.setCellAlign(),this.cursorPosition=this.size.innerWidth*this.cellAlign};var g={center:{left:.5,right:.5},left:{left:0,right:1},right:{right:0,left:1}};return p.setCellAlign=function(){var t=g[this.options.cellAlign];this.cellAlign=t?t[this.originSide]:this.options.cellAlign},p.setGallerySize=function(){if(this.options.setGallerySize){var t=this.options.adaptiveHeight&&this.selectedSlide?this.selectedSlide.height:this.maxCellHeight;this.viewport.style.height=t+"px"}},p._getWrapShiftCells=function(){if(this.options.wrapAround){this._unshiftCells(this.beforeShiftCells),this._unshiftCells(this.afterShiftCells);var t=this.cursorPosition,e=this.cells.length-1;this.beforeShiftCells=this._getGapCells(t,e,-1),t=this.size.innerWidth-this.cursorPosition,this.afterShiftCells=this._getGapCells(t,0,1)}},p._getGapCells=function(t,e,i){for(var n=[];0<t;){var s=this.cells[e];if(!s)break;n.push(s),e+=i,t-=s.size.outerWidth}return n},p._containSlides=function(){if(this.options.contain&&!this.options.wrapAround&&this.cells.length){var t=this.options.rightToLeft,e=t?"marginRight":"marginLeft",i=t?"marginLeft":"marginRight",n=this.slideableWidth-this.getLastCell().size[i],s=n<this.size.innerWidth,o=this.cursorPosition+this.cells[0].size[e],r=n-this.size.innerWidth*(1-this.cellAlign);this.slides.forEach(function(t){s?t.target=n*this.cellAlign:(t.target=Math.max(t.target,o),t.target=Math.min(t.target,r))},this)}},p.dispatchEvent=function(t,e,i){var n=e?[e].concat(i):i;if(this.emitEvent(t,n),l&&this.$element){var s=t+=this.options.namespaceJQueryEvents?".flickity":"";if(e){var o=l.Event(e);o.type=t,s=o}this.$element.trigger(s,i)}},p.select=function(t,e,i){if(this.isActive&&(t=parseInt(t,10),this._wrapSelect(t),(this.options.wrapAround||e)&&(t=a.modulo(t,this.slides.length)),this.slides[t])){var n=this.selectedIndex;this.selectedIndex=t,this.updateSelectedSlide(),i?this.positionSliderAtSelected():this.startAnimation(),this.options.adaptiveHeight&&this.setGallerySize(),this.dispatchEvent("select",null,[t]),t!=n&&this.dispatchEvent("change",null,[t]),this.dispatchEvent("cellSelect")}},p._wrapSelect=function(t){var e=this.slides.length;if(!(this.options.wrapAround&&1<e))return t;var i=a.modulo(t,e),n=Math.abs(i-this.selectedIndex),s=Math.abs(i+e-this.selectedIndex),o=Math.abs(i-e-this.selectedIndex);!this.isDragSelect&&s<n?t+=e:!this.isDragSelect&&o<n&&(t-=e),t<0?this.x-=this.slideableWidth:e<=t&&(this.x+=this.slideableWidth)},p.previous=function(t,e){this.select(this.selectedIndex-1,t,e)},p.next=function(t,e){this.select(this.selectedIndex+1,t,e)},p.updateSelectedSlide=function(){var t=this.slides[this.selectedIndex];t&&(this.unselectSelectedSlide(),(this.selectedSlide=t).select(),this.selectedCells=t.cells,this.selectedElements=t.getCellElements(),this.selectedCell=t.cells[0],this.selectedElement=this.selectedElements[0])},p.unselectSelectedSlide=function(){this.selectedSlide&&this.selectedSlide.unselect()},p.selectInitialIndex=function(){var t=this.options.initialIndex;if(this.isInitActivated)this.select(this.selectedIndex,!1,!0);else{if(t&&"string"==typeof t)if(this.queryCell(t))return void this.selectCell(t,!1,!0);var e=0;t&&this.slides[t]&&(e=t),this.select(e,!1,!0)}},p.selectCell=function(t,e,i){var n=this.queryCell(t);if(n){var s=this.getCellSlideIndex(n);this.select(s,e,i)}},p.getCellSlideIndex=function(t){for(var e=0;e<this.slides.length;e++){if(-1!=this.slides[e].cells.indexOf(t))return e}},p.getCell=function(t){for(var e=0;e<this.cells.length;e++){var i=this.cells[e];if(i.element==t)return i}},p.getCells=function(t){t=a.makeArray(t);var i=[];return t.forEach(function(t){var e=this.getCell(t);e&&i.push(e)},this),i},p.getCellElements=function(){return this.cells.map(function(t){return t.element})},p.getParentCell=function(t){var e=this.getCell(t);return e||(t=a.getParent(t,".flickity-slider > *"),this.getCell(t))},p.getAdjacentCellElements=function(t,e){if(!t)return this.selectedSlide.getCellElements();e=void 0===e?this.selectedIndex:e;var i=this.slides.length;if(i<=1+2*t)return this.getCellElements();for(var n=[],s=e-t;s<=e+t;s++){var o=this.options.wrapAround?a.modulo(s,i):s,r=this.slides[o];r&&(n=n.concat(r.getCellElements()))}return n},p.queryCell=function(t){if("number"==typeof t)return this.cells[t];if("string"==typeof t){if(t.match(/^[#\.]?[\d\/]/))return;t=this.element.querySelector(t)}return this.getCell(t)},p.uiChange=function(){this.emitEvent("uiChange")},p.childUIPointerDown=function(t){"touchstart"!=t.type&&t.preventDefault(),this.focus()},p.onresize=function(){this.watchCSS(),this.resize()},a.debounceMethod(f,"onresize",150),p.resize=function(){if(this.isActive){this.getSize(),this.options.wrapAround&&(this.x=a.modulo(this.x,this.slideableWidth)),this.positionCells(),this._getWrapShiftCells(),this.setGallerySize(),this.emitEvent("resize");var t=this.selectedElements&&this.selectedElements[0];this.selectCell(t,!1,!0)}},p.watchCSS=function(){this.options.watchCSS&&(-1!=o(this.element,":after").content.indexOf("flickity")?this.activate():this.deactivate())},p.onkeydown=function(t){var e=document.activeElement&&document.activeElement!=this.element;if(this.options.accessibility&&!e){var i=f.keyboardHandlers[t.keyCode];i&&i.call(this)}},f.keyboardHandlers={37:function(){var t=this.options.rightToLeft?"next":"previous";this.uiChange(),this[t]()},39:function(){var t=this.options.rightToLeft?"previous":"next";this.uiChange(),this[t]()}},p.focus=function(){var t=n.pageYOffset;this.element.focus({preventScroll:!0}),n.pageYOffset!=t&&n.scrollTo(n.pageXOffset,t)},p.deactivate=function(){this.isActive&&(this.element.classList.remove("flickity-enabled"),this.element.classList.remove("flickity-rtl"),this.unselectSelectedSlide(),this.cells.forEach(function(t){t.destroy()}),this.element.removeChild(this.viewport),c(this.slider.children,this.element),this.options.accessibility&&(this.element.removeAttribute("tabIndex"),this.element.removeEventListener("keydown",this)),this.isActive=!1,this.emitEvent("deactivate"))},p.destroy=function(){this.deactivate(),n.removeEventListener("resize",this),this.allOff(),this.emitEvent("destroy"),l&&this.$element&&l.removeData(this.element,"flickity"),delete this.element.flickityGUID,delete u[this.guid]},a.extend(p,s),f.data=function(t){var e=(t=a.getQueryElement(t))&&t.flickityGUID;return e&&u[e]},a.htmlInit(f,"flickity"),l&&l.bridget&&l.bridget("flickity",f),f.setJQuery=function(t){l=t},f.Cell=i,f.Slide=r,f}),function(e,i){"function"==typeof define&&define.amd?define("unipointer/unipointer",["ev-emitter/ev-emitter"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("ev-emitter")):e.Unipointer=i(e,e.EvEmitter)}(window,function(s,t){function e(){}var i=e.prototype=Object.create(t.prototype);i.bindStartEvent=function(t){this._bindStartEvent(t,!0)},i.unbindStartEvent=function(t){this._bindStartEvent(t,!1)},i._bindStartEvent=function(t,e){var i=(e=void 0===e||e)?"addEventListener":"removeEventListener",n="mousedown";s.PointerEvent?n="pointerdown":"ontouchstart"in s&&(n="touchstart"),t[i](n,this)},i.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},i.getTouch=function(t){for(var e=0;e<t.length;e++){var i=t[e];if(i.identifier==this.pointerIdentifier)return i}},i.onmousedown=function(t){var e=t.button;e&&0!==e&&1!==e||this._pointerDown(t,t)},i.ontouchstart=function(t){this._pointerDown(t,t.changedTouches[0])},i.onpointerdown=function(t){this._pointerDown(t,t)},i._pointerDown=function(t,e){t.button||this.isPointerDown||(this.isPointerDown=!0,this.pointerIdentifier=void 0!==e.pointerId?e.pointerId:e.identifier,this.pointerDown(t,e))},i.pointerDown=function(t,e){this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e])};var n={mousedown:["mousemove","mouseup"],touchstart:["touchmove","touchend","touchcancel"],pointerdown:["pointermove","pointerup","pointercancel"]};return i._bindPostStartEvents=function(t){if(t){var e=n[t.type];e.forEach(function(t){s.addEventListener(t,this)},this),this._boundPointerEvents=e}},i._unbindPostStartEvents=function(){this._boundPointerEvents&&(this._boundPointerEvents.forEach(function(t){s.removeEventListener(t,this)},this),delete this._boundPointerEvents)},i.onmousemove=function(t){this._pointerMove(t,t)},i.onpointermove=function(t){t.pointerId==this.pointerIdentifier&&this._pointerMove(t,t)},i.ontouchmove=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerMove(t,e)},i._pointerMove=function(t,e){this.pointerMove(t,e)},i.pointerMove=function(t,e){this.emitEvent("pointerMove",[t,e])},i.onmouseup=function(t){this._pointerUp(t,t)},i.onpointerup=function(t){t.pointerId==this.pointerIdentifier&&this._pointerUp(t,t)},i.ontouchend=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerUp(t,e)},i._pointerUp=function(t,e){this._pointerDone(),this.pointerUp(t,e)},i.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e])},i._pointerDone=function(){this._pointerReset(),this._unbindPostStartEvents(),this.pointerDone()},i._pointerReset=function(){this.isPointerDown=!1,delete this.pointerIdentifier},i.pointerDone=function(){},i.onpointercancel=function(t){t.pointerId==this.pointerIdentifier&&this._pointerCancel(t,t)},i.ontouchcancel=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerCancel(t,e)},i._pointerCancel=function(t,e){this._pointerDone(),this.pointerCancel(t,e)},i.pointerCancel=function(t,e){this.emitEvent("pointerCancel",[t,e])},e.getPointerPoint=function(t){return{x:t.pageX,y:t.pageY}},e}),function(e,i){"function"==typeof define&&define.amd?define("unidragger/unidragger",["unipointer/unipointer"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("unipointer")):e.Unidragger=i(e,e.Unipointer)}(window,function(o,t){function e(){}var i=e.prototype=Object.create(t.prototype);i.bindHandles=function(){this._bindHandles(!0)},i.unbindHandles=function(){this._bindHandles(!1)},i._bindHandles=function(t){for(var e=(t=void 0===t||t)?"addEventListener":"removeEventListener",i=t?this._touchActionValue:"",n=0;n<this.handles.length;n++){var s=this.handles[n];this._bindStartEvent(s,t),s[e]("click",this),o.PointerEvent&&(s.style.touchAction=i)}},i._touchActionValue="none",i.pointerDown=function(t,e){this.okayPointerDown(t)&&(this.pointerDownPointer=e,t.preventDefault(),this.pointerDownBlur(),this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e]))};var s={TEXTAREA:!0,INPUT:!0,SELECT:!0,OPTION:!0},r={radio:!0,checkbox:!0,button:!0,submit:!0,image:!0,file:!0};return i.okayPointerDown=function(t){var e=s[t.target.nodeName],i=r[t.target.type],n=!e||i;return n||this._pointerReset(),n},i.pointerDownBlur=function(){var t=document.activeElement;t&&t.blur&&t!=document.body&&t.blur()},i.pointerMove=function(t,e){var i=this._dragPointerMove(t,e);this.emitEvent("pointerMove",[t,e,i]),this._dragMove(t,e,i)},i._dragPointerMove=function(t,e){var i={x:e.pageX-this.pointerDownPointer.pageX,y:e.pageY-this.pointerDownPointer.pageY};return!this.isDragging&&this.hasDragStarted(i)&&this._dragStart(t,e),i},i.hasDragStarted=function(t){return 3<Math.abs(t.x)||3<Math.abs(t.y)},i.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e]),this._dragPointerUp(t,e)},i._dragPointerUp=function(t,e){this.isDragging?this._dragEnd(t,e):this._staticClick(t,e)},i._dragStart=function(t,e){this.isDragging=!0,this.isPreventingClicks=!0,this.dragStart(t,e)},i.dragStart=function(t,e){this.emitEvent("dragStart",[t,e])},i._dragMove=function(t,e,i){this.isDragging&&this.dragMove(t,e,i)},i.dragMove=function(t,e,i){t.preventDefault(),this.emitEvent("dragMove",[t,e,i])},i._dragEnd=function(t,e){this.isDragging=!1,setTimeout(function(){delete this.isPreventingClicks}.bind(this)),this.dragEnd(t,e)},i.dragEnd=function(t,e){this.emitEvent("dragEnd",[t,e])},i.onclick=function(t){this.isPreventingClicks&&t.preventDefault()},i._staticClick=function(t,e){this.isIgnoringMouseUp&&"mouseup"==t.type||(this.staticClick(t,e),"mouseup"!=t.type&&(this.isIgnoringMouseUp=!0,setTimeout(function(){delete this.isIgnoringMouseUp}.bind(this),400)))},i.staticClick=function(t,e){this.emitEvent("staticClick",[t,e])},e.getPointerPoint=t.getPointerPoint,e}),function(n,s){"function"==typeof define&&define.amd?define("flickity/js/drag",["./flickity","unidragger/unidragger","fizzy-ui-utils/utils"],function(t,e,i){return s(n,t,e,i)}):"object"==typeof module&&module.exports?module.exports=s(n,require("./flickity"),require("unidragger"),require("fizzy-ui-utils")):n.Flickity=s(n,n.Flickity,n.Unidragger,n.fizzyUIUtils)}(window,function(i,t,e,a){a.extend(t.defaults,{draggable:">1",dragThreshold:3}),t.createMethods.push("_createDrag");var n=t.prototype;a.extend(n,e.prototype),n._touchActionValue="pan-y";var s="createTouch"in document,o=!1;n._createDrag=function(){this.on("activate",this.onActivateDrag),this.on("uiChange",this._uiChangeDrag),this.on("deactivate",this.onDeactivateDrag),this.on("cellChange",this.updateDraggable),s&&!o&&(i.addEventListener("touchmove",function(){}),o=!0)},n.onActivateDrag=function(){this.handles=[this.viewport],this.bindHandles(),this.updateDraggable()},n.onDeactivateDrag=function(){this.unbindHandles(),this.element.classList.remove("is-draggable")},n.updateDraggable=function(){">1"==this.options.draggable?this.isDraggable=1<this.slides.length:this.isDraggable=this.options.draggable,this.isDraggable?this.element.classList.add("is-draggable"):this.element.classList.remove("is-draggable")},n.bindDrag=function(){this.options.draggable=!0,this.updateDraggable()},n.unbindDrag=function(){this.options.draggable=!1,this.updateDraggable()},n._uiChangeDrag=function(){delete this.isFreeScrolling},n.pointerDown=function(t,e){this.isDraggable?this.okayPointerDown(t)&&(this._pointerDownPreventDefault(t),this.pointerDownFocus(t),document.activeElement!=this.element&&this.pointerDownBlur(),this.dragX=this.x,this.viewport.classList.add("is-pointer-down"),this.pointerDownScroll=l(),i.addEventListener("scroll",this),this._pointerDownDefault(t,e)):this._pointerDownDefault(t,e)},n._pointerDownDefault=function(t,e){this.pointerDownPointer={pageX:e.pageX,pageY:e.pageY},this._bindPostStartEvents(t),this.dispatchEvent("pointerDown",t,[e])};var r={INPUT:!0,TEXTAREA:!0,SELECT:!0};function l(){return{x:i.pageXOffset,y:i.pageYOffset}}return n.pointerDownFocus=function(t){r[t.target.nodeName]||this.focus()},n._pointerDownPreventDefault=function(t){var e="touchstart"==t.type,i="touch"==t.pointerType,n=r[t.target.nodeName];e||i||n||t.preventDefault()},n.hasDragStarted=function(t){return Math.abs(t.x)>this.options.dragThreshold},n.pointerUp=function(t,e){delete this.isTouchScrolling,this.viewport.classList.remove("is-pointer-down"),this.dispatchEvent("pointerUp",t,[e]),this._dragPointerUp(t,e)},n.pointerDone=function(){i.removeEventListener("scroll",this),delete this.pointerDownScroll},n.dragStart=function(t,e){this.isDraggable&&(this.dragStartPosition=this.x,this.startAnimation(),i.removeEventListener("scroll",this),this.dispatchEvent("dragStart",t,[e]))},n.pointerMove=function(t,e){var i=this._dragPointerMove(t,e);this.dispatchEvent("pointerMove",t,[e,i]),this._dragMove(t,e,i)},n.dragMove=function(t,e,i){if(this.isDraggable){t.preventDefault(),this.previousDragX=this.dragX;var n=this.options.rightToLeft?-1:1;this.options.wrapAround&&(i.x=i.x%this.slideableWidth);var s=this.dragStartPosition+i.x*n;if(!this.options.wrapAround&&this.slides.length){var o=Math.max(-this.slides[0].target,this.dragStartPosition);s=o<s?.5*(s+o):s;var r=Math.min(-this.getLastSlide().target,this.dragStartPosition);s=s<r?.5*(s+r):s}this.dragX=s,this.dragMoveTime=new Date,this.dispatchEvent("dragMove",t,[e,i])}},n.dragEnd=function(t,e){if(this.isDraggable){this.options.freeScroll&&(this.isFreeScrolling=!0);var i=this.dragEndRestingSelect();if(this.options.freeScroll&&!this.options.wrapAround){var n=this.getRestingPosition();this.isFreeScrolling=-n>this.slides[0].target&&-n<this.getLastSlide().target}else this.options.freeScroll||i!=this.selectedIndex||(i+=this.dragEndBoostSelect());delete this.previousDragX,this.isDragSelect=this.options.wrapAround,this.select(i),delete this.isDragSelect,this.dispatchEvent("dragEnd",t,[e])}},n.dragEndRestingSelect=function(){var t=this.getRestingPosition(),e=Math.abs(this.getSlideDistance(-t,this.selectedIndex)),i=this._getClosestResting(t,e,1),n=this._getClosestResting(t,e,-1);return i.distance<n.distance?i.index:n.index},n._getClosestResting=function(t,e,i){for(var n=this.selectedIndex,s=1/0,o=this.options.contain&&!this.options.wrapAround?function(t,e){return t<=e}:function(t,e){return t<e};o(e,s)&&(n+=i,s=e,null!==(e=this.getSlideDistance(-t,n)));)e=Math.abs(e);return{distance:s,index:n-i}},n.getSlideDistance=function(t,e){var i=this.slides.length,n=this.options.wrapAround&&1<i,s=n?a.modulo(e,i):e,o=this.slides[s];if(!o)return null;var r=n?this.slideableWidth*Math.floor(e/i):0;return t-(o.target+r)},n.dragEndBoostSelect=function(){if(void 0===this.previousDragX||!this.dragMoveTime||100<new Date-this.dragMoveTime)return 0;var t=this.getSlideDistance(-this.dragX,this.selectedIndex),e=this.previousDragX-this.dragX;return 0<t&&0<e?1:t<0&&e<0?-1:0},n.staticClick=function(t,e){var i=this.getParentCell(t.target),n=i&&i.element,s=i&&this.cells.indexOf(i);this.dispatchEvent("staticClick",t,[e,n,s])},n.onscroll=function(){var t=l(),e=this.pointerDownScroll.x-t.x,i=this.pointerDownScroll.y-t.y;(3<Math.abs(e)||3<Math.abs(i))&&this._pointerDone()},t}),function(n,s){"function"==typeof define&&define.amd?define("flickity/js/prev-next-button",["./flickity","unipointer/unipointer","fizzy-ui-utils/utils"],function(t,e,i){return s(n,t,e,i)}):"object"==typeof module&&module.exports?module.exports=s(n,require("./flickity"),require("unipointer"),require("fizzy-ui-utils")):s(n,n.Flickity,n.Unipointer,n.fizzyUIUtils)}(window,function(t,e,i,n){"use strict";var s="http://www.w3.org/2000/svg";function o(t,e){this.direction=t,this.parent=e,this._create()}(o.prototype=Object.create(i.prototype))._create=function(){this.isEnabled=!0,this.isPrevious=-1==this.direction;var t=this.parent.options.rightToLeft?1:-1;this.isLeft=this.direction==t;var e=this.element=document.createElement("button");e.className="flickity-button flickity-prev-next-button",e.className+=this.isPrevious?" previous":" next",e.setAttribute("type","button"),this.disable(),e.setAttribute("aria-label",this.isPrevious?"Previous":"Next");var i=this.createSVG();e.appendChild(i),this.parent.on("select",this.update.bind(this)),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},o.prototype.activate=function(){this.bindStartEvent(this.element),this.element.addEventListener("click",this),this.parent.element.appendChild(this.element)},o.prototype.deactivate=function(){this.parent.element.removeChild(this.element),this.unbindStartEvent(this.element),this.element.removeEventListener("click",this)},o.prototype.createSVG=function(){var t=document.createElementNS(s,"svg");t.setAttribute("class","flickity-button-icon"),t.setAttribute("viewBox","0 0 100 100");var e=document.createElementNS(s,"path"),i=function(t){return"string"!=typeof t?"M "+t.x0+",50 L "+t.x1+","+(t.y1+50)+" L "+t.x2+","+(t.y2+50)+" L "+t.x3+",50  L "+t.x2+","+(50-t.y2)+" L "+t.x1+","+(50-t.y1)+" Z":t}(this.parent.options.arrowShape);return e.setAttribute("d",i),e.setAttribute("class","arrow"),this.isLeft||e.setAttribute("transform","translate(100, 100) rotate(180) "),t.appendChild(e),t},o.prototype.handleEvent=n.handleEvent,o.prototype.onclick=function(){if(this.isEnabled){this.parent.uiChange();var t=this.isPrevious?"previous":"next";this.parent[t]()}},o.prototype.enable=function(){this.isEnabled||(this.element.disabled=!1,this.isEnabled=!0)},o.prototype.disable=function(){this.isEnabled&&(this.element.disabled=!0,this.isEnabled=!1)},o.prototype.update=function(){var t=this.parent.slides;if(this.parent.options.wrapAround&&1<t.length)this.enable();else{var e=t.length?t.length-1:0,i=this.isPrevious?0:e;this[this.parent.selectedIndex==i?"disable":"enable"]()}},o.prototype.destroy=function(){this.deactivate(),this.allOff()},n.extend(e.defaults,{prevNextButtons:!0,arrowShape:{x0:10,x1:60,y1:50,x2:70,y2:40,x3:30}}),e.createMethods.push("_createPrevNextButtons");var r=e.prototype;return r._createPrevNextButtons=function(){this.options.prevNextButtons&&(this.prevButton=new o(-1,this),this.nextButton=new o(1,this),this.on("activate",this.activatePrevNextButtons))},r.activatePrevNextButtons=function(){this.prevButton.activate(),this.nextButton.activate(),this.on("deactivate",this.deactivatePrevNextButtons)},r.deactivatePrevNextButtons=function(){this.prevButton.deactivate(),this.nextButton.deactivate(),this.off("deactivate",this.deactivatePrevNextButtons)},e.PrevNextButton=o,e}),function(n,s){"function"==typeof define&&define.amd?define("flickity/js/page-dots",["./flickity","unipointer/unipointer","fizzy-ui-utils/utils"],function(t,e,i){return s(n,t,e,i)}):"object"==typeof module&&module.exports?module.exports=s(n,require("./flickity"),require("unipointer"),require("fizzy-ui-utils")):s(n,n.Flickity,n.Unipointer,n.fizzyUIUtils)}(window,function(t,e,i,n){function s(t){this.parent=t,this._create()}(s.prototype=Object.create(i.prototype))._create=function(){this.holder=document.createElement("ol"),this.holder.className="flickity-page-dots",this.dots=[],this.handleClick=this.onClick.bind(this),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},s.prototype.activate=function(){this.setDots(),this.holder.addEventListener("click",this.handleClick),this.bindStartEvent(this.holder),this.parent.element.appendChild(this.holder)},s.prototype.deactivate=function(){this.holder.removeEventListener("click",this.handleClick),this.unbindStartEvent(this.holder),this.parent.element.removeChild(this.holder)},s.prototype.setDots=function(){var t=this.parent.slides.length-this.dots.length;0<t?this.addDots(t):t<0&&this.removeDots(-t)},s.prototype.addDots=function(t){for(var e=document.createDocumentFragment(),i=[],n=this.dots.length,s=n+t,o=n;o<s;o++){var r=document.createElement("li");r.className="dot",r.setAttribute("aria-label","Page dot "+(o+1)),e.appendChild(r),i.push(r)}this.holder.appendChild(e),this.dots=this.dots.concat(i)},s.prototype.removeDots=function(t){this.dots.splice(this.dots.length-t,t).forEach(function(t){this.holder.removeChild(t)},this)},s.prototype.updateSelected=function(){this.selectedDot&&(this.selectedDot.className="dot",this.selectedDot.removeAttribute("aria-current")),this.dots.length&&(this.selectedDot=this.dots[this.parent.selectedIndex],this.selectedDot.className="dot is-selected",this.selectedDot.setAttribute("aria-current","step"))},s.prototype.onTap=s.prototype.onClick=function(t){var e=t.target;if("LI"==e.nodeName){this.parent.uiChange();var i=this.dots.indexOf(e);this.parent.select(i)}},s.prototype.destroy=function(){this.deactivate(),this.allOff()},e.PageDots=s,n.extend(e.defaults,{pageDots:!0}),e.createMethods.push("_createPageDots");var o=e.prototype;return o._createPageDots=function(){this.options.pageDots&&(this.pageDots=new s(this),this.on("activate",this.activatePageDots),this.on("select",this.updateSelectedPageDots),this.on("cellChange",this.updatePageDots),this.on("resize",this.updatePageDots),this.on("deactivate",this.deactivatePageDots))},o.activatePageDots=function(){this.pageDots.activate()},o.updateSelectedPageDots=function(){this.pageDots.updateSelected()},o.updatePageDots=function(){this.pageDots.setDots()},o.deactivatePageDots=function(){this.pageDots.deactivate()},e.PageDots=s,e}),function(t,n){"function"==typeof define&&define.amd?define("flickity/js/player",["ev-emitter/ev-emitter","fizzy-ui-utils/utils","./flickity"],function(t,e,i){return n(t,e,i)}):"object"==typeof module&&module.exports?module.exports=n(require("ev-emitter"),require("fizzy-ui-utils"),require("./flickity")):n(t.EvEmitter,t.fizzyUIUtils,t.Flickity)}(window,function(t,e,i){function n(t){this.parent=t,this.state="stopped",this.onVisibilityChange=this.visibilityChange.bind(this),this.onVisibilityPlay=this.visibilityPlay.bind(this)}(n.prototype=Object.create(t.prototype)).play=function(){"playing"!=this.state&&(document.hidden?document.addEventListener("visibilitychange",this.onVisibilityPlay):(this.state="playing",document.addEventListener("visibilitychange",this.onVisibilityChange),this.tick()))},n.prototype.tick=function(){if("playing"==this.state){var t=this.parent.options.autoPlay;t="number"==typeof t?t:3e3;var e=this;this.clear(),this.timeout=setTimeout(function(){e.parent.next(!0),e.tick()},t)}},n.prototype.stop=function(){this.state="stopped",this.clear(),document.removeEventListener("visibilitychange",this.onVisibilityChange)},n.prototype.clear=function(){clearTimeout(this.timeout)},n.prototype.pause=function(){"playing"==this.state&&(this.state="paused",this.clear())},n.prototype.unpause=function(){"paused"==this.state&&this.play()},n.prototype.visibilityChange=function(){this[document.hidden?"pause":"unpause"]()},n.prototype.visibilityPlay=function(){this.play(),document.removeEventListener("visibilitychange",this.onVisibilityPlay)},e.extend(i.defaults,{pauseAutoPlayOnHover:!0}),i.createMethods.push("_createPlayer");var s=i.prototype;return s._createPlayer=function(){this.player=new n(this),this.on("activate",this.activatePlayer),this.on("uiChange",this.stopPlayer),this.on("pointerDown",this.stopPlayer),this.on("deactivate",this.deactivatePlayer)},s.activatePlayer=function(){this.options.autoPlay&&(this.player.play(),this.element.addEventListener("mouseenter",this))},s.playPlayer=function(){this.player.play()},s.stopPlayer=function(){this.player.stop()},s.pausePlayer=function(){this.player.pause()},s.unpausePlayer=function(){this.player.unpause()},s.deactivatePlayer=function(){this.player.stop(),this.element.removeEventListener("mouseenter",this)},s.onmouseenter=function(){this.options.pauseAutoPlayOnHover&&(this.player.pause(),this.element.addEventListener("mouseleave",this))},s.onmouseleave=function(){this.player.unpause(),this.element.removeEventListener("mouseleave",this)},i.Player=n,i}),function(i,n){"function"==typeof define&&define.amd?define("flickity/js/add-remove-cell",["./flickity","fizzy-ui-utils/utils"],function(t,e){return n(i,t,e)}):"object"==typeof module&&module.exports?module.exports=n(i,require("./flickity"),require("fizzy-ui-utils")):n(i,i.Flickity,i.fizzyUIUtils)}(window,function(t,e,n){var i=e.prototype;return i.insert=function(t,e){var i=this._makeCells(t);if(i&&i.length){var n=this.cells.length;e=void 0===e?n:e;var s=function(t){var e=document.createDocumentFragment();return t.forEach(function(t){e.appendChild(t.element)}),e}(i),o=e==n;if(o)this.slider.appendChild(s);else{var r=this.cells[e].element;this.slider.insertBefore(s,r)}if(0===e)this.cells=i.concat(this.cells);else if(o)this.cells=this.cells.concat(i);else{var a=this.cells.splice(e,n-e);this.cells=this.cells.concat(i).concat(a)}this._sizeCells(i),this.cellChange(e,!0)}},i.append=function(t){this.insert(t,this.cells.length)},i.prepend=function(t){this.insert(t,0)},i.remove=function(t){var e=this.getCells(t);if(e&&e.length){var i=this.cells.length-1;e.forEach(function(t){t.remove();var e=this.cells.indexOf(t);i=Math.min(e,i),n.removeFrom(this.cells,t)},this),this.cellChange(i,!0)}},i.cellSizeChange=function(t){var e=this.getCell(t);if(e){e.getSize();var i=this.cells.indexOf(e);this.cellChange(i)}},i.cellChange=function(t,e){var i=this.selectedElement;this._positionCells(t),this._getWrapShiftCells(),this.setGallerySize();var n=this.getCell(i);n&&(this.selectedIndex=this.getCellSlideIndex(n)),this.selectedIndex=Math.min(this.slides.length-1,this.selectedIndex),this.emitEvent("cellChange",[t]),this.select(this.selectedIndex),e&&this.positionSliderAtSelected()},e}),function(i,n){"function"==typeof define&&define.amd?define("flickity/js/lazyload",["./flickity","fizzy-ui-utils/utils"],function(t,e){return n(i,t,e)}):"object"==typeof module&&module.exports?module.exports=n(i,require("./flickity"),require("fizzy-ui-utils")):n(i,i.Flickity,i.fizzyUIUtils)}(window,function(t,e,o){"use strict";e.createMethods.push("_createLazyload");var i=e.prototype;function s(t,e){this.img=t,this.flickity=e,this.load()}return i._createLazyload=function(){this.on("select",this.lazyLoad)},i.lazyLoad=function(){var t=this.options.lazyLoad;if(t){var e="number"==typeof t?t:0,i=this.getAdjacentCellElements(e),n=[];i.forEach(function(t){var e=function(t){if("IMG"==t.nodeName){var e=t.getAttribute("data-flickity-lazyload"),i=t.getAttribute("data-flickity-lazyload-src"),n=t.getAttribute("data-flickity-lazyload-srcset");if(e||i||n)return[t]}var s=t.querySelectorAll("img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]");return o.makeArray(s)}(t);n=n.concat(e)}),n.forEach(function(t){new s(t,this)},this)}},s.prototype.handleEvent=o.handleEvent,s.prototype.load=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this);var t=this.img.getAttribute("data-flickity-lazyload")||this.img.getAttribute("data-flickity-lazyload-src"),e=this.img.getAttribute("data-flickity-lazyload-srcset");this.img.src=t,e&&this.img.setAttribute("srcset",e),this.img.removeAttribute("data-flickity-lazyload"),this.img.removeAttribute("data-flickity-lazyload-src"),this.img.removeAttribute("data-flickity-lazyload-srcset")},s.prototype.onload=function(t){this.complete(t,"flickity-lazyloaded")},s.prototype.onerror=function(t){this.complete(t,"flickity-lazyerror")},s.prototype.complete=function(t,e){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this);var i=this.flickity.getParentCell(this.img),n=i&&i.element;this.flickity.cellSizeChange(n),this.img.classList.add(e),this.flickity.dispatchEvent("lazyLoad",t,n)},e.LazyLoader=s,e}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/index",["./flickity","./drag","./prev-next-button","./page-dots","./player","./add-remove-cell","./lazyload"],e):"object"==typeof module&&module.exports&&(module.exports=e(require("./flickity"),require("./drag"),require("./prev-next-button"),require("./page-dots"),require("./player"),require("./add-remove-cell"),require("./lazyload")))}(window,function(t){return t}),function(t,e){"function"==typeof define&&define.amd?define("flickity-as-nav-for/as-nav-for",["flickity/js/index","fizzy-ui-utils/utils"],e):"object"==typeof module&&module.exports?module.exports=e(require("flickity"),require("fizzy-ui-utils")):t.Flickity=e(t.Flickity,t.fizzyUIUtils)}(window,function(n,s){n.createMethods.push("_createAsNavFor");var t=n.prototype;return t._createAsNavFor=function(){this.on("activate",this.activateAsNavFor),this.on("deactivate",this.deactivateAsNavFor),this.on("destroy",this.destroyAsNavFor);var t=this.options.asNavFor;if(t){var e=this;setTimeout(function(){e.setNavCompanion(t)})}},t.setNavCompanion=function(t){t=s.getQueryElement(t);var e=n.data(t);if(e&&e!=this){this.navCompanion=e;var i=this;this.onNavCompanionSelect=function(){i.navCompanionSelect()},e.on("select",this.onNavCompanionSelect),this.on("staticClick",this.onNavStaticClick),this.navCompanionSelect(!0)}},t.navCompanionSelect=function(t){var e=this.navCompanion&&this.navCompanion.selectedCells;if(e){var i=e[0],n=this.navCompanion.cells.indexOf(i),s=n+e.length-1,o=Math.floor(function(t,e,i){return(e-t)*i+t}(n,s,this.navCompanion.cellAlign));if(this.selectCell(o,!1,t),this.removeNavSelectedElements(),!(o>=this.cells.length)){var r=this.cells.slice(n,1+s);this.navSelectedElements=r.map(function(t){return t.element}),this.changeNavSelectedClass("add")}}},t.changeNavSelectedClass=function(e){this.navSelectedElements.forEach(function(t){t.classList[e]("is-nav-selected")})},t.activateAsNavFor=function(){this.navCompanionSelect(!0)},t.removeNavSelectedElements=function(){this.navSelectedElements&&(this.changeNavSelectedClass("remove"),delete this.navSelectedElements)},t.onNavStaticClick=function(t,e,i,n){"number"==typeof n&&this.navCompanion.selectCell(n)},t.deactivateAsNavFor=function(){this.removeNavSelectedElements()},t.destroyAsNavFor=function(){this.navCompanion&&(this.navCompanion.off("select",this.onNavCompanionSelect),this.off("staticClick",this.onNavStaticClick),delete this.navCompanion)},n}),function(e,i){"use strict";"function"==typeof define&&define.amd?define("imagesloaded/imagesloaded",["ev-emitter/ev-emitter"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("ev-emitter")):e.imagesLoaded=i(e,e.EvEmitter)}("undefined"!=typeof window?window:this,function(e,t){var s=e.jQuery,o=e.console;function r(t,e){for(var i in e)t[i]=e[i];return t}var a=Array.prototype.slice;function l(t,e,i){if(!(this instanceof l))return new l(t,e,i);var n=t;"string"==typeof t&&(n=document.querySelectorAll(t)),n?(this.elements=function(t){return Array.isArray(t)?t:"object"==typeof t&&"number"==typeof t.length?a.call(t):[t]}(n),this.options=r({},this.options),"function"==typeof e?i=e:r(this.options,e),i&&this.on("always",i),this.getImages(),s&&(this.jqDeferred=new s.Deferred),setTimeout(this.check.bind(this))):o.error("Bad element for imagesLoaded "+(n||t))}(l.prototype=Object.create(t.prototype)).options={},l.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},l.prototype.addElementImages=function(t){"IMG"==t.nodeName&&this.addImage(t),!0===this.options.background&&this.addElementBackgroundImages(t);var e=t.nodeType;if(e&&h[e]){for(var i=t.querySelectorAll("img"),n=0;n<i.length;n++){var s=i[n];this.addImage(s)}if("string"==typeof this.options.background){var o=t.querySelectorAll(this.options.background);for(n=0;n<o.length;n++){var r=o[n];this.addElementBackgroundImages(r)}}}};var h={1:!0,9:!0,11:!0};function i(t){this.img=t}function n(t,e){this.url=t,this.element=e,this.img=new Image}return l.prototype.addElementBackgroundImages=function(t){var e=getComputedStyle(t);if(e)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(e.backgroundImage);null!==n;){var s=n&&n[2];s&&this.addBackground(s,t),n=i.exec(e.backgroundImage)}},l.prototype.addImage=function(t){var e=new i(t);this.images.push(e)},l.prototype.addBackground=function(t,e){var i=new n(t,e);this.images.push(i)},l.prototype.check=function(){var n=this;function e(t,e,i){setTimeout(function(){n.progress(t,e,i)})}this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?this.images.forEach(function(t){t.once("progress",e),t.check()}):this.complete()},l.prototype.progress=function(t,e,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!t.isLoaded,this.emitEvent("progress",[this,t,e]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,t),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&o&&o.log("progress: "+i,t,e)},l.prototype.complete=function(){var t=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(t,[this]),this.emitEvent("always",[this]),this.jqDeferred){var e=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[e](this)}},(i.prototype=Object.create(t.prototype)).check=function(){this.getIsImageComplete()?this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.proxyImage.src=this.img.src)},i.prototype.getIsImageComplete=function(){return this.img.complete&&this.img.naturalWidth},i.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.img,e])},i.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},i.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},i.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},i.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},(n.prototype=Object.create(i.prototype)).check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url,this.getIsImageComplete()&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},n.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},n.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.element,e])},l.makeJQueryPlugin=function(t){(t=t||e.jQuery)&&((s=t).fn.imagesLoaded=function(t,e){return new l(this,t,e).jqDeferred.promise(s(this))})},l.makeJQueryPlugin(),l}),function(i,n){"function"==typeof define&&define.amd?define(["flickity/js/index","imagesloaded/imagesloaded"],function(t,e){return n(i,t,e)}):"object"==typeof module&&module.exports?module.exports=n(i,require("flickity"),require("imagesloaded")):i.Flickity=n(i,i.Flickity,i.imagesLoaded)}(window,function(t,e,i){"use strict";e.createMethods.push("_createImagesLoaded");var n=e.prototype;return n._createImagesLoaded=function(){this.on("activate",this.imagesLoaded)},n.imagesLoaded=function(){if(this.options.imagesLoaded){var n=this;i(this.slider).on("progress",function(t,e){var i=n.getParentCell(e.img);n.cellSizeChange(i&&i.element),n.options.freeScroll||n.positionSliderAtSelected()})}},e});

  /**
   * Flickity fade v1.0.0
   * Fade between Flickity slides
   */

  /* jshint browser: true, undef: true, unused: true */

  ( function( window, factory ) {
    // universal module definition
    /*globals define, module, require */
    if ( typeof define == 'function' && define.amd ) {
      // AMD
      define( [
        'flickity/js/index',
        'fizzy-ui-utils/utils',
      ], factory );
    } else if ( typeof module == 'object' && module.exports ) {
      // CommonJS
      module.exports = factory(
        require('flickity'),
        require('fizzy-ui-utils')
      );
    } else {
      // browser global
      factory(
        window.Flickity,
        window.fizzyUIUtils
      );
    }

  }( this, function factory( Flickity, utils ) {

  // ---- Slide ---- //

  var Slide = Flickity.Slide;

  var slideUpdateTarget = Slide.prototype.updateTarget;
  Slide.prototype.updateTarget = function() {
    slideUpdateTarget.apply( this, arguments );
    if ( !this.parent.options.fade ) {
      return;
    }
    // position cells at selected target
    var slideTargetX = this.target - this.x;
    var firstCellX = this.cells[0].x;
    this.cells.forEach( function( cell ) {
      var targetX = cell.x - firstCellX - slideTargetX;
      cell.renderPosition( targetX );
    });
  };

  Slide.prototype.setOpacity = function( alpha ) {
    this.cells.forEach( function( cell ) {
      cell.element.style.opacity = alpha;
    });
  };

  // ---- Flickity ---- //

  var proto = Flickity.prototype;

  Flickity.createMethods.push('_createFade');

  proto._createFade = function() {
    this.fadeIndex = this.selectedIndex;
    this.prevSelectedIndex = this.selectedIndex;
    this.on( 'select', this.onSelectFade );
    this.on( 'dragEnd', this.onDragEndFade );
    this.on( 'settle', this.onSettleFade );
    this.on( 'activate', this.onActivateFade );
    this.on( 'deactivate', this.onDeactivateFade );
  };

  var updateSlides = proto.updateSlides;
  proto.updateSlides = function() {
    updateSlides.apply( this, arguments );
    if ( !this.options.fade ) {
      return;
    }
    // set initial opacity
    this.slides.forEach( function( slide, i ) {
      var alpha = i == this.selectedIndex ? 1 : 0;
      slide.setOpacity( alpha );
    }, this );
  };

  /* ---- events ---- */

  proto.onSelectFade = function() {
    // in case of resize, keep fadeIndex within current count
    this.fadeIndex = Math.min( this.prevSelectedIndex, this.slides.length - 1 );
    this.prevSelectedIndex = this.selectedIndex;
  };

  proto.onSettleFade = function() {
    delete this.didDragEnd;
    if ( !this.options.fade ) {
      return;
    }
    // set full and 0 opacity on selected & faded slides
    this.selectedSlide.setOpacity( 1 );
    var fadedSlide = this.slides[ this.fadeIndex ];
    if ( fadedSlide && this.fadeIndex != this.selectedIndex ) {
      this.slides[ this.fadeIndex ].setOpacity( 0 );
    }
  };

  proto.onDragEndFade = function() {
    // set flag
    this.didDragEnd = true;
  };

  proto.onActivateFade = function() {
    if ( this.options.fade ) {
      this.element.classList.add('is-fade');
    }
  };

  proto.onDeactivateFade = function() {
    if ( !this.options.fade ) {
      return;
    }
    this.element.classList.remove('is-fade');
    // reset opacity
    this.slides.forEach( function( slide ) {
      slide.setOpacity('');
    });
  };

  /* ---- position & fading ---- */

  var positionSlider = proto.positionSlider;
  proto.positionSlider = function() {
    if ( !this.options.fade ) {
      positionSlider.apply( this, arguments );
      return;
    }

    this.fadeSlides();
    this.dispatchScrollEvent();
  };

  var positionSliderAtSelected = proto.positionSliderAtSelected;
  proto.positionSliderAtSelected = function() {
    if ( this.options.fade ) {
      // position fade slider at origin
      this.setTranslateX( 0 );
    }
    positionSliderAtSelected.apply( this, arguments );
  };

  proto.fadeSlides = function() {
    if ( this.slides.length < 2 ) {
      return;
    }
    // get slides to fade-in & fade-out
    var indexes = this.getFadeIndexes();
    var fadeSlideA = this.slides[ indexes.a ];
    var fadeSlideB = this.slides[ indexes.b ];
    var distance = this.wrapDifference( fadeSlideA.target, fadeSlideB.target );
    var progress = this.wrapDifference( fadeSlideA.target, -this.x );
    progress = progress / distance;

    fadeSlideA.setOpacity( 1 - progress );
    fadeSlideB.setOpacity( progress );

    // hide previous slide
    var fadeHideIndex = indexes.a;
    if ( this.isDragging ) {
      fadeHideIndex = progress > 0.5 ? indexes.a : indexes.b;
    }
    var isNewHideIndex = this.fadeHideIndex != undefined &&
      this.fadeHideIndex != fadeHideIndex &&
      this.fadeHideIndex != indexes.a &&
      this.fadeHideIndex != indexes.b;
    if ( isNewHideIndex ) {
      // new fadeHideSlide set, hide previous
      this.slides[ this.fadeHideIndex ].setOpacity( 0 );
    }
    this.fadeHideIndex = fadeHideIndex;
  };

  proto.getFadeIndexes = function() {
    if ( !this.isDragging && !this.didDragEnd ) {
      return {
        a: this.fadeIndex,
        b: this.selectedIndex,
      };
    }
    if ( this.options.wrapAround ) {
      return this.getFadeDragWrapIndexes();
    } else {
      return this.getFadeDragLimitIndexes();
    }
  };

  proto.getFadeDragWrapIndexes = function() {
    var distances = this.slides.map( function( slide, i ) {
      return this.getSlideDistance( -this.x, i );
    }, this );
    var absDistances = distances.map( function( distance ) {
      return Math.abs( distance );
    });
    var minDistance = Math.min.apply( Math, absDistances );
    var closestIndex = absDistances.indexOf( minDistance );
    var distance = distances[ closestIndex ];
    var len = this.slides.length;

    var delta = distance >= 0 ? 1 : -1;
    return {
      a: closestIndex,
      b: utils.modulo( closestIndex + delta, len ),
    };
  };

  proto.getFadeDragLimitIndexes = function() {
    // calculate closest previous slide
    var dragIndex = 0;
    for ( var i=0; i < this.slides.length - 1; i++ ) {
      var slide = this.slides[i];
      if ( -this.x < slide.target ) {
        break;
      }
      dragIndex = i;
    }
    return {
      a: dragIndex,
      b: dragIndex + 1,
    };
  };

  proto.wrapDifference = function( a, b ) {
    var diff = b - a;

    if ( !this.options.wrapAround ) {
      return diff;
    }

    var diffPlus = diff + this.slideableWidth;
    var diffMinus = diff - this.slideableWidth;
    if ( Math.abs( diffPlus ) < Math.abs( diff ) ) {
      diff = diffPlus;
    }
    if ( Math.abs( diffMinus ) < Math.abs( diff ) ) {
      diff = diffMinus;
    }
    return diff;
  };

  // ---- wrapAround ---- //

  var _getWrapShiftCells = proto._getWrapShiftCells;
  proto._getWrapShiftCells = function() {
    if ( !this.options.fade ) {
      _getWrapShiftCells.apply( this, arguments );
    }
  };

  var shiftWrapCells = proto.shiftWrapCells;
  proto.shiftWrapCells = function() {
    if ( !this.options.fade ) {
      shiftWrapCells.apply( this, arguments );
    }
  };

  return Flickity;

  }));

  /*!
 * Flickity sync v2.0.0
 * enable sync for Flickity
 */

/*jshint browser: true, undef: true, unused: true, strict: true*/

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'flickity/js/index',
      'fizzy-ui-utils/utils'
    ], factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('flickity'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = factory(
      window.Flickity,
      window.fizzyUIUtils
    );
  }

}( window, function factory( Flickity, utils ) {

'use strict';

  // -------------------------- sync prototype -------------------------- //

  // Flickity.defaults.sync = false;

  Flickity.createMethods.push('_createSync');

  Flickity.prototype._createSync = function() {
    this.syncers = {};
    var syncOption = this.options.sync;

    this.on( 'destroy', this.unsyncAll );

    if ( !syncOption ) {
      return;
    }
    // HACK do async, give time for other flickity to be initalized
    var _this = this;
    setTimeout( function initSyncCompanion() {
      _this.sync( syncOption );
    });
  };

  /**
   * sync
   * @param {Element} or {String} elem
   */
  Flickity.prototype.sync = function( elem ) {
    elem = utils.getQueryElement( elem );
    var companion = Flickity.data( elem );
    if ( !companion ) {
      return;
    }
    // two hearts, that beat as one
    this._syncCompanion( companion );
    companion._syncCompanion( this );
  };

  /**
   * @param {Flickity} companion
   */
  Flickity.prototype._syncCompanion = function( companion ) {
    var _this = this;
    function syncListener() {
      var index = _this.selectedIndex;
      // do not select if already selected, prevent infinite loop
      if ( companion.selectedIndex != index ) {
        companion.select( index );
      }
    }
    this.on( 'select', syncListener );
    // keep track of all synced flickities
    // hold on to listener to unsync
    this.syncers[ companion.guid ] = {
      flickity: companion,
      listener: syncListener
    };
  };

  /**
   * unsync
   * @param {Element} or {String} elem
   */
  Flickity.prototype.unsync = function( elem ) {
    elem = utils.getQueryElement( elem );
    var companion = Flickity.data( elem );
    this._unsync( companion );
  };

  /**
   * @param {Flickity} companion
   */
  Flickity.prototype._unsync = function( companion ) {
    if ( !companion ) {
      return;
    }
    // I love you but I've chosen darkness
    this._unsyncCompanion( companion );
    companion._unsyncCompanion( this );
  };

  /**
   * @param {Flickity} companion
   */
  Flickity.prototype._unsyncCompanion = function( companion ) {
    var id = companion.guid;
    var syncer = this.syncers[ id ];
    this.off( 'select', syncer.listener );
    delete this.syncers[ id ];
  };

  Flickity.prototype.unsyncAll = function() {
    for ( var id in this.syncers ) {
      var syncer = this.syncers[ id ];
      this._unsync( syncer.flickity );
    }
  };

  // -----  ----- //

  return Flickity;

  }));
})();
(function vendorFlexslider() {

  /*
   * jQuery FlexSlider v2.7.2
   * Copyright 2012 WooThemes
   * Contributing Author: Tyler Smith
   */
  ;
  (function ($) {

    var focused = true;

    //FlexSlider: Object Instance
    $.flexslider = function(el, options) {
      var slider = $(el);

      // making variables public

      //if rtl value was not passed and html is in rtl..enable it by default.
      if(typeof options.rtl=='undefined' && $('html').attr('dir')=='rtl'){
        options.rtl=true;
      }
      slider.vars = $.extend({}, $.flexslider.defaults, options);

      var namespace = slider.vars.namespace,
          msGesture = window.navigator && window.navigator.msPointerEnabled && window.MSGesture,
          touch = (( "ontouchstart" in window ) || msGesture || window.DocumentTouch && document instanceof DocumentTouch) && slider.vars.touch,
          // deprecating this idea, as devices are being released with both of these events
          eventType = "click touchend MSPointerUp keyup",
          watchedEvent = "",
          watchedEventClearTimer,
          vertical = slider.vars.direction === "vertical",
          reverse = slider.vars.reverse,
          carousel = (slider.vars.itemWidth > 0),
          fade = slider.vars.animation === "fade",
          asNav = slider.vars.asNavFor !== "",
          methods = {};

      // Store a reference to the slider object
      $.data(el, "flexslider", slider);

      // Private slider methods
      methods = {
        init: function() {
          slider.animating = false;
          // Get current slide and make sure it is a number
          slider.currentSlide = parseInt( ( slider.vars.startAt ? slider.vars.startAt : 0), 10 );
          if ( isNaN( slider.currentSlide ) ) { slider.currentSlide = 0; }
          slider.animatingTo = slider.currentSlide;
          slider.atEnd = (slider.currentSlide === 0 || slider.currentSlide === slider.last);
          slider.containerSelector = slider.vars.selector.substr(0,slider.vars.selector.search(' '));
          slider.slides = $(slider.vars.selector, slider);
          slider.container = $(slider.containerSelector, slider);
          slider.count = slider.slides.length;
          // SYNC:
          slider.syncExists = $(slider.vars.sync).length > 0;
          // SLIDE:
          if (slider.vars.animation === "slide") { slider.vars.animation = "swing"; }
          slider.prop = (vertical) ? "top" : ( slider.vars.rtl ? "marginRight" : "marginLeft" );
          slider.args = {};
          // SLIDESHOW:
          slider.manualPause = false;
          slider.stopped = false;
          //PAUSE WHEN INVISIBLE
          slider.started = false;
          slider.startTimeout = null;
          // TOUCH/USECSS:
          slider.transitions = !slider.vars.video && !fade && slider.vars.useCSS && (function() {
            var obj = document.createElement('div'),
                props = ['perspectiveProperty', 'WebkitPerspective', 'MozPerspective', 'OPerspective', 'msPerspective'];
            for (var i in props) {
              if ( obj.style[ props[i] ] !== undefined ) {
                slider.pfx = props[i].replace('Perspective','').toLowerCase();
                slider.prop = "-" + slider.pfx + "-transform";
                return true;
              }
            }
            return false;
          }());
          slider.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
          slider.ensureAnimationEnd = '';
          // CONTROLSCONTAINER:
          if (slider.vars.controlsContainer !== "") slider.controlsContainer = $(slider.vars.controlsContainer).length > 0 && $(slider.vars.controlsContainer);
          // MANUAL:
          if (slider.vars.manualControls !== "") slider.manualControls = $(slider.vars.manualControls).length > 0 && $(slider.vars.manualControls);

          // CUSTOM DIRECTION NAV:
          if (slider.vars.customDirectionNav !== "") slider.customDirectionNav = $(slider.vars.customDirectionNav).length === 2 && $(slider.vars.customDirectionNav);

          // RANDOMIZE:
          if (slider.vars.randomize) {
            slider.slides.sort(function() { return (Math.round(Math.random())-0.5); });
            slider.container.empty().append(slider.slides);
          }

          slider.doMath();

          // INIT
          slider.setup("init");

          // CONTROLNAV:
          if (slider.vars.controlNav) { methods.controlNav.setup(); }

          // DIRECTIONNAV:
          if (slider.vars.directionNav) { methods.directionNav.setup(); }

          // KEYBOARD:
          if (slider.vars.keyboard && ($(slider.containerSelector).length === 1 || slider.vars.multipleKeyboard)) {
            $(document).bind('keyup', function(event) {
              var keycode = event.keyCode;
              if (!slider.animating && (keycode === 39 || keycode === 37)) {
                var target = (slider.vars.rtl?
                                  ((keycode === 37) ? slider.getTarget('next') :
                                  (keycode === 39) ? slider.getTarget('prev') : false)
                                  :
                                  ((keycode === 39) ? slider.getTarget('next') :
                                  (keycode === 37) ? slider.getTarget('prev') : false)
                                  )
                                  ;
                slider.flexAnimate(target, slider.vars.pauseOnAction);
              }
            });
          }
          // MOUSEWHEEL:
          if (slider.vars.mousewheel) {
            slider.bind('mousewheel', function(event, delta, deltaX, deltaY) {
              event.preventDefault();
              var target = (delta < 0) ? slider.getTarget('next') : slider.getTarget('prev');
              slider.flexAnimate(target, slider.vars.pauseOnAction);
            });
          }

          // PAUSEPLAY
          if (slider.vars.pausePlay) { methods.pausePlay.setup(); }

          //PAUSE WHEN INVISIBLE
          if (slider.vars.slideshow && slider.vars.pauseInvisible) { methods.pauseInvisible.init(); }

          // SLIDSESHOW
          if (slider.vars.slideshow) {
            if (slider.vars.pauseOnHover) {
              slider.hover(function() {
                if (!slider.manualPlay && !slider.manualPause) { slider.pause(); }
              }, function() {
                if (!slider.manualPause && !slider.manualPlay && !slider.stopped) { slider.play(); }
              });
            }
            // initialize animation
            //If we're visible, or we don't use PageVisibility API
            if(!slider.vars.pauseInvisible || !methods.pauseInvisible.isHidden()) {
              (slider.vars.initDelay > 0) ? slider.startTimeout = setTimeout(slider.play, slider.vars.initDelay) : slider.play();
            }
          }

          // ASNAV:
          if (asNav) { methods.asNav.setup(); }

          // TOUCH
          if (touch && slider.vars.touch) { methods.touch(); }

          // FADE&&SMOOTHHEIGHT || SLIDE:
          if (!fade || (fade && slider.vars.smoothHeight)) { $(window).bind("resize orientationchange focus", methods.resize); }

          slider.find("img").attr("draggable", "false");

          // API: start() Callback
          setTimeout(function(){
            slider.vars.start(slider);
          }, 200);
        },
        asNav: {
          setup: function() {
            slider.asNav = true;
            slider.animatingTo = Math.floor(slider.currentSlide/slider.move);
            slider.currentItem = slider.currentSlide;
            slider.slides.removeClass(namespace + "active-slide").eq(slider.currentItem).addClass(namespace + "active-slide");
            if(!msGesture){
                slider.slides.on(eventType, function(e){
                  e.preventDefault();
                  var $slide = $(this),
                      target = $slide.index();
                  var posFromX;
                  if(slider.vars.rtl){
                    posFromX = -1*($slide.offset().right - $(slider).scrollLeft()); // Find position of slide relative to right of slider container
                  }
                  else
                  {
                    posFromX = $slide.offset().left - $(slider).scrollLeft(); // Find position of slide relative to left of slider container
                  }
                  if( posFromX <= 0 && $slide.hasClass( namespace + 'active-slide' ) ) {
                    slider.flexAnimate(slider.getTarget("prev"), true);
                  } else if (!$(slider.vars.asNavFor).data('flexslider').animating && !$slide.hasClass(namespace + "active-slide")) {
                    slider.direction = (slider.currentItem < target) ? "next" : "prev";
                    slider.flexAnimate(target, slider.vars.pauseOnAction, false, true, true);
                  }
                });
            }else{
                el._slider = slider;
                slider.slides.each(function (){
                    var that = this;
                    that._gesture = new MSGesture();
                    that._gesture.target = that;
                    that.addEventListener("MSPointerDown", function (e){
                        e.preventDefault();
                        if(e.currentTarget._gesture) {
                          e.currentTarget._gesture.addPointer(e.pointerId);
                        }
                    }, false);
                    that.addEventListener("MSGestureTap", function (e){
                        e.preventDefault();
                        var $slide = $(this),
                            target = $slide.index();
                        if (!$(slider.vars.asNavFor).data('flexslider').animating && !$slide.hasClass('active')) {
                            slider.direction = (slider.currentItem < target) ? "next" : "prev";
                            slider.flexAnimate(target, slider.vars.pauseOnAction, false, true, true);
                        }
                    });
                });
            }
          }
        },
        controlNav: {
          setup: function() {
            if (!slider.manualControls) {
              methods.controlNav.setupPaging();
            } else { // MANUALCONTROLS:
              methods.controlNav.setupManual();
            }
          },
          setupPaging: function() {
            var type = (slider.vars.controlNav === "thumbnails") ? 'control-thumbs' : 'control-paging',
                j = 1,
                item,
                slide;

            slider.controlNavScaffold = $('<ol class="'+ namespace + 'control-nav ' + namespace + type + '"></ol>');

            if (slider.pagingCount > 1) {
              for (var i = 0; i < slider.pagingCount; i++) {
                slide = slider.slides.eq(i);

                if ( undefined === slide.attr( 'data-thumb-alt' ) ) {
                  slide.attr( 'data-thumb-alt', '' );
                }

                item = $( '<a></a>' ).attr( 'href', '#' ).text( j );
                if ( slider.vars.controlNav === "thumbnails" ) {
                  item = $( '<img/>' ).attr( 'src', slide.attr( 'data-thumb' ) );
                }

                if ( '' !== slide.attr( 'data-thumb-alt' ) ) {
                  item.attr( 'alt', slide.attr( 'data-thumb-alt' ) );
                }

                if ( 'thumbnails' === slider.vars.controlNav && true === slider.vars.thumbCaptions ) {
                  var captn = slide.attr( 'data-thumbcaption' );
                  if ( '' !== captn && undefined !== captn ) {
                    var caption = $('<span></span>' ).addClass( namespace + 'caption' ).text( captn );
                    item.append( caption );
                  }
                }

                var liElement = $( '<li>' );
                item.appendTo( liElement );
                liElement.append( '</li>' );

                slider.controlNavScaffold.append(liElement);
                j++;

              }
            }

            // CONTROLSCONTAINER:
            (slider.controlsContainer) ? $(slider.controlsContainer).append(slider.controlNavScaffold) : slider.append(slider.controlNavScaffold);
            methods.controlNav.set();

            methods.controlNav.active();

            slider.controlNavScaffold.delegate('a, img', eventType, function(event) {
              event.preventDefault();

              if (watchedEvent === "" || watchedEvent === event.type) {
                var $this = $(this),
                    target = slider.controlNav.index($this);

                if (!$this.hasClass(namespace + 'active')) {
                  slider.direction = (target > slider.currentSlide) ? "next" : "prev";
                  slider.flexAnimate(target, slider.vars.pauseOnAction);
                }
              }

              // setup flags to prevent event duplication
              if (watchedEvent === "") {
                watchedEvent = event.type;
              }
              methods.setToClearWatchedEvent();

            });
          },
          setupManual: function() {
            slider.controlNav = slider.manualControls;
            methods.controlNav.active();

            slider.controlNav.bind(eventType, function(event) {
              event.preventDefault();

              if (watchedEvent === "" || watchedEvent === event.type) {
                var $this = $(this),
                    target = slider.controlNav.index($this);

                if (!$this.hasClass(namespace + 'active')) {
                  (target > slider.currentSlide) ? slider.direction = "next" : slider.direction = "prev";
                  slider.flexAnimate(target, slider.vars.pauseOnAction);
                }
              }

              // setup flags to prevent event duplication
              if (watchedEvent === "") {
                watchedEvent = event.type;
              }
              methods.setToClearWatchedEvent();
            });
          },
          set: function() {
            var selector = (slider.vars.controlNav === "thumbnails") ? 'img' : 'a';
            slider.controlNav = $('.' + namespace + 'control-nav li ' + selector, (slider.controlsContainer) ? slider.controlsContainer : slider);
          },
          active: function() {
            slider.controlNav.removeClass(namespace + "active").eq(slider.animatingTo).addClass(namespace + "active");
          },
          update: function(action, pos) {
            if (slider.pagingCount > 1 && action === "add") {
              slider.controlNavScaffold.append($('<li><a href="#">' + slider.count + '</a></li>'));
            } else if (slider.pagingCount === 1) {
              slider.controlNavScaffold.find('li').remove();
            } else {
              slider.controlNav.eq(pos).closest('li').remove();
            }
            methods.controlNav.set();
            (slider.pagingCount > 1 && slider.pagingCount !== slider.controlNav.length) ? slider.update(pos, action) : methods.controlNav.active();
          }
        },
        directionNav: {
          setup: function() {
            var directionNavScaffold = $('<ul class="' + namespace + 'direction-nav"><li class="' + namespace + 'nav-prev"><a class="' + namespace + 'prev" href="#">' + slider.vars.prevText + '</a></li><li class="' + namespace + 'nav-next"><a class="' + namespace + 'next" href="#">' + slider.vars.nextText + '</a></li></ul>');

            // CUSTOM DIRECTION NAV:
            if (slider.customDirectionNav) {
              slider.directionNav = slider.customDirectionNav;
            // CONTROLSCONTAINER:
            } else if (slider.controlsContainer) {
              $(slider.controlsContainer).append(directionNavScaffold);
              slider.directionNav = $('.' + namespace + 'direction-nav li a', slider.controlsContainer);
            } else {
              slider.append(directionNavScaffold);
              slider.directionNav = $('.' + namespace + 'direction-nav li a', slider);
            }

            methods.directionNav.update();

            slider.directionNav.bind(eventType, function(event) {
              event.preventDefault();
              var target;

              if (watchedEvent === "" || watchedEvent === event.type) {
                target = ($(this).hasClass(namespace + 'next')) ? slider.getTarget('next') : slider.getTarget('prev');
                slider.flexAnimate(target, slider.vars.pauseOnAction);
              }

              // setup flags to prevent event duplication
              if (watchedEvent === "") {
                watchedEvent = event.type;
              }
              methods.setToClearWatchedEvent();
            });
          },
          update: function() {
            var disabledClass = namespace + 'disabled';
            if (slider.pagingCount === 1) {
              slider.directionNav.addClass(disabledClass).attr('tabindex', '-1');
            } else if (!slider.vars.animationLoop) {
              if (slider.animatingTo === 0) {
                slider.directionNav.removeClass(disabledClass).filter('.' + namespace + "prev").addClass(disabledClass).attr('tabindex', '-1');
              } else if (slider.animatingTo === slider.last) {
                slider.directionNav.removeClass(disabledClass).filter('.' + namespace + "next").addClass(disabledClass).attr('tabindex', '-1');
              } else {
                // slider.directionNav.removeClass(disabledClass).removeAttr('tabindex');
              }
            } else {
              // slider.directionNav.removeClass(disabledClass).removeAttr('tabindex');
            }
          }
        },
        pausePlay: {
          setup: function() {
            var pausePlayScaffold = $('<div class="' + namespace + 'pauseplay"><a href="#"></a></div>');

            // CONTROLSCONTAINER:
            if (slider.controlsContainer) {
              slider.controlsContainer.append(pausePlayScaffold);
              slider.pausePlay = $('.' + namespace + 'pauseplay a', slider.controlsContainer);
            } else {
              slider.append(pausePlayScaffold);
              slider.pausePlay = $('.' + namespace + 'pauseplay a', slider);
            }

            methods.pausePlay.update((slider.vars.slideshow) ? namespace + 'pause' : namespace + 'play');

            slider.pausePlay.bind(eventType, function(event) {
              event.preventDefault();

              if (watchedEvent === "" || watchedEvent === event.type) {
                if ($(this).hasClass(namespace + 'pause')) {
                  slider.manualPause = true;
                  slider.manualPlay = false;
                  slider.pause();
                } else {
                  slider.manualPause = false;
                  slider.manualPlay = true;
                  slider.play();
                }
              }

              // setup flags to prevent event duplication
              if (watchedEvent === "") {
                watchedEvent = event.type;
              }
              methods.setToClearWatchedEvent();
            });
          },
          update: function(state) {
            (state === "play") ? slider.pausePlay.removeClass(namespace + 'pause').addClass(namespace + 'play').html(slider.vars.playText) : slider.pausePlay.removeClass(namespace + 'play').addClass(namespace + 'pause').html(slider.vars.pauseText);
          }
        },
        touch: function() {
          var startX,
            startY,
            offset,
            cwidth,
            dx,
            startT,
            onTouchStart,
            onTouchMove,
            onTouchEnd,
            scrolling = false,
            localX = 0,
            localY = 0,
            accDx = 0;

          if(!msGesture){
              onTouchStart = function(e) {
                if (slider.animating) {
                  e.preventDefault();
                } else if ( ( window.navigator.msPointerEnabled ) || e.touches.length === 1 ) {
                  slider.pause();
                  // CAROUSEL:
                  cwidth = (vertical) ? slider.h : slider. w;
                  startT = Number(new Date());
                  // CAROUSEL:

                  // Local vars for X and Y points.
                  localX = e.touches[0].pageX;
                  localY = e.touches[0].pageY;

                  offset = (carousel && reverse && slider.animatingTo === slider.last) ? 0 :
                           (carousel && reverse) ? slider.limit - (((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo) :
                           (carousel && slider.currentSlide === slider.last) ? slider.limit :
                           (carousel) ? ((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.currentSlide :
                           (reverse) ? (slider.last - slider.currentSlide + slider.cloneOffset) * cwidth : (slider.currentSlide + slider.cloneOffset) * cwidth;
                  startX = (vertical) ? localY : localX;
                  startY = (vertical) ? localX : localY;
                  el.addEventListener('touchmove', onTouchMove, false);
                  el.addEventListener('touchend', onTouchEnd, false);
                }
              };

              onTouchMove = function(e) {
                // Local vars for X and Y points.

                localX = e.touches[0].pageX;
                localY = e.touches[0].pageY;

                dx = (vertical) ? startX - localY : (slider.vars.rtl?-1:1)*(startX - localX);
                scrolling = (vertical) ? (Math.abs(dx) < Math.abs(localX - startY)) : (Math.abs(dx) < Math.abs(localY - startY));
                var fxms = 500;

                if ( ! scrolling || Number( new Date() ) - startT > fxms ) {
                  e.preventDefault();
                  if (!fade && slider.transitions) {
                    if (!slider.vars.animationLoop) {
                      dx = dx/((slider.currentSlide === 0 && dx < 0 || slider.currentSlide === slider.last && dx > 0) ? (Math.abs(dx)/cwidth+2) : 1);
                    }
                    slider.setProps(offset + dx, "setTouch");
                  }
                }
              };

              onTouchEnd = function(e) {
                // finish the touch by undoing the touch session
                el.removeEventListener('touchmove', onTouchMove, false);

                if (slider.animatingTo === slider.currentSlide && !scrolling && !(dx === null)) {
                  var updateDx = (reverse) ? -dx : dx,
                      target = (updateDx > 0) ? slider.getTarget('next') : slider.getTarget('prev');

                  if (slider.canAdvance(target) && (Number(new Date()) - startT < 550 && Math.abs(updateDx) > 50 || Math.abs(updateDx) > cwidth/2)) {
                    slider.flexAnimate(target, slider.vars.pauseOnAction);
                  } else {
                    if (!fade) { slider.flexAnimate(slider.currentSlide, slider.vars.pauseOnAction, true); }
                  }
                }
                el.removeEventListener('touchend', onTouchEnd, false);

                startX = null;
                startY = null;
                dx = null;
                offset = null;
              };

              el.addEventListener('touchstart', onTouchStart, false);
          }else{
              el.style.msTouchAction = "none";
              el._gesture = new MSGesture();
              el._gesture.target = el;
              el.addEventListener("MSPointerDown", onMSPointerDown, false);
              el._slider = slider;
              el.addEventListener("MSGestureChange", onMSGestureChange, false);
              el.addEventListener("MSGestureEnd", onMSGestureEnd, false);

              function onMSPointerDown(e){
                  e.stopPropagation();
                  if (slider.animating) {
                      e.preventDefault();
                  }else{
                      slider.pause();
                      el._gesture.addPointer(e.pointerId);
                      accDx = 0;
                      cwidth = (vertical) ? slider.h : slider. w;
                      startT = Number(new Date());
                      // CAROUSEL:

                      offset = (carousel && reverse && slider.animatingTo === slider.last) ? 0 :
                          (carousel && reverse) ? slider.limit - (((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo) :
                              (carousel && slider.currentSlide === slider.last) ? slider.limit :
                                  (carousel) ? ((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.currentSlide :
                                      (reverse) ? (slider.last - slider.currentSlide + slider.cloneOffset) * cwidth : (slider.currentSlide + slider.cloneOffset) * cwidth;
                  }
              }

              function onMSGestureChange(e) {
                  e.stopPropagation();
                  var slider = e.target._slider;
                  if(!slider){
                      return;
                  }
                  var transX = -e.translationX,
                      transY = -e.translationY;

                  //Accumulate translations.
                  accDx = accDx + ((vertical) ? transY : transX);
                  dx = (slider.vars.rtl?-1:1)*accDx;
                  scrolling = (vertical) ? (Math.abs(accDx) < Math.abs(-transX)) : (Math.abs(accDx) < Math.abs(-transY));

                  if(e.detail === e.MSGESTURE_FLAG_INERTIA){
                      setImmediate(function (){
                          el._gesture.stop();
                      });

                      return;
                  }

                  if (!scrolling || Number(new Date()) - startT > 500) {
                      e.preventDefault();
                      if (!fade && slider.transitions) {
                          if (!slider.vars.animationLoop) {
                              dx = accDx / ((slider.currentSlide === 0 && accDx < 0 || slider.currentSlide === slider.last && accDx > 0) ? (Math.abs(accDx) / cwidth + 2) : 1);
                          }
                          slider.setProps(offset + dx, "setTouch");
                      }
                  }
              }

              function onMSGestureEnd(e) {
                  e.stopPropagation();
                  var slider = e.target._slider;
                  if(!slider){
                      return;
                  }
                  if (slider.animatingTo === slider.currentSlide && !scrolling && !(dx === null)) {
                      var updateDx = (reverse) ? -dx : dx,
                          target = (updateDx > 0) ? slider.getTarget('next') : slider.getTarget('prev');

                      if (slider.canAdvance(target) && (Number(new Date()) - startT < 550 && Math.abs(updateDx) > 50 || Math.abs(updateDx) > cwidth/2)) {
                          slider.flexAnimate(target, slider.vars.pauseOnAction);
                      } else {
                          if (!fade) { slider.flexAnimate(slider.currentSlide, slider.vars.pauseOnAction, true); }
                      }
                  }

                  startX = null;
                  startY = null;
                  dx = null;
                  offset = null;
                  accDx = 0;
              }
          }
        },
        resize: function() {
          if (!slider.animating && slider.is(':visible')) {
            if (!carousel) { slider.doMath(); }

            if (fade) {
              // SMOOTH HEIGHT:
              methods.smoothHeight();
            } else if (carousel) { //CAROUSEL:
              slider.slides.width(slider.computedW);
              slider.update(slider.pagingCount);
              slider.setProps();
            }
            else if (vertical) { //VERTICAL:
              slider.viewport.height(slider.h);
              slider.setProps(slider.h, "setTotal");
            } else {
              // SMOOTH HEIGHT:
              if (slider.vars.smoothHeight) { methods.smoothHeight(); }
              slider.newSlides.width(slider.computedW);
              slider.setProps(slider.computedW, "setTotal");
            }
          }
        },
        smoothHeight: function(dur) {
          if (!vertical || fade) {
            var $obj = (fade) ? slider : slider.viewport;
            (dur) ? $obj.animate({"height": slider.slides.eq(slider.animatingTo).innerHeight()}, dur) : $obj.innerHeight(slider.slides.eq(slider.animatingTo).innerHeight());
          }
        },
        sync: function(action) {
          var $obj = $(slider.vars.sync).data("flexslider"),
              target = slider.animatingTo;

          if (!$obj) return false;

          switch (action) {
            case "animate": $obj.flexAnimate(target, slider.vars.pauseOnAction, false, true); break;
            case "play": if (!$obj.playing && !$obj.asNav) { $obj.play(); } break;
            case "pause": $obj.pause(); break;
          }
        },
        uniqueID: function($clone) {
          // Append _clone to current level and children elements with id attributes
          $clone.filter( '[id]' ).add($clone.find( '[id]' )).each(function() {
            var $this = $(this);
            $this.attr( 'id', $this.attr( 'id' ) + '_clone' );
          });
          return $clone;
        },
        pauseInvisible: {
          visProp: null,
          init: function() {
            var visProp = methods.pauseInvisible.getHiddenProp();
            if (visProp) {
              var evtname = visProp.replace(/[H|h]idden/,'') + 'visibilitychange';
              document.addEventListener(evtname, function() {
                if (methods.pauseInvisible.isHidden()) {
                  if(slider.startTimeout) {
                    clearTimeout(slider.startTimeout); //If clock is ticking, stop timer and prevent from starting while invisible
                  } else {
                    slider.pause(); //Or just pause
                  }
                }
                else {
                  if(slider.started) {
                    slider.play(); //Initiated before, just play
                  } else {
                    if (slider.vars.initDelay > 0) {
                      setTimeout(slider.play, slider.vars.initDelay);
                    } else {
                      slider.play(); //Didn't init before: simply init or wait for it
                    }
                  }
                }
              });
            }
          },
          isHidden: function() {
            var prop = methods.pauseInvisible.getHiddenProp();
            if (!prop) {
              return false;
            }
            return document[prop];
          },
          getHiddenProp: function() {
            var prefixes = ['webkit','moz','ms','o'];
            // if 'hidden' is natively supported just return it
            if ('hidden' in document) {
              return 'hidden';
            }
            // otherwise loop over all the known prefixes until we find one
            for ( var i = 0; i < prefixes.length; i++ ) {
                if ((prefixes[i] + 'Hidden') in document) {
                  return prefixes[i] + 'Hidden';
                }
            }
            // otherwise it's not supported
            return null;
          }
        },
        setToClearWatchedEvent: function() {
          clearTimeout(watchedEventClearTimer);
          watchedEventClearTimer = setTimeout(function() {
            watchedEvent = "";
          }, 3000);
        }
      };

      // public methods
      slider.flexAnimate = function(target, pause, override, withSync, fromNav) {
        if (!slider.vars.animationLoop && target !== slider.currentSlide) {
          slider.direction = (target > slider.currentSlide) ? "next" : "prev";
        }

        if (asNav && slider.pagingCount === 1) slider.direction = (slider.currentItem < target) ? "next" : "prev";

        if (!slider.animating && (slider.canAdvance(target, fromNav) || override) && slider.is(":visible")) {
          if (asNav && withSync) {
            var master = $(slider.vars.asNavFor).data('flexslider');
            slider.atEnd = target === 0 || target === slider.count - 1;

            master.flexAnimate(target, true, false, true, fromNav);
            slider.direction = (slider.currentItem < target) ? "next" : "prev";
            master.direction = slider.direction;

            if (Math.ceil((target + 1)/slider.visible) - 1 !== slider.currentSlide && target !== 0) {
              slider.currentItem = target;
              slider.slides.removeClass(namespace + "active-slide").eq(target).addClass(namespace + "active-slide");
              target = Math.floor(target/slider.visible);
            } else {
              slider.currentItem = target;
              slider.slides.removeClass(namespace + "active-slide").eq(target).addClass(namespace + "active-slide");
              return false;
            }
          }

          slider.animating = true;
          slider.animatingTo = target;

          // SLIDESHOW:
          if (pause) { slider.pause(); }

          // API: before() animation Callback
          slider.vars.before(slider);

          // SYNC:
          if (slider.syncExists && !fromNav) { methods.sync("animate"); }

          // CONTROLNAV
          if (slider.vars.controlNav) { methods.controlNav.active(); }

          // !CAROUSEL:
          // CANDIDATE: slide active class (for add/remove slide)
          if (!carousel) { slider.slides.removeClass(namespace + 'active-slide').eq(target).addClass(namespace + 'active-slide'); }

          // INFINITE LOOP:
          // CANDIDATE: atEnd
          slider.atEnd = target === 0 || target === slider.last;

          // DIRECTIONNAV:
          if (slider.vars.directionNav) { methods.directionNav.update(); }

          if (target === slider.last) {
            // API: end() of cycle Callback
            slider.vars.end(slider);
            // SLIDESHOW && !INFINITE LOOP:
            if (!slider.vars.animationLoop) { slider.pause(); }
          }

          // SLIDE:
          if (!fade) {
            var dimension = (vertical) ? slider.slides.filter(':first').height() : slider.computedW,
                margin, slideString, calcNext;

            // INFINITE LOOP / REVERSE:
            if (carousel) {
              margin = slider.vars.itemMargin;
              calcNext = ((slider.itemW + margin) * slider.move) * slider.animatingTo;
              slideString = (calcNext > slider.limit && slider.visible !== 1) ? slider.limit : calcNext;
            } else if (slider.currentSlide === 0 && target === slider.count - 1 && slider.vars.animationLoop && slider.direction !== "next") {
              slideString = (reverse) ? (slider.count + slider.cloneOffset) * dimension : 0;
            } else if (slider.currentSlide === slider.last && target === 0 && slider.vars.animationLoop && slider.direction !== "prev") {
              slideString = (reverse) ? 0 : (slider.count + 1) * dimension;
            } else {
              slideString = (reverse) ? ((slider.count - 1) - target + slider.cloneOffset) * dimension : (target + slider.cloneOffset) * dimension;
            }
            slider.setProps(slideString, "", slider.vars.animationSpeed);
            if (slider.transitions) {
              if (!slider.vars.animationLoop || !slider.atEnd) {
                slider.animating = false;
                slider.currentSlide = slider.animatingTo;
              }

              // Unbind previous transitionEnd events and re-bind new transitionEnd event
              slider.container.unbind("webkitTransitionEnd transitionend");
              slider.container.bind("webkitTransitionEnd transitionend", function() {
                clearTimeout(slider.ensureAnimationEnd);
                slider.wrapup(dimension);
              });

              // Insurance for the ever-so-fickle transitionEnd event
              clearTimeout(slider.ensureAnimationEnd);
              slider.ensureAnimationEnd = setTimeout(function() {
                slider.wrapup(dimension);
              }, slider.vars.animationSpeed + 100);

            } else {
              slider.container.animate(slider.args, slider.vars.animationSpeed, slider.vars.easing, function(){
                slider.wrapup(dimension);
              });
            }
          } else { // FADE:
            if (!touch) {
              slider.slides.eq(slider.currentSlide).css({"zIndex": 1}).animate({"opacity": 0}, slider.vars.animationSpeed, slider.vars.easing);
              slider.slides.eq(target).css({"zIndex": 2}).animate({"opacity": 1}, slider.vars.animationSpeed, slider.vars.easing, slider.wrapup);
            } else {
              slider.slides.eq(slider.currentSlide).css({ "opacity": 0, "zIndex": 1 });
              slider.slides.eq(target).css({ "opacity": 1, "zIndex": 2 });
              slider.wrapup(dimension);
            }
          }
          // SMOOTH HEIGHT:
          if (slider.vars.smoothHeight) { methods.smoothHeight(slider.vars.animationSpeed); }
        }
      };
      slider.wrapup = function(dimension) {
        // SLIDE:
        if (!fade && !carousel) {
          if (slider.currentSlide === 0 && slider.animatingTo === slider.last && slider.vars.animationLoop) {
            slider.setProps(dimension, "jumpEnd");
          } else if (slider.currentSlide === slider.last && slider.animatingTo === 0 && slider.vars.animationLoop) {
            slider.setProps(dimension, "jumpStart");
          }
        }
        slider.animating = false;
        slider.currentSlide = slider.animatingTo;
        // API: after() animation Callback
        slider.vars.after(slider);
      };

      // SLIDESHOW:
      slider.animateSlides = function() {
        if (!slider.animating && focused ) { slider.flexAnimate(slider.getTarget("next")); }
      };
      // SLIDESHOW:
      slider.pause = function() {
        clearInterval(slider.animatedSlides);
        slider.animatedSlides = null;
        slider.playing = false;
        // PAUSEPLAY:
        if (slider.vars.pausePlay) { methods.pausePlay.update("play"); }
        // SYNC:
        if (slider.syncExists) { methods.sync("pause"); }
      };
      // SLIDESHOW:
      slider.play = function() {
        if (slider.playing) { clearInterval(slider.animatedSlides); }
        slider.animatedSlides = slider.animatedSlides || setInterval(slider.animateSlides, slider.vars.slideshowSpeed);
        slider.started = slider.playing = true;
        // PAUSEPLAY:
        if (slider.vars.pausePlay) { methods.pausePlay.update("pause"); }
        // SYNC:
        if (slider.syncExists) { methods.sync("play"); }
      };
      // STOP:
      slider.stop = function () {
        slider.pause();
        slider.stopped = true;
      };
      slider.canAdvance = function(target, fromNav) {
        // ASNAV:
        var last = (asNav) ? slider.pagingCount - 1 : slider.last;
        return (fromNav) ? true :
               (asNav && slider.currentItem === slider.count - 1 && target === 0 && slider.direction === "prev") ? true :
               (asNav && slider.currentItem === 0 && target === slider.pagingCount - 1 && slider.direction !== "next") ? false :
               (target === slider.currentSlide && !asNav) ? false :
               (slider.vars.animationLoop) ? true :
               (slider.atEnd && slider.currentSlide === 0 && target === last && slider.direction !== "next") ? false :
               (slider.atEnd && slider.currentSlide === last && target === 0 && slider.direction === "next") ? false :
               true;
      };
      slider.getTarget = function(dir) {
        slider.direction = dir;
        if (dir === "next") {
          return (slider.currentSlide === slider.last) ? 0 : slider.currentSlide + 1;
        } else {
          return (slider.currentSlide === 0) ? slider.last : slider.currentSlide - 1;
        }
      };

      // SLIDE:
      slider.setProps = function(pos, special, dur) {
        var target = (function() {
          var posCheck = (pos) ? pos : ((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo,
              posCalc = (function() {
                if (carousel) {
                  return (special === "setTouch") ? pos :
                         (reverse && slider.animatingTo === slider.last) ? 0 :
                         (reverse) ? slider.limit - (((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo) :
                         (slider.animatingTo === slider.last) ? slider.limit : posCheck;
                } else {
                  switch (special) {
                    case "setTotal": return (reverse) ? ((slider.count - 1) - slider.currentSlide + slider.cloneOffset) * pos : (slider.currentSlide + slider.cloneOffset) * pos;
                    case "setTouch": return (reverse) ? pos : pos;
                    case "jumpEnd": return (reverse) ? pos : slider.count * pos;
                    case "jumpStart": return (reverse) ? slider.count * pos : pos;
                    default: return pos;
                  }
                }
              }());

              return (posCalc * ((slider.vars.rtl)?1:-1)) + "px";
            }());

        if (slider.transitions) {
          if (slider.isFirefox) {
            target = (vertical) ? "translate3d(0," + target + ",0)" : "translate3d(" + (parseInt(target)+'px') + ",0,0)";
          } else {
            target = (vertical) ? "translate3d(0," + target + ",0)" : "translate3d(" + ((slider.vars.rtl?-1:1)*parseInt(target)+'px') + ",0,0)";
          }
          dur = (dur !== undefined) ? (dur/1000) + "s" : "0s";
          slider.container.css("-" + slider.pfx + "-transition-duration", dur);
           slider.container.css("transition-duration", dur);
        }

        slider.args[slider.prop] = target;
        if (slider.transitions || dur === undefined) { slider.container.css(slider.args); }

        slider.container.css('transform',target);
      };

      slider.setup = function(type) {
        // SLIDE:
        if (!fade) {
          var sliderOffset, arr;

          if (type === "init") {
            slider.viewport = $('<div class="' + namespace + 'viewport"></div>').css({"overflow": "hidden", "position": "relative"}).appendTo(slider).append(slider.container);
            // INFINITE LOOP:
            slider.cloneCount = 0;
            slider.cloneOffset = 0;
            // REVERSE:
            if (reverse) {
              arr = $.makeArray(slider.slides).reverse();
              slider.slides = $(arr);
              slider.container.empty().append(slider.slides);
            }
          }
          // INFINITE LOOP && !CAROUSEL:
          if (slider.vars.animationLoop && !carousel) {
            slider.cloneCount = 2;
            slider.cloneOffset = 1;
            // clear out old clones
            if (type !== "init") { slider.container.find('.clone').remove(); }
            slider.container.append(methods.uniqueID(slider.slides.first().clone().addClass('clone')).attr('aria-hidden', 'true'))
                            .prepend(methods.uniqueID(slider.slides.last().clone().addClass('clone')).attr('aria-hidden', 'true'));
          }
          slider.newSlides = $(slider.vars.selector, slider);

          sliderOffset = (reverse) ? slider.count - 1 - slider.currentSlide + slider.cloneOffset : slider.currentSlide + slider.cloneOffset;
          // VERTICAL:
          if (vertical) {
            slider.container.height((slider.newSlides.height() + 5) * slider.count + "px").css("position", "absolute").width("100%");
            setTimeout(function(){
              slider.newSlides.css({"display": "block"});
              slider.doMath();

              if ($('#slider')) {
                var sliderHeight = $('#slider img').height();
                slider.viewport.height(sliderHeight);
              } else {
                slider.viewport.height(slider.h);
              }
              slider.setProps(sliderOffset * slider.h, "init");
            }, (type === "init") ? 100 : 0);
          } else {
            slider.container.width((slider.count + slider.cloneCount) * 200 + "%");
            slider.setProps(sliderOffset * slider.computedW, "init");
            setTimeout(function(){
              slider.doMath();
            if(slider.vars.rtl){
              if (slider.isFirefox) {
                slider.newSlides.css({"width": slider.computedW, "marginRight" : slider.computedM, "float": "right", "display": "block"});
              } else {
                slider.newSlides.css({"width": slider.computedW, "marginRight" : slider.computedM, "float": "left", "display": "block"});
              }

             }
              else{
                slider.newSlides.css({"width": slider.computedW, "marginRight" : slider.computedM, "float": "left", "display": "block"});
              }
              // SMOOTH HEIGHT:
              if (slider.vars.smoothHeight) { methods.smoothHeight(); }
            }, (type === "init") ? 100 : 0);
          }
        } else { // FADE:
          if(slider.vars.rtl){
            slider.slides.css({"width": "100%", "float": 'right', "marginLeft": "-100%", "position": "relative"});
          }
          else{
            slider.slides.css({"width": "100%", "float": 'left', "marginRight": "-100%", "position": "relative"});
          }
          if (type === "init") {
            if (!touch) {
              //slider.slides.eq(slider.currentSlide).fadeIn(slider.vars.animationSpeed, slider.vars.easing);
              if (slider.vars.fadeFirstSlide == false) {
                slider.slides.css({ "opacity": 0, "display": "block", "zIndex": 1 }).eq(slider.currentSlide).css({"zIndex": 2}).css({"opacity": 1});
              } else {
                slider.slides.css({ "opacity": 0, "display": "block", "zIndex": 1 }).eq(slider.currentSlide).css({"zIndex": 2}).animate({"opacity": 1},slider.vars.animationSpeed,slider.vars.easing);
              }
            } else {
              slider.slides.css({ "opacity": 0, "display": "block", "webkitTransition": "opacity " + slider.vars.animationSpeed / 1000 + "s ease", "zIndex": 1 }).eq(slider.currentSlide).css({ "opacity": 1, "zIndex": 2});
            }
          }
          // SMOOTH HEIGHT:
          if (slider.vars.smoothHeight) { methods.smoothHeight(); }
        }
        // !CAROUSEL:
        // CANDIDATE: active slide
        if (!carousel) { slider.slides.removeClass(namespace + "active-slide").eq(slider.currentSlide).addClass(namespace + "active-slide"); }

        //FlexSlider: init() Callback
        slider.vars.init(slider);
      };

      slider.doMath = function() {
        var slide = slider.slides.first(),
            slideMargin = slider.vars.itemMargin,
            minItems = slider.vars.minItems,
            maxItems = slider.vars.maxItems;

        slider.w = (slider.viewport===undefined) ? slider.width() : slider.viewport.width();
        if (slider.isFirefox) { slider.w = slider.width(); }
        slider.h = (vertical) ? slider.height() : slide.height();
        slider.boxPadding = slide.outerWidth() - slide.width();

        // CAROUSEL:
        if (carousel) {
          slider.itemT = slider.vars.itemWidth + slideMargin;
          slider.itemM = slideMargin;
          slider.minW = (minItems) ? minItems * slider.itemT : slider.w;
          slider.maxW = (maxItems) ? (maxItems * slider.itemT) - slideMargin : slider.w;
          // slider.itemW = (slider.minW > slider.w) ? (slider.w - (slideMargin * (minItems - 1)))/minItems :
          //                (slider.maxW < slider.w) ? (slider.w - (slideMargin * (maxItems - 1)))/maxItems :
          //                (slider.vars.itemWidth > slider.w) ? slider.w : slider.vars.itemWidth;
          //
          // slider.visible = Math.floor(slider.w/(slider.itemW));

          if (vertical) {
            slider.itemW = slider.w;
          } else {
            slider.itemW = (slider.minW > slider.w) ? (slider.w - (slideMargin * (minItems - 1)))/minItems :
                           (slider.maxW < slider.w) ? (slider.w - (slideMargin * (maxItems - 1)))/maxItems :
                           (slider.vars.itemWidth > slider.w) ? slider.w : slider.vars.itemWidth;
          }

          slider.visible = (vertical) ? Math.floor(slider.h/(slider.itemW)) : Math.floor(slider.w/(slider.itemW));

          slider.move = (slider.vars.move > 0 && slider.vars.move < slider.visible ) ? slider.vars.move : slider.visible;
          slider.pagingCount = Math.ceil(((slider.count - slider.visible)/slider.move) + 1);
          slider.last =  slider.pagingCount - 1;
          slider.limit = (slider.pagingCount === 1) ? 0 :
                         (slider.vars.itemWidth > slider.w) ? (slider.itemW * (slider.count - 1)) + (slideMargin * (slider.count - 1)) : ((slider.itemW + slideMargin) * slider.count) - slider.w - slideMargin;
        } else {
          slider.itemW = slider.w;
          slider.itemM = slideMargin;
          slider.pagingCount = slider.count;
          slider.last = slider.count - 1;
        }
        slider.computedW = slider.itemW - slider.boxPadding;
        slider.computedM = slider.itemM;
      };

      slider.update = function(pos, action) {
        slider.doMath();

        // update currentSlide and slider.animatingTo if necessary
        if (!carousel) {
          if (pos < slider.currentSlide) {
            slider.currentSlide += 1;
          } else if (pos <= slider.currentSlide && pos !== 0) {
            slider.currentSlide -= 1;
          }
          slider.animatingTo = slider.currentSlide;
        }

        // update controlNav
        if (slider.vars.controlNav && !slider.manualControls) {
          if ((action === "add" && !carousel) || slider.pagingCount > slider.controlNav.length) {
            methods.controlNav.update("add");
          } else if ((action === "remove" && !carousel) || slider.pagingCount < slider.controlNav.length) {
            if (carousel && slider.currentSlide > slider.last) {
              slider.currentSlide -= 1;
              slider.animatingTo -= 1;
            }
            methods.controlNav.update("remove", slider.last);
          }
        }
        // update directionNav
        if (slider.vars.directionNav) { methods.directionNav.update(); }

      };

      slider.addSlide = function(obj, pos) {
        var $obj = $(obj);

        slider.count += 1;
        slider.last = slider.count - 1;

        // append new slide
        if (vertical && reverse) {
          (pos !== undefined) ? slider.slides.eq(slider.count - pos).after($obj) : slider.container.prepend($obj);
        } else {
          (pos !== undefined) ? slider.slides.eq(pos).before($obj) : slider.container.append($obj);
        }

        // update currentSlide, animatingTo, controlNav, and directionNav
        slider.update(pos, "add");

        // update slider.slides
        slider.slides = $(slider.vars.selector + ':not(.clone)', slider);
        // re-setup the slider to accomdate new slide
        slider.setup();

        //FlexSlider: added() Callback
        slider.vars.added(slider);
      };
      slider.removeSlide = function(obj) {
        var pos = (isNaN(obj)) ? slider.slides.index($(obj)) : obj;

        // update count
        slider.count -= 1;
        slider.last = slider.count - 1;

        // remove slide
        if (isNaN(obj)) {
          $(obj, slider.slides).remove();
        } else {
          (vertical && reverse) ? slider.slides.eq(slider.last).remove() : slider.slides.eq(obj).remove();
        }

        // update currentSlide, animatingTo, controlNav, and directionNav
        slider.doMath();
        slider.update(pos, "remove");

        // update slider.slides
        slider.slides = $(slider.vars.selector + ':not(.clone)', slider);
        // re-setup the slider to accomdate new slide
        slider.setup();

        // FlexSlider: removed() Callback
        slider.vars.removed(slider);
      };

      //FlexSlider: Initialize
      methods.init();
    };

    // Ensure the slider isn't focussed if the window loses focus.
    $( window ).blur( function ( e ) {
      focused = false;
    }).focus( function ( e ) {
      focused = true;
    });

    //FlexSlider: Default Settings
    $.flexslider.defaults = {
      namespace: "flex-",             //{NEW} String: Prefix string attached to the class of every element generated by the plugin
      selector: ".slides > li",       //{NEW} Selector: Must match a simple pattern. '{container} > {slide}' -- Ignore pattern at your own peril
      animation: "fade",              //String: Select your animation type, "fade" or "slide"
      easing: "swing",                //{NEW} String: Determines the easing method used in jQuery transitions. jQuery easing plugin is supported!
      direction: "horizontal",        //String: Select the sliding direction, "horizontal" or "vertical"
      reverse: false,                 //{NEW} Boolean: Reverse the animation direction
      animationLoop: true,            //Boolean: Should the animation loop? If false, directionNav will received "disable" classes at either end
      smoothHeight: false,            //{NEW} Boolean: Allow height of the slider to animate smoothly in horizontal mode
      startAt: 0,                     //Integer: The slide that the slider should start on. Array notation (0 = first slide)
      slideshow: true,                //Boolean: Animate slider automatically
      slideshowSpeed: 7000,           //Integer: Set the speed of the slideshow cycling, in milliseconds
      animationSpeed: 600,            //Integer: Set the speed of animations, in milliseconds
      initDelay: 0,                   //{NEW} Integer: Set an initialization delay, in milliseconds
      randomize: false,               //Boolean: Randomize slide order
      fadeFirstSlide: true,           //Boolean: Fade in the first slide when animation type is "fade"
      thumbCaptions: false,           //Boolean: Whether or not to put captions on thumbnails when using the "thumbnails" controlNav.

      // Usability features
      pauseOnAction: true,            //Boolean: Pause the slideshow when interacting with control elements, highly recommended.
      pauseOnHover: false,            //Boolean: Pause the slideshow when hovering over slider, then resume when no longer hovering
      pauseInvisible: true,       //{NEW} Boolean: Pause the slideshow when tab is invisible, resume when visible. Provides better UX, lower CPU usage.
      useCSS: true,                   //{NEW} Boolean: Slider will use CSS3 transitions if available
      touch: true,                    //{NEW} Boolean: Allow touch swipe navigation of the slider on touch-enabled devices
      video: false,                   //{NEW} Boolean: If using video in the slider, will prevent CSS3 3D Transforms to avoid graphical glitches

      // Primary Controls
      controlNav: true,               //Boolean: Create navigation for paging control of each slide? Note: Leave true for manualControls usage
      directionNav: true,             //Boolean: Create navigation for previous/next navigation? (true/false)
      prevText: "Previous",           //String: Set the text for the "previous" directionNav item
      nextText: "Next",               //String: Set the text for the "next" directionNav item

      // Secondary Navigation
      keyboard: true,                 //Boolean: Allow slider navigating via keyboard left/right keys
      multipleKeyboard: false,        //{NEW} Boolean: Allow keyboard navigation to affect multiple sliders. Default behavior cuts out keyboard navigation with more than one slider present.
      mousewheel: false,              //{UPDATED} Boolean: Requires jquery.mousewheel.js (https://github.com/brandonaaron/jquery-mousewheel) - Allows slider navigating via mousewheel
      pausePlay: false,               //Boolean: Create pause/play dynamic element
      pauseText: "Pause",             //String: Set the text for the "pause" pausePlay item
      playText: "Play",               //String: Set the text for the "play" pausePlay item

      // Special properties
      controlsContainer: "",          //{UPDATED} jQuery Object/Selector: Declare which container the navigation elements should be appended too. Default container is the FlexSlider element. Example use would be $(".flexslider-container"). Property is ignored if given element is not found.
      manualControls: "",             //{UPDATED} jQuery Object/Selector: Declare custom control navigation. Examples would be $(".flex-control-nav li") or "#tabs-nav li img", etc. The number of elements in your controlNav should match the number of slides/tabs.
      customDirectionNav: "",         //{NEW} jQuery Object/Selector: Custom prev / next button. Must be two jQuery elements. In order to make the events work they have to have the classes "prev" and "next" (plus namespace)
      sync: "",                       //{NEW} Selector: Mirror the actions performed on this slider with another slider. Use with care.
      asNavFor: "",                   //{NEW} Selector: Internal property exposed for turning the slider into a thumbnail navigation for another slider

      // Carousel Options
      itemWidth: 0,                   //{NEW} Integer: Box-model width of individual carousel items, including horizontal borders and padding.
      itemMargin: 0,                  //{NEW} Integer: Margin between carousel items.
      minItems: 1,                    //{NEW} Integer: Minimum number of carousel items that should be visible. Items will resize fluidly when below this.
      maxItems: 0,                    //{NEW} Integer: Maxmimum number of carousel items that should be visible. Items will resize fluidly when above this limit.
      move: 0,                        //{NEW} Integer: Number of carousel items that should move on animation. If 0, slider will move all visible items.
      allowOneSlide: true,           //{NEW} Boolean: Whether or not to allow a slider comprised of a single slide

      // Browser Specific
      isFirefox: false,             // {NEW} Boolean: Set to true when Firefox is the browser used.

      // Callback API
      start: function(){},            //Callback: function(slider) - Fires when the slider loads the first slide
      before: function(){},           //Callback: function(slider) - Fires asynchronously with each slider animation
      after: function(){},            //Callback: function(slider) - Fires after each slider animation completes
      end: function(){},              //Callback: function(slider) - Fires when the slider reaches the last slide (asynchronous)
      added: function(){},            //{NEW} Callback: function(slider) - Fires after a slide is added
      removed: function(){},           //{NEW} Callback: function(slider) - Fires after a slide is removed
      init: function() {},             //{NEW} Callback: function(slider) - Fires after the slider is initially setup
      rtl: false             //{NEW} Boolean: Whether or not to enable RTL mode
    };

    //FlexSlider: Plugin Function
    $.fn.flexslider = function(options) {
      if (options === undefined) { options = {}; }

      if (typeof options === "object") {
        return this.each(function() {
          var $this = $(this),
              selector = (options.selector) ? options.selector : ".slides > li",
              $slides = $this.find(selector);

        if ( ( $slides.length === 1 && options.allowOneSlide === false ) || $slides.length === 0 ) {
            $slides.fadeIn(400);
            if (options.start) { options.start($this); }
          } else if ($this.data('flexslider') === undefined) {
            new $.flexslider(this, options);
          }
        });
      } else {
        // Helper strings to quickly perform functions on the slider
        var $slider = $(this).data('flexslider');
        switch (options) {
          case "play": $slider.play(); break;
          case "pause": $slider.pause(); break;
          case "stop": $slider.stop(); break;
          case "next": $slider.flexAnimate($slider.getTarget("next"), true); break;
          case "prev":
          case "previous": $slider.flexAnimate($slider.getTarget("prev"), true); break;
          default: if (typeof options === "number") { $slider.flexAnimate(options, true); }
        }
      }
    };
  })(jQuery);


})();
(function vendorWow() {
  /* wow js */
  (function(){var t,e,n,i,o,r=function(t,e){return function(){return t.apply(e,arguments)}},s=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};e=function(){function t(){}return t.prototype.extend=function(t,e){var n,i;for(n in e)i=e[n],null==t[n]&&(t[n]=i);return t},t.prototype.isMobile=function(t){return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(t)},t.prototype.addEvent=function(t,e,n){return null!=t.addEventListener?t.addEventListener(e,n,!1):null!=t.attachEvent?t.attachEvent("on"+e,n):t[e]=n},t.prototype.removeEvent=function(t,e,n){return null!=t.removeEventListener?t.removeEventListener(e,n,!1):null!=t.detachEvent?t.detachEvent("on"+e,n):delete t[e]},t.prototype.innerHeight=function(){return"innerHeight"in window?window.innerHeight:document.documentElement.clientHeight},t}(),n=this.WeakMap||this.MozWeakMap||(n=function(){function t(){this.keys=[],this.values=[]}return t.prototype.get=function(t){var e,n,i,o,r;for(r=this.keys,e=i=0,o=r.length;o>i;e=++i)if(n=r[e],n===t)return this.values[e]},t.prototype.set=function(t,e){var n,i,o,r,s;for(s=this.keys,n=o=0,r=s.length;r>o;n=++o)if(i=s[n],i===t)return void(this.values[n]=e);return this.keys.push(t),this.values.push(e)},t}()),t=this.MutationObserver||this.WebkitMutationObserver||this.MozMutationObserver||(t=function(){function t(){"undefined"!=typeof console&&null!==console&&console.warn("MutationObserver is not supported by your browser."),"undefined"!=typeof console&&null!==console&&console.warn("WOW.js cannot detect dom mutations, please call .sync() after loading new content.")}return t.notSupported=!0,t.prototype.observe=function(){},t}()),i=this.getComputedStyle||function(t){return this.getPropertyValue=function(e){var n;return"float"===e&&(e="styleFloat"),o.test(e)&&e.replace(o,function(t,e){return e.toUpperCase()}),(null!=(n=t.currentStyle)?n[e]:void 0)||null},this},o=/(\-([a-z]){1})/g,this.WOW=function(){function o(t){null==t&&(t={}),this.scrollCallback=r(this.scrollCallback,this),this.scrollHandler=r(this.scrollHandler,this),this.start=r(this.start,this),this.scrolled=!0,this.config=this.util().extend(t,this.defaults),this.animationNameCache=new n}return o.prototype.defaults={boxClass:"wow",animateClass:"animated",offset:0,mobile:!0,live:!0,callback:null},o.prototype.init=function(){var t;return this.element=window.document.documentElement,"interactive"===(t=document.readyState)||"complete"===t?this.start():this.util().addEvent(document,"DOMContentLoaded",this.start),this.finished=[]},o.prototype.start=function(){var e,n,i,o;if(this.stopped=!1,this.boxes=function(){var t,n,i,o;for(i=this.element.querySelectorAll("."+this.config.boxClass),o=[],t=0,n=i.length;n>t;t++)e=i[t],o.push(e);return o}.call(this),this.all=function(){var t,n,i,o;for(i=this.boxes,o=[],t=0,n=i.length;n>t;t++)e=i[t],o.push(e);return o}.call(this),this.boxes.length)if(this.disabled())this.resetStyle();else for(o=this.boxes,n=0,i=o.length;i>n;n++)e=o[n],this.applyStyle(e,!0);return this.disabled()||(this.util().addEvent(window,"scroll",this.scrollHandler),this.util().addEvent(window,"resize",this.scrollHandler),this.interval=setInterval(this.scrollCallback,50)),this.config.live?new t(function(t){return function(e){var n,i,o,r,s;for(s=[],o=0,r=e.length;r>o;o++)i=e[o],s.push(function(){var t,e,o,r;for(o=i.addedNodes||[],r=[],t=0,e=o.length;e>t;t++)n=o[t],r.push(this.doSync(n));return r}.call(t));return s}}(this)).observe(document.body,{childList:!0,subtree:!0}):void 0},o.prototype.stop=function(){return this.stopped=!0,this.util().removeEvent(window,"scroll",this.scrollHandler),this.util().removeEvent(window,"resize",this.scrollHandler),null!=this.interval?clearInterval(this.interval):void 0},o.prototype.sync=function(){return t.notSupported?this.doSync(this.element):void 0},o.prototype.doSync=function(t){var e,n,i,o,r;if(null==t&&(t=this.element),1===t.nodeType){for(t=t.parentNode||t,o=t.querySelectorAll("."+this.config.boxClass),r=[],n=0,i=o.length;i>n;n++)e=o[n],s.call(this.all,e)<0?(this.boxes.push(e),this.all.push(e),this.stopped||this.disabled()?this.resetStyle():this.applyStyle(e,!0),r.push(this.scrolled=!0)):r.push(void 0);return r}},o.prototype.show=function(t){return this.applyStyle(t),t.className=""+t.className+" "+this.config.animateClass,null!=this.config.callback?this.config.callback(t):void 0},o.prototype.applyStyle=function(t,e){var n,i,o;return i=t.getAttribute("data-wow-duration"),n=t.getAttribute("data-wow-delay"),o=t.getAttribute("data-wow-iteration"),this.animate(function(r){return function(){return r.customStyle(t,e,i,n,o)}}(this))},o.prototype.animate=function(){return"requestAnimationFrame"in window?function(t){return window.requestAnimationFrame(t)}:function(t){return t()}}(),o.prototype.resetStyle=function(){var t,e,n,i,o;for(i=this.boxes,o=[],e=0,n=i.length;n>e;e++)t=i[e],o.push(t.style.visibility="visible");return o},o.prototype.customStyle=function(t,e,n,i,o){return e&&this.cacheAnimationName(t),t.style.visibility=e?"hidden":"visible",n&&this.vendorSet(t.style,{animationDuration:n}),i&&this.vendorSet(t.style,{animationDelay:i}),o&&this.vendorSet(t.style,{animationIterationCount:o}),this.vendorSet(t.style,{animationName:e?"none":this.cachedAnimationName(t)}),t},o.prototype.vendors=["moz","webkit"],o.prototype.vendorSet=function(t,e){var n,i,o,r;r=[];for(n in e)i=e[n],t[""+n]=i,r.push(function(){var e,r,s,l;for(s=this.vendors,l=[],e=0,r=s.length;r>e;e++)o=s[e],l.push(t[""+o+n.charAt(0).toUpperCase()+n.substr(1)]=i);return l}.call(this));return r},o.prototype.vendorCSS=function(t,e){var n,o,r,s,l,a;for(o=i(t),n=o.getPropertyCSSValue(e),a=this.vendors,s=0,l=a.length;l>s;s++)r=a[s],n=n||o.getPropertyCSSValue("-"+r+"-"+e);return n},o.prototype.animationName=function(t){var e;try{e=this.vendorCSS(t,"animation-name").cssText}catch(n){e=i(t).getPropertyValue("animation-name")}return"none"===e?"":e},o.prototype.cacheAnimationName=function(t){return this.animationNameCache.set(t,this.animationName(t))},o.prototype.cachedAnimationName=function(t){return this.animationNameCache.get(t)},o.prototype.scrollHandler=function(){return this.scrolled=!0},o.prototype.scrollCallback=function(){var t;return!this.scrolled||(this.scrolled=!1,this.boxes=function(){var e,n,i,o;for(i=this.boxes,o=[],e=0,n=i.length;n>e;e++)t=i[e],t&&(this.isVisible(t)?this.show(t):o.push(t));return o}.call(this),this.boxes.length||this.config.live)?void 0:this.stop()},o.prototype.offsetTop=function(t){for(var e;void 0===t.offsetTop;)t=t.parentNode;for(e=t.offsetTop;t=t.offsetParent;)e+=t.offsetTop;return e},o.prototype.isVisible=function(t){var e,n,i,o,r;return n=t.getAttribute("data-wow-offset")||this.config.offset,r=window.pageYOffset,o=r+Math.min(this.element.clientHeight,this.util().innerHeight())-n,i=this.offsetTop(t),e=i+t.clientHeight,o>=i&&e>=r},o.prototype.util=function(){return null!=this._util?this._util:this._util=new e},o.prototype.disabled=function(){return!this.config.mobile&&this.util().isMobile(navigator.userAgent)},o}()}).call(this);

})();
(function vendorThrottle() {
  /*
   * jQuery throttle / debounce - v1.1 - 3/7/2010
   * http://benalman.com/projects/jquery-throttle-debounce-plugin/
   *
   * Copyright (c) 2010 "Cowboy" Ben Alman
   * Dual licensed under the MIT and GPL licenses.
   * http://benalman.com/about/license/
   */
  (function(b,c){var $=b.jQuery||b.Cowboy||(b.Cowboy={}),a;$.throttle=a=function(e,f,j,i){var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g};$.debounce=function(d,e,f){return f===c?a(d,e,false):a(d,f,e!==false)}})(this);

})();
(function vendorLodash() {
  // lodash.core.min.js

  /**
   * @license
   * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
   * Build: `lodash core -o ./dist/lodash.core.js`
   */
  ;(function(){function n(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];return n}function t(n,t,r){for(var e=-1,u=n.length;++e<u;){var o=n[e],i=t(o);if(null!=i&&(c===an?i===i:r(i,c)))var c=i,f=o}return f}function r(n,t,r){var e;return r(n,function(n,r,u){return t(n,r,u)?(e=n,false):void 0}),e}function e(n,t,r,e,u){return u(n,function(n,u,o){r=e?(e=false,n):t(r,n,u,o)}),r}function u(n,t){return O(t,function(t){return n[t]})}function o(n){return n&&n.Object===Object?n:null}function i(n){return vn[n];
  }function c(n){var t=false;if(null!=n&&typeof n.toString!="function")try{t=!!(n+"")}catch(r){}return t}function f(n,t){return n=typeof n=="number"||hn.test(n)?+n:-1,n>-1&&0==n%1&&(null==t?9007199254740991:t)>n}function a(n){if(Y(n)&&!Pn(n)){if(n instanceof l)return n;if(En.call(n,"__wrapped__")){var t=new l(n.__wrapped__,n.__chain__);return t.__actions__=N(n.__actions__),t}}return new l(n)}function l(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t}function p(n,t,r,e){var u;return(u=n===an)||(u=xn[r],
  u=(n===u||n!==n&&u!==u)&&!En.call(e,r)),u?t:n}function s(n){return X(n)?Fn(n):{}}function h(n,t,r){if(typeof n!="function")throw new TypeError("Expected a function");return setTimeout(function(){n.apply(an,r)},t)}function v(n,t){var r=true;return $n(n,function(n,e,u){return r=!!t(n,e,u)}),r}function y(n,t){var r=[];return $n(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function _(t,r,e,u){u||(u=[]);for(var o=-1,i=t.length;++o<i;){var c=t[o];r>0&&Y(c)&&L(c)&&(e||Pn(c)||K(c))?r>1?_(c,r-1,e,u):n(u,c):e||(u[u.length]=c);
  }return u}function g(n,t){return n&&qn(n,t,en)}function b(n,t){return y(t,function(t){return Q(n[t])})}function j(n,t,r,e,u){return n===t?true:null==n||null==t||!X(n)&&!Y(t)?n!==n&&t!==t:m(n,t,j,r,e,u)}function m(n,t,r,e,u,o){var i=Pn(n),f=Pn(t),a="[object Array]",l="[object Array]";i||(a=kn.call(n),"[object Arguments]"==a&&(a="[object Object]")),f||(l=kn.call(t),"[object Arguments]"==l&&(l="[object Object]"));var p="[object Object]"==a&&!c(n),f="[object Object]"==l&&!c(t);return!(l=a==l)||i||p?2&u||(a=p&&En.call(n,"__wrapped__"),
  f=f&&En.call(t,"__wrapped__"),!a&&!f)?l?(o||(o=[]),(a=J(o,function(t){return t[0]===n}))&&a[1]?a[1]==t:(o.push([n,t]),t=(i?I:q)(n,t,r,e,u,o),o.pop(),t)):false:r(a?n.value():n,f?t.value():t,e,u,o):$(n,t,a)}function d(n){var t=typeof n;return"function"==t?n:null==n?cn:("object"==t?x:A)(n)}function w(n){n=null==n?n:Object(n);var t,r=[];for(t in n)r.push(t);return r}function O(n,t){var r=-1,e=L(n)?Array(n.length):[];return $n(n,function(n,u,o){e[++r]=t(n,u,o)}),e}function x(n){var t=en(n);return function(r){
  var e=t.length;if(null==r)return!e;for(r=Object(r);e--;){var u=t[e];if(!(u in r&&j(n[u],r[u],an,3)))return false}return true}}function E(n,t){return n=Object(n),P(t,function(t,r){return r in n&&(t[r]=n[r]),t},{})}function A(n){return function(t){return null==t?an:t[n]}}function k(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Array(u);++e<u;)r[e]=n[e+t];return r}function N(n){return k(n,0,n.length)}function S(n,t){var r;return $n(n,function(n,e,u){return r=t(n,e,u),
  !r}),!!r}function T(t,r){return P(r,function(t,r){return r.func.apply(r.thisArg,n([t],r.args))},t)}function F(n,t,r,e){r||(r={});for(var u=-1,o=t.length;++u<o;){var i=t[u],c=e?e(r[i],n[i],i,r,n):n[i],f=r,a=f[i];En.call(f,i)&&(a===c||a!==a&&c!==c)&&(c!==an||i in f)||(f[i]=c)}return r}function R(n){return V(function(t,r){var e=-1,u=r.length,o=u>1?r[u-1]:an,o=typeof o=="function"?(u--,o):an;for(t=Object(t);++e<u;){var i=r[e];i&&n(t,i,e,o)}return t})}function B(n){return function(){var t=arguments,r=s(n.prototype),t=n.apply(r,t);
  return X(t)?t:r}}function D(n,t,r){function e(){for(var o=-1,i=arguments.length,c=-1,f=r.length,a=Array(f+i),l=this&&this!==wn&&this instanceof e?u:n;++c<f;)a[c]=r[c];for(;i--;)a[c++]=arguments[++o];return l.apply(t,a)}if(typeof n!="function")throw new TypeError("Expected a function");var u=B(n);return e}function I(n,t,r,e,u,o){var i=-1,c=1&u,f=n.length,a=t.length;if(f!=a&&!(2&u&&a>f))return false;for(a=true;++i<f;){var l=n[i],p=t[i];if(void 0!==an){a=false;break}if(c){if(!S(t,function(n){return l===n||r(l,n,e,u,o);
  })){a=false;break}}else if(l!==p&&!r(l,p,e,u,o)){a=false;break}}return a}function $(n,t,r){switch(r){case"[object Boolean]":case"[object Date]":return+n==+t;case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object Number]":return n!=+n?t!=+t:n==+t;case"[object RegExp]":case"[object String]":return n==t+""}return false}function q(n,t,r,e,u,o){var i=2&u,c=en(n),f=c.length,a=en(t).length;if(f!=a&&!i)return false;for(var l=f;l--;){var p=c[l];if(!(i?p in t:En.call(t,p)))return false}for(a=true;++l<f;){
  var p=c[l],s=n[p],h=t[p];if(void 0!==an||s!==h&&!r(s,h,e,u,o)){a=false;break}i||(i="constructor"==p)}return a&&!i&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(a=false)),a}function z(n){var t=n?n.length:an;if(W(t)&&(Pn(n)||nn(n)||K(n))){n=String;for(var r=-1,e=Array(t);++r<t;)e[r]=n(r);t=e}else t=null;return t}function C(n){var t=n&&n.constructor,t=Q(t)&&t.prototype||xn;return n===t}function G(n){
  return n?n[0]:an}function J(n,t){return r(n,d(t),$n)}function M(n,t){return $n(n,typeof t=="function"?t:cn)}function P(n,t,r){return e(n,d(t),r,3>arguments.length,$n)}function U(n,t){var r;if(typeof t!="function")throw new TypeError("Expected a function");return n=Un(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=an),r}}function V(n){var t;if(typeof n!="function")throw new TypeError("Expected a function");return t=In(t===an?n.length-1:Un(t),0),function(){for(var r=arguments,e=-1,u=In(r.length-t,0),o=Array(u);++e<u;)o[e]=r[t+e];
  for(u=Array(t+1),e=-1;++e<t;)u[e]=r[e];return u[t]=o,n.apply(this,u)}}function H(n,t){return n>t}function K(n){return Y(n)&&L(n)&&En.call(n,"callee")&&(!Rn.call(n,"callee")||"[object Arguments]"==kn.call(n))}function L(n){return null!=n&&!(typeof n=="function"&&Q(n))&&W(zn(n))}function Q(n){return n=X(n)?kn.call(n):"","[object Function]"==n||"[object GeneratorFunction]"==n}function W(n){return typeof n=="number"&&n>-1&&0==n%1&&9007199254740991>=n}function X(n){var t=typeof n;return!!n&&("object"==t||"function"==t);
  }function Y(n){return!!n&&typeof n=="object"}function Z(n){return typeof n=="number"||Y(n)&&"[object Number]"==kn.call(n)}function nn(n){return typeof n=="string"||!Pn(n)&&Y(n)&&"[object String]"==kn.call(n)}function tn(n,t){return t>n}function rn(n){return typeof n=="string"?n:null==n?"":n+""}function en(n){var t=C(n);if(!t&&!L(n))return Dn(Object(n));var r,e=z(n),u=!!e,e=e||[],o=e.length;for(r in n)!En.call(n,r)||u&&("length"==r||f(r,o))||t&&"constructor"==r||e.push(r);return e}function un(n){for(var t=-1,r=C(n),e=w(n),u=e.length,o=z(n),i=!!o,o=o||[],c=o.length;++t<u;){
  var a=e[t];i&&("length"==a||f(a,c))||"constructor"==a&&(r||!En.call(n,a))||o.push(a)}return o}function on(n){return n?u(n,en(n)):[]}function cn(n){return n}function fn(t,r,e){var u=en(r),o=b(r,u);null!=e||X(r)&&(o.length||!u.length)||(e=r,r=t,t=this,o=b(r,en(r)));var i=X(e)&&"chain"in e?e.chain:true,c=Q(t);return $n(o,function(e){var u=r[e];t[e]=u,c&&(t.prototype[e]=function(){var r=this.__chain__;if(i||r){var e=t(this.__wrapped__);return(e.__actions__=N(this.__actions__)).push({func:u,args:arguments,
  thisArg:t}),e.__chain__=r,e}return u.apply(t,n([this.value()],arguments))})}),t}var an,ln=1/0,pn=/[&<>"'`]/g,sn=RegExp(pn.source),hn=/^(?:0|[1-9]\d*)$/,vn={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","`":"&#96;"},yn={"function":true,object:true},_n=yn[typeof exports]&&exports&&!exports.nodeType?exports:an,gn=yn[typeof module]&&module&&!module.nodeType?module:an,bn=gn&&gn.exports===_n?_n:an,jn=o(yn[typeof self]&&self),mn=o(yn[typeof window]&&window),dn=o(yn[typeof this]&&this),wn=o(_n&&gn&&typeof global=="object"&&global)||mn!==(dn&&dn.window)&&mn||jn||dn||Function("return this")(),On=Array.prototype,xn=Object.prototype,En=xn.hasOwnProperty,An=0,kn=xn.toString,Nn=wn._,Sn=wn.Reflect,Tn=Sn?Sn.f:an,Fn=Object.create,Rn=xn.propertyIsEnumerable,Bn=wn.isFinite,Dn=Object.keys,In=Math.max,$n=function(n,t){
  return function(r,e){if(null==r)return r;if(!L(r))return n(r,e);for(var u=r.length,o=t?u:-1,i=Object(r);(t?o--:++o<u)&&false!==e(i[o],o,i););return r}}(g),qn=function(n){return function(t,r,e){var u=-1,o=Object(t);e=e(t);for(var i=e.length;i--;){var c=e[n?i:++u];if(false===r(o[c],c,o))break}return t}}();Tn&&!Rn.call({valueOf:1},"valueOf")&&(w=function(n){n=Tn(n);for(var t,r=[];!(t=n.next()).done;)r.push(t.value);return r});var zn=A("length"),Cn=V(function(t,r){return Pn(t)||(t=null==t?[]:[Object(t)]),_(r,1),
  n(N(t),on)}),Gn=V(function(n,t,r){return D(n,t,r)}),Jn=V(function(n,t){return h(n,1,t)}),Mn=V(function(n,t,r){return h(n,Vn(t)||0,r)}),Pn=Array.isArray,Un=Number,Vn=Number,Hn=R(function(n,t){F(t,en(t),n)}),Kn=R(function(n,t){F(t,un(t),n)}),Ln=R(function(n,t,r,e){F(t,un(t),n,e)}),Qn=V(function(n){return n.push(an,p),Ln.apply(an,n)}),Wn=V(function(n,t){return null==n?{}:E(n,_(t,1))}),Xn=d;l.prototype=s(a.prototype),l.prototype.constructor=l,a.assignIn=Kn,a.before=U,a.bind=Gn,a.chain=function(n){return n=a(n),
  n.__chain__=true,n},a.compact=function(n){return y(n,Boolean)},a.concat=Cn,a.create=function(n,t){var r=s(n);return t?Hn(r,t):r},a.defaults=Qn,a.defer=Jn,a.delay=Mn,a.filter=function(n,t){return y(n,d(t))},a.flatten=function(n){return n&&n.length?_(n,1):[]},a.flattenDeep=function(n){return n&&n.length?_(n,ln):[]},a.iteratee=Xn,a.keys=en,a.map=function(n,t){return O(n,d(t))},a.matches=function(n){return x(Hn({},n))},a.mixin=fn,a.negate=function(n){if(typeof n!="function")throw new TypeError("Expected a function");
  return function(){return!n.apply(this,arguments)}},a.once=function(n){return U(2,n)},a.pick=Wn,a.slice=function(n,t,r){var e=n?n.length:0;return r=r===an?e:+r,e?k(n,null==t?0:+t,r):[]},a.sortBy=function(n,t){var r=0;return t=d(t),O(O(n,function(n,e,u){return{c:n,b:r++,a:t(n,e,u)}}).sort(function(n,t){var r;n:{r=n.a;var e=t.a;if(r!==e){var u=null===r,o=r===an,i=r===r,c=null===e,f=e===an,a=e===e;if(r>e&&!c||!i||u&&!f&&a||o&&a){r=1;break n}if(e>r&&!u||!a||c&&!o&&i||f&&i){r=-1;break n}}r=0}return r||n.b-t.b;
  }),A("c"))},a.tap=function(n,t){return t(n),n},a.thru=function(n,t){return t(n)},a.toArray=function(n){return L(n)?n.length?N(n):[]:on(n)},a.values=on,a.extend=Kn,fn(a,a),a.clone=function(n){return X(n)?Pn(n)?N(n):F(n,en(n)):n},a.escape=function(n){return(n=rn(n))&&sn.test(n)?n.replace(pn,i):n},a.every=function(n,t,r){return t=r?an:t,v(n,d(t))},a.find=J,a.forEach=M,a.has=function(n,t){return null!=n&&En.call(n,t)},a.head=G,a.identity=cn,a.indexOf=function(n,t,r){var e=n?n.length:0;r=typeof r=="number"?0>r?In(e+r,0):r:0,
  r=(r||0)-1;for(var u=t===t;++r<e;){var o=n[r];if(u?o===t:o!==o)return r}return-1},a.isArguments=K,a.isArray=Pn,a.isBoolean=function(n){return true===n||false===n||Y(n)&&"[object Boolean]"==kn.call(n)},a.isDate=function(n){return Y(n)&&"[object Date]"==kn.call(n)},a.isEmpty=function(n){if(L(n)&&(Pn(n)||nn(n)||Q(n.splice)||K(n)))return!n.length;for(var t in n)if(En.call(n,t))return false;return true},a.isEqual=function(n,t){return j(n,t)},a.isFinite=function(n){return typeof n=="number"&&Bn(n)},a.isFunction=Q,a.isNaN=function(n){
  return Z(n)&&n!=+n},a.isNull=function(n){return null===n},a.isNumber=Z,a.isObject=X,a.isRegExp=function(n){return X(n)&&"[object RegExp]"==kn.call(n)},a.isString=nn,a.isUndefined=function(n){return n===an},a.last=function(n){var t=n?n.length:0;return t?n[t-1]:an},a.max=function(n){return n&&n.length?t(n,cn,H):an},a.min=function(n){return n&&n.length?t(n,cn,tn):an},a.noConflict=function(){return wn._===this&&(wn._=Nn),this},a.noop=function(){},a.reduce=P,a.result=function(n,t,r){return t=null==n?an:n[t],
  t===an&&(t=r),Q(t)?t.call(n):t},a.size=function(n){return null==n?0:(n=L(n)?n:en(n),n.length)},a.some=function(n,t,r){return t=r?an:t,S(n,d(t))},a.uniqueId=function(n){var t=++An;return rn(n)+t},a.each=M,a.first=G,fn(a,function(){var n={};return g(a,function(t,r){En.call(a.prototype,r)||(n[r]=t)}),n}(),{chain:false}),a.VERSION="4.5.1",$n("pop join replace reverse split push shift sort splice unshift".split(" "),function(n){var t=(/^(?:replace|split)$/.test(n)?String.prototype:On)[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|join|replace|shift)$/.test(n);
  a.prototype[n]=function(){var n=arguments;return e&&!this.__chain__?t.apply(this.value(),n):this[r](function(r){return t.apply(r,n)})}}),a.prototype.toJSON=a.prototype.valueOf=a.prototype.value=function(){return T(this.__wrapped__,this.__actions__)},(mn||jn||{})._=a,typeof define=="function"&&typeof define.amd=="object"&&define.amd? define(function(){return a}):_n&&gn?(bn&&((gn.exports=a)._=a),_n._=a):wn._=a}).call(this);

})();



// sections.js
window.theme = window.theme || {};

/* Shopify Library Loader */
theme.Helpers = (function() {
  var touchDevice = false;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }
  return {
    setTouch: setTouch,
    isTouch: isTouch
  };
})();

theme.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };

  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };

  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

  var libraries = {
    youtubeSdk: {
      tagId: 'youtube-sdk',
      src: 'https://www.youtube.com/iframe_api',
      type: types.script
    },
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
      type: types.link
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load
  };
})();

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

theme.Disclosure = (function() {
  var selectors = {
    disclosureList: '[data-disclosure-list]',
    disclosureToggle: '[data-disclosure-toggle]',
    disclosureInput: '[data-disclosure-input]',
    disclosureOptions: '[data-disclosure-option]'
  };

  var classes = {
    listVisible: 'disclosure-list--visible'
  };

  function Disclosure($disclosure) {
    this.$container = $disclosure;
    this.cache = {};
    this._cacheSelectors();
    this._connectOptions();
    this._connectToggle();
    this._onFocusOut();
  }

  Disclosure.prototype = _.assignIn({}, Disclosure.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        $disclosureList: this.$container.find(selectors.disclosureList),
        $disclosureToggle: this.$container.find(selectors.disclosureToggle),
        $disclosureInput: this.$container.find(selectors.disclosureInput),
        $disclosureOptions: this.$container.find(selectors.disclosureOptions)
      };
    },

    _connectToggle: function() {
      this.cache.$disclosureToggle.on(
        'click',
        function(evt) {
          var ariaExpanded =
            $(evt.currentTarget).attr('aria-expanded') === 'true';
          $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);

          this.cache.$disclosureList.toggleClass(classes.listVisible);
        }.bind(this)
      );
    },

    _connectOptions: function() {
      this.cache.$disclosureOptions.on(
        'click',
        function(evt) {
          this._submitForm($(evt.currentTarget).data('value'));
        }.bind(this)
      );
    },

    _onFocusOut: function() {
      this.cache.$disclosureToggle.on(
        'focusout',
        function(evt) {
          var disclosureLostFocus =
            this.$container.has(evt.relatedTarget).length === 0;

          if (disclosureLostFocus) {
            this._hideList();
          }
        }.bind(this)
      );

      this.cache.$disclosureList.on(
        'focusout',
        function(evt) {
          var childInFocus =
            $(evt.currentTarget).has(evt.relatedTarget).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !childInFocus) {
            this._hideList();
          }
        }.bind(this)
      );

      this.$container.on(
        'keyup',
        function(evt) {
          if (evt.which !== slate.utils.keyboardKeys.ESCAPE) return;
          this._hideList();
          this.cache.$disclosureToggle.focus();
        }.bind(this)
      );

      this.bodyOnClick = function(evt) {
        var isOption = this.$container.has(evt.target).length > 0;
        var isVisible = this.cache.$disclosureList.hasClass(
          classes.listVisible
        );

        if (isVisible && !isOption) {
          this._hideList();
        }
      }.bind(this);

      $('body').on('click', this.bodyOnClick);
    },

    _submitForm: function(value) {
      this.cache.$disclosureInput.val(value);
      this.$container.parents('form').submit();
      this.cache.$disclosureToggle.html(value);
    },

    _hideList: function() {
      this.cache.$disclosureList.removeClass(classes.listVisible);
      this.cache.$disclosureToggle.attr('aria-expanded', false);
    },

    unload: function() {
      $('body').off('click', this.bodyOnClick);
      this.cache.$disclosureOptions.off();
      this.cache.$disclosureToggle.off();
      this.cache.$disclosureList.off();
      this.$container.off();
    }
  });

  return Disclosure;
})();

$(document).ready(function() {

  (function() {
    $(document).on('shopify:section:load', function(event) {
      $('.no-fouc').removeClass('no-fouc');
      $('.load-wait').addClass('hide');

      // Call Fancybox globally on all elements with class fancybox
      $(".fancybox").fancybox({
        helpers: {
          overlay: {
            locked: false
          }
        }
      });
      //<![CDATA[
      jQuery(function() {
        jQuery('#sidebar ul li a').each(function() {
          if (jQuery(this).attr('href')  ===  window.location.pathname) {
            jQuery(this).addClass('current');
          }
        });
      });
      //]]>
      // Scroll to top
      $(window).scroll(function(){
        if ($(this).scrollTop() > 100) {
          $('.scrollup').fadeIn();
        } else {
          $('.scrollup').fadeOut();
        }
      });
      $('.scrollup').click(function(){
        $("html, body").animate({ scrollTop: 0 }, 600);
        return false;
      });

    });

    $(".has_sub_menu").hover(function(){
      $(this).attr('aria-expanded', function(index, attr){
        return attr == 'false' ? true : 'false';
      });
    });

  }());
});

$(document).ready(function() {

  $(document).on('click', function(e) {
    if ( $(e.target).closest('.seeks').length ) {
      $("#searchbox").show();
    }else if ( ! $(e.target).closest('#searchbox').length ) {
      $('#searchbox').hide();
    }
  });

  $('.no-fouc').removeClass('no-fouc');
  $('.load-wait').addClass('hide');

  setTimeout(heightFix, 500);
  function heightFix() {
    $('.prod-image').matchHeight();
  }

  $('.collection-image').matchHeight();

  // Help old browsers with placeholders for inputs
  $('input, textarea').placeholder();

  // Call Fancybox on all elemnets with class "fancybox"
  $('.fancybox').fancybox();

  // Call Fancybox for search & mailing list signup + stop scroll to top
  $(".open_popup").fancybox({
    helpers: {
      overlay: {
        locked: false
      }
    }
  });

  // Scroll to top button
  $(window).scroll(function(){
    if ($(this).scrollTop() > 100) {
      $('.scrollup').fadeIn();
    } else {
      $('.scrollup').fadeOut();
    }
  });

  $('.scrollup').click(function(){
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });

});

/*======================================================
  Slideshow Section
========================================================*/
theme.Slideshow = (function() {
  function Slideshow(container) {

    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var speed = $('.index_Slider').data('speed');

    $('.index_Slider').flexslider({
      animation: 'fade',
      slideshowSpeed: speed,
      animationSpeed: 600,
      directionNav: true,
      controlNav: false,
      pauseOnHover: true,
      pauseOnAction: true,
      nextText: '',
      prevText: ''
    });
  }

  return Slideshow;
})();

theme.Slideshow.prototype = _.assignIn({}, theme.Slideshow.prototype, {

  onBlockSelect: function(event) {

    // Ignore the cloned version
    var Slider = $(event.target).closest('.index_Slider').data('flexslider');
    var $slide =  $(event.target);
    var slideIndex = $slide.data('flexslider-index');
    // Go to selected slide, pause autoplay


    Slider.flexslider(slideIndex);
    Slider.flexslider("pause");

  },
  onBlockDeselect: function() {
    var Slider = $(event.target).closest('.index_Slider').data('flexslider');
    // Resume autoplay
    Slider.flexslider("play");

  }
});

/*======================================================
  Featured Collection Section
========================================================*/
theme.FeaturedProducts = (function() {
  function FeaturedProducts(container) {
	var $container = this.$container = $(container);

    // Collection carousel  edit to work with new theme editor
    var initHomepageCarousel = function(productCarousel) {
      productCarousel.owlCarousel({
        itemsCustom : [
          [0, 2],
          [450, 2],
          [600, 2],
          [700, 3],
          [1000, 4],
          [1200, 5],
          [1400, 5],
          [1600, 5]
        ],
        lazyLoad : false,
        pagination : false,
        navigation: true,
        navigationText : false,
        autoPlay : false,
        stopOnHover : true
      });
    };

    initHomepageCarousel($('.collection-carousel'));

    (function productQuickView() {
      var products = $('.collection-carousel .owl-item .lazyOwl', $container);

      $(products).each(function( index ) {
        var id = $( this ).data('productId');
        var quickView = $('[data-fancybox="quick-view-' + id + '"]');

        quickView.fancybox({
           type : 'ajax',
           toolbar: false,
           infobar: false,
           arrows: false,
           touch: false,
           autoFocus: false,
           iframe : {
            preload: true,
            css : {
              width : '800px'
            }
           },
           baseClass: 'quickview-popup',
           afterShow: function () {
            var context = document.querySelector(".product-quick-view");

             Events.trigger("quickview:load", context);
             // Close fancybox after add to cart
             Events.on("ajaxcart:cartUpdate", function() {
               $.fancybox.close()
             });
           }
         });
      });
     })();

    $(document).on('shopify:section:unload', function(event) {
      var target = $(event.target);
      target.find('.collection-carousel').owlCarousel("destroy");
      $(document).off('.collection-carousel');
    });

    $(document).on('shopify:section:load', function(event) {
      initHomepageCarousel($(event.target).find('.collection-carousel'));
      $('.prod-image').matchHeight({ remove: true });
      setTimeout(heightFix, 500);
      function heightFix() {
      $('.prod-image').matchHeight();
      }
    });


  }

  FeaturedProducts.prototype = _.assignIn({}, FeaturedProducts.prototype, {});

  return FeaturedProducts;
})();

/*============================================================================
  Product Modules
==============================================================================*/

var Events = new EventEmitter3();
Events.trigger = Events.emit; // trigger alias

var mobile = window.matchMedia('(max-width: 740px)');
var tablet = window.matchMedia('(max-width: 979px) and (min-width: 741px)');
var device = window.matchMedia('(max-width: 980px)');
var desktop = window.matchMedia('(min-width: 980px)');

theme.ProductForm = function (context, events, Product) {
    var formConfig = context.querySelector('#AddToCartForm');
    var config = JSON.parse(formConfig.dataset.productForm || '{}');

    (function quantity() {
      var element = context.querySelector("[name=quantity]");

      events.on("quantitycontrol:click", change);

      function change(value) {
        var quantity = parseInt(element.value) + value;

        if ( quantity < 1 ) {
          return false;
        }

        element.value = quantity;
      }
    })();

    (function quantity_controls() {
      Control(".quantity-control-up", 1);
      Control(".quantity-control-down", -1);

      function Control(selector, value) {
        var element = context.querySelector(selector);

        if ( !element ) {
          return false;
        }

        element.addEventListener("click", function (event) {
          event.preventDefault();
          events.trigger("quantitycontrol:click", value);
        });
      }
    })();

    if ( Product.variants.length == 1 ) {
      return false;
    }

    if ( config.quickview ) {
      var prodSelector = "qv-product-select-" + Product.id;
    } else {
      var prodSelector = "product-select-" + Product.id;
    }

    new Shopify.OptionSelectors(prodSelector, {
      product: Product,
      onVariantSelected: function(variant, selector) {
if(variant)
{
   
 var pid = $('.product-section').data("product-id");
    var thumbnails = $("#thumbnail-gallery");
    var thumbnails1 = $("#thumbnail-gallery1");                 
	 
                
            	var selected = $("#product-select-"+pid+"-option-0 option:selected").val();
                     
                 if (selected == 'Default Title')
                     {
                        $(".slider-for").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                fade: true,
                 arrows: true,
     prevArrow:"<button type='button' class='slick-prev'><svg viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z'></path></svg></button>",
  nextArrow:"<button type='button' class='slick-next'><svg viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z' transform='translate(100, 100) rotate(180)''></path></svg></button>",
                asNavFor: ".slider-nav",
                responsive: [
                    {
                        breakpoint: 640,
                        settings: {
                            dots: true,
                        },
                    },
                ],
            });
                         
    $(".slider-nav").slick({
                slidesToShow:4,
                slidesToScroll: 1,
                asNavFor: ".slider-for",
                dots: false,
                arrows: false,
                vertical: true,
                focusOnSelect: true,
            });
                    }
                    else {
                     
	 
        thumbnails.empty();
        thumbnails1.empty();
	
        var addImage = '';
        var addImage1 = '';             
		$.each( images, function( i, image ) { console.log(images[i]);
      		var alt = images[i].alt; 
            var url = images[i].url;
            var image_id = images[i].imagid;
			var product_name = ''; 
      		
                   
			if (alt == selected) {
              
				addImage += '<li>     <a id="zoom1" data-zoom-id="zoom1"   href="' + url + '" class="MagicZoomPlus"  data-ver="' + url + '"><img   src="' + url + '" alt="' + alt + '"  class="img-fluid"></a> </li>';
                    
				//arr.push(addImage);
                addImage1 += '<li> <img  src="' + url + '" alt="' + alt + '"  class="img-fluid" > </li>';    
      		    //arr1.push(addImage1);
            }
    	});
          	addImage = '<div class="slider-for">'+addImage+'</div>';
           
          	thumbnails.html(addImage);
       
       $(".slider-for").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                fade: true,
                 arrows: true,
     prevArrow:"<button type='button' class='slick-prev'><svg viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z'></path></svg></button>",
  nextArrow:"<button type='button' class='slick-next'><svg viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z' transform='translate(100, 100) rotate(180)''></path></svg></button>",
                asNavFor: ".slider-nav",
                responsive: [
                    {
                        breakpoint: 640,
                        settings: {
                            dots: true,
                        },
                    },
                ],
            });
     
         
           addImage1 = '<div class="slider-nav">'+addImage1+'</div>';
          	thumbnails1.html(addImage1);
    
    $(".slider-nav").slick({
                slidesToShow:4,
                slidesToScroll: 1,
                asNavFor: ".slider-for",
                dots: false,
                arrows: false,
                vertical: true,
                focusOnSelect: true,
            });
    $(window).trigger('resize');
      eval(function(m,a,g,i,c,k){c=function(e){return(e<a?'':c(parseInt(e/a)))+((e=e%a)>35?String.fromCharCode(e+29):e.toString(36))};if(!''.replace(/^/,String)){while(g--){k[c(g)]=i[g]||c(g)}i=[function(e){return k[e]}];c=function(){return'\\w+'};g=1};while(g--){if(i[g]){m=m.replace(new RegExp('\\b'+c(g)+'\\b','g'),i[g])}}return m}('1m.9C=(17(){1b x,y;x=y=(17(){1b T={4F:"kC.3-b5-7-gw",dM:0,8a:{},$b8:17(X){1a(X.$6C||(X.$6C=++N.dM))},9K:17(X){1a(N.8a[X]||(N.8a[X]={}))},$F:17(){},$1k:17(){1a 1k},$1s:17(){1a 1s},eK:"fm-"+1p.5Q(1p.6q()*1t av().eC()),3q:17(X){1a(2A!=X)},bn:17(Y,X){1a(2A!=Y)?Y:X},a3:17(X){1a!!(X)},1Q:17(X){if(!N.3q(X)){1a 1k}if(X.$4H){1a X.$4H}if(!!X.6b){if(1==X.6b){1a"6c"}if(3==X.6b){1a"eU"}}if(X.1K&&X.d4){1a"go"}if(X.1K&&X.9F){1a"26"}if((X 3G 1m.75||X 3G 1m.bj)&&X.5n===N.3L){1a"41"}if(X 3G 1m.6p){1a"4a"}if(X 3G 1m.bj){1a"17"}if(X 3G 1m.6e){1a"1N"}if(N.1e.4O){if(N.3q(X.eu)){1a"1z"}}1j{if(X===1m.1z||X.5n==1m.1v||X.5n==1m.fx||X.5n==1m.dR||X.5n==1m.gx||X.5n==1m.fU){1a"1z"}}if(X 3G 1m.av){1a"eR"}if(X 3G 1m.fj){1a"fS"}if(X===1m){1a"1m"}if(X===1n){1a"1n"}1a 8B(X)},29:17(ac,ab){if(!(ac 3G 1m.6p)){ac=[ac]}if(!ab){1a ac[0]}1T(1b aa=0,Y=ac.1K;aa<Y;aa++){if(!N.3q(ac)){8F}1T(1b Z in ab){if(!75.2w.3V.2e(ab,Z)){8F}3d{ac[aa][Z]=ab[Z]}3w(X){}}}1a ac[0]},9E:17(ab,aa){if(!(ab 3G 1m.6p)){ab=[ab]}1T(1b Z=0,X=ab.1K;Z<X;Z++){if(!N.3q(ab[Z])){8F}if(!ab[Z].2w){8F}1T(1b Y in(aa||{})){if(!ab[Z].2w[Y]){ab[Z].2w[Y]=aa[Y]}}}1a ab[0]},ft:17(Z,Y){if(!N.3q(Z)){1a Z}1T(1b X in(Y||{})){if(!Z[X]){Z[X]=Y[X]}}1a Z},$3d:17(){1T(1b Y=0,X=26.1K;Y<X;Y++){3d{1a 26[Y]()}3w(Z){}}1a 1h},$A:17(Z){if(!N.3q(Z)){1a N.$([])}if(Z.cy){1a N.$(Z.cy())}if(Z.d4){1b Y=Z.1K||0,X=1t 6p(Y);5G(Y--){X[Y]=Z[Y]}1a N.$(X)}1a N.$(6p.2w.aQ.2e(Z))},6t:17(){1a 1t av().eC()},4b:17(ab){1b Z;4G(N.1Q(ab)){1C"8K":Z={};1T(1b aa in ab){Z[aa]=N.4b(ab[aa])}1H;1C"4a":Z=[];1T(1b Y=0,X=ab.1K;Y<X;Y++){Z[Y]=N.4b(ab[Y])}1H;1P:1a ab}1a N.$(Z)},$:17(Z){1b X=1s;if(!N.3q(Z)){1a 1h}if(Z.$bd){1a Z}4G(N.1Q(Z)){1C"4a":Z=N.ft(Z,N.29(N.6p,{$bd:N.$F}));Z.36=Z.fo;1a Z;1H;1C"1N":1b Y=1n.e8(Z);if(N.3q(Y)){1a N.$(Y)}1a 1h;1H;1C"1m":1C"1n":N.$b8(Z);Z=N.29(Z,N.3z);1H;1C"6c":N.$b8(Z);Z=N.29(Z,N.3Z);1H;1C"1z":Z=N.29(Z,N.1v);1H;1C"eU":1C"17":1C"4a":1C"eR":1P:X=1k;1H}if(X){1a N.29(Z,{$bd:N.$F})}1j{1a Z}},$1t:17(X,Z,Y){1a N.$(N.ej.8d(X)).8q(Z||{}).1y(Y||{})},6J:17(aa,ab,Y){1b X,ad,Z,af=[],ae=-1;Y||(Y=N.eK);X=N.$(Y)||N.$1t("2n",{id:Y,1u:"am/62"}).2a((1n.hY||1n.3B),"1G");ad=X.fa||X.f6;if("1N"!=N.1Q(ab)){1T(1b Z in ab){af.3c(Z+":"+ab[Z])}ab=af.7D(";")}if(ad.eG){ae=ad.eG(aa+" {"+ab+"}",ad.g7.1K)}1j{3d{ae=ad.gj(aa,ab,ad.gS.1K)}3w(ac){}}1a ae},gs:17(aa,X){1b Z,Y;Z=N.$(aa);if("6c"!==N.1Q(Z)){1a}Y=Z.fa||Z.f6;if(Y.f5){Y.f5(X)}1j{if(Y.dk){Y.dk(X)}}},gG:17(){1a"gE-gB-gA-gy-gm".4r(/[gp]/g,17(Z){1b Y=1p.6q()*16|0,X=Z=="x"?Y:(Y&3|8);1a X.7U(16)}).7C()},6o:(17(){1b X;1a 17(Y){if(!X){X=1n.8d("a")}X.3y("79",Y);1a("!!"+X.79).4r("!!","")}})(),h3:17(Z){1b aa=0,X=Z.1K;1T(1b Y=0;Y<X;++Y){aa=31*aa+Z.fh(Y);aa%=gY}1a aa}};1b N=T;1b O=T.$;if(!1m.fk){1m.fk=T;1m.$fm=T.$}N.6p={$4H:"4a",4J:17(aa,ab){1b X=13.1K;1T(1b Y=13.1K,Z=(ab<0)?1p.1X(0,Y+ab):ab||0;Z<Y;Z++){if(13[Z]===aa){1a Z}}1a-1},5M:17(X,Y){1a 13.4J(X,Y)!=-1},fo:17(X,aa){1T(1b Z=0,Y=13.1K;Z<Y;Z++){if(Z in 13){X.2e(aa,13[Z],Z,13)}}},2Z:17(X,ac){1b ab=[];1T(1b aa=0,Y=13.1K;aa<Y;aa++){if(aa in 13){1b Z=13[aa];if(X.2e(ac,13[aa],aa,13)){ab.3c(Z)}}}1a ab},gL:17(X,ab){1b aa=[];1T(1b Z=0,Y=13.1K;Z<Y;Z++){if(Z in 13){aa[Z]=X.2e(ab,13[Z],Z,13)}}1a aa}};N.9E(6e,{$4H:"1N",57:17(){1a 13.4r(/^\\s+|\\s+$/g,"")},eq:17(X,Y){1a(Y||1k)?(13.7U()===X.7U()):(13.4S().7U()===X.4S().7U())},5v:17(){1a 13.4r(/-\\D/g,17(X){1a X.9v(1).7C()})},92:17(){1a 13.4r(/[A-Z]/g,17(X){1a("-"+X.9v(0).4S())})},gl:17(X){1a 5U(13,X||10)},fV:17(){1a 2t(13)},eA:17(){1a!13.4r(/1s/i,"").57()},3Q:17(Y,X){X=X||"";1a(X+13+X).4J(X+Y+X)>-1}});T.9E(bj,{$4H:"17",1E:17(){1b Y=N.$A(26),X=13,Z=Y.6N();1a 17(){1a X.6B(Z||1h,Y.5E(N.$A(26)))}},2I:17(){1b Y=N.$A(26),X=13,Z=Y.6N();1a 17(aa){1a X.6B(Z||1h,N.$([aa||(N.1e.2z?1m.1z:1h)]).5E(Y))}},2E:17(){1b Y=N.$A(26),X=13,Z=Y.6N();1a 1m.4q(17(){1a X.6B(X,Y)},Z||0)},ex:17(){1b Y=N.$A(26),X=13;1a 17(){1a X.2E.6B(X,Y)}},e9:17(){1b Y=N.$A(26),X=13,Z=Y.6N();1a 1m.f7(17(){1a X.6B(X,Y)},Z||0)}});1b U={};1b M=3E.fW.4S();1b L=M.3A(/(3K|6g|4O|aS)\\/(\\d+\\.?\\d*)/i);1b Q=M.3A(/(fM|bw)\\/(\\d+\\.?\\d*)/i)||M.3A(/(eB|5A|9p|eY|76|bw)\\/(\\d+\\.?\\d*)/i);1b S=M.3A(/4F\\/(\\d+\\.?\\d*)/i);1b H=1n.5b.2n;17 I(Y){1b X=Y.9v(0).7C()+Y.aQ(1);1a Y in H||("cT"+X)in H||("dm"+X)in H||("5Y"+X)in H||("O"+X)in H}N.1e={2M:{fL:!!(1n.fF),fG:!!(1m.bR),bU:!!(1n.dZ),4Z:!!(1n.fN||1n.fY||1n.a9||1n.ct||1n.g9||1n.gi||1n.fX||1n.gb||1n.fZ),en:!!(1m.g5)&&!!(1m.g3)&&(1m.ao&&"g2"in 1t ao),21:I("21"),2j:I("2j"),8Y:I("8Y"),eP:I("eP"),4P:1k,d7:1k,7S:1k,5V:1k,7L:(17(){1a 1n.h5.gM("bi://bh.bf.be/i8/i7/hS#hW","1.1")}())},aA:(17(){1a"hU"in 1m||(1m.eL&&1n 3G eL)||(3E.ic>0)||(3E.ix>0)}()),2T:!!M.3A(/(6L|bb\\d+|iw).+|iu|it\\/|ir|im|il|hQ|hu|hP|ho|ip(cY|cX|ad)|hj|ht|hH |hv|hC|hB|2T.+eY|hz|76 m(hy|in)i|i9( hx)?|fB|p(hE|ij)\\/|hT|i0|i5|g1(4|6)0|fQ|gP|gK\\.(1e|3S)|gn|gu|gz (ce|fB)|iB|gF/),7b:(L&&L[1])?L[1].4S():(1m.76)?"aS":!!(1m.gD)?"4O":(1n.gC!==2A||1m.gv!==1h)?"6g":(1m.gt!==1h||!3E.gr)?"3K":"gq",4F:(L&&L[2])?2t(L[2]):0,4v:(Q&&Q[1])?Q[1].4S():"",72:(Q&&Q[2])?2t(Q[2]):0,8E:"",aM:"",52:"",2z:0,4X:M.3A(/ip(?:ad|cX|cY)/)?"9q":(M.3A(/(?:h2|6L)/)||3E.4X.3A(/gW|al|gR/i)||["gQ"])[0].4S(),cR:1n.9P&&1n.9P.4S()==="d0",fs:0,43:17(){1a(1n.9P&&1n.9P.4S()==="d0")?1n.3B:1n.5b},4P:1m.4P||1m.gk||1m.fJ||1m.g8||1m.g4||2A,ap:1m.ap||1m.d2||1m.d2||1m.i6||1m.i4||1m.i3||2A,2l:1k,7F:17(){if(N.1e.2l){1a}1b aa;1b Z;N.1e.2l=1s;N.3B=N.$(1n.3B);N.al=N.$(1m);3d{1b Y=N.$1t("2V").1y({1f:2K,1g:2K,7O:"6u",2h:"5J",1G:-i1}).2a(1n.3B);N.1e.fs=Y.cI-Y.eg;Y.2S()}3w(X){}3d{aa=N.$1t("2V");Z=aa.2n;Z.db="d8:1V(aE://),1V(aE://),hX 1V(aE://)";N.1e.2M.d7=(/(1V\\s*\\(.*?){3}/).3n(Z.d8);Z=1h;aa=1h}3w(X){}if(!N.1e.7J){N.1e.7J=N.8X("2j").92()}3d{aa=N.$1t("2V");aa.2n.db=N.8X("2Z").92()+":5i(hr);";N.1e.2M.7S=!!aa.2n.1K&&(!N.1e.2z||N.1e.2z>9);aa=1h}3w(X){}if(!N.1e.2M.7S){N.$(1n.5b).1B("73-hb-3i")}3d{N.1e.2M.5V=(17(){1b ab=N.$1t("5V");1a!!(ab.df&&ab.df("2d"))}())}3w(X){}if(1m.hA===2A&&1m.hw!==2A){U.2U="fK"}N.3z.2W.2e(N.$(1n),"9l")}};(17(){1b Y=[],ab,aa,ac;17 X(){1a!!(26.9F.aW)}4G(N.1e.7b){1C"4O":if(!N.1e.4F){N.1e.4F=!!(1m.ao)?3:2}1H;1C"6g":N.1e.4F=(Q&&Q[2])?2t(Q[2]):0;1H}N.1e[N.1e.7b]=1s;if(Q&&Q[1]==="eB"){N.1e.4v="5A"}if(!!1m.5A){N.1e.5A=1s}if(Q&&Q[1]==="bw"){N.1e.4v="76";N.1e.76=1s}if(N.1e.4v==="9p"&&(S&&S[1])){N.1e.72=2t(S[1])}if(N.1e.4X==="6L"&&N.1e.3K&&(S&&S[1])){N.1e.7T=1s}ab=({6g:["-dp-","dm","dp"],3K:["-3K-","cT","3K"],4O:["-5Y-","5Y","5Y"],aS:["-o-","O","o"]})[N.1e.7b]||["","",""];N.1e.8E=ab[0];N.1e.aM=ab[1];N.1e.52=ab[2];N.1e.2z=!N.1e.4O?2A:(1n.cK)?1n.cK:(17(){1b ad=0;if(N.1e.cR){1a 5}4G(N.1e.4F){1C 2:ad=6;1H;1C 3:ad=7;1H}1a ad}());Y.3c(N.1e.4X+"-3i");if(N.1e.2T){Y.3c("2T-3i")}if(N.1e.7T){Y.3c("6L-1e-3i")}if(N.1e.2z){N.1e.4v="ie";N.1e.72=N.1e.2z;Y.3c("ie"+N.1e.2z+"-3i");1T(aa=11;aa>N.1e.2z;aa--){Y.3c("hD-ie"+aa+"-3i")}}if(N.1e.3K&&N.1e.4F<hG){N.1e.2M.4Z=1k}if(N.1e.4P){N.1e.4P.2e(1m,17(){N.1e.2M.4P=1s})}if(N.1e.2M.7L){Y.3c("7L-3i")}1j{Y.3c("73-7L-3i")}ac=(1n.5b.5W||"").3A(/\\S+/g)||[];1n.5b.5W=N.$(ac).5E(Y).7D(" ");3d{1n.5b.3y("3v-3i-cw",N.1e.4v);1n.5b.3y("3v-3i-cw-hI",N.1e.72)}3w(Z){}if(N.1e.2z&&N.1e.2z<9){1n.8d("5O");1n.8d("dS")}if(!1m.3E.6I){N.$(["hJ","hK","hL","hM","hN"]).36(17(ad){U["hO"+ad.4S()]=1m.3E.7Z?"hF"+ad:-1})}}());(17(){N.1e.4Z={a6:N.1e.2M.4Z,4W:17(){1a!!(1n.hi||1n[N.1e.52+"hs"]||1n.4Z||1n.h9||1n[N.1e.52+"ha"])},bX:17(X,Y){if(!Y){Y={}}if(13.a6){N.$(1n).1D(13.b3,13.cs=17(Z){if(13.4W()){if(Y.ch){Y.ch()}}1j{N.$(1n).1O(13.b3,13.cs);if(Y.bK){Y.bK()}}}.2I(13));N.$(1n).1D(13.aH,13.69=17(Z){if(Y.8h){Y.8h()}N.$(1n).1O(13.aH,13.69)}.2I(13));(X.hc||X[N.1e.52+"hd"]||X[N.1e.52+"he"]||17(){}).2e(X)}1j{if(Y.8h){Y.8h()}}},e6:(1n.a9||1n.ct||1n[N.1e.52+"hf"]||1n[N.1e.52+"hg"]||17(){}).1E(1n),b3:1n.cl?"h8":(1n.a9?"":N.1e.52)+"hh",aH:1n.cl?"hk":(1n.a9?"":N.1e.52)+"hm",hn:N.1e.52,hp:1h}}());1b W=/\\S+/g,K=/^(3N(cp|co|cn|cm)hq)|((7N|8p)(cp|co|cn|cm))$/,P={"ih":("2A"===8B(H.cB))?"ik":"cB"},R={eI:1s,cA:1s,2o:1s,f4:1s,1l:1s},J=(1m.cQ)?17(Z,X){1b Y=1m.cQ(Z,1h);1a Y?Y.io(X)||Y[X]:1h}:17(aa,Y){1b Z=aa.iq,X=1h;X=Z?Z[Y]:1h;if(1h==X&&aa.2n&&aa.2n[Y]){X=aa.2n[Y]}1a X};17 V(Z){1b X,Y;Y=(N.1e.3K&&"2Z"==Z)?1k:(Z in H);if(!Y){X=N.1e.aM+Z.9v(0).7C()+Z.aQ(1);if(X in H){1a X}}1a Z}N.8X=V;N.3Z={cN:17(X){1a!(X||"").3Q(" ")&&(13.5W||"").3Q(X," ")},1B:17(ab){1b Y=(13.5W||"").3A(W)||[],aa=(ab||"").3A(W)||[],X=aa.1K,Z=0;1T(;Z<X;Z++){if(!N.$(Y).5M(aa[Z])){Y.3c(aa[Z])}}13.5W=Y.7D(" ");1a 13},1U:17(ac){1b Y=(13.5W||"").3A(W)||[],ab=(ac||"").3A(W)||[],X=ab.1K,aa=0,Z;1T(;aa<X;aa++){if((Z=N.$(Y).4J(ab[aa]))>-1){Y.9z(Z,1)}}13.5W=ac?Y.7D(" "):"";1a 13},is:17(X){1a 13.cN(X)?13.1U(X):13.1B(X)},3t:17(Y){1b Z=Y.5v(),X=1h;Y=P[Z]||(P[Z]=V(Z));X=J(13,Y);if("2D"===X){X=1h}if(1h!==X){if("2o"==Y){1a N.3q(X)?2t(X):1}if(K.3n(Y)){X=5U(X,10)?X:"6x"}}1a X},3F:17(Y,X){1b aa=Y.5v();3d{if("2o"==Y){13.cM(X);1a 13}Y=P[aa]||(P[aa]=V(aa));13.2n[Y]=X+(("66"==N.1Q(X)&&!R[aa])?"2v":"")}3w(Z){}1a 13},1y:17(Y){1T(1b X in Y){13.3F(X,Y[X])}1a 13},ii:17(){1b X={};N.$A(26).36(17(Y){X[Y]=13.3t(Y)},13);1a X},cM:17(Z,X){1b Y;X=X||1k;13.2n.2o=Z;Z=5U(2t(Z)*2K);if(X){if(0===Z){if("3p"!=13.2n.4w){13.2n.4w="3p"}}1j{if("5u"!=13.2n.4w){13.2n.4w="5u"}}}if(N.1e.2z&&N.1e.2z<9){if(!9Z(Z)){if(!~13.2n.2Z.4J("aG")){13.2n.2Z+=" cL:cJ.cC.aG(9i="+Z+")"}1j{13.2n.2Z=13.2n.2Z.4r(/9i=\\d*/i,"9i="+Z)}}1j{13.2n.2Z=13.2n.2Z.4r(/cL:cJ.cC.aG\\(9i=\\d*\\)/i,"").57();if(""===13.2n.2Z){13.2n.5H("2Z")}}}1a 13},8q:17(X){1T(1b Y in X){if("41"===Y){13.1B(""+X[Y])}1j{13.3y(Y,""+X[Y])}}1a 13},iy:17(){1b Y=0,X=0;Y=13.3t("21-5e");X=13.3t("21-bH");Y=Y.4J("5Y")>-1?2t(Y):Y.4J("s")>-1?2t(Y)*b4:0;X=X.4J("5Y")>-1?2t(X):X.4J("s")>-1?2t(X)*b4:0;1a Y+X},4t:17(){1a 13.1y({6w:"2X",4w:"3p"})},5I:17(){1a 13.1y({6w:"",4w:"5u"})},1F:17(){1a{1f:13.cI,1g:13.iz}},89:17(Y){1b X=13.1F();X.1f-=(2t(13.3t("3N-1M-1f")||0)+2t(13.3t("3N-2H-1f")||0));X.1g-=(2t(13.3t("3N-1G-1f")||0)+2t(13.3t("3N-2J-1f")||0));if(!Y){X.1f-=(2t(13.3t("7N-1M")||0)+2t(13.3t("7N-2H")||0));X.1g-=(2t(13.3t("7N-1G")||0)+2t(13.3t("7N-2J")||0))}1a X},7i:17(){1a{1G:13.8f,1M:13.8z}},iA:17(){1b X=13,Y={1G:0,1M:0};do{Y.1M+=X.8z||0;Y.1G+=X.8f||0;X=X.4I}5G(X);1a Y},8o:17(){1b ab=13,Y=0,aa=0;if(N.3q(1n.5b.7f)){1b X=13.7f(),Z=N.$(1n).7i(),ac=N.1e.43();1a{1G:X.1G+Z.y-ac.iF,1M:X.1M+Z.x-ac.iC}}do{Y+=ab.iD||0;aa+=ab.iE||0;ab=ab.iv}5G(ab&&!(/^(?:3B|bV)$/i).3n(ab.az));1a{1G:aa,1M:Y}},7P:17(){1b Y=13.8o();1b X=13.1F();1a{1G:Y.1G,2J:Y.1G+X.1g,1M:Y.1M,2H:Y.1M+X.1f}},5r:17(Y){3d{13.ig=Y}3w(X){13.i2=Y}1a 13},2S:17(){1a(13.4I)?13.4I.bk(13):13},5f:17(){N.$A(13.hV).36(17(X){if(3==X.6b||8==X.6b){1a}N.$(X).5f()});13.2S();13.bC();if(13.$6C){N.8a[13.$6C]=1h;4R N.8a[13.$6C]}1a 1h},3a:17(Z,Y){Y=Y||"2J";1b X=13.4n;("1G"==Y&&X)?13.hZ(Z,X):13.c9(Z);1a 13},2a:17(Z,Y){1b X=N.$(Z).3a(13,Y);1a 13},dG:17(X){13.3a(X.4I.7V(13,X));1a 13},a4:17(X){if("6c"!==N.1Q("1N"==N.1Q(X)?X=1n.e8(X):X)){1a 1k}1a(13==X)?1k:(13.5M&&!(N.1e.ef))?(13.5M(X)):(13.eb)?!!(13.eb(X)&16):N.$A(13.8r(X.az)).5M(X)}};N.3Z.h6=N.3Z.3t;N.3Z.ia=N.3Z.1y;if(!1m.3Z){1m.3Z=N.$F;if(N.1e.7b.3K){1m.1n.8d("ib")}1m.3Z.2w=(N.1e.7b.3K)?1m["[[hR.2w]]"]:{}}N.9E(1m.3Z,{$4H:"6c"});N.3z={1F:17(){if(N.1e.aA||N.1e.g0||N.1e.ef){1a{1f:1m.5K,1g:1m.5k}}1a{1f:N.1e.43().eg,1g:N.1e.43().g6}},7i:17(){1a{x:1m.ga||N.1e.43().8z,y:1m.gc||N.1e.43().8f}},gd:17(){1b X=13.1F();1a{1f:1p.1X(N.1e.43().ge,X.1f),1g:1p.1X(N.1e.43().gf,X.1g)}}};N.29(1n,{$4H:"1n"});N.29(1m,{$4H:"1m"});N.29([N.3Z,N.3z],{2c:17(aa,Y){1b X=N.9K(13.$6C),Z=X[aa];if(2A!==Y&&2A===Z){Z=X[aa]=Y}1a(N.3q(Z)?Z:1h)},3b:17(Z,Y){1b X=N.9K(13.$6C);X[Z]=Y;1a 13},34:17(Y){1b X=N.9K(13.$6C);4R X[Y];1a 13}});if(!(1m.aX&&1m.aX.2w&&1m.aX.2w.aY)){N.29([N.3Z,N.3z],{aY:17(X){1a N.$A(13.9S("*")).2Z(17(Z){3d{1a(1==Z.6b&&Z.5W.3Q(X," "))}3w(Y){}})}})}N.29([N.3Z,N.3z],{9A:17(){1a 13.aY(26[0])},8r:17(){1a 13.9S(26[0])}});if(N.1e.4Z.a6&&!1n.ep){N.3Z.ep=17(){N.1e.4Z.bX(13)}}N.1v={$4H:"1z",6l:N.$1k,2i:17(){1a 13.5h().3U()},5h:17(){if(13.et){13.et()}1j{13.eu=1s}1a 13},3U:17(){if(13.ev){13.ev()}1j{13.fH=1k}1a 13},4u:17(){13.6l=N.$1s;1a 13},7p:17(){1b X=(/3I/i).3n(13.1u)?13.33[0]:13;1a!N.3q(X)?{x:0,y:0}:{x:X.2F,y:X.2G}},5w:17(){1b X=(/3I/i).3n(13.1u)?13.33[0]:13;1a!N.3q(X)?{x:0,y:0}:{x:X.4Q||X.2F+N.1e.43().8z,y:X.4T||X.2G+N.1e.43().8f}},b2:17(){1b X=13.4d||13.fI;5G(X&&X.6b===3){X=X.4I}1a X},8H:17(){1b Y=1h;4G(13.1u){1C"7w":1C"fO":1C"fP":Y=13.9y||13.fR;1H;1C"8u":1C"bB":1C"eX":Y=13.9y||13.fT;1H;1P:1a Y}3d{5G(Y&&Y.6b===3){Y=Y.4I}}3w(X){Y=1h}1a Y},6Z:17(){if(!13.dL&&13.2q!==2A){1a(13.2q&1?1:(13.2q&2?3:(13.2q&4?2:0)))}1a 13.dL},6k:17(){1a(13.2B&&(13.2B==="3I"||13.2B===13.6h))||(/3I/i).3n(13.1u)},5o:17(){if(13.2B){1a(13.2B==="3I"||13.6h===13.2B)&&13.7G}1j{if(13 3G 1m.7H){1a 13.33.1K===1&&(13.9b.1K?13.9b[0].4A===13.33[0].4A:1s)}}1a 1k},5X:17(){if(13.2B){1a 13.7G&&(13.2B==="3I"||13.6h===13.2B)?13:1h}1j{if(13 3G 1m.7H){1a 13.33[0]}}1a 1h},8g:17(){if(13.2B){1a 13.7G&&(13.2B==="3I"||13.6h===13.2B)?13.9g:1h}1j{if(13 3G 1m.7H){1a 13.33[0].4A}}1a 1h}};N.b1="e0";N.aZ="gJ";N.9w="";if(!1n.e0){N.b1="gN";N.aZ="gO";N.9w="8T"}N.1v.1x={1u:"",x:1h,y:1h,2O:1h,2q:1h,4d:1h,9y:1h,$4H:"1z.4m",6l:N.$1k,5a:N.$([]),4f:17(X){1b Y=X;13.5a.3c(Y)},2i:17(){1a 13.5h().3U()},5h:17(){13.5a.36(17(Y){3d{Y.5h()}3w(X){}});1a 13},3U:17(){13.5a.36(17(Y){3d{Y.3U()}3w(X){}});1a 13},4u:17(){13.6l=N.$1s;1a 13},7p:17(){1a{x:13.2F,y:13.2G}},5w:17(){1a{x:13.x,y:13.y}},b2:17(){1a 13.4d},8H:17(){1a 13.9y},6Z:17(){1a 13.2q},du:17(){1a 13.5a.1K>0?13.5a[0].b2():2A},6k:17(){1a(13.2B&&(13.2B==="3I"||13.2B===13.6h))||(/3I/i).3n(13.1u)},5o:17(){if(13.2B){1a(13.2B==="3I"||13.6h===13.2B)&&13.7G}1j{if(13 3G 1m.7H){1a 13.33.1K===1&&(13.9b.1K?13.9b[0].4A===13.33[0].4A:1s)}}1a 1k},5X:17(){if(13.2B){1a 13.7G&&(13.2B==="3I"||13.6h===13.2B)?13:1h}1j{if(13 3G 1m.7H){1a 13.33[0]}}1a 1h},8g:17(){if(13.2B){1a 13.7G&&(13.2B==="3I"||13.6h===13.2B)?13.9g:1h}1j{if(13 3G 1m.7H){1a 13.33[0].4A}}1a 1h}};N.29([N.3Z,N.3z],{1D:17(Z,ab,ac,af){1b ae,X,aa,ad,Y;if(N.1Q(Z)==="1N"){Y=Z.8s(" ");if(Y.1K>1){Z=Y}}if(N.1Q(Z)==="4a"){N.$(Z).36(13.1D.2I(13,ab,ac,af));1a 13}Z=U[Z]||Z;if(!Z||!ab||N.1Q(Z)!=="1N"||N.1Q(ab)!=="17"){1a 13}if(Z==="9l"&&N.1e.2l){ab.2e(13);1a 13}ac=5U(ac||50,10);if(!ab.$9B){ab.$9B=1p.5Q(1p.6q()*N.6t())}ae=N.3z.2c.2e(13,"7Y",{});X=ae[Z];if(!X){ae[Z]=X=N.$([]);aa=13;if(N.1v.1x[Z]){N.1v.1x[Z].1L.5t.2e(13,af)}1j{X.3m=17(ag){ag=N.29(ag||1m.e,{$4H:"1z"});N.3z.2W.2e(aa,Z,N.$(ag))};13[N.b1](N.9w+Z,X.3m,1k)}}ad={1u:Z,fn:ab,b0:ac,dD:ab.$9B};X.3c(ad);X.gX(17(ah,ag){1a ah.b0-ag.b0});1a 13},1O:17(ad){1b ab=N.3z.2c.2e(13,"7Y",{});1b Z;1b X;1b Y;1b ae;1b ac;1b aa;ac=26.1K>1?26[1]:-2K;if(N.1Q(ad)==="1N"){aa=ad.8s(" ");if(aa.1K>1){ad=aa}}if(N.1Q(ad)==="4a"){N.$(ad).36(13.1O.2I(13,ac));1a 13}ad=U[ad]||ad;if(!ad||N.1Q(ad)!=="1N"||!ab||!ab[ad]){1a 13}Z=ab[ad]||[];1T(Y=0;Y<Z.1K;Y++){X=Z[Y];if(ac===-2K||!!ac&&ac.$9B===X.dD){ae=Z.9z(Y--,1)}}if(Z.1K===0){if(N.1v.1x[ad]){N.1v.1x[ad].1L.2S.2e(13)}1j{13[N.aZ](N.9w+ad,Z.3m,1k)}4R ab[ad]}1a 13},2W:17(aa,ac){1b Z=N.3z.2c.2e(13,"7Y",{});1b Y;1b X;aa=U[aa]||aa;if(!aa||N.1Q(aa)!=="1N"||!Z||!Z[aa]){1a 13}3d{ac=N.29(ac||{},{1u:aa})}3w(ab){}if(ac.2O===2A){ac.2O=N.6t()}Y=Z[aa]||[];1T(X=0;X<Y.1K&&!(ac.6l&&ac.6l());X++){Y[X].fn.2e(13,ac)}},bZ:17(Y,X){1b ab=(Y!=="9l");1b aa=13;1b Z;Y=U[Y]||Y;if(!ab){N.3z.2W.2e(13,Y);1a 13}if(aa===1n&&1n.9D&&!aa.aC){aa=1n.5b}if(1n.9D){Z=1n.9D(Y);Z.65(X,1s,1s)}1j{Z=1n.h0();Z.9O=Y}if(1n.9D){aa.aC(Z)}1j{aa.h1("8T"+X,Z)}1a Z},bC:17(){1b Y=N.3z.2c.2e(13,"7Y");if(!Y){1a 13}1T(1b X in Y){N.3z.1O.2e(13,X)}N.3z.34.2e(13,"7Y");1a 13}});(17(X){if(1n.8A==="8y"){1a X.1e.7F.2E(1)}if(X.1e.3K&&X.1e.4F<h4){(17(){if(X.$(["2f","8y"]).5M(1n.8A)){X.1e.7F()}1j{26.9F.2E(50)}}())}1j{if(X.1e.4O&&X.1e.2z<9&&1m===1G){(17(){if(X.$3d(17(){X.1e.43().gV("1M");1a 1s})){X.1e.7F()}1j{26.9F.2E(50)}}())}1j{X.3z.1D.2e(X.$(1n),"gI",X.1e.7F);X.3z.1D.2e(X.$(1m),"5Z",X.1e.7F)}}}(T));N.3L=17(){1b ab=1h,Y=N.$A(26);if("41"==N.1Q(Y[0])){ab=Y.6N()}1b X=17(){1T(1b ae in 13){13[ae]=N.4b(13[ae])}if(13.5n.$3R){13.$3R={};1b ag=13.5n.$3R;1T(1b af in ag){1b ad=ag[af];4G(N.1Q(ad)){1C"17":13.$3R[af]=N.3L.dI(13,ad);1H;1C"8K":13.$3R[af]=N.4b(ad);1H;1C"4a":13.$3R[af]=N.4b(ad);1H}}}1b ac=(13.3J)?13.3J.6B(13,26):13;4R 13.aW;1a ac};if(!X.2w.3J){X.2w.3J=N.$F}if(ab){1b aa=17(){};aa.2w=ab.2w;X.2w=1t aa;X.$3R={};1T(1b Z in ab.2w){X.$3R[Z]=ab.2w[Z]}}1j{X.$3R=1h}X.5n=N.3L;X.2w.5n=X;N.29(X.2w,Y[0]);N.29(X,{$4H:"41"});1a X};T.3L.dI=17(X,Y){1a 17(){1b aa=13.aW;1b Z=Y.6B(X,26);1a Z}};(17(aa){1b Z=aa.$;1b X=5,Y=b9;aa.1v.1x.1R=1t aa.3L(aa.29(aa.1v.1x,{1u:"1R",3J:17(ad,ac){1b ab=ac.5w();13.x=ab.x;13.y=ab.y;13.2F=ac.2F;13.2G=ac.2G;13.2O=ac.2O;13.2q=ac.6Z();13.4d=ad;13.4f(ac)}}));aa.1v.1x.1R.1L={1w:{7r:Y,2q:1},5t:17(ab){13.3b("1z:1R:1w",aa.29(aa.4b(aa.1v.1x.1R.1L.1w),ab||{}));13.1D("6E",aa.1v.1x.1R.1L.3m,1);13.1D("6r",aa.1v.1x.1R.1L.3m,1);13.1D("2Q",aa.1v.1x.1R.1L.aV,1);if(aa.1e.4O&&aa.1e.2z<9){13.1D("9L",aa.1v.1x.1R.1L.3m,1)}},2S:17(){13.1O("6E",aa.1v.1x.1R.1L.3m);13.1O("6r",aa.1v.1x.1R.1L.3m);13.1O("2Q",aa.1v.1x.1R.1L.aV);if(aa.1e.4O&&aa.1e.2z<9){13.1O("9L",aa.1v.1x.1R.1L.3m)}},aV:17(ab){ab.3U()},3m:17(ae){1b ad,ab,ac;ab=13.2c("1z:1R:1w");if(ae.1u!="9L"&&ae.6Z()!=ab.2q){1a}if(13.2c("1z:1R:aR")){13.34("1z:1R:aR");1a}if("6E"==ae.1u){ad=1t aa.1v.1x.1R(13,ae);13.3b("1z:1R:9f",ad)}1j{if("6r"==ae.1u){ad=13.2c("1z:1R:9f");if(!ad){1a}ac=ae.5w();13.34("1z:1R:9f");ad.4f(ae);if(ae.2O-ad.2O<=ab.7r&&1p.8O(1p.4B(ac.x-ad.x,2)+1p.4B(ac.y-ad.y,2))<=X){13.2W("1R",ad)}1n.2W("6r",ae)}1j{if(ae.1u=="9L"){ad=1t aa.1v.1x.1R(13,ae);13.2W("1R",ad)}}}}}})(T);(17(Y){1b X=Y.$;Y.1v.1x.2P=1t Y.3L(Y.29(Y.1v.1x,{1u:"2P",2m:"3O",63:1k,3J:17(ac,ab,aa){1b Z=ab.5w();13.x=Z.x;13.y=Z.y;13.2F=ab.2F;13.2G=ab.2G;13.2O=ab.2O;13.2q=ab.6Z();13.4d=ac;13.4f(ab);13.2m=aa}}));Y.1v.1x.2P.1L={5t:17(){1b aa=Y.1v.1x.2P.1L.dU.2I(13),Z=Y.1v.1x.2P.1L.9t.2I(13);13.1D("6E",Y.1v.1x.2P.1L.aU,1);13.1D("6r",Y.1v.1x.2P.1L.9t,1);1n.1D("6P",aa,1);1n.1D("6r",Z,1);13.3b("1z:2P:4z:1n:5N",aa);13.3b("1z:2P:4z:1n:7m",Z)},2S:17(){13.1O("6E",Y.1v.1x.2P.1L.aU);13.1O("6r",Y.1v.1x.2P.1L.9t);X(1n).1O("6P",13.2c("1z:2P:4z:1n:5N")||Y.$F);X(1n).1O("6r",13.2c("1z:2P:4z:1n:7m")||Y.$F);13.34("1z:2P:4z:1n:5N");13.34("1z:2P:4z:1n:7m")},aU:17(aa){1b Z;if(1!=aa.6Z()){1a}Z=1t Y.1v.1x.2P(13,aa,"3O");13.3b("1z:2P:3O",Z)},9t:17(aa){1b Z;Z=13.2c("1z:2P:3O");if(!Z){1a}aa.3U();Z=1t Y.1v.1x.2P(13,aa,"9V");13.34("1z:2P:3O");13.2W("2P",Z)},dU:17(aa){1b Z;Z=13.2c("1z:2P:3O");if(!Z){1a}aa.3U();if(!Z.63){Z.63=1s;13.2W("2P",Z)}Z=1t Y.1v.1x.2P(13,aa,"dQ");13.2W("2P",Z)}}})(T);(17(Y){1b X=Y.$;Y.1v.1x.4e=1t Y.3L(Y.29(Y.1v.1x,{1u:"4e",7o:1k,7q:1h,3J:17(ab,aa){1b Z=aa.5w();13.x=Z.x;13.y=Z.y;13.2F=aa.2F;13.2G=aa.2G;13.2O=aa.2O;13.2q=aa.6Z();13.4d=ab;13.4f(aa)}}));Y.1v.1x.4e.1L={1w:{7r:7I},5t:17(Z){13.3b("1z:4e:1w",Y.29(Y.4b(Y.1v.1x.4e.1L.1w),Z||{}));13.1D("1R",Y.1v.1x.4e.1L.3m,1)},2S:17(){13.1O("1R",Y.1v.1x.4e.1L.3m)},3m:17(ab){1b aa,Z;aa=13.2c("1z:4e:1z");Z=13.2c("1z:4e:1w");if(!aa){aa=1t Y.1v.1x.4e(13,ab);aa.7q=4q(17(){aa.7o=1s;ab.6l=Y.$1k;13.2W("1R",ab);13.34("1z:4e:1z")}.1E(13),Z.7r+10);13.3b("1z:4e:1z",aa);ab.4u()}1j{3M(aa.7q);13.34("1z:4e:1z");if(!aa.7o){aa.4f(ab);ab.4u().2i();13.2W("4e",aa)}1j{}}}}})(T);(17(aa){1b Z=aa.$;1b X=10;1b Y=7I;aa.1v.1x.24=1t aa.3L(aa.29(aa.1v.1x,{1u:"24",id:1h,3J:17(ac,ab){1b ad=ab.5X();13.id=ad.9g||ad.4A;13.x=ad.4Q;13.y=ad.4T;13.4Q=ad.4Q;13.4T=ad.4T;13.2F=ad.2F;13.2G=ad.2G;13.2O=ab.2O;13.2q=0;13.4d=ac;13.4f(ab)}}));aa.1v.1x.24.1L={5t:17(ab){13.1D(["5c","6Q"],aa.1v.1x.24.1L.7l,1);13.1D(["6f","5F"],aa.1v.1x.24.1L.71,1);13.1D("2Q",aa.1v.1x.24.1L.aT,1)},2S:17(){13.1O(["5c","6Q"],aa.1v.1x.24.1L.7l);13.1O(["6f","5F"],aa.1v.1x.24.1L.71);13.1O("2Q",aa.1v.1x.24.1L.aT)},aT:17(ab){ab.3U()},7l:17(ab){if(!ab.5o()){13.34("1z:24:1z");1a}13.3b("1z:24:1z",1t aa.1v.1x.24(13,ab));13.3b("1z:1R:aR",1s)},71:17(ae){1b ac=aa.6t();1b ad=13.2c("1z:24:1z");1b ab=13.2c("1z:24:1w");if(!ad||!ae.5o()){1a}13.34("1z:24:1z");if(ad.id===ae.8g()&&ae.2O-ad.2O<=Y&&1p.8O(1p.4B(ae.5X().4Q-ad.x,2)+1p.4B(ae.5X().4T-ad.y,2))<=X){13.34("1z:1R:9f");ae.2i();ad.4f(ae);13.2W("24",ad)}}}}(T));N.1v.1x.3r=1t N.3L(N.29(N.1v.1x,{1u:"3r",7o:1k,7q:1h,3J:17(Y,X){13.x=X.x;13.y=X.y;13.2F=X.2F;13.2G=X.2G;13.2O=X.2O;13.2q=0;13.4d=Y;13.4f(X)}}));N.1v.1x.3r.1L={1w:{7r:b9},5t:17(X){13.3b("1z:3r:1w",N.29(N.4b(N.1v.1x.3r.1L.1w),X||{}));13.1D("24",N.1v.1x.3r.1L.3m,1)},2S:17(){13.1O("24",N.1v.1x.3r.1L.3m)},3m:17(Z){1b Y,X;Y=13.2c("1z:3r:1z");X=13.2c("1z:3r:1w");if(!Y){Y=1t N.1v.1x.3r(13,Z);Y.7q=4q(17(){Y.7o=1s;Z.6l=N.$1k;13.2W("24",Z)}.1E(13),X.7r+10);13.3b("1z:3r:1z",Y);Z.4u()}1j{3M(Y.7q);13.34("1z:3r:1z");if(!Y.7o){Y.4f(Z);Z.4u().2i();13.2W("3r",Y)}1j{}}}};(17(Z){1b Y=Z.$;1b X=10;Z.1v.1x.2p=1t Z.3L(Z.29(Z.1v.1x,{1u:"2p",2m:"3O",id:1h,63:1k,3J:17(ac,ab,aa){1b ad=ab.5X();13.id=ad.9g||ad.4A;13.2F=ad.2F;13.2G=ad.2G;13.4Q=ad.4Q;13.4T=ad.4T;13.x=ad.4Q;13.y=ad.4T;13.2O=ab.2O;13.2q=0;13.4d=ac;13.4f(ab);13.2m=aa}}));Z.1v.1x.2p.1L={5t:17(){1b ab=Z.1v.1x.2p.1L.9h.1E(13);1b aa=Z.1v.1x.2p.1L.71.1E(13);13.1D(["5c","6Q"],Z.1v.1x.2p.1L.7l,1);13.1D(["6f","5F"],Z.1v.1x.2p.1L.71,1);13.1D(["7X","5q"],Z.1v.1x.2p.1L.9h,1);13.3b("1z:2p:4z:1n:5N",ab);13.3b("1z:2p:4z:1n:7m",aa);Y(1n).1D("5q",ab,1);Y(1n).1D("5F",aa,1)},2S:17(){13.1O(["5c","6Q"],Z.1v.1x.2p.1L.7l);13.1O(["6f","5F"],Z.1v.1x.2p.1L.71);13.1O(["7X","5q"],Z.1v.1x.2p.1L.9h);Y(1n).1O("5q",13.2c("1z:2p:4z:1n:5N")||Z.$F,1);Y(1n).1O("5F",13.2c("1z:2p:4z:1n:7m")||Z.$F,1);13.34("1z:2p:4z:1n:5N");13.34("1z:2p:4z:1n:7m")},7l:17(ab){1b aa;if(!ab.5o()){1a}aa=1t Z.1v.1x.2p(13,ab,"3O");13.3b("1z:2p:3O",aa)},71:17(ab){1b aa;aa=13.2c("1z:2p:3O");if(!aa||!aa.63||aa.id!==ab.8g()){1a}aa=1t Z.1v.1x.2p(13,ab,"9V");13.34("1z:2p:3O");13.2W("2p",aa)},9h:17(ab){1b aa;aa=13.2c("1z:2p:3O");if(!aa||!ab.5o()){1a}if(aa.id!==ab.8g()){13.34("1z:2p:3O");1a}if(!aa.63&&1p.8O(1p.4B(ab.5X().4Q-aa.x,2)+1p.4B(ab.5X().4T-aa.y,2))>X){aa.63=1s;13.2W("2p",aa)}if(!aa.63){1a}aa=1t Z.1v.1x.2p(13,ab,"dQ");13.2W("2p",aa)}}}(T));N.1v.1x.3Y=1t N.3L(N.29(N.1v.1x,{1u:"3Y",4c:1,aP:1,dt:1,2m:"kh",3J:17(Y,X){13.2O=X.2O;13.2q=0;13.4d=Y;13.x=X.4i[0].2F+(X.4i[1].2F-X.4i[0].2F)/2;13.y=X.4i[0].2G+(X.4i[1].2G-X.4i[0].2G)/2;13.dK=1p.8O(1p.4B(X.4i[0].2F-X.4i[1].2F,2)+1p.4B(X.4i[0].2G-X.4i[1].2G,2));13.4f(X)},3W:17(X){1b Y;13.2m="kl";if(X.33[0].4A!=13.5a[0].4i[0].4A||X.33[1].4A!=13.5a[0].4i[1].4A){1a}Y=1p.8O(1p.4B(X.33[0].2F-X.33[1].2F,2)+1p.4B(X.33[0].2G-X.33[1].2G,2));13.aP=13.4c;13.4c=Y/13.dK;13.dt=13.4c/13.aP;13.x=X.33[0].2F+(X.33[1].2F-X.33[0].2F)/2;13.y=X.33[0].2G+(X.33[1].2G-X.33[0].2G)/2;13.4f(X)}}));N.1v.1x.3Y.1L={5t:17(){13.1D("5c",N.1v.1x.3Y.1L.aO,1);13.1D("6f",N.1v.1x.3Y.1L.aN,1);13.1D("7X",N.1v.1x.3Y.1L.by,1)},2S:17(){13.1O("5c",N.1v.1x.3Y.1L.aO);13.1O("6f",N.1v.1x.3Y.1L.aN);13.1O("7X",N.1v.1x.3Y.1L.by)},aO:17(Y){1b X;if(Y.4i.1K!=2){1a}Y.3U();X=1t N.1v.1x.3Y(13,Y);13.3b("1z:3Y:1z",X)},aN:17(Y){1b X;X=13.2c("1z:3Y:1z");if(!X){1a}Y.3U();13.34("1z:3Y:1z")},by:17(Y){1b X;X=13.2c("1z:3Y:1z");if(!X){1a}Y.3U();X.3W(Y);13.2W("3Y",X)}};(17(ac){1b aa=ac.$;ac.1v.1x.4N=1t ac.3L(ac.29(ac.1v.1x,{1u:"4N",3J:17(ai,ah,ak,ae,ad,aj,af){1b ag=ah.5w();13.x=ag.x;13.y=ag.y;13.2O=ah.2O;13.4d=ai;13.kB=ak||0;13.aL=ae||0;13.8Q=ad||0;13.ky=aj||0;13.kx=af||0;13.aK=ah.aK||0;13.bF=1k;13.4f(ah)}}));1b ab,Y;17 X(){ab=1h}17 Z(ad,ae){1a(ad>50)||(1===ae&&!("al"==ac.1e.4X&&ad<1))||(0===ad%12)||(0==ad%4.lg)}ac.1v.1x.4N.1L={9O:"kD"in 1n||ac.1e.2z>8?"kw":"kH",5t:17(){13.1D(ac.1v.1x.4N.1L.9O,ac.1v.1x.4N.1L.3m,1)},2S:17(){13.1O(ac.1v.1x.4N.1L.9O,ac.1v.1x.4N.1L.3m,1)},3m:17(ai){1b aj=0,ag=0,ae=0,ad=0,ah,af;if(ai.dA){ae=ai.dA*-1}if(ai.dz!==2A){ae=ai.dz}if(ai.dw!==2A){ae=ai.dw}if(ai.dv!==2A){ag=ai.dv*-1}if(ai.8Q){ae=-1*ai.8Q}if(ai.aL){ag=ai.aL}if(0===ae&&0===ag){1a}aj=0===ae?ag:ae;ad=1p.1X(1p.3C(ae),1p.3C(ag));if(!ab||ad<ab){ab=ad}ah=aj>0?"5Q":"4h";aj=1p[ah](aj/ab);ag=1p[ah](ag/ab);ae=1p[ah](ae/ab);if(Y){3M(Y)}Y=4q(X,7I);af=1t ac.1v.1x.4N(13,ai,aj,ag,ae,0,ab);af.bF=Z(ab,ai.aK||0);13.2W("4N",af)}}})(T);N.al=N.$(1m);N.ej=N.$(1n);1a T})();(17(J){if(!J){5R"6H 6D 6K"}1b I=J.$;1b H=1m.km||1m.kn||1h;x.aw=1t J.3L({2b:1h,2l:1k,1w:{an:J.$F,6y:J.$F,bx:J.$F,69:J.$F,7u:J.$F,es:J.$F,as:1k,ez:1s},1A:1h,8v:1h,aJ:0,7z:{an:17(K){if(K.4d&&(7I===K.4d.ar||er===K.4d.ar)&&K.ko){13.1w.an.1E(1h,(K.2f-(13.1w.ez?13.aJ:0))/K.kp).2E(1);13.aJ=K.2f}},6y:17(K){if(K){I(K).2i()}13.8w();if(13.2l){1a}13.2l=1s;13.8x();!13.1w.as&&13.1w.an.1E(1h,1).2E(1);13.1w.6y.1E(1h,13).2E(1);13.1w.7u.1E(1h,13).2E(1)},bx:17(K){if(K){I(K).2i()}13.8w();13.2l=1k;13.8x();13.1w.bx.1E(1h,13).2E(1);13.1w.7u.1E(1h,13).2E(1)},69:17(K){if(K){I(K).2i()}13.8w();13.2l=1k;13.8x();13.1w.69.1E(1h,13).2E(1);13.1w.7u.1E(1h,13).2E(1)}},au:17(){I(["5Z","aI","ew"]).36(17(K){13.2b.1D(K,13.7z["8T"+K].2I(13).ex(1))},13)},8w:17(){if(13.8v){3d{3M(13.8v)}3w(K){}13.8v=1h}I(["5Z","aI","ew"]).36(17(L){13.2b.1O(L)},13)},8x:17(){13.1F();if(13.2b.2c("1t")){1b K=13.2b.4I;13.2b.2S().34("1t").1y({2h:"kO",1G:"2D"});K.5f()}},em:17(L){1b M=1t ao(),K;I(["aI","kv"]).36(17(N){M["8T"+N]=I(17(O){13.7z["8T"+N].2e(13,O)}).1E(13)},13);M.69=I(17(){13.1w.es.1E(1h,13).2E(1);13.1w.as=1k;13.au();13.2b.1Z=L}).1E(13);M.6y=I(17(){if(7I!==M.ar&&er!==M.ar){13.7z.69.2e(13);1a}K=M.l9;13.au();if(H&&!J.1e.4O&&!("9q"===J.1e.4X&&J.1e.4F<lb)){13.2b.3y("1Z",H.lc(K))}1j{13.2b.1Z=L}}).1E(13);M.83("le",L);M.lf="l8";M.lh()},3J:17(L,K){13.1w=J.29(13.1w,K);13.2b=I(L)||J.$1t("2b",{},{"1X-1f":"2X","1X-1g":"2X"}).2a(J.$1t("2V").1B("3i-aD-2b").1y({2h:"5J",1G:-ek,1f:10,1g:10,7O:"3p"}).2a(1n.3B)).3b("1t",1s);if(J.1e.2M.en&&13.1w.as&&"1N"==J.1Q(L)){13.em(L);1a}1b M=17(){if(13.ed()){13.7z.6y.2e(13)}1j{13.7z.69.2e(13)}M=1h}.1E(13);13.au();if("1N"==J.1Q(L)){13.2b.1Z=L}1j{if(J.1e.4O&&5==J.1e.4F&&J.1e.2z<9){13.2b.eh=17(){if(/2f|8y/.3n(13.2b.8A)){13.2b.eh=1h;M&&M()}}.1E(13)}13.2b.1Z=L.2r("1Z")}13.2b&&13.2b.8y&&M&&(13.8v=M.2E(2K))},lo:17(){13.8w();13.8x();13.2l=1k;1a 13},ed:17(){1b K=13.2b;1a(K.9c)?(K.9c>0):(K.8A)?("8y"==K.8A):K.1f>0},1F:17(){1a 13.1A||(13.1A={1f:13.2b.9c||13.2b.1f,1g:13.2b.eZ||13.2b.1g})}})})(x);(17(I){if(!I){5R"6H 6D 6K"}if(I.5p){1a}1b H=I.$;I.5p=1t I.3L({3J:17(K,J){1b L;13.el=I.$(K);13.1w=I.29(13.1w,J);13.5x=1k;13.7y=13.br;L=I.5p.8k[13.1w.21]||13.1w.21;if("17"===I.1Q(L)){13.7y=L}1j{13.5C=13.8i(L)||13.8i("6d")}if("1N"==I.1Q(13.1w.7K)){13.1w.7K="l7"===13.1w.7K?6n:5U(13.1w.7K)||1}},1w:{e7:60,5e:at,21:"6d",7K:1,59:"l5",ea:I.$F,7n:I.$F,bL:I.$F,cG:I.$F,9X:1k,l6:1k},4j:1h,5C:1h,7y:1h,kS:17(J){13.1w.21=J;J=I.5p.8k[13.1w.21]||13.1w.21;if("17"===I.1Q(J)){13.7y=J}1j{13.7y=13.br;13.5C=13.8i(J)||13.8i("6d")}},4D:17(L){1b J=/\\%$/,K;13.4j=L||{};13.bu=0;13.2m=0;13.kT=0;13.9T={};13.7d="7d"===13.1w.59||"7d-4M"===13.1w.59;13.7c="7c"===13.1w.59||"7c-4M"===13.1w.59;1T(K in 13.4j){J.3n(13.4j[K][0])&&(13.9T[K]=1s);if("4M"===13.1w.59||"7d-4M"===13.1w.59||"7c-4M"===13.1w.59){13.4j[K].4M()}}13.bl=I.6t();13.dr=13.bl+13.1w.5e;13.1w.ea.2e();if(0===13.1w.5e){13.6G(1);13.1w.7n.2e()}1j{13.a5=13.e5.1E(13);if(!13.1w.9X&&I.1e.2M.4P){13.5x=I.1e.4P.2e(1m,13.a5)}1j{13.5x=13.a5.e9(1p.5s(b4/13.1w.e7))}}1a 13},bv:17(){if(13.5x){if(!13.1w.9X&&I.1e.2M.4P&&I.1e.ap){I.1e.ap.2e(1m,13.5x)}1j{e4(13.5x)}13.5x=1k}},2i:17(J){J=I.3q(J)?J:1k;13.bv();if(J){13.6G(1);13.1w.7n.2E(10)}1a 13},bt:17(L,K,J){L=2t(L);K=2t(K);1a(K-L)*J+L},e5:17(){1b K=I.6t(),J=(K-13.bl)/13.1w.5e,L=1p.5Q(J);if(K>=13.dr&&L>=13.1w.7K){13.bv();13.6G(1);13.1w.7n.2E(10);1a 13}if(13.7d&&13.bu<L){1T(1b M in 13.4j){13.4j[M].4M()}}13.bu=L;if(!13.1w.9X&&I.1e.2M.4P){13.5x=I.1e.4P.2e(1m,13.a5)}13.6G((13.7c?L:0)+13.7y(J%1))},6G:17(J){1b K={},M=J;1T(1b L in 13.4j){if("2o"===L){K[L]=1p.5s(13.bt(13.4j[L][0],13.4j[L][1],J)*2K)/2K}1j{K[L]=13.bt(13.4j[L][0],13.4j[L][1],J);13.9T[L]&&(K[L]+="%")}}13.1w.bL(K,13.el);13.7A(K);13.1w.cG(K,13.el)},7A:17(J){1a 13.el.1y(J)},8i:17(J){1b K,L=1h;if("1N"!==I.1Q(J)){1a 1h}4G(J){1C"93":L=H([0,0,1,1]);1H;1C"6d":L=H([0.25,0.1,0.25,1]);1H;1C"6d-in":L=H([0.42,0,1,1]);1H;1C"6d-cH":L=H([0,0,0.58,1]);1H;1C"6d-in-cH":L=H([0.42,0,0.58,1]);1H;1C"cS":L=H([0.47,0,0.l0,0.l1]);1H;1C"dn":L=H([0.39,0.l2,0.l3,1]);1H;1C"l4":L=H([0.ke,0.bs,0.55,0.95]);1H;1C"di":L=H([0.55,0.kc,0.68,0.53]);1H;1C"dh":L=H([0.25,0.46,0.45,0.94]);1H;1C"j9":L=H([0.ja,0.cz,0.jb,0.jc]);1H;1C"dg":L=H([0.55,0.j5,0.je,0.19]);1H;1C"de":L=H([0.jg,0.61,0.cu,1]);1H;1C"ji":L=H([0.jj,0.cb,0.cu,1]);1H;1C"jk":L=H([0.ec,0.cz,0.ee,0.22]);1H;1C"jl":L=H([0.cv,0.84,0.44,1]);1H;1C"jn":L=H([0.77,0,0.9I,1]);1H;1C"jf":L=H([0.j3,0.bs,0.iS,0.j2]);1H;1C"iJ":L=H([0.23,1,0.32,1]);1H;1C"iL":L=H([0.86,0,0.iM,1]);1H;1C"dl":L=H([0.95,0.bs,0.iQ,0.iR]);1H;1C"dj":L=H([0.19,1,0.22,1]);1H;1C"iV":L=H([1,0,0,1]);1H;1C"iW":L=H([0.6,0.iX,0.98,0.iZ]);1H;1C"j0":L=H([0.j1,0.82,0.cv,1]);1H;1C"j4":L=H([0.jq,0.jO,0.15,0.86]);1H;1C"dd":L=H([0.6,-0.28,0.ei,0.cb]);1H;1C"dc":L=H([0.9I,0.c1,0.32,1.jR]);1H;1C"jS":L=H([0.68,-0.55,0.jU,1.55]);1H;1P:J=J.4r(/\\s/g,"");if(J.3A(/^5y-5z\\((?:-?[0-9\\.]{0,}[0-9]{1,},){3}(?:-?[0-9\\.]{0,}[0-9]{1,})\\)$/)){L=J.4r(/^5y-5z\\s*\\(|\\)$/g,"").8s(",");1T(K=L.1K-1;K>=0;K--){L[K]=2t(L[K])}}}1a H(L)},br:17(V){1b J=0,U=0,R=0,W=0,T=0,P=0,Q=13.1w.5e;17 O(X){1a((J*X+U)*X+R)*X}17 N(X){1a((W*X+T)*X+P)*X}17 L(X){1a(3*J*X+2*U)*X+R}17 S(X){1a 1/(7I*X)}17 K(X,Y){1a N(M(X,Y))}17 M(ae,af){1b ad,ac,ab,Y,X,aa;17 Z(ag){if(ag>=0){1a ag}1j{1a 0-ag}}1T(ab=ae,aa=0;aa<8;aa++){Y=O(ab)-ae;if(Z(Y)<af){1a ab}X=L(ab);if(Z(X)<0.bT){1H}ab=ab-Y/X}ad=0;ac=1;ab=ae;if(ab<ad){1a ad}if(ab>ac){1a ac}5G(ad<ac){Y=O(ab);if(Z(Y-ae)<af){1a ab}if(ae>Y){ad=ab}1j{ac=ab}ab=(ac-ad)*0.5+ad}1a ab}R=3*13.5C[0];U=3*(13.5C[2]-13.5C[0])-R;J=1-R-U;P=3*13.5C[1];T=3*(13.5C[3]-13.5C[1])-P;W=1-P-T;1a K(V,S(Q))}});I.5p.8k={93:"93",jW:"cS",jX:"dn",jY:"dl",jP:"dj",jZ:"di",k1:"dh",k2:"dg",k3:"de",k4:"dd",k5:"dc",d9:17(K,J){J=J||[];1a 1p.4B(2,10*--K)*1p.eO(20*K*1p.eD*(J[0]||1)/3)},k6:17(K,J){1a 1-I.5p.8k.d9(1-K,J)},d6:17(L){1T(1b K=0,J=1;1;K+=J,J/=2){if(L>=(7-4*K)/11){1a J*J-1p.4B((11-6*K-11*L)/4,2)}}},k7:17(J){1a 1-I.5p.8k.d6(1-J)},2X:17(J){1a 0}}})(x);(17(I){if(!I){5R"6H 6D 6K"}if(I.8W){1a}1b H=I.$;I.8W=1t I.3L(I.5p,{3J:17(J,K){13.bq=J;13.1w=I.29(13.1w,K);13.5x=1k;13.$3R.3J()},4D:17(N){1b J=/\\%$/,M,L,K=N.1K;13.bp=N;13.9U=1t 6p(K);1T(L=0;L<K;L++){13.9U[L]={};1T(M in N[L]){J.3n(N[L][M][0])&&(13.9U[L][M]=1s);if("4M"===13.1w.59||"7d-4M"===13.1w.59||"7c-4M"===13.1w.59){13.bp[L][M].4M()}}}13.$3R.4D({});1a 13},6G:17(J){1T(1b K=0;K<13.bq.1K;K++){13.el=I.$(13.bq[K]);13.4j=13.bp[K];13.9T=13.9U[K];13.$3R.6G(J)}}})})(x);(17(I){if(!I){5R"6H 6D 6K";1a}if(I.bo){1a}1b H=I.$;I.bo=17(K,L){1b J=13.7j=I.$1t("2V",1h,{2h:"5J","z-8J":cZ}).1B("jM");I.$(K).1D("7w",17(){J.2a(1n.3B)});I.$(K).1D("8u",17(){J.2S()});I.$(K).1D("6P",17(Q){1b S=20,P=I.$(Q).5w(),O=J.1F(),N=I.$(1m).1F(),R=I.$(1m).7i();17 M(V,T,U){1a(U<(V-T)/2)?U:((U>(V+T)/2)?(U-T):(V-T)/2)}J.1y({1M:R.x+M(N.1f,O.1f+2*S,P.x-R.x)+S,1G:R.y+M(N.1g,O.1g+2*S,P.y-R.y)+S})});13.am(L)};I.bo.2w.am=17(J){13.7j.4n&&13.7j.bk(13.7j.4n);13.7j.3a(1n.97(J))}})(x);(17(I){if(!I){5R"6H 6D 6K";1a}if(I.jv){1a}1b H=I.$;I.9Y=17(M,L,K,J){13.9W=1h;13.5l=I.$1t("bA",1h,{2h:"5J","z-8J":cZ,4w:"3p",2o:0.8}).1B(J||"").2a(K||1n.3B);13.cW(M);13.5I(L)};I.9Y.2w.5I=17(J){13.5l.5I();13.9W=13.4t.1E(13).2E(I.bn(J,jw))};I.9Y.2w.4t=17(J){3M(13.9W);13.9W=1h;if(13.5l&&!13.bm){13.bm=1t x.5p(13.5l,{5e:I.bn(J,c3),7n:17(){13.5l.5f();4R 13.5l;13.bm=1h}.1E(13)}).4D({2o:[13.5l.3t("2o"),0]})}};I.9Y.2w.cW=17(J){13.5l.4n&&13.7j.bk(13.5l.4n);13.5l.3a(1n.97(J))}})(x);(17(I){if(!I){5R"6H 6D 6K"}if(I.7e){1a}1b L=I.$,H=1h,P={"3f":1,4a:2,66:3,"17":4,1N:2K},J={"3f":17(S,R,Q){if("3f"!=I.1Q(R)){if(Q||"1N"!=I.1Q(R)){1a 1k}1j{if(!/^(1s|1k)$/.3n(R)){1a 1k}1j{R=R.eA()}}}if(S.3V("2C")&&!L(S["2C"]).5M(R)){1a 1k}H=R;1a 1s},1N:17(S,R,Q){if("1N"!==I.1Q(R)){1a 1k}1j{if(S.3V("2C")&&!L(S["2C"]).5M(R)){1a 1k}1j{H=""+R;1a 1s}}},66:17(T,S,R){1b Q=1k,V=/%$/,U=(I.1Q(S)=="1N"&&V.3n(S));if(R&&!"66"==8B S){1a 1k}S=2t(S);if(9Z(S)){1a 1k}if(9Z(T.7Q)){T.7Q=e2.jB}if(9Z(T.b7)){T.b7=e2.jE}if(T.3V("2C")&&!L(T["2C"]).5M(S)){1a 1k}if(T.7Q>S||S>T.b7){1a 1k}H=U?(S+"%"):S;1a 1s},4a:17(T,R,Q){if("1N"===I.1Q(R)){3d{R=1m.jF.jH(R)}3w(S){1a 1k}}if(I.1Q(R)==="4a"){H=R;1a 1s}1j{1a 1k}},"17":17(S,R,Q){if(I.1Q(R)==="17"){H=R;1a 1s}1j{1a 1k}}},K=17(V,U,R){1b T;T=V.3V("3e")?V.3e:[V];if("4a"!=I.1Q(T)){1a 1k}1T(1b S=0,Q=T.1K-1;S<=Q;S++){if(J[T[S].1u](T[S],U,R)){1a 1s}}1a 1k},N=17(V){1b T,S,U,Q,R;if(V.3V("3e")){Q=V.3e.1K;1T(T=0;T<Q;T++){1T(S=T+1;S<Q;S++){if(P[V.3e[T]["1u"]]>P[V.3e[S].1u]){R=V.3e[T];V.3e[T]=V.3e[S];V.3e[S]=R}}}}1a V},O=17(T){1b S;S=T.3V("3e")?T.3e:[T];if("4a"!=I.1Q(S)){1a 1k}1T(1b R=S.1K-1;R>=0;R--){if(!S[R].1u||!P.3V(S[R].1u)){1a 1k}if(I.3q(S[R]["2C"])){if("4a"!==I.1Q(S[R]["2C"])){1a 1k}1T(1b Q=S[R]["2C"].1K-1;Q>=0;Q--){if(!J[S[R].1u]({1u:S[R].1u},S[R]["2C"][Q],1s)){1a 1k}}}}if(T.3V("1P")&&!K(T,T["1P"],1s)){1a 1k}1a 1s},M=17(Q){13.4K={};13.1w={};13.fE(Q)};I.29(M.2w,{fE:17(S){1b R,Q,T;1T(R in S){if(!S.3V(R)){8F}Q=(R+"").57().5v();if(!13.4K.3V(Q)){13.4K[Q]=N(S[R]);if(!O(13.4K[Q])){5R"jJ jK jL iH \'"+R+"\' jd in "+S}13.1w[Q]=2A}}},7A:17(R,Q){R=(R+"").57().5v();if(I.1Q(Q)=="1N"){Q=Q.57()}if(13.4K.3V(R)){H=Q;if(K(13.4K[R],Q)){13.1w[R]=H}H=1h}},dE:17(Q){Q=(Q+"").57().5v();if(13.4K.3V(Q)){1a I.3q(13.1w[Q])?13.1w[Q]:13.4K[Q]["1P"]}},8m:17(R){1T(1b Q in R){13.7A(Q,R[Q])}},dP:17(){1b R=I.29({},13.1w);1T(1b Q in R){if(2A===R[Q]&&2A!==13.4K[Q]["1P"]){R[Q]=13.4K[Q]["1P"]}}1a R},9x:17(Q){L(Q.8s(";")).36(L(17(R){R=R.8s(":");13.7A(R.6N().57(),R.7D(":"))}).1E(13))},a3:17(Q){Q=(Q+"").57().5v();1a 13.4K.3V(Q)},jG:17(Q){Q=(Q+"").57().5v();1a 13.a3(Q)&&I.3q(13.1w[Q])},2S:17(Q){Q=(Q+"").57().5v();if(13.a3(Q)){4R 13.1w[Q];4R 13.4K[Q]}}});I.7e=M}(x));(17(L){if(!L){5R"6H 6D 6K";1a}1b K=L.$;if(L.9e){1a}1b J="bi://bh.bf.be/jD/7L",I="bi://bh.bf.be/js/jz";1b H=17(M){13.6M={};13.7v=K(M);13.5V=K(1n.9a(J,"7L"));13.5V.3y("1f",13.7v.9c||13.7v.1f);13.5V.3y("1g",13.7v.eZ||13.7v.1g);13.1i=K(1n.9a(J,"1i"));13.1i.jy(I,"79",13.7v.2r("1Z"));13.1i.3y("1f","2K%");13.1i.3y("1g","2K%");13.1i.2a(13.5V)};H.2w.6R=17(){1a 13.5V};H.2w.5i=17(M){if(1p.5s(M)<1){1a}if(!13.6M.5i){13.6M.5i=K(1n.9a(J,"2Z"));13.6M.5i.3y("id","eW");13.6M.5i.c9(K(1n.9a(J,"jx")).8q({"in":"ju",eV:M}));13.6M.5i.2a(13.5V);13.1i.3y("2Z","1V(#eW)")}1j{13.6M.5i.4n.3y("eV",M)}1a 13};L.9e=H}(x));1b q=(17(J){1b I=J.$;1b H=17(L,K){13.3o={8E:"3i",3D:"8D",2h:"2J",1A:{jC:"2v",1f:"2D",1g:"2D"},jN:["1g","1f"]};13.3R=L;13.4E=1h;13.78=1h;13.2R=1h;13.2N={};13.eS=[];13.6v=1h;13.bc=1h;13.5P=1h;13.3o=J.29(13.3o,K);13.3l=13.3o.8E+"-cd";13.8R=13.3o.8E+"-6U";13.eT()};H.2w={eT:17(){13.4E=J.$1t("2V").1B(13.3l).1B(13.3l+"-"+13.3o.3D).1y({4w:"3p"});13.78=J.$1t("2V").1B(13.3l+"-78").2a(13.4E);13.4E.2a(13.3R);I(["4x","4y"]).36(17(K){13.2N[K]=J.$1t("2q").1B(13.3l+"-2q").1B(13.3l+"-2q-"+K).2a(13.4E).1D("1R 24",(17(M,L){I(M).5a[0].2i().4u();I(M).5h();13.6u(L)}).2I(13,K))}.1E(13));13.2N.4x.1B(13.3l+"-2q-51");13.2R=J.$1t("k0").1D("1R 24",17(K){K.2i()})},cE:17(L){1b K=J.$1t("li").1B(13.8R).3a(L).2a(13.2R);1t J.aw(L,{7u:13.8Z.1E(13)});13.eS.3c(K);1a K},eE:17(L){1b K=13.6v||13.2R.9A(13.8R+"-6W")[0];if(K){I(K).1U(13.8R+"-6W")}13.6v=I(L);if(!13.6v){1a}13.6v.1B(13.8R+"-6W");13.6u(13.6v)},c5:17(){if(13.78!==13.2R.4I){I(13.2R).2a(13.78);13.eQ();I(1m).1D("6X",13.5P=13.8Z.1E(13));13.c5.1E(13).2E(1);1a}1b K=13.3R.1F();if(K.1g>0&&K.1g>K.1f){13.8C("4U")}1j{13.8C("8D")}13.8Z();13.4E.1y({4w:""})},2i:17(){if(13.5P){I(1m).1O("6X",13.5P)}13.4E.5f()},6u:17(X,N){1b P={x:0,y:0},aa="4U"==13.3o.3D?"1G":"1M",S="4U"==13.3o.3D?"1g":"1f",O="4U"==13.3o.3D?"y":"x",W=13.2R.4I.1F()[S],T=13.2R.4I.8o(),M=13.2R.1F()[S],V,K,Z,Q,L,U,R,Y=[];if(13.bc){13.bc.2i()}1j{13.2R.1y("21",J.1e.7J+6e.7g(32)+"9H")}if(2A===N){N=at}V=13.2R.8o();if("1N"==J.1Q(X)){P[O]=("4y"==X)?1p.1X(V[aa]-T[aa]-W,W-M):1p.2g(V[aa]-T[aa]+W,0)}1j{if("6c"==J.1Q(X)){K=X.1F();Z=X.8o();P[O]=1p.2g(0,1p.1X(W-M,V[aa]+W/2-Z[aa]-K[S]/2))}1j{1a}}if(J.1e.6g&&"6L"==J.1e.4X||J.1e.2z&&J.1e.2z<10){if("1N"==J.1Q(X)&&P[O]==V[aa]-T[aa]){V[aa]+=0===V[aa]-T[aa]?30:-30}P["8p-"+aa]=[((M<=W)?0:(V[aa]-T[aa])),P[O]];4R P.x;4R P.y;if(!13.ba){13.ba=1t J.8W([13.2R],{5e:c3})}Y.3c(P);13.ba.4D(Y);R=P["8p-"+aa][1]}1j{13.2R.1y({21:J.1e.7J+6e.7g(32)+N+"5Y 6d",2j:"4o("+P.x+"2v, "+P.y+"2v, 0)"});R=P[O]}if(R>=0){13.2N.4x.1B(13.3l+"-2q-51")}1j{13.2N.4x.1U(13.3l+"-2q-51")}if(R<=W-M){13.2N.4y.1B(13.3l+"-2q-51")}1j{13.2N.4y.1U(13.3l+"-2q-51")}R=1h},eQ:17(){1b M,L,N,U,T,W,O,S,R,V,ab,Y,Z,X={x:0,y:0},K,Q,P=b9,aa=17(ae){1b ad,ac=0;1T(ad=1.5;ad<=90;ad+=1.5){ac+=(ae*1p.eO(ad/1p.eD/2))}(U<0)&&(ac*=(-1));1a ac};T=I(17(ac){X={x:0,y:0};K="4U"==13.3o.3D?"1G":"1M";Q="4U"==13.3o.3D?"1g":"1f";M="4U"==13.3o.3D?"y":"x";Y=13.2R.4I.1F()[Q];ab=13.2R.1F()[Q];N=Y-ab;if(N>=0){1a}if(ac.2m=="3O"){if(2A===Z){Z=0}13.2R.3F("21",J.1e.7J+6e.7g(32)+"eJ");W=ac[M];R=ac.y;S=ac.x;V=1k}1j{if("9V"==ac.2m){if(V){1a}O=aa(1p.3C(U));Z+=O;(Z<=N)&&(Z=N);(Z>=0)&&(Z=0);X[M]=Z;13.2R.3F("21",J.1e.7J+6e.7g(32)+P+"5Y  5y-5z(.0, .0, .0, 1)");13.2R.3F("2j","4o("+X.x+"2v, "+X.y+"2v, 6x)");U=0}1j{if(V){1a}if("8D"==13.3o.3D&&1p.3C(ac.x-S)>1p.3C(ac.y-R)||"4U"==13.3o.3D&&1p.3C(ac.x-S)<1p.3C(ac.y-R)){ac.2i();U=ac[M]-W;Z+=U;X[M]=Z;13.2R.3F("2j","4o("+X.x+"2v, "+X.y+"2v, 6x)");if(Z>=0){13.2N.4x.1B(13.3l+"-2q-51")}1j{13.2N.4x.1U(13.3l+"-2q-51")}if(Z<=N){13.2N.4y.1B(13.3l+"-2q-51")}1j{13.2N.4y.1U(13.3l+"-2q-51")}}1j{V=1s}}W=ac[M]}}).1E(13);13.2R.1D("2p",T)},8Z:17(){1b N,M,K,L=13.3R.1F();if(L.1g>0&&L.1g>L.1f){13.8C("4U")}1j{13.8C("8D")}N="4U"==13.3o.3D?"1g":"1f";M=13.2R.1F()[N];K=13.4E.1F()[N];if(M<=K){13.4E.1B("73-2N");13.2R.3F("21","").1F();13.2R.3F("2j","4o(0,0,0)");13.2N.4x.1B(13.3l+"-2q-51");13.2N.4y.1U(13.3l+"-2q-51")}1j{13.4E.1U("73-2N")}if(13.6v){13.6u(13.6v,0)}},8C:17(K){if("4U"!==K&&"8D"!==K||K==13.3o.3D){1a}13.4E.1U(13.3l+"-"+13.3o.3D);13.3o.3D=K;13.4E.1B(13.3l+"-"+13.3o.3D);13.2R.3F("21","2X").1F();13.2R.3F("2j","").3F("8p","")}};1a H})(x);1b g=y.$;if(8B 75.aF!=="17"){75.aF=17(K){if(K==1h){5R 1t jp("iY iU 2A iT 1h 6a 8K")}K=75(K);1T(1b H=1;H<26.1K;H++){1b J=26[H];if(J!=1h){1T(1b I in J){if(75.2w.3V.2e(J,I)){K[I]=J[I]}}}}1a K}}if(!y.1e.9J){y.1e.9J=y.8X("2j").92()}1b n={4k:{1u:"1N","2C":["2Q","7x"],"1P":"7x"},48:{3e:[{1u:"1N","2C":["1l","2u","4l","3T"],"1P":"1l"},{1u:"3f","2C":[1k]}],"1P":"1l"},fb:{3e:[{1u:"1N","2C":["2D"]},{1u:"66",7Q:1}],"1P":"2D"},fc:{3e:[{1u:"1N","2C":["2D"]},{1u:"66",7Q:1}],"1P":"2D"},ci:{1u:"1N","1P":"2H"},iN:{1u:"66",7Q:0,"1P":15},8N:{3e:[{1u:"1N","2C":["2J","1G","3T"],"1P":"3T"},{1u:"3f","2C":[1k]}],"1P":"3T"},2s:{3e:[{1u:"1N","2C":["1m","dY","3T"]},{1u:"3f","2C":[1k]}],"1P":"1m"},4L:{3e:[{1u:"1N","2C":["1l","2u","3T"],"1P":"1l"},{1u:"3f","2C":[1k]}],"1P":"1l"},3x:{1u:"1N","2C":["2Q","2Y"],"1P":"2Q"},40:{1u:"3f","1P":1s},e1:{1u:"3f","1P":1s},3h:{3e:[{1u:"1N","2C":["bz","2Y","3T"]},{1u:"3f","2C":[1k]}],"1P":"bz"},fz:{1u:"3f","1P":1s},eN:{1u:"3f","1P":1s},fD:{1u:"3f","1P":1k},8t:{1u:"3f","1P":1k},c7:{1u:"3f","1P":1s},dC:{1u:"3f","1P":1k},f1:{1u:"3f","1P":1s},cf:{1u:"1N","2C":["2Q","7x"],"1P":"2Q"},5B:{1u:"1N"},9N:{1u:"3f","1P":1k},bJ:{1u:"1N","1P":"iK 6a 1l"},9s:{1u:"1N","1P":"ff 6a 1l"},8V:{1u:"1N","1P":"ff 6a 2s"},jo:{1u:"1N","1P":"jm"},jh:{1u:"1N","1P":"kb"},j8:{1u:"1N","1P":"j7"}};1b k={48:{3e:[{1u:"1N","2C":["1l","2u","3T"],"1P":"1l"},{1u:"3f","2C":[1k]}],"1P":"1l"},3x:{1u:"1N","2C":["2Q","2Y"],"1P":"2Q"},8V:{1u:"1N","1P":"ka 6a 2s"},bJ:{1u:"1N","1P":"jr 6a 1l"},9s:{1u:"1N","1P":"kZ 24 6a 1l"}};1b m="9C";1b C="1q";1b b=20;1b z=["bP","fe","fu","fw","dJ","dT"];1b B=at;1b t;1b o={};1b E=g([]);1b G;1b e=1m.kQ||1;1b F;1b w=1s;1b f=y.1e.2M.8Y?"4o(":"a1(";1b A=y.1e.2M.8Y?",0)":")";1b l=1h;1b p=(17(){1b I,L,K,J,H;1a H})();1b r=17(){1a"kW$kY"+"p".7C()+" lk$"+"dF.2.9".4r("v","")+" ln$"+"c".7C()+((1m.cc$b6&&y.1Q(1m.cc$b6)==="1N")?" ld$"+1m.cc$b6.4S():"")};17 v(J){1b I,H;I="";1T(H=0;H<J.1K;H++){I+=6e.7g(14^J.fh(H))}1a I}17 h(J){1b I=[],H=1h;(J&&(H=g(J)))&&(I=E.2Z(17(K){1a K.3H===H}));1a I.1K?I[0]:1h}17 a(J){1b I=g(1m).1F();1b H=g(1m).7i();J=J||0;1a{1M:J,2H:I.1f-J,1G:J,2J:I.1g-J,x:H.x,y:H.y}}17 d(H){1a 75.aF({},H,{1u:H.1u,4Q:H.4Q,4T:H.4T,f3:H.f3,fd:H.fd,2F:H.2F,2G:H.2G})}17 s(){1b J=y.$A(26);1b I=J.6N();1b H=o[I];if(H){1T(1b K=0;K<H.1K;K++){H[K].6B(1h,J)}}}17 D(){1b L=26[0],H,K,I=[];3d{do{K=L.az;if(/^[A-ay-z]*$/.3n(K)){if(H=L.2r("id")){if(/^[A-ay-z][-A-ay-kj-ki]*/.3n(H)){K+="#"+H}}I.3c(K)}L=L.4I}5G(L&&L!==1n.5b);I=I.4M();y.6J(I.7D(" ")+"> .1q-5O > 2b",{1f:"2K% !2k;",21:"2X",2j:"2X"},"1q-bR-62",1s)}3w(J){}}17 u(){1b I=1h,J=1h,H=17(){1m.kg(1n.3B.8z,1n.3B.8f);1m.aC(1t 1v("6X"))};J=f7(17(){1b M=1m.3D===90||1m.3D===-90;1b L=1m.5k;1b K=(M?fg.kJ:fg.kI)*0.85;if((I===1h||I===1k)&&((M&&L<K)||(!M&&L<K))){I=1s;H()}1j{if((I===1h||I===1s)&&((M&&L>K)||(!M&&L>K))){I=1k;H()}}},kG);1a J}17 c(){y.6J(".3i-3p-78, .3i-aD-2b",{6w:"eH !2k","2g-1g":"0 !2k","2g-1f":"0 !2k","1X-1g":"2X !2k","1X-1f":"2X !2k",1f:"f0 !2k",1g:"f0 !2k",2h:"5J !2k",1G:"-cj !2k",1M:"0 !2k",7O:"3p !2k","-3K-2j":"2X !2k",2j:"2X !2k","-3K-21":"2X !2k",21:"2X !2k"},"a8-9o-62");y.6J(".3i-aD-2b 2b",{6w:"bS-eH !2k",3N:"0 !2k",7N:"0 !2k","2g-1g":"0 !2k","2g-1f":"0 !2k","1X-1g":"2X !2k","1X-1f":"2X !2k","-3K-2j":"2X !2k",2j:"2X !2k","-3K-21":"2X !2k",21:"2X !2k"},"a8-9o-62");if(y.1e.7T){y.6J(".2T-3i .1q-2s .1q-2s-bg",{6w:"2X !2k"},"a8-9o-62")}if(y.1e.7T&&(y.1e.4v!=="5A"||y.1e.72===44)){y.6J(".2T-3i .1q-1l-1m.1q-2u, .2T-3i .1q-1l-1m.1q-2u:kr",{"3N-kz":"0 !2k"},"a8-9o-62")}}1b j=17(K,L,I,J,H){13.1I={1Z:1h,1V:1h,6A:1,1d:1h,2m:0,1A:{1f:0,1g:0},2f:1k};13.1l={1Z:1h,1V:1h,6A:1,1d:1h,2m:0,1A:{1f:0,1g:0},2f:1k};if(y.1Q(K)==="8K"){13.1I=K}1j{if(y.1Q(K)==="1N"){13.1I.1V=y.6o(K)}}if(y.1Q(L)==="8K"){13.1l=L}1j{if(y.1Q(L)==="1N"){13.1l.1V=y.6o(L)}}13.3u=I;13.1w=J;13.4p=H;13.7M=1h;13.3S=1h;13.1d=1h};j.2w={9Q:17(J,I,H){1b K=J.8r("2b")[0];if(H){13.1I.1d=K||y.$1t("2b").2a(J)}if(e>1){13.1I.1V=J.2r("3v-1i-2x");if(13.1I.1V){13.1I.6A=2}13.1l.1V=J.2r("3v-1l-1i-2x");if(13.1l.1V){13.1l.6A=2}}13.1I.1Z=J.2r("3v-1i")||J.2r("kt")||(K?K.7R||K.2r("1Z"):1h);if(13.1I.1Z){13.1I.1Z=y.6o(13.1I.1Z)}13.1I.1V=13.1I.1V||13.1I.1Z;if(13.1I.1V){13.1I.1V=y.6o(13.1I.1V)}13.1l.1Z=J.2r("3v-1l-1i")||J.2r("79");if(13.1l.1Z){13.1l.1Z=y.6o(13.1l.1Z)}13.1l.1V=13.1l.1V||13.1l.1Z;if(13.1l.1V){13.1l.1V=y.6o(13.1l.1V)}13.3u=J.2r("3v-3u")||J.2r("8l")||I;13.3S=J.2r("3v-3S");13.4p=J;1a 13},aB:17(H){1b I=1h;if(26.1K>1&&y.1Q(26[1])==="17"){I=26[1]}if(13[H].2m!==0){if(13[H].2f){13.6y(I)}1a}if(13[H].1V&&13[H].1d&&!13[H].1d.2r("1Z")&&!13[H].1d.2r("kf")){13[H].1d.3y("1Z",13[H].1V)}13[H].2m=1;1t y.aw(13[H].1d||13[H].1V,{7u:g(17(J){13[H].2f=1s;13[H].2m=J.2l?2:-1;if(J.2l){13[H].1A=J.1F();if(!13[H].1d){13[H].1d=g(J.2b);13[H].1d.2r("2n");13[H].1d.5H("2n");13[H].1A.1f/=13[H].6A;13[H].1A.1g/=13[H].6A}1j{13[H].1d.1y({"1X-1f":13[H].1A.1f,"1X-1g":13[H].1A.1g});if(13[H].1d.7R&&13[H].1d.7R!==13[H].1d.1Z){13[H].1V=13[H].1d.7R}1j{if(y.6o(13[H].1d.2r("1Z")||"")!==13[H].1V){13[H].1d.3y("1Z",13[H].1V)}}}}13.6y(I)}).1E(13)})},91:17(){13.aB("1I",26[0])},bN:17(){13.aB("1l",26[0])},5Z:17(){13.7M=1h;if(26.1K>0&&y.1Q(26[0])==="17"){13.7M=26[0]}13.91();13.bN()},6y:17(H){if(H){H.2e(1h,13)}if(13.7M&&13.1I.2f&&13.1l.2f){13.7M.2e(1h,13);13.7M=1h;1a}},2f:17(){1a(13.1I.2f&&13.1l.2f)},2l:17(){1a(13.1I.2m===2&&13.1l.2m===2)},7t:17(I){1b H=I==="1I"?"1l":"1I";if(!13[I].2f||(13[I].2f&&13[I].2m===2)){1a 13[I].1V}1j{if(!13[H].2f||(13[H].2f&&13[H].2m===2)){1a 13[H].1V}}1a 1h},6R:17(I){1b H=I==="1I"?"1l":"1I";if(!13[I].2f||(13[I].2f&&13[I].2m===2)){1a 13[I].1d}1j{if(!13[H].2f||(13[H].2f&&13[H].2m===2)){1a 13[H].1d}}1a 1h},1F:17(I){1b H=I==="1I"?"1l":"1I";if(!13[I].2f||(13[I].2f&&13[I].2m===2)){1a 13[I].1A}1j{if(!13[H].2f||(13[H].2f&&13[H].2m===2)){1a 13[H].1A}}1a{1f:0,1g:0}},kk:17(I){1b H=I==="1I"?"1l":"1I";if(!13[I].2f||(13[I].2f&&13[I].2m===2)){1a 13[I].6A}1j{if(!13[H].2f||(13[H].2f&&13[H].2m===2)){1a 13[H].6A}}1a 1},6T:17(H){13.1d=13.6R(H)}};1b i=17(I,H){13.1w=1t y.7e(n);13.1o=g(17(){if(26.1K>1){1a 13.7A(26[0],26[1])}1a 13.dE(26[0])}).1E(13.1w);13.dO=1t y.7e(k);13.3P=[];13.1i=1h;13.6F=1h;13.3H=g(I).1D("3O la 2Q",17(J){J.2i()});13.id=1h;13.1d=1h;13.80=1h;13.6V=1h;13.aq=1h;13.6O=1h;13.7B={1f:0,1g:0};13.1A={1f:0,1g:0};13.1S={1f:0,1g:0};13.3k={1f:0,1g:0};13.1Y={1G:0,1M:0,2J:0,2H:0};13.2l=1k;13.1J=1k;13.5L=1h;13.ax=1h;13.5P=g(17(){if(13.1J){13.1i.1d.1y({"1X-1g":1p.2g(13.1i.1F("1l").1g,13.74())});13.1i.1d.1y({"1X-1f":1p.2g(13.1i.1F("1l").1f,13.7h())})}13.8c(26[0])}).1E(13);13.bD=g(17(J){3M(13.ax);13.ax=g(13.5P).2E(10,J.1u==="6u")}).2I(13);if(r){G.3a(y.$1t("2V",{},{6w:"2X",4w:"3p"}).3a(1n.97(r)));r=2A}13.1r=1h;13.1c=1h;13.3h=1h;13.bI=1h;13.6m=0;13.8P=1s;13.67=1h;13.5D=1h;13.6U=1h;13.3j=1h;13.3X=1h;13.40=1h;13.5g=1h;13.87=1h;13.56=1h;13.8b=1h;13.5m=1h;13.4g=1h;13.4Y=[];13.2N={};13.ck=0;13.bQ=1h;13.4D(H)};i.2w={ey:17(H){13.1w.8m(1m[C+"7e"]||{});13.1w.9x(13.3H.2r("3v-1w")||"");if(!y.1e.aA){13.1o("9N",1k)}if(y.1e.2T||13.1o("9N")){13.1w.8m(13.dO.dP());13.1w.8m(1m[C+"kX"]||{});13.1w.9x(13.3H.2r("3v-2T-1w")||"")}if(y.1Q(H)==="1N"){13.1w.9x(H||"")}1j{13.1w.8m(H||{})}if(13.1o("5B")){13.1o("5B",13.1o("5B").4r(","," "))}if(13.1o("8N")===1k){13.1o("8N","3T")}if(13.1o("3h")===1k){13.1o("3h","3T")}4G(13.1o("3h")){1C"3T":13.6m=0;1H;1C"2Y":13.6m=6n;1H;1C"bz":1P:13.6m=2;1H}if(13.1o("48")==="3T"){13.1o("48",1k)}if(13.1o("2s")==="3T"){13.1o("2s",1k)}if(13.1o("4L")==="3T"){13.1o("4L",1k)}if(y.1e.2T&&13.1o("48")==="1l"&&13.1o("ci")==="2y"){if(13.1o("2s")){13.1o("48",1k)}1j{13.1o("4k","2Q")}}},4D:17(K){1b I;1b H=13;1b J;if(13.ck<1){13.ey(K);if(w&&!13.1o("c7")){1a}13.6V=13.3H.dZ("2b");13.aq=13.6V?13.6V.2r("1Z"):1h;13.6O=g(13.3H).2r("8l");g(13.3H).5H("8l")}J=1t j().9Q(13.3H,13.6O,1s);if(!J.1I.1V){if(++13.ck<=B){13.bQ=4q(17(){H.4D()},2K)}1a}13.6F=J;13.1i=13.6F;D(13.3H);13.id=13.3H.2r("id")||"1q-"+1p.5Q(1p.6q()*y.6t());13.3H.3y("id",13.id);13.1d=y.$1t("5O").1B("1q-5O");13.1d.dG(13.1i.1I.1d).1B(13.1o("5B"));if(13.1o("dC")!==1s){13.1d.1D("kR",17(M){M.2i();1a 1k})}13.1d.1B("1q-"+13.1o("4k")+"-1l");if(!13.1o("2s")){13.1d.1B("1q-73-2s")}13.1r={1d:y.$1t("2V",{"41":"1q-1r"},{1G:0}).2a(13.1d),1i:y.$1t("2b",{1Z:"3v:1i/ds;da,cD/cx="},{2h:"5J",1G:0,1M:0}),1f:0,1g:0,38:{x:0,y:0},5T:{x:0,y:0},1A:{1f:0,1g:0},3N:{x:0,y:0},dx:0,dy:0,6j:1k,4t:17(){if(y.1e.2M.2j){13.1d.1y({2j:"a1(-cj, -cj)"})}1j{13.1d.1y({1G:-ek})}}};13.1r.4t();13.1r.1d.3a(13.1r.1i);13.1c={1d:y.$1t("2V",{"41":"1q-1l-1m"},{1G:-fv}).1B(13.1o("5B")).2a(G),1i:y.$1t("2b",{1Z:"3v:1i/ds;da,cD/cx="},{2h:"5J"}),bE:0,1f:0,1g:0,5K:0,5k:0,1A:{1f:"2D",6S:"2v",1g:"2D",6Y:"2v"},1W:13.1o("48"),2h:13.1o("ci"),7k:13.1o("4k"),4m:1k,2L:1k,3g:1k,4W:1k,64:g(17(){13.1c.4W=26[0]!==1k;13.1d[13.1c.4W?"1U":"1B"]("1q-73-1l")}).1E(13),4t:g(17(){1b M=g(13.1d).2c("cr");13.1c.1d.1O("2U");13.1c.1d.1y({1G:-fv}).2a(G);13.1c.1d.1U("1q-a2 1q-p-"+(13.1c.1W==="1l"?13.1c.2h:13.1c.1W));if(!13.1J&&M){M.2S()}13.1c.1i.2r("2n");13.1c.1i.5H("2n")}).1E(13),9k:g(17(M){13.1d[M===1k?"1B":"1U"]("1q-73-1l");13.1d[M==="2u"?"1B":"1U"]("1q-2u-1l");13.1c.1d[M==="2u"?"1B":"1U"]("1q-2u");13.1c.1d[M==="4l"?"1B":"1U"]("1q-4l");if(M!=="1l"){13.1d.1U("1q-2y-1l");13.1c.1d.1U("1q-2y")}13.1c.1W=M;if(M===1k){13.1c.64(1k)}}).1E(13)};13.1c.1d.3a(13.1c.1i);13.1c.9k(13.1o("48"));13.1c.1i.5H("1f");13.1c.1i.5H("1g");if(8B(p)!=="2A"){1b L=1p.5Q(1p.6q()*y.6t());g(13.1d).3b("cr",y.$1t(((1p.5Q(1p.6q()*bW)+1)%2)?"bA":"2V").8q({id:"8S"+L}).1y({6w:"bS",7O:"3p",4w:"5u",f8:p[1],kA:p[2],eI:p[3],kE:"kL-kM",2h:"5J",1G:8,1M:8,8p:"2D",1f:"2D",kF:"2H",cA:"ku",f4:f9}).5r(v(p[0])));if(g(g(13.1d).2c("cr")).8r("a")[0]){g(g(g(13.1d).2c("cr")).8r("a")[0]).1D("24 1R",17(M){M.5h();1m.83(13.79)}).8q({id:"cg"+L})}y.6J("#"+13.id+" > 5O.1q-5O > #"+("8S"+L)+",#"+13.id+" > 5O.1q-5O > #"+("8S"+L)+" > #"+("cg"+L)+",bV 3B .1q-2s > #"+("8S"+L)+",bV 3B .1q-2s > #"+("8S"+L)+" > #"+("cg"+L),{6w:"bS !2k;",4w:"5u !2k;",f8:p[1]+" !2k;","kd-1A":p[2]+"2v !2k;","z-8J":"f9 !2k;"},"1q-bR-62",1s)}if((I=(""+13.1o("fb")).3A(/^([0-9]+)?(2v|%)?$/))){13.1c.1A.6S=I[2]||"2v";13.1c.1A.1f=(2t(I[1])||"2D")}if((I=(""+13.1o("fc")).3A(/^([0-9]+)?(2v|%)?$/))){13.1c.1A.6Y=I[2]||"2v";13.1c.1A.1g=(2t(I[1])||"2D")}if(13.1c.1W==="2u"){13.1d.1B("1q-2u-1l");13.1c.1d.1B("1q-2u");if(13.1c.1A.1f==="2D"){13.1c.1A.6S="%";13.1c.1A.1f=70}if(13.1c.1A.1g==="2D"){13.1c.1A.6Y="%"}}1j{if(13.1o("1l-2h").3A(/^#/)){if(13.1c.4m=g(13.1o("1l-2h").4r(/^#/,""))){if(g(13.1c.4m).1F().1g>50){if(13.1c.1A.1f==="2D"){13.1c.1A.6S="%";13.1c.1A.1f=2K}if(13.1c.1A.1g==="2D"){13.1c.1A.6Y="%";13.1c.1A.1g=2K}}}1j{13.1o("1l-2h","2H")}}if(13.1c.1W==="4l"){if(13.1c.1A.1f==="2D"){13.1c.1A.6S="2v"}if(13.1c.1A.1g==="2D"){13.1c.1A.6Y="2v"}}if(13.1c.1W==="1l"){if(13.1c.1A.1f==="2D"||13.1o("1l-2h")==="2y"){13.1c.1A.6S="%";13.1c.1A.1f=2K}if(13.1c.1A.1g==="2D"||13.1o("1l-2h")==="2y"){13.1c.1A.6Y="%";13.1c.1A.1g=2K}}if(13.1o("1l-2h")==="2y"){13.1d.1B("1q-2y-1l")}}13.1c.2h=13.1c.4m?"4m":13.1o("1l-2h");13.1r.3N.x=2t(13.1r.1d.3t("3N-1M-1f")||"0");13.1r.3N.y=2t(13.1r.1d.3t("3N-1G-1f")||"0");13.1i.91(17(){if(13.1i.1I.2m!==2){1a}13.1i.6T("1I");13.1A=13.1i.1d.1F();13.fr();13.2l=1s;if(13.1o("8t")===1s){s("bP",13.id);if(y.1e.2T){13.8c()}1j{13.5S()}}}.1E(13));if(13.1o("8t")!==1s||13.1o("4k")==="2Y"){13.1i.5Z(g(17(M){13.7E(M,1s)}).1E(13));13.5D=g(13.8n).1E(13).2E(a7)}13.fi()},2i:17(){3M(13.bQ);13.fA();if(13.1c){13.1c.1d.5f()}if(13.4g){13.4g.2i();13.4g=1h}if(13.3j){13.3j.5f()}if(13.1J){g(y.1e.43()).1y({7O:""})}g(13.3P).36(17(H){g(H.4p).1U("1q-6U-6W").1U(13.1o("5B")||"1q-$kN-62-41-6a-2S$")},13);if(13.6V){13.3H.3a(13.6V);if(13.aq){13.6V.3y("1Z",13.aq)}}if(13.6O){13.3H.3y("8l",13.6O)}if(13.1d){13.1d.5f()}},7E:17(I,J){1b H=13.1i;if(I.1l.2m!==2){13.1i=I;13.2l=1s;13.1c.64(1k);1a}13.1i=I;13.1i.6T(13.1J?"1l":"1I");13.1c.1i.1Z=13.1i.7t("1l");13.1c.1d.1U("1q-4l");13.1c.1i.2r("2n");13.1c.1i.5H("2n");13.1c.1d.1F();4q(g(17(){1b L=13.1c.1i.1F(),K;13.3k=13.1i.1F("1l");if(L.1f*L.1g>1&&L.1f*L.1g<13.3k.1f*13.3k.1g){13.3k=L}13.1S=y.4b(13.3k);if(13.1c.1W==="4l"){13.1c.1d.1B("1q-4l")}13.eF();13.1r.1i.1Z=13.1i.1d.7R||13.1i.1d.1Z;13.1c.64(13.1c.1W&&!(13.1J&&13.1c.1W==="4l"));13.2l=1s;13.5L=1h;13.5P();13.1d.1B("1q-2l");13.bG();if(H!==13.1i){s("fe",13.id,H.4p,13.1i.4p);if(13.8U){K=13.8U;13.8U=1h;13.3W(K.1i,K.fq)}}1j{if(!!J){s("bP",13.id)}}if(13.65){13.1d.2W(13.65.1u,13.65)}1j{if(13.1J&&13.1o("3x")==="2Y"){13.4C()}1j{if(!!J){13.5S()}}}}).1E(13),kP)},fi:17(){1b I=13.id;1b H;1b J;J=1t fj("1l\\\\-id(\\\\s+)?:(\\\\s+)?"+I+"($|;)");if(y.1e.2M.bU){H=y.$A(1n.c6(\'[3v-1l-id="\'+13.id+\'"]\'));H=g(H).5E(y.$A(1n.c6(\'[bO*="1l-id"]\')).2Z(17(K){1a J.3n(K.2r("bO")||"")}))}1j{H=y.$A(1n.9S("A")).2Z(17(K){1a I===K.2r("3v-1l-id")||J.3n(K.2r("bO")||"")})}g(H).36(17(L){1b K;1b M;g(L).1D("2Q",17(N){N.3U()});K=1t j().9Q(L,13.6O);if((13.1i.1l.1Z.3Q(K.1l.1V)||13.1i.1l.1V.3Q(K.1l.1V))&&(13.1i.1I.1Z.3Q(K.1I.1V)||13.1i.1I.1V.3Q(K.1I.1V))){g(K.4p).1B("1q-6U-6W");K=13.1i;K.4p=L}if(!K.3S&&13.1i.3S){K.3S=13.1i.3S}M=g(17(){13.3W(K)}).1E(13);g(L).1D("6E",17(N){if("fl"in N){N.fl()}},5);g(L).1D("24 "+(13.1o("cf")==="7x"?"7w 8u":"1R"),g(17(O,N){if(13.6i){3M(13.6i)}13.6i=1k;if(O.1u==="7w"){13.6i=g(M).2E(N)}1j{if(O.1u==="24"||O.1u==="1R"){M()}}}).2I(13,60)).1B(13.1o("5B")).1B("1q-6U");K.91();if(13.1o("8t")!==1s){K.bN()}13.3P.3c(K)},13)},3W:17(H,I){if(!13.2l){13.8U={1i:H,fq:I};1a}if(!H||H===13.1i){1a 1k}13.49(1h,1s);13.2l=1k;13.1d.1U("1q-2l");13.5D=g(13.8n).1E(13).2E(a7);H.5Z(g(17(P){1b J,Q,O,L,K,N,M=(y.1e.2z<10)?"1F":"7f";13.bG();P.6T("1I");if(!P.1d){13.2l=1s;13.1d.1B("1q-2l");1a}13.9r(P);J=13.1i.1d[M]();if(13.1J){P.6T("1l");O=y.$1t("2V").1B("1q-2s-bg");if(y.1e.2M.7S||y.1e.2z<10){O.3a(y.$1t("2b",{1Z:P.7t("1l")}).1y({2o:0}))}1j{O.3a(1t y.9e(P.1d).5i(b).6R().1y({2o:0}))}g(O).1y({"z-8J":-99}).2a(13.3j)}if(13.1J&&13.1c.1W==="1l"&&13.1o("3x")==="2Y"){g(P.1d).1y({2o:0}).2a(13.1d);Q=J;K=[P.1d,13.1i.1d];N=[{2o:[0,1]},{2o:[1,0]}];g(P.1d).1y({"1X-1f":1p.2g(P.1F("1l").1f,13.7h()),"1X-1g":1p.2g(P.1F("1l").1g,13.74())})}1j{13.1d.1y({1g:13.1d[M]().1g});13.1i.1d.1y({2h:"5J",1G:0,1M:0,2J:0,2H:0,1f:"2K%",1g:"2K%","1X-1f":"","1X-1g":""});g(P.1d).1y({"1X-1f":1p.2g(P.1F(13.1J?"1l":"1I").1f,13.1J?13.7h():6n),"1X-1g":1p.2g(P.1F(13.1J?"1l":"1I").1g,13.1J?13.74():6n),2h:"j6",1G:0,1M:0,2o:0,2j:""}).2a(13.1d);Q=g(P.1d)[M]();if(!I){g(P.1d).1y({"2g-1f":J.1f,1g:J.1g,"1X-1f":J.1f,"1X-1g":""})}13.1d.1y({1g:"",7O:""}).1F();g(P.1d).1F();K=[P.1d,13.1i.1d];N=[y.29({2o:[0,1]},I?{4c:[0.6,1]}:{"2g-1f":[J.1f,Q.1f],"1X-1f":[J.1f,Q.1f],1g:[J.1g,Q.1g]}),{2o:[1,0]}]}if(13.1J){if(13.3X.4n&&O.4n){L=g(13.3X.4n).3t("2o");if(y.1e.6g){K=K.5E([O.4n]);N=N.5E([{2o:[0.bM,L]}])}1j{K=K.5E([O.4n,13.3X.4n]);N=N.5E([{2o:[0.bM,L]},{2o:[L,0.bM]}])}}}1t y.8W(K,{5e:(I||13.1o("f1"))?I?iO:iI:0,21:I?"5y-5z(0.9I, 0.c1, 0.dH, 1)":(J.1f===Q.1f)?"93":"5y-5z(0.25, .1, .1, 1)",7n:g(17(){13.1i.1d.2S().2r("2n");13.1i.1d.5H("2n");g(P.1d).1y(13.1J?{1f:"2D",1g:"2D"}:{1f:"",1g:""}).1y({"2g-1f":"","2g-1g":"",2o:"","1X-1f":1p.2g(P.1F(13.1J?"1l":"1I").1f,13.1J?13.7h():6n),"1X-1g":1p.2g(P.1F(13.1J?"1l":"1I").1g,13.1J?13.74():6n)});if(13.1J){13.3X.2S();13.3X=2A;13.3X=O.3F("z-8J",-2K);g(13.3X.4n).1y({2o:""});if(13.40){if(P.3u){if(P.3S){13.40.5r("").3a(y.$1t("a",{79:P.3S}).1D("24 1R",13.9G.1E(13)).5r(P.3u))}1j{13.40.5r(P.3u).1B("1q-5I")}}1j{13.40.1U("1q-5I")}}}13.7E(P)}).1E(13),bL:g(17(R,S){if(2A!==R.4c){S.3F("2j","4c("+R.4c+")")}})}).4D(N)}).1E(13))},9r:17(I){1b H=1k;g(13.3P).36(17(J){g(J.4p).1U("1q-6U-6W");if(J===I){H=1s}});if(H&&I.4p){g(I.4p).1B("1q-6U-6W")}if(13.4g){13.4g.eE(I.cF)}},eF:17(H){if(13.1i.3u&&13.1o("8N")!=="3T"&&13.1c.1W!=="2u"){if(!13.1c.3u){13.1c.3u=y.$1t("2V",{"41":"1q-3u"}).2a(13.1c.1d.1B("3u-"+13.1o("8N")))}13.1c.3u.5r(13.1i.3u)}},5S:17(H,K,I){1b J;if(!13.1J){if(13.6m<=0){1a}if(I!==1s){13.6m--}}if(K===2A||K===1h){if(!13.1c.2L&&!13.1c.3g){if(13.1o("48")&&(13.1c.4W||!13.1i.2f())&&!(y.1e.2T&&13.1o("2s")&&13.1c.1W==="1l"&&13.1c.2h==="2y")){if(13.1c.7k==="7x"){K=13.1o("bJ")}1j{if(13.1c.7k==="2Q"){K=13.1o("9s")}}}1j{K=13.1o("2s")?13.1o("8V"):""}}1j{K=13.1o("2s")?13.1o("8V"):""}}if(!K){13.ca();1a}J=13.1d;if(!13.3h){13.3h=y.$1t("2V",{"41":"1q-3h"});13.bI=y.$1t("bA",{"41":"1q-3h-jQ"}).3a(1n.97(K)).2a(13.3h);g(13.3h).2a(13.1d)}1j{g(13.bI).5r(K)}13.3h.1y({"21-bH":""}).1U("1q-3h-3p");if(13.1J){J=13.56}1j{if((13.1c.2L||13.1c.3g)&&13.1c.1W!=="2u"&&13.1c.2h==="2y"){J=13.1c.1d}}if(H===1s){4q(g(17(){13.3h.1B("1q-3h-3p")}).1E(13),16)}13.3h.2a(J)},ca:17(){if(13.3h){13.3h.1y({"21-bH":"eJ"}).1B("1q-3h-3p")}},8n:17(){if(!13.67){13.67=y.$1t("2V",{"41":"1q-jT"});13.1d.3a(13.67);13.67.1F()}13.67.1B("eM")},bG:17(){3M(13.5D);13.5D=1h;if(13.67){g(13.67).1U("eM")}},7a:17(J,N){1b M=y.4b(13.1c.1A),L=(!13.1J&&13.1c.4m)?g(13.1c.4m).1F():{1f:0,1g:0},I,H,K=13.1A,O={x:0,y:0};N=N||13.1c.2h;13.7B=13.1i.1d.1F();13.1A=13.1i.1d.1F();13.1Y=13.1i.1d.7f();if(!L.1g){L=13.1A}if(13.1o("eN")===1k||13.1c.1W===1k||13.1c.1W==="4l"){J=1k}if(13.1c.1W==="4l"){if(M.1f==="2D"){M.1f=13.3k.1f}if(M.1g==="2D"){M.1g=13.3k.1g}}if(13.1J&&13.1c.1W==="2u"){M.1f=70;M.1g="2D"}if(13.1c.1W==="2u"&&M.1g==="2D"){13.1c.1f=2t(M.1f/2K)*1p.2g(L.1f,L.1g);13.1c.1g=13.1c.1f}1j{if(13.1c.1W==="1l"&&N==="2y"){13.1A=13.1d.1F();L=13.1A;13.1Y=13.1d.7f();13.1c.1f=L.1f;13.1c.1g=L.1g}1j{13.1c.1f=(M.6S==="%")?2t(M.1f/2K)*L.1f:5U(M.1f);13.1c.1g=(M.6Y==="%")?2t(M.1g/2K)*L.1g:5U(M.1g)}}if(13.1c.1W==="4l"){H=1p.2g(1p.2g(13.1c.1f/13.3k.1f,13.1c.1g/13.3k.1g),1);13.1c.1f=13.3k.1f*H;13.1c.1g=13.3k.1g*H}13.1c.1f=1p.4h(13.1c.1f);13.1c.1g=1p.4h(13.1c.1g);13.1c.bE=13.1c.1f/13.1c.1g;13.1c.1d.1y({1f:13.1c.1f,1g:13.1c.1g});if(J){L=13.1J?13.3j.1F():13.1c.1d.1F();if(!13.1J&&(13.7B.1f*13.7B.1g)/(13.3k.1f*13.3k.1g)>0.8){13.1S.1f=1.5*13.3k.1f;13.1S.1g=1.5*13.3k.1g}1j{13.1S=y.4b(13.3k)}}if(13.1c.1W!==1k&&!13.1c.2L&&!(13.1J&&13.1o("3x")==="2Y")){if((13.7B.1f*13.7B.1g)/(13.1S.1f*13.1S.1g)>0.8){13.1S=y.4b(13.3k);13.1c.64(1k)}1j{13.1c.64(1s)}}13.1c.1i.1y({1f:13.1S.1f,1g:13.1S.1g});13.1S.8I=13.1S.1f;13.1S.a0=13.1S.1g;I=13.1c.1d.89();13.1c.5K=1p.4h(I.1f);13.1c.5k=1p.4h(I.1g);13.1r.1f=1p.4h(13.1c.5K/(13.1S.1f/13.1A.1f));13.1r.1g=1p.4h(13.1c.5k/(13.1S.1g/13.1A.1g));13.1r.1d.1y({1f:13.1r.1f,1g:13.1r.1g});13.1r.1i.1y(13.1A);y.29(13.1r,13.1r.1d.1F());if(13.1c.2L){3M(13.4V);13.4V=1h;if(13.1r.6j){13.1r.38.x*=(13.1A.1f/K.1f);13.1r.38.y*=(13.1A.1g/K.1g);O.x=13.1r.5T.x;O.y=13.1r.5T.y}1j{O.x=13.1Y.1M+13.1r.1f/2+(13.1r.38.x*(13.1A.1f/K.1f));O.y=13.1Y.1G+13.1r.1g/2+(13.1r.38.y*(13.1A.1g/K.1g))}13.88(1h,O)}},8c:17(L){1b O;1b N;1b H;1b M;1b K;1b J;1b I=g(13.1d).2c("cr");H=a(5);K=13.1c.2h;M=13.1J?"2y":13.1c.4m?"4m":13.1o("1l-2h");J=13.1J&&13.1c.1W==="1l"?13.3j:1n.3B;if(13.1J){H.y=0;H.x=0}if(!L){13.7a(1s,M)}O=13.1Y.1G;if(13.1c.1W!=="2u"){if(L){13.7a(1k);1a}4G(M){1C"2y":1C"4m":O=0;N=0;1H;1C"1G":O=13.1Y.1G-13.1c.1g-13.1o("1l-5d");if(H.1G>O){O=13.1Y.2J+13.1o("1l-5d");M="2J"}N=13.1Y.1M;1H;1C"2J":O=13.1Y.2J+13.1o("1l-5d");if(H.2J<O+13.1c.1g){O=13.1Y.1G-13.1c.1g-13.1o("1l-5d");M="1G"}N=13.1Y.1M;1H;1C"1M":N=13.1Y.1M-13.1c.1f-13.1o("1l-5d");if(H.1M>N&&H.2H>=13.1Y.2H+13.1o("1l-5d")+13.1c.1f){N=13.1Y.2H+13.1o("1l-5d");M="2H"}1H;1C"2H":1P:N=13.1Y.2H+13.1o("1l-5d");if(H.2H<N+13.1c.1f&&H.1M<=13.1Y.1M-13.1c.1f-13.1o("1l-5d")){N=13.1Y.1M-13.1c.1f-13.1o("1l-5d");M="1M"}1H}4G(13.1o("1l-2h")){1C"1G":1C"2J":if(H.1G>O||H.2J<O+13.1c.1g){M="2y"}1H;1C"1M":1C"2H":if(H.1M>N||H.2H<N+13.1c.1f){M="2y"}1H;1P:}13.1c.2h=M;if(!13.1c.3g&&!13.1c.2L){if(y.1e.2T&&!13.1J&&13.1c.1W==="1l"){if(13.1o("2s")){13.1c.64(M!=="2y")}1j{if(13.1o("4k")!=="2Q"){13.1c.7k=M==="2y"?"2Q":13.1o("4k");13.9d();13.9j();13.8M(13.1c.7k==="2Q");13.8L(13.1c.7k==="2Q"&&!13.1o("2s"))}}13.5S(1k,1h,!13.1i.2f())}1a}13.7a(1k);if(L){1a}if(M==="4m"){J=13.1c.4m;H.y=0;H.x=0}if(M==="2y"){if(13.1c.1W!=="4l"){13.1c.1d.1B("1q-2y");13.1d.1B("1q-2y-1l")}13.1r.4t();O=13.1Y.1G+H.y;N=13.1Y.1M+H.x;if(!13.1J&&y.1e.2z&&y.1e.2z<11){O=0;N=0;J=13.1d}}1j{O+=H.y;N+=H.x;13.1d.1U("1q-2y-1l");13.1c.1d.1U("1q-2y")}13.1c.1d.1y({1G:O,1M:N})}1j{13.7a(1k);J=13.1d;if(y.1e.2T&&!13.1J&&!13.1c.3g&&!13.1c.2L){13.5S(1k,1h,!(13.1o("8t")&&13.1i.2f()))}}13.1c.1d[13.1J?"1B":"1U"]("1q-1J");if(!13.1J&&I){I.2a(13.1c.1W==="1l"&&M==="2y"?13.1c.1d:13.1d,((1p.5Q(1p.6q()*bW)+1)%2)?"1G":"2J")}13.1c.1d.2a(J)},fC:17(N){1b J;1b H;1b L;1b K;1b M=1k;1b I=N.bF?5:3/54;if(!13.1c.2L){1a}g(N).2i();I=(2K+I*1p.3C(N.8Q))/2K;if(N.8Q<0){I=1/I}if(13.1c.1W==="2u"){H=1p.1X(2K,1p.5s(13.1c.1f*I));H=1p.2g(H,13.1A.1f*0.9);L=H/13.1c.bE;13.1c.1f=1p.4h(H);13.1c.1g=1p.4h(L);13.1c.1d.1y({1f:13.1c.1f,1g:13.1c.1g});J=13.1c.1d.89();13.1c.5K=1p.4h(J.1f);13.1c.5k=1p.4h(J.1g);M=1s}1j{if(!13.1J&&13.1c.1W==="1l"){H=1p.1X(13.1A.1f,1p.5s(13.1S.1f*I));H=1p.2g(H,13.1S.8I);L=H/(13.1S.8I/13.1S.a0);13.1S.1f=1p.4h(H);13.1S.1g=1p.4h(L)}1j{1a}}K=g(1m).7i();13.1r.1f=(13.1c.5K/(13.1S.1f/13.1A.1f));13.1r.1g=(13.1c.5k/(13.1S.1g/13.1A.1g));13.1r.1d.1y({1f:13.1r.1f,1g:13.1r.1g});y.29(13.1r,13.1r.1d.1F());if(13.1c.2L){3M(13.4V);13.4V=1h;if(M){13.4V=1s}13.88(1h,{x:N.x-K.x,y:N.y-K.y});if(M){13.4V=1h}}},8M:17(J){1b I;1b H=J?"3r 1R":"5c"+(1m.3E.6I?" 6Q":1m.3E.7Z?" f2":"")+(1m.3E.6I?" 5q":1m.3E.7Z?" 9M":" 6P");1b K=13.1d.2c("1q:5j:4C:fn",(!J)?g(17(L){if(L.6k()&&!L.5o()){1a}if(L&&L.2B==="3I"&&L.1u!=="6Q"){1a}I=(y.1e.2z<9)?y.29({},L):L;if(!13.5L){3M(13.5L);13.5L=4q(g(17(){13.4C(I)}).1E(13),jt)}}).2I(13):g(13.4C).2I(13));13.1d.3b("1q:5j:4C:1z",H).1D(H,K,10)},9d:17(){1b H=13.1d.2c("1q:5j:4C:1z");1b I=13.1d.2c("1q:5j:4C:fn");13.1d.1O(H,I);13.1d.34("1q:5j:4C:fn")},8L:17(I){1b H="6f";if(1m.3E.6I){H+=" 5F bB 5q"}1j{if(1m.3E.7Z){H+=" fy eX 9M"}1j{H+=" 8u 6P"}}if(I){if(13.1J||y.1e.2T){H="3r 1R"}1j{H+=" 3r 1R"}}1b J=13.1d.2c("1q:5j:49:fn",g(17(L){if(L.6k()&&!L.5o()){1a}if(L&&L.1u==="5F"&&L.2B!=="3I"){1a}if(L&&(L.1u==="5q"||L.1u==="9M"||L.1u==="6P")){if(!13.2l||!13.1c.4W||!13.1c.2L){1a}1b K=L.7p();if(K.x<13.1Y.1M||K.x>13.1Y.2H||K.y<13.1Y.1G||K.y>13.1Y.2J){13.49(L);1a}}1j{if(13.1c.1d!==L.8H()&&!((13.1c.2h==="2y"||13.1c.1W==="2u")&&13.1c.1d.a4(L.8H()))&&!13.1d.a4(L.8H())){13.49(L);1a}}}).2I(13));13.1d.3b("1q:5j:49:1z",H).1D(H,J,20)},9j:17(){1b H=13.1d.2c("1q:5j:49:1z");1b I=13.1d.2c("1q:5j:49:fn");13.1d.1O(H,I);13.1d.34("1q:5j:49:fn")},fr:17(){13.cV=13.5N.1E(13);13.1d.1D(["5c",1m.3E.6I?"6Q":"f2"],g(17(H){if((y.1e.7T||y.1e.4X==="6L"&&y.1e.6g)&&13.1o("48")&&13.1o("4k")!=="2Q"&&H.1u==="5c"){H.3U();if(y.1e.6g){H.5h()}}if(!13.1c.2L){1a}if(13.1c.2h==="2y"){13.1r.5T=H.7p()}}).2I(13),10);13.1d.1D(["6f",1m.3E.6I?"5F":"fy"],g(17(H){if(H.6k()&&H.5o()){13.1r.7s=1k}}).2I(13),10);13.1d.1D("7X "+(y.1e.4X==="6L"?"":1m.3E.6I?"5q":1m.3E.7Z?"9M":"6P"),g(13.88).2I(13));if(13.1o("48")){13.8M(13.1o("4k")==="2Q");13.8L(13.1o("4k")==="2Q")}13.1d.1D("6E",17(H){H.5h()},10).1D("1R",g(17(H){13.1d.bZ("fx","2Q");if(13.1J){13.3j.2W("1R",H)}}).1E(13),15);if(13.1o("2s")){13.1d.1D("24 1R",g(13.2s).2I(13),15)}1j{13.1d.1D("24 1R",g(13.9G).2I(13),15)}if(13.3P.1K>1){13.c4()}if(!y.1e.2T&&13.1o("fD")){13.1d.1D("4N",13.fC.2I(13))}g(1m).1D(y.1e.2T?"6X":"6X 6u",13.bD)},fA:17(){if(13.1d){13.1d.1O("4N")}g(1m).1O("6X 6u",13.bD);g(13.3P).36(17(H){g(H.4p).bC()})},4C:17(N){1b O;1b M;1b K;1b L;1b H;1b I=0;1b J=0;if(!13.1i.2f()||!13.2l||!13.1c.4W||13.1c.2L||13.1c.3g){if(!13.1i.2f()&&!13.65){if(N){13.65=d(N);N.4u()}13.1i.5Z(13.7E.1E(13));if(!13.5D){13.5D=g(13.8n).1E(13).2E(a7)}}1a}if(N&&N.1u==="5q"&&N.2B==="3I"){1a}if(!13.1o("48")&&13.1o("2s")&&!13.1J){13.1c.2L=1s;1a}13.1c.3g=1s;if(13.1J&&13.1c.1W==="1l"){L=13.1i.1d.7P();13.5g.1B("1q-1l-in");H=13.56.7P();J=((L.1M+L.2H)/2-(H.1M+H.2H)/2);I=((L.1G+L.2J)/2-(H.1G+H.2J)/2)}13.1c.1i.1O("2U");13.1c.1d.1U("1q-a2").1O("2U");13.1c.1d.1B("1q-3g");13.1d.1B("1q-3g");13.8c();M=(13.1c.1W==="1l")?13.1c.2h:13.1c.1W;if(y.1e.2M.21&&!(13.1J&&13.1o("3x")==="2Y")){if(M==="2y"){K=13.1i.1d.1F();13.1c.1i.1y({2j:"4o(0,"+I+"2v, 0) 4c("+K.1f/13.1S.1f+", "+K.1g/13.1S.1g+")"}).1F();13.1c.1i.1D("2U",g(17(){13.1c.1i.1O("2U");13.1c.1d.1U("1q-3g 1q-p-"+M);13.1c.3g=1k;13.1c.2L=1s}).1E(13));13.1c.1d.1B("1q-p-"+M).1F();if(!y.1e.2T&&y.1e.5A&&(y.1e.4v==="5A"||y.1e.4v==="76")){13.1c.3g=1k;13.1c.2L=1s}}1j{13.1c.1d.1D("2U",g(17(){13.1c.1d.1O("2U");13.1c.1d.1U("1q-3g 1q-p-"+M)}).1E(13));13.1c.1d.1y({21:"2X"});13.1c.1d.1B("1q-p-"+M).1F();13.1c.1d.1y({21:""}).1F();13.1c.1d.1U("1q-p-"+M);13.1c.3g=1k;13.1c.2L=1s}}1j{13.1c.1d.1U("1q-3g");13.1c.3g=1k;13.1c.2L=1s}if(!13.1J){13.5S(1s)}if(N){N.2i().4u();O=N.7p();if(13.1c.1W==="2u"&&(/24/i).3n(N.1u)){O.y-=13.1c.1g/2+10}if(M==="2y"&&((/24/i).3n(N.1u)||N.6k())){13.1r.38={x:0,y:0};O.x=-(O.x-13.1Y.1M-13.1A.1f/2)*(13.1S.1f/13.1A.1f);O.y=-(O.y-13.1Y.1G-13.1A.1g/2)*(13.1S.1g/13.1A.1g)}}1j{O={x:13.1Y.1M+(13.1Y.2H-13.1Y.1M)/2,y:13.1Y.1G+(13.1Y.2J-13.1Y.1G)/2};if(y.1e.2T&&13.1J&&13.1o("3x")==="2Y"){13.1r.6j=1s;13.1r.38={x:0,y:0};O.x=-(O.x-13.1Y.1M-13.1A.1f/2)*(13.1S.1f/13.1A.1f);O.y=-(O.y-13.1Y.1G-13.1A.1g/2)*(13.1S.1g/13.1A.1g)}}13.1d.1U("1q-3g").1B("1q-2L");O.x+=-J;O.y+=-I;13.1r.5T={x:0,y:0};13.1r.dx=0;13.1r.dy=0;13.88(N,O,1s);s("fu",13.id)},49:17(J,O){1b M;1b K;1b H;1b I;1b L=0;1b N=0;1b P=13.1c.2L;13.65=1h;if(!13.2l){1a}if(J&&J.1u==="bB"&&J.2B==="3I"){1a}3M(13.4V);13.4V=1h;3M(13.5L);13.5L=1h;13.1c.3g=1k;13.1c.2L=1k;if(O!==1s&&!13.1J){if(P){if(y.1e.2T&&!13.1J&&13.1c.1W==="1l"){13.8c()}1j{13.5S()}}}if(!13.1c.4W){1a}if(J){J.2i()}13.1c.1i.1O("2U");13.1c.1d.1U("1q-3g").1O("2U");if(13.1J){I=13.56.7P();if(13.1o("3x")!=="2Y"){13.5g.1U("1q-1l-in")}13.1i.1d.1y({"1X-1g":13.74()});H=13.1i.1d.7P();N=((H.1M+H.2H)/2-(I.1M+I.2H)/2);L=((H.1G+H.2J)/2-(I.1G+I.2J)/2)}M=(13.1c.1W==="1l")?13.1c.2h:13.1c.1W;if(y.1e.2M.21&&J&&!(13.1J&&13.1o("3x")==="2Y")){if(M==="2y"){13.1c.1i.1D("2U",g(17(){13.1c.1i.1O("2U");13.1d.1U("1q-2L");4q(g(17(){13.1c.4t()}).1E(13),32)}).1E(13));K=13.1i.1d.1F();13.1c.1d.1B("1q-a2 1q-p-"+M).1F();13.1c.1i.1y({2j:"4o(0,"+L+"2v,0) 4c("+K.1f/13.1S.8I+", "+K.1g/13.1S.a0+")"})}1j{13.1c.1d.1D("2U",g(17(){13.1c.4t();13.1d.1U("1q-2L")}).1E(13));13.1c.1d.3t("2o");13.1c.1d.1B("1q-a2 1q-p-"+M);13.1d.1U("1q-2L")}}1j{13.1c.4t();13.1d.1U("1q-2L")}13.1r.dx=0;13.1r.dy=0;13.1r.5T={x:0,y:0};13.1r.4t();if(P){s("fw",13.id)}},88:17(R,Q,P){1b J=Q;1b L;1b K;1b N=0;1b I;1b M=0;1b H;1b S;1b O=1k;if(!13.1c.2L&&!P){1a}if(R){g(R).3U().5h();if(R.6k()&&!R.5o()){1a}O=(/24/i).3n(R.1u)||R.6k();if(O&&!13.1r.7s){13.1r.7s=O}if(!J){J=R.7p()}}if(13.1c.1W==="4l"){1a}if(13.1c.1W==="1l"&&13.1c.2h==="2y"&&(R&&O||!R&&13.1r.6j)){13.1r.6j=1s;L=13.1r.38.x+(J.x-13.1r.5T.x);K=13.1r.38.y+(J.y-13.1r.5T.y);13.1r.5T=J;N=1p.2g(0,13.1c.5K-13.1S.1f)/2;I=-N;M=1p.2g(0,13.1c.5k-13.1S.1g)/2;H=-M}1j{13.1r.6j=1k;if(13.1c.1W==="2u"){J.y=1p.1X(13.1Y.1G,1p.2g(J.y,13.1Y.2J));J.x=1p.1X(13.1Y.1M,1p.2g(J.x,13.1Y.2H))}L=J.x-13.1Y.1M;K=J.y-13.1Y.1G;I=13.1A.1f-13.1r.1f;H=13.1A.1g-13.1r.1g;L-=13.1r.1f/2;K-=13.1r.1g/2}if(13.1c.1W!=="2u"){L=1p.1X(N,1p.2g(L,I));K=1p.1X(M,1p.2g(K,H))}13.1r.38.x=L;13.1r.38.y=K;if(13.1c.1W==="1l"&&13.1c.2h!=="2y"){if(y.1e.2M.2j){13.1r.1d.1y({2j:"a1("+13.1r.38.x+"2v,"+13.1r.38.y+"2v)"});13.1r.1i.1y({2j:"a1("+-(13.1r.38.x+13.1r.3N.x)+"2v, "+-(13.1r.38.y+13.1r.3N.y)+"2v)"})}1j{13.1r.1d.1y({1G:13.1r.38.y,1M:13.1r.38.x});13.1r.1i.1y({1G:-(13.1r.38.y+13.1r.3N.y),1M:-(13.1r.38.x+13.1r.3N.x)})}}if(13.1c.1W==="2u"){if(13.1r.7s&&!(R&&R.1u==="3r")){J.y-=13.1c.1g/2+10}13.1c.1d.1y({1G:J.y-13.1Y.1G-13.1c.1g/2,1M:J.x-13.1Y.1M-13.1c.1f/2})}if(!13.4V){13.1r.dx=0;13.1r.dy=0;13.5N(1)}},5N:17(M){1b K;1b I;1b H;1b N;1b L;1b J;if(!jI(M)){if(13.1r.6j){M=13.1r.7s?0.4:0.16}1j{M=13.1o("fz")?0.2:13.1r.7s?0.4:0.8}}K=((13.1r.38.x-13.1r.dx)*M);I=((13.1r.38.y-13.1r.dy)*M);13.1r.dx+=K;13.1r.dy+=I;if(!13.4V||1p.3C(K)>0.bT||1p.3C(I)>0.bT){if(13.1r.6j){H=13.1r.dx;N=13.1r.dy}1j{H=(13.1r.dx*(13.1S.1f/13.1A.1f)-1p.1X(0,13.1S.1f-13.1c.5K)/2);N=(13.1r.dy*(13.1S.1g/13.1A.1g)-1p.1X(0,13.1S.1g-13.1c.5k)/2);if(13.1c.1W==="2u"){H=1p.5s(H);N=1p.5s(N)}H=-H;N=-N}L=13.1S.1f/13.1S.8I;J=13.1S.1g/13.1S.a0;13.1c.1i.1y(y.1e.2M.2j?{2j:f+H+"2v,"+N+"2v"+A+" 4c("+L+","+J+")"}:{1f:13.1S.1f,1g:13.1S.1g,1M:-(13.1r.dx*(13.1S.1f/13.1A.1f)+1p.2g(0,13.1S.1f-13.1c.5K)/2),1G:-(13.1r.dy*(13.1S.1g/13.1A.1g)+1p.2g(0,13.1S.1g-13.1c.5k)/2)})}if(13.1c.1W==="2u"){1a}13.4V=4q(13.cV,16)},c4:17(){1b T;1b J;1b O=30;1b L=jA;1b Q;1b R="";1b I={};1b H;1b N;1b S=0;1b U={21:y.1e.9J+6e.7g(32)+"d5 5y-5z(.18,.35,.58,1)"};1b K;1b P;1b M=g(17(V){if(!13.2l||13.1c.2L){1a}if(V.2m==="3O"){3M(13.5L);13.5L=1h;S=0;I={x:V.x,y:V.y,d1:V.2O};T=13.1A.1f;J=T/2;13.1i.1d.1O("2U");13.1i.1d.3F("21","");13.1i.1d.3F("2j","4o(0, 0, 0)");P=1h}1j{H=(V.x-I.x);N={x:0,y:0,z:0};if(P===1h){P=(1p.3C(V.x-I.x)<1p.3C(V.y-I.y))}if(P){1a}V.2i();if(V.2m==="9V"){S=0;K=1h;Q=V.2O-I.d1;if(1p.3C(H)>J||(Q<L&&1p.3C(H)>O)){if((R=(H>0)?"d3":(H<=0)?"k9":"")){if(R==="d3"){K=13.7W();S+=T*10}1j{K=13.81();S-=T*10}}}N.x=S;N.cU=-90*(N.x/T);13.1i.1d.1D("2U",g(17(W){13.1i.1d.1O("2U");13.1i.1d.3F("21","");if(K){13.1i.1d.1y({2j:"4o("+N.x+"2v, 6x, 6x)"});13.3W(K,1s)}}).1E(13));13.1i.1d.1y(U);13.1i.1d.1y({"21-5e":N.x?"k8":"d5",2o:1-0.2*1p.3C(N.x/T),2j:"4o("+N.x+"2v, 6x, 6x)"});H=0;1a}N.x=H;N.z=-50*1p.3C(N.x/J);N.cU=-60*(N.x/J);13.1i.1d.1y({2o:1-0.2*1p.3C(N.x/J),2j:"4o("+N.x+"2v, 6x, "+N.z+"2v)"})}}).1E(13);13.1d.1D("2p",M)},dW:17(){1b I,H;if(13.3P.1K){13.4Y=13.3P}1j{I=13.3H.2r("3v-9R");if(I){if(y.1e.2M.bU){H=y.$A(1n.c6(\'.9C[3v-9R="\'+I+\'"], .9n[3v-9R="\'+I+\'"]\'))}1j{H=y.$A(1n.9S("A")).2Z(17(J){1a I===J.2r("3v-9R")})}g(H).36(17(K){1b J,L;J=h(K);if(J&&J.3P.1K>0){1a}if(J){L=1t j(J.1i.1I.1V,J.1i.1l.1V,J.1i.3u,1h,J.1i.4p);L.3S=J.1i.3S}1j{L=1t j().9Q(K,J?J.6O:1h)}if((13.1i.1l.1Z.3Q(L.1l.1V)||13.1i.1l.1V.3Q(L.1l.1V))&&(13.1i.1I.1Z.3Q(L.1I.1V)||13.1i.1I.1V.3Q(L.1I.1V))){L=13.1i}13.4Y.3c(L)},13);13.6F=13.1i}}if(13.4Y.1K>1){13.5g.1B("dq-cd");13.5m=y.$1t("2V",{"41":"1q-2s-iP"}).2a(13.5g);13.4g=1t q(13.5m);g(13.4Y).36(17(J){1b K=g(17(L){13.9r(J);13.3W(J)}).1E(13);J.cF=13.4g.cE(y.$1t("2b",{1Z:J.7t("1I")}).1D("24 1R",17(L){L.2i()}).1D("24 "+(13.1o("cf")==="7x"?"7w 8u":"1R"),g(17(M,L){if(13.6i){3M(13.6i)}13.6i=1k;if(M.1u==="7w"){13.6i=g(K).2E(L)}1j{if(M.1u==="24"||M.1u==="1R"){K()}}}).2I(13,60)))},13);13.2N.4y.5I();13.2N.4x.5I()}1j{13.5g.1U("dq-cd");13.2N.4y.4t();13.2N.4x.4t()}},dN:17(){1b H;if(13.4g){13.4g.2i();13.4g=1h}if(13.5m){13.5m.2S();13.5m=1h}if(13.4Y.1K>1&&!13.3P.1K){13.1d.1O("2p");13.1i.1d.2S().2r("2n");13.1i.1d.5H("2n");13.6F.1d.2a(13.1d);13.7E(13.6F);5G(H=13.4Y.kV()){if(H!==13.6F){if(H.1I.1d){H.1I.1d.5f();H.1I.1d=1h}if(H.1l.1d){H.1l.1d.5f();H.1l.1d=1h}H=1h}}}13.4Y=[]},6z:17(){if(!13.2l||!13.1J){1a}if(y.1e.4X==="9q"&&y.1e.4v==="9p"&&5U(y.1e.72)===7){e4(l);l=1h}g(1n).1O("c2",13.9m);13.49(1h,1s);13.2l=1k;if(y.1e.4Z.a6&&y.1e.4Z.4W()){y.1e.4Z.e6()}1j{if(y.1e.2M.21){13.1d.1O("2U").1y({21:""});13.1d.1D("2U",13.8G);if(y.1e.3K){4q(g(17(){13.8G()}).1E(13),kU)}13.3X.1O("2U").1y({21:""});13.3X.1y({21:"e3 0.6s 5y-5z(0.ec, 0.ll, 0.ee, 0.lj) 0.9H"}).1F();13.1d.1y({21:"e3 .3s 5y-5z(0.at, 0, 0.ei, 0.cb) 9H"}).1F();if(13.1c.1W!==1k&&13.1o("3x")==="2Y"&&13.1o("4L")!=="2u"){13.1i.1d.1y({"1X-1g":13.1i.1F("1l").1g});13.1i.1d.1y({"1X-1f":13.1i.1F("1l").1f})}13.3X.1y({2o:0.4});13.1d.1y({2o:0.lm,2j:"4c(0.4)"})}1j{13.8G()}}},2s:17(J){if(!13.1i.2f()||!13.2l||13.1J){if(!13.1i.2f()){if(J){13.65=d(J);J.4u();if(J.1u==="24"){J.5a[1].4u()}}13.1i.5Z(13.7E.1E(13));if(!13.5D){13.5D=g(13.8n).1E(13).2E(a7)}}1a}if(J){J.4u()}1b H=g(13.1d).2c("cr");1b I=1n.ks();13.ca();13.6m--;13.49(1h,1s);13.9d();13.9j();13.2l=1k;if(!13.3j){13.3j=y.$1t("2V").1B("1q-2s").1B(13.1o("5B")).1y({2o:0});13.5g=y.$1t("2V").1B("1q-2s-dV").2a(13.3j);13.8b=y.$1t("2V").1B("1q-2s-iG").2a(13.5g);g(["4x","4y","6z"]).36(17(L){1b K="1q-2q";13.2N[L]=y.$1t("2q",{8l:13.1o("am-kq-"+L)}).1B(K).1B(K+"-"+L);I.c9(13.2N[L]);4G(L){1C"4x":13.2N[L].1D("24 1R",17(M){M.2i();13.3W(13.7W())}.2I(13));1H;1C"4y":13.2N[L].1D("24 1R",17(M){M.2i();13.3W(13.81())}.2I(13));1H;1C"6z":13.2N[L].1D("24 1R",17(M){M.2i();13.6z()}.2I(13));1H;1P:}},13);13.8b.3a(I);13.3j.1D("4N 5c 3r",g(17(K){g(K).2i()}));if(13.1o("e1")){13.3j.1D("24 1R",17(M){1b L=M.5w();1b K=g(13.1o("4L")==="2u"?13.1c.1d:13.1c.1i).7P();if(13.1o("3x")!=="2Y"&&K.1G<=L.y&&L.y<=K.2J&&K.1M<=L.x&&L.x<=K.2H){M.4u();13.49(M);1a}if(13.1o("3x")!=="2Y"&&13.1d.a4(M.du())){1a}M.2i();13.6z()}.2I(13))}13.9m=g(17(L){1b K=1h;if(L.8j!==27&&L.8j!==37&&L.8j!==39){1a}g(L).2i();if(L.8j===27){13.6z()}1j{K=(L.8j===37)?13.7W():13.81();if(K){13.3W(K)}}}).2I(13);13.8e=g(17(){1b K;13.1d.1O("2U").1y({21:"",2j:"4o(0, 0, 0)"});if(13.1J){1a}13.1J=1s;13.3j.1U("1q-2s-kK").1y({2o:1});13.1c.9k(13.1o("4L"));13.1S=y.4b(13.3k);13.5P();if(13.40&&13.1i.3u){if(13.1i.3S){13.40.3a(y.$1t("a",{79:13.1i.3S}).1D("24 1R",13.9G.1E(13)).5r(13.1i.3u))}1j{13.40.5r(13.1i.3u)}13.40.1B("1q-5I")}if(13.1o("3x")!=="2Y"){13.8M(1s);13.8L(1s)}13.2l=1s;if(13.1o("3x")==="2Y"){if(13.1c.1W!==1k){13.1c.64(1s)}if(y.1e.2T&&13.8P){13.8P=1k}13.4C()}if((y.1e.2T||13.1o("9N"))&&13.1c.4W){if(13.8P||13.6m>0){13.5S(1s,13.1o("9s"))}13.8P=1k}13.8b.1U("1q-3p").1B("1q-9u 1q-5u");if(13.5m){13.5m.1U("1q-3p").1B("1q-9u 1q-5u")}if(13.4g){13.4g.c5();13.9r(13.1i)}if(H){H.2a(13.3j,((1p.5Q(1p.6q()*bW)+1)%2)?"1G":"2J")}if(13.4Y.1K>1&&!13.3P.1K){13.c4()}g(1n).1D("c2",13.9m);if(y.1e.4X==="9q"&&y.1e.4v==="9p"&&5U(y.1e.72)===7){l=u()}s("dJ",13.id)}).1E(13);13.8G=g(17(){13.1d.1O("2U");if(!13.1J){1a}if(13.1J){g(1n).1O("c2",13.9m);13.49(1h,1s)}13.dN();13.1J=1k;13.1c.9k(13.1o("48"));13.1d.7V(13.1i.6R("1I"),13.1i.1d);13.1i.6T("1I");g(13.1i.1d).1y({1f:"",1g:"","1X-1f":1p.2g(13.1i.1F("1I").1f),"1X-1g":1p.2g(13.1i.1F("1I").1g)});13.1r.1i.1Z=13.1i.7t("1I");13.1d.1y({2o:"",21:""});13.1d.1y({2j:"4o(0, 0, 0)"});g(13.3H).7V(13.1d,13.80);13.7a(1s);if(13.40){13.40.2S();13.40=1h}13.9d();13.9j();if(13.1o("4k")==="2Y"){13.4C()}1j{if(13.1o("48")!==1k){13.8M(13.1o("4k")==="2Q");13.8L(13.1o("4k")==="2Q")}}13.5S();13.3X.1O("2U");13.3j.2S();13.3X.2S();13.3X=1h;g(y.1e.43()).1U("1q-1J-dX-83");13.2l=1s;if(y.1e.2z<10){13.5P()}1j{g(1m).bZ("dR","6X")}s("dT",13.id)}).1E(13);13.87=y.$1t("2V",{"41":"1q-1i-dV"}).2a(13.5g);13.56=y.$1t("5O").2a(13.87);13.80=13.1d.jV(1k)}13.dW();g(y.1e.43()).1B("1q-1J-dX-83");g(1n.3B).1F();if(13.1o("2s")==="dY"){13.bY();y.1e.4Z.bX(13.3j,{ch:g(17(){13.8e()}).1E(13),bK:13.8G,8h:g(17(){13.c0()}).1E(13)})}1j{4q(g(17(){13.bY();13.c0()}).1E(13),96)}},bY:17(){1b I;1b H;I=y.$1t("2b",{1Z:13.1i.7t("1l")});13.3X=y.$1t("2V").1B("1q-2s-bg").3a((y.1e.2M.7S||y.1e.2z<10)?I:1t y.9e(I).5i(b).6R()).2a(13.3j);if(13.1o("3x")==="2Y"&&13.1o("4L")!==1k){13.5g.1B("1q-2Y-1l"+(13.1o("4L")==="1l"?" 1q-1l-in":"")).1F()}H=g(13.1d)[(y.1e.2z<10)?"1F":"7f"]();g(13.80).1y({1f:H.1f,1g:H.1g});13.1d.7V(13.1i.6R("1l"),13.1i.1d);13.1i.6T("1l");13.3j.2a(1n.3B);13.7h=17(){1b J=13.87;if(g(13.56).1F().1f>50){J=13.56}1a 17(){1a 13.1o("3x")==="2Y"&&13.1o("4L")!==1k&&13.1o("4L")!=="2u"?6n:1p.5s(g(J).89().1f)}}.2e(13);13.74=17(){1b J=13.87;if(g(13.56).1F().1g>50){J=13.56}1a 17(){1a 13.1o("3x")==="2Y"&&13.1o("4L")!==1k&&13.1o("4L")!=="2u"?6n:1p.5s(g(J).89().1g)}}.2e(13);13.8b.1U("1q-9u 1q-5u").1B("1q-3p");if(13.5m){13.5m.1U("1q-9u 1q-5u").1B("1q-3p")}13.1i.1d.1y({"1X-1g":1p.2g(13.1i.1F("1l").1g,13.74())});13.1i.1d.1y({"1X-1f":1p.2g(13.1i.1F("1l").1f,13.7h())});13.56.3a(g(13.3H).7V(13.80,13.1d));if(13.1o("40")){13.40=y.$1t("dS",{"41":"1q-3u"}).2a(13.56)}},c0:17(){13.1d.1y({21:""});13.1d.1y({2j:"4c(0.6)"}).1F();13.1d.1y({21:y.1e.9J+" 0.4s 5y-5z(0.9I, 0.c1, 0.dH, 1) 9H"});if(y.1e.2M.21){13.1d.1D("2U",13.8e);if(y.1e.5A&&(y.1e.4v==="5A"||y.1e.4v==="76")){4q(g(17(){13.8e()}).1E(13),c3)}}1j{13.8e.2E(16,13)}13.3j.1y({2o:1});13.1d.1y({2j:"4c(1)"})},9G:17(){if(13.1i.3S){1m.83(13.1i.3S,"gH")}},81:17(){1b H=(13.1J?13.4Y:13.3P).2Z(17(K){1a(K.1I.2m!==-1||K.1l.2m!==-1)});1b I=H.1K;1b J=g(H).4J(13.1i)+1;1a(I<=1)?1h:H[(J>=I)?0:J]},7W:17(){1b H=(13.1J?13.4Y:13.3P).2Z(17(K){1a(K.1I.2m!==-1||K.1l.2m!==-1)});1b I=H.1K;1b J=g(H).4J(13.1i)-1;1a(I<=1)?1h:H[(J<0)?I-1:J]},dB:17(I,J){1b H=13.3P.2Z(17(K){1a((K.1l.1Z.3Q(I)||K.1l.1V.3Q(I))&&(K.1I.1Z.3Q(J)||K.1I.1V.3Q(J)))})||[];1a H[0]||((J&&I&&y.1Q(J)==="1N"&&y.1Q(I)==="1N")?1t j(J,I):1h)},c8:17(I){1b H=13.3P.2Z(17(J){1a(J.4p===I)})||[];1a H[0]},eo:17(H){1a 13.3P[H]}};t={4F:"dF.2.9 (gZ)",4D:17(K,I){1b J=1h;1b H=[];y.$A((K?[g(K)]:y.$A(1n.9A("9C")).5E(y.$A(1n.9A("9n"))))).36(g(17(L){if(g(L)){if(!h(L)){J=1t i(L,I);if(w&&!J.1o("c7")){J.2i();J=1h}1j{E.3c(J);H.3c(J)}}}}).1E(13));1a K?H[0]:H},2i:17(K){1b I,J,H;if(K){(J=h(K))&&(J=E.9z(E.4J(J),1))&&J[0].2i()&&(4R J[0]);1a}5G(I=E.1K){J=E.9z(I-1,1);J[0].2i();4R J[0]}},gU:17(H){13.2i(H);1a 13.4D(H)},3W:17(M,L,K,I){1b J=h(M);1b H;if(J){H=y.1Q(L)==="6c"?J.c8(L):J.dB(L,K);if(H){J.3W(H)}}},gT:17(K,J){1b I=h(K);1b H;if(I){4G(y.1Q(J)){1C"6c":H=I.c8(J);1H;1C"66":H=I.eo(J);1H;1P:}if(H){I.3W(H)}}},4x:17(I){1b H;(H=h(I))&&H.3W(H.7W())},4y:17(I){1b H;(H=h(I))&&H.3W(H.81())},gh:17(I){1b H;(H=h(I))&&H.4C()},gg:17(I){1b H;(H=h(I))&&H.49()},2s:17(I){1b H;(H=h(I))&&H.2s()},6z:17(I){1b H;(H=h(I))&&H.6z()},fp:17(H,I){if(!o[H]){o[H]=[]}if(y.1Q(I)==="17"){o[H].3c(I)}},h7:17(H){1a!!h(H)}};g(1n).1D("9l",17(){1b I=1m[C+"7e"]||{};r=r();c();G=y.$1t("2V",{"41":"3i-3p-78"}).2a(1n.3B);F=(y.1e.2T&&1m.cO&&1m.cO("(1X-cP-1f: cq), (1X-cP-1g: cq)").hl);if(y.1e.2T){y.29(n,k)}1T(1b H=0;H<z.1K;H++){if(I[z[H]]&&y.$F!==I[z[H]]){t.fp(z[H],I[z[H]])}}t.4D();w=1k});1m.9n=1m.9n||{};1a t})();',62,1327,'|||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||this||||function|||return|var|zoomBox|node|browser|width|height|null|image|else|false|zoom|window|document|option|Math|mz|lens|true|new|type|Event|options|Custom|jSetCss|event|size|jAddClass|case|jAddEvent|jBind|jGetSize|top|break|small|expanded|length|handler|left|string|jRemoveEvent|default|jTypeOf|btnclick|zoomSize|for|jRemoveClass|url|mode|max|boundaries|src||transition|||tap||arguments|||extend|jAppendTo|img|jFetch||call|loaded|min|position|stop|transform|important|ready|state|style|opacity|touchdrag|button|getAttribute|expand|parseFloat|magnifier|px|prototype||inner|ieMode|undefined|pointerType|enum|auto|jDelay|clientX|clientY|right|jBindAsEvent|bottom|100|active|features|buttons|timeStamp|mousedrag|click|context|jRemove|mobile|transitionend|div|jCallEvent|none|always|filter||||changedTouches|jDel||jEach||pos||append|jStore|push|try|oneOf|boolean|activating|hint|magic|expandBox|zoomSizeOrigin|rootCSS|handle|test|settings|hidden|defined|dbltap||jGetCss|caption|data|catch|expandZoomOn|setAttribute|Doc|match|body|abs|orientation|navigator|jSetCssProp|instanceof|placeholder|touch|init|webkit|Class|clearTimeout|border|dragstart|additionalImages|has|parent|link|off|stopDefaults|hasOwnProperty|update|expandBg|touchpinch|Element|expandCaption|class||getDoc|||||zoomMode|deactivate|array|detach|scale|target|dblbtnclick|pushToEvents|expandThumbs|ceil|touches|styles|zoomOn|preview|custom|firstChild|translate3d|origin|setTimeout|replace||hide|stopQueue|uaName|visibility|prev|next|listeners|identifier|pow|activate|start|root|version|switch|J_TYPE|parentNode|indexOf|schema|expandZoomMode|reverse|mousescroll|trident|requestAnimationFrame|pageX|delete|toLowerCase|pageY|vertical|moveTimer|enabled|platform|expandGallery|fullScreen||disabled|domPrefix||||expandFigure|jTrim||direction|events|documentElement|touchstart|distance|duration|kill|expandStage|stopDistribution|blur|handlers|innerHeight|messageBox|expandNav|constructor|isPrimaryTouch|FX|pointermove|changeContent|round|add|visible|jCamelize|jGetPageXY|timer|cubic|bezier|chrome|cssClass|cubicBezier|loadTimer|concat|pointerup|while|removeAttribute|show|absolute|innerWidth|activateTimer|contains|move|figure|resizeCallback|floor|throw|showHint|spos|parseInt|canvas|className|getPrimaryTouch|ms|load|||css|dragged|enable|initEvent|number|loadingBox||onerror|to|nodeType|element|ease|String|touchend|gecko|MSPOINTER_TYPE_TOUCH|updateTimer|innertouch|isTouchEvent|isQueueStopped|hintRuns|Infinity|getAbsoluteURL|Array|random|mouseup||now|scroll|selectedItem|display|0px|onload|close|dppx|apply|J_UUID|not|mousedown|primaryImage|render|MagicJS|pointerEnabled|addCSS|found|android|filters|shift|originalTitle|mousemove|pointerdown|getNode|wunits|setCurNode|thumb|originalImg|selected|resize|hunits|getButton||onTouchEnd|uaVersion|no|expandMaxHeight|Object|opera||wrapper|href|setSize|engine|continuous|alternate|Options|getBoundingClientRect|fromCharCode|expandMaxWidth|jGetScroll|tooltip|trigger|onTouchStart|end|onComplete|timedout|getClientXY|tm|threshold|touchmovement|getURL|oncomplete|originalImage|mouseover|hover|easeFn|_handlers|set|normalSize|toUpperCase|join|setupZoom|onready|isPrimary|TouchEvent|200|cssTransformProp|cycles|svg|callback|padding|overflow|jGetRect|minimum|currentSrc|cssFilters|androidBrowser|toString|replaceChild|getPrev|touchmove|_EVENTS_|msPointerEnabled|stubNode|getNext||open||||expandImageStage|animate|getInnerSize|storage|expandControls|reflowZoom|createElement|onExpand|scrollTop|getPrimaryTouchId|fallback|parseCubicBezier|keyCode|Transition|title|fromJSON|showLoading|jGetPosition|margin|setProps|byTag|split|lazyZoom|mouseout|_timer|_unbind|_cleanup|complete|scrollLeft|readyState|typeof|setOrientation|horizontal|cssPrefix|continue|onClose|getRelated|maxWidth|index|object|registerDeactivateEvent|registerActivateEvent|zoomCaption|sqrt|mobileZoomHint|deltaY|itemCSS|crMz|on|nextImage|textExpandHint|PFX|normalizeCSS|perspective|reflow||loadSmall|dashize|linear||||createTextNode|||createElementNS|targetTouches|naturalWidth|unregisterActivateEvent|SVGImage|btnclickEvent|pointerId|onTouchMove|Opacity|unregisterDeactivateEvent|setMode|domready|keyboardCallback|MagicZoomPlus|reset|safari|ios|setActiveThumb|textClickZoomHint|handleMouseUp|fade|charAt|_event_prefix_|fromString|relatedTarget|splice|byClass|J_EUID|MagicZoom|createEvent|implement|callee|openLink|0s|175|cssTransform|getStorage|dblclick|MSPointerMove|forceTouch|eventType|compatMode|parseNode|gallery|getElementsByTagName|pStyles|pStyles_arr|dragend|hideTimer|forceAnimation|Message|isNaN|maxHeight|translate|deactivating|exists|hasChild|loopBind|capable|400|magiczoom|exitFullscreen||||||||||||win|text|onprogress|XMLHttpRequest|cancelAnimationFrame|originalImgSrc|status|xhr|600|_bind|Date|ImageLoader|resizeTimer|Za|tagName|touchScreen|loadImg|dispatchEvent|temporary|https|assign|Alpha|errorEventName|abort|loadedBytes|deltaMode|deltaX|cssDomPrefix|handleTouchEnd|handleTouchStart|previousScale|slice|ignore|presto|onClick|handleMouseDown|onclick|caller|HTMLElement|getElementsByClassName|_event_del_|priority|_event_add_|getTarget|changeEventName|1000||Pltm|maximum|uuid|300|selectorsMoveFX||scrollFX|J_EXT|org|w3||www|http|Function|removeChild|startTime|hideFX|ifndef|Tooltip|styles_arr|el_arr|cubicBezierAtTime|05|calc|cycle|stopAnimation|opr|onabort|handleTouchMove|once|span|pointerout|jClearEvents|onResize|aspectRatio|isMouse|hideLoading|delay|hintMessage|textHoverZoomHint|onExit|onBeforeRender|0001|loadZoom|rel|onZoomReady|startTimer|runtime|inline|000001|query|html|101|request|prepareExpandedView|jRaiseEvent|expandToWindow|885|keydown|500|swipe|run|querySelectorAll|autostart|imageByOrigin|appendChild|hideHint|045|mgctlbx|thumbs||selectorTrigger|mzCrA|onEnter|zoomPosition|10000px|startAttempts|msExitFullscreen|Right|Left|Bottom|Top|767px||onchange|cancelFullScreen|355|165|ua|ACwAAAAAAQABAAACADs|toArray|03|lineHeight|styleFloat|Microsoft|R0lGODlhAQABAAD|addItem|selector|onAfterRender|out|offsetWidth|DXImageTransform|documentMode|progid|jSetOpacity|jHasClass|matchMedia|device|getComputedStyle|backCompat|easeInSine|Webkit|deg|moveBind|setMessage|od|hone|999|backcompat|ts|mozCancelAnimationFrame|backward|item|300ms|bounceIn|multibackground|background|elasticIn|base64|cssText|easeOutBack|easeInBack|easeOutCubic|getContext|easeInCubic|easeOutQuad|easeInQuad|easeOutExpo|removeRule|easeInExpo|Moz|easeOutSine||moz|with|finishTime|gif|curScale|getOriginalTarget|wheelDeltaX|wheelDeltaY|||wheelDelta|detail|imageByURL|rightClick|euid|get|v5|enclose|320|wrap|onExpandOpen|_initialDistance|which|UUID|destroyExpandGallery|touchOptions|getJSON|dragmove|UIEvent|figcaption|onExpandClose|handleMouseMove|stage|setupExpandGallery|view|fullscreen|querySelector|addEventListener|closeOnClickOutside|Number|all|clearInterval|loop|cancel|fps|getElementById|interval|onStart|compareDocumentPosition|895|isReady|685|webkit419|clientWidth|onreadystatechange|735|doc|10000||loadBlob|xhr2|imageByIndex|requestFullScreen||304|onxhrerror|stopPropagation|cancelBubble|preventDefault|error|jDefer|loadOptions|progressiveLoad|jToBool|crios|getTime|PI|selectItem|setCaption|insertRule|block|fontWeight|0ms|stylesId|DocumentTouch|shown|upscale|cos|animation|initDrag|date|items|setupContent|textnode|stdDeviation|filterBlur|MSPointerOut|firefox|naturalHeight|10px|transitionEffect|MSPointerDown|screenX|zIndex|deleteRule|styleSheet|setInterval|color|2147483647|sheet|zoomWidth|zoomHeight|screenY|onUpdate|Click|screen|charCodeAt|setupSelectors|RegExp|magicJS|stopImmediatePropagation|mjs||forEach|registerCallback|onswipe|registerEvents|scrollbarsWidth|nativize|onZoomIn|100000|onZoomOut|MouseEvent|MSPointerUp|smoothing|unregisterEvents|phone|changeZoomLevel|variableZoom|parseSchema|evaluate|air|returnValue|srcElement|webkitRequestAnimationFrame|webkitTransitionEnd|xpath|edge|fullscreenEnabled|pointerover|MSPointerOver|symbian|fromElement|regexp|toElement|KeyEvent|toFloat|userAgent|mozCancelFullScreen|msFullscreenEnabled|msCancelFullScreen|presto925|series|withCredentials|FormData|msRequestAnimationFrame|ProgressEvent|clientHeight|cssRules|oRequestAnimationFrame|webkitexitFullscreen|pageXOffset|oCancelFullScreen|pageYOffset|jGetFullSize|scrollWidth|scrollHeight|zoomOut|zoomIn|webkitCancelFullScreen|addRule|mozRequestAnimationFrame|jToInt|xxxxxxxxxxxx|vodafone|collection|xy|unknown|taintEnabled|removeCSS|WebKitPoint|wap|mozInnerScreenY|g46fd501|KeyboardEvent|yxxx|windows|4xxx|xxxx|getBoxObjectFor|ActiveXObject|xxxxxxxx|xiino|generateUUID|_self|DOMContentLoaded|removeEventListener|up|map|hasFeature|attachEvent|detachEvent|treo|other|linux|rules|switchTo|refresh|doScroll|mac|sort|4294967296|Plus|createEventObject|fireEvent|webos|getHashCode|420|implementation|jGetStyle|running|MSFullscreenChange|webkitIsFullScreen|FullScreen|cssfilters|requestFullscreen|RequestFullscreen|RequestFullScreen|ExitFullscreen|CancelFullScreen|fullscreenchange|fullscreenElement|iris|MSFullscreenError|matches|fullscreenerror|prefix|iemobile|activeElement|Width|2px|FullscreenElement|kindle|fennec|maemo|WebKitTransitionEvent|os|ob|netfront|TransitionEvent|mmp|midp|lt|ixi|MSPointer|536|lge|ver|Down|Up|Move|Over|Out|pointer|hiptop|elaine|DOMElement|feature|plucker|ontouchstart|childNodes|Image|red|head|insertBefore|pocket|9999|innerText|webkitCancelRequestAnimationFrame|msCancelAnimationFrame|psp|oCancelAnimationFrame|SVG11|TR|palm|jSetStyle|iframe|maxTouchPoints||||innerHTML|float|jGetStyles|re|cssFloat|compal|blazer||getPropertyValue||currentStyle|blackberry|jToggleClass|bada|avantgo|offsetParent|meego|msMaxTouchPoints|jGetTransitionDuration|offsetHeight|jGetFullScroll|xda|clientLeft|offsetLeft|offsetTop|clientTop|controls|the|350|easeOutQuint|Hover|easeInOutQuint|07|zoomDistance|160|thumbnails|795|035|855|or|convert|easeInOutExpo|easeInCirc|04|Cannot|335|easeOutCirc|075|06|755|easeInOutCirc|055|relative|Previous|textBtnPrev|easeInOutQuad|455|515|955|parameter|675|easeInQuint|215|textBtnNext|easeInOutCubic|645|easeInQuart|easeOutQuart|Close|easeInOutQuart|textBtnClose|TypeError|785|Touch|1999|120|SourceGraphic|MessageBox|5000|feGaussianBlur|setAttributeNS|xlink|201|NEGATIVE_INFINITY|units|2000|POSITIVE_INFINITY|JSON|isset|parse|isFinite|Incorrect|definition|of|MagicToolboxTooltip|sides|135|expoOut|message|275|easeInOutBack|loading|265|cloneNode|sineIn|sineOut|expoIn|quadIn|ul|quadOut|cubicIn|cubicOut|backIn|backOut|elasticOut|bounceOut|100ms|forward|Tap|Next|085|font|445|srcset|scrollTo|pinchstart|9_|z0|getRatio|pinchupdate|URL|webkitURL|lengthComputable|total|btn|before|createDocumentFragment|rev|2em|progress|wheel|deltaFactor|deltaZ|radius|fontSize|delta|v3|onwheel|fontFamily|textAlign|250|mousewheel|availHeight|availWidth|opening|sans|serif|dummy|static|256|devicePixelRatio|contextmenu|setTransition|curFrame|260|pop|mgctlbxN|MobileOptions|MZ|Double|745|715|575|565|easeInOutSine|normal|roundCss|infinite|blob|response|selectstart|537|createObjectURL|mgctlbxP|GET|responseType|000244140625|send||220|mgctlbxV|030|01|mgctlbxL|destroy'.split('|'),0,{}))
      
  }
}
	 
        if ( !variant ) {
          events.trigger("variantunavailable");
          return;
        }

        if ( Product.variants.length == 1 ) {
          return;
        }

        events.trigger("variantchange", variant);
        events.trigger("variantchange:option1:" + variant.option1);
        events.trigger("variantchange:option2:" + variant.option2);
        events.trigger("variantchange:option3:" + variant.option3);

        if ( variant.featured_media ) {
          if ( variant.featured_media.id == null ) {
            events.trigger("variantchange:image", Product.featured_media_id);
          } else {

            events.trigger("variantchange:image", variant.featured_media.id);
          }
        }
      },
      enableHistoryState: config.enable_history
    });

    (function single_option_selectors() {
      var elements = context.querySelectorAll(".single-option-selector");

      elements.forEach(Selector);

      function Selector(element, index) {
        var option_position = index + 1;

        events.on("swatch:change:" + option_position, change);

        function change(value) {
          $(element).val(value).trigger("change");
        }
      }
    })();

    (function swatches() {
      var elements = context.querySelectorAll("[type=radio]");

      var states = {
        sold_out: function (element) {
          element.parentElement.classList.add("soldout");
        },
        available: function (element) {
          element.parentElement.classList.remove("soldout");
        }
      };

      events.on("variantunavailable", set_unavailable);

      elements.forEach(Swatch);

      function set_unavailable() {
        var selected = {};

        var selected_elements = $(elements).filter(":checked").toArray();

        selected_elements.forEach(function (element) {
          var option = "option" + element.getAttribute("data-position");
          var value = element.value;

          selected[option] = value;
        });

        elements.forEach(function (element) {
          var available = false;

          var current_option = "option" + element.getAttribute("data-position");

          var current_value = element.value;

          var other_options = ["option1", "option2", "option3"].filter(function (option) {
            return selected[option] && option != current_option;
          });

          Product.variants.forEach(function (variant) {
            if ( !variant.available ) {
              return;
            }

            if ( variant[current_option] != current_value ) {
              return;
            }

            if ( variant[other_options[0]] == selected[other_options[0]] && variant[other_options[1]] == selected[other_options[1]] ) {
              available = true;
              return;
            }
          });

          if ( available ) {
            states.available(element);
          } else {
            states.sold_out(element);
          }
        });
      }

      function Swatch(element) {
        var option_position = element.getAttribute("data-position");

        var current_option = "option" + option_position;

        var other_options = ["option1", "option2", "option3"].filter(function (option) {
          return option != current_option;
        });

        element.addEventListener("change", function (event) {
          events.trigger("swatch:change:" + option_position, element.value);
        });

        events.on("variantchange:option" + option_position + ":" + element.value, select);

        events.on("variantchange", set_availability);

        function select() {
          element.checked = true;
        }

        function set_availability(current_variant) {
          var available = false;

          Product.variants.forEach(function (variant) {
            if ( !variant.available ) {
              return;
            }

            if ( variant[current_option] != element.value ) {
              return;
            }

            if ( variant[other_options[0]] != current_variant[other_options[0]] ) {
              return;
            }

            if ( variant[other_options[1]] != current_variant[other_options[1]] ) {
              return;
            }

            available = true;
          });

          if ( available ) {
            states.available(element);
          } else {
            states.sold_out(element);
          }
        }
      }
    })();

    (function price() {
      var element = context.querySelector(".product-price .money") || context.querySelector(".product-price");

      events.on("variantchange", function (variant) {
        var price = money(variant.price);

        if ( !variant.available ) {
          price = config.sold_out;
         
          $('#AddToCartsticky').prop("disabled",true);
          $('#AddToCartsticky').html("Sold Out");
        }
        

        element.innerHTML = price;

        events.on("variantunavailable", function (variant) {
          price = config.unavailable;
          element.innerHTML = price;
        });
        if(variant.available){
          $('#AddToCartsticky').prop("disabled",false);
          $('#AddToCartsticky').html("Add To Cart");
        }
      });
    })();

    (function compare_price() {
      var element = context.querySelector(".was");

      if ( !element ) {
        return false;
      }

      events.on("variantchange", function (variant) {
        var price = "";

        if ( variant.compare_at_price > variant.price ) {
          var price = money(variant.compare_at_price);
        }

        if ( !variant.available ) {
          price = "";
        }

        element.innerHTML = price;
      });
    })();

    (function sku() {
      var element = context.querySelector(".variant_sku");

      if ( !element ) {
        return false;
      }

      events.on("variantchange", function (variant) {
        var variant_sku = variant.sku;
        element.innerHTML = variant_sku;
      });
      events.on("variantunavailable", function (variant) {
        var variant_sku = config.unavailable;
        element.innerHTML = variant_sku;
      });

    })();

    (function add_to_cart() {
      var element = context.querySelector(".add");

      events.on("variantchange", function (variant) {
        var text = config.button;
        var disabled = false;

        if ( !variant.available ) {
          text = config.sold_out;
          disabled = true;
        }

        element.value = text;
        element.disabled = disabled;
      });

      events.on("variantunavailable", function () {
        element.value = config.unavailable;
        element.disabled = true;
      });
    })();

    (function smart_payment_buttons() {
      var element = context.querySelector(".shopify-payment-button");

      if ( !element ) {
        return false;
      }

      events.on("variantchange", function (variant) {
        if ( !variant.available ) {
           element.style.display = 'none';
         } else {
           element.style.display = 'block';
         }
      });
    })();

    function money(cents) {
      return Shopify.formatMoney(cents, config.money_format);
    }
}

theme.ProductGallery = function (context, sectionId, events, Product) {
  events.trigger = events.emit;

  var config = JSON.parse(context.querySelector('.product-photos').dataset.galleryConfig || '{}');
  var $main = $("#slider .slides.carousel-main ", context),
      $carouselNav = $('#thumbnails .carousel-nav', context);

    if ( !$main.length ) {
      return false;
    }

    /* Main Gallery Slider */
    var $carousel = $main.flickity({
      fade: true,
      wrapAround: true,
      cellAlign: 'left',
      draggable: true,
      contain: true,
      pageDots: false,
      prevNextButtons: config.mainSlider,
      autoPlay: false,
      selectedAttraction: 0.01,
      dragThreshold: 5,
      adaptiveHeight: false,
      imagesLoaded: true
    });

    var flkty = $carousel.data('flickity');

    /* Pause flickity drag on model play */
    $('.carousel-main', context).on('model:start', function(event, id) {
      if ($('[data-model-id='+ id +']').closest('ul.slides.product-image-container').length >= 1) {
       $('[data-model-id='+ id +']').closest('ul.slides.product-image-container').data('flickity').unbindDrag();
      }
    });
    $('.carousel-main', context).on('model:stop', function(event, id) {
      if ($('[data-model-id='+ id +']').closest('ul.slides.product-image-container').length >= 1) {
       $('[data-model-id='+ id +']').closest('ul.slides.product-image-container').data('flickity').bindDrag();
      }
    });

  (function focusControl() {
    /* set focus on load after flickity is ready */
    $carousel.on( 'ready.flickity', function() {
      var id = $(flkty.selectedElement).data('imageId');

      var $newMedia = $(
        '[data-product-single-media-wrapper]' +
          "[data-thumbnail-id='product-template-" + id + "']",
        context
      );

      if ( $newMedia.hasClass('external_video') ) {
          $('.product-video .plyr', context)
            .find('*')
            .addBack()
            .attr('tabIndex', '-1')
            .removeClass('focus-visible')
            .addClass('js-hide-focus');
          $('.shopify-model-viewer-ui__controls-overlay', context)
            .find('*')
            .addBack()
            .attr('tabIndex', '-1')
            .removeClass('focus-visible')
            .addClass('js-hide-focus');
          $('.product-video.videoWrapper iframe', context).removeAttr("tabIndex");
      } else if ( $newMedia.hasClass('video') ) {
        $('.product-video.videoWrapper iframe', context)
          .attr('tabIndex', '-1')
          .removeClass('focus-visible')
          .addClass('js-hide-focus');
        $('.shopify-model-viewer-ui__controls-overlay', context)
          .find('*')
          .addBack()
          .attr('tabIndex', '-1')
          .removeClass('focus-visible')
          .addClass('js-hide-focus');
      } else if ( $newMedia.hasClass('model') ) {
        $('.product-video.videoWrapper iframe', context)
          .attr('tabIndex', '-1')
          .removeClass('focus-visible')
          .addClass('js-hide-focus');
        $('.product-video .plyr', context)
          .find('*')
          .addBack()
          .attr('tabIndex', '-1')
          .removeClass('focus-visible')
          .addClass('js-hide-focus');
      } else if ( $newMedia.hasClass('image') ) {
        $('.product-video.videoWrapper iframe', context)
          .attr('tabIndex', '-1')
          .removeClass('focus-visible')
          .addClass('js-hide-focus');
        $('.product-video .plyr', context)
          .find('*')
          .addBack()
          .attr('tabIndex', '-1')
          .removeClass('focus-visible')
          .addClass('js-hide-focus');
        $('.shopify-model-viewer-ui__controls-overlay', context)
          .find('*')
          .addBack()
          .attr('tabIndex', '-1')
          .removeClass('focus-visible')
          .addClass('js-hide-focus');
      }

      $('.flickity-button', context)
        .find('*')
        .addBack()
        .attr('tabIndex', '-1')
       .addClass('js-hide-focus');

      $('.carousel-main.flickity-enabled', context)
        .attr('tabIndex', '-1')
        .addClass('js-hide-focus');

    });

    /* set focus on load after first variant is selected */
    events.on('variantchange:image', function(id){
      var $newMedia = $(
        '[data-product-single-media-wrapper]' +
          "[data-thumbnail-id='" + sectionId + "-" + id + "']",
        context
      );

      if ( $newMedia.hasClass('external_video') ) {
        $( window ).on( "load", function() {
          $('.product-video .plyr', context)
            .find('*')
            .addBack()
            .attr('tabIndex', '-1')
            .addClass('js-hide-focus');
          $('.shopify-model-viewer-ui__controls-overlay', context)
            .find('*')
            .addBack()
            .attr('tabIndex', '-1')
            .addClass('js-hide-focus');
          $('.product-video.videoWrapper iframe', context).removeAttr("tabIndex");
        });

      } else if ( $newMedia.hasClass('video') ) {
        $( window ).on( "load", function() {
          $('.product-video.videoWrapper iframe', context)
            .attr('tabIndex', '-1')
            .addClass('js-hide-focus');
          $('.shopify-model-viewer-ui__controls-overlay', context)
            .find('*')
            .addBack()
            .attr('tabIndex', '-1')
            .addClass('js-hide-focus');
        });
      } else if ( $newMedia.hasClass('model') ) {
        $( window ).on( "load", function() {
          $('.product-video.videoWrapper iframe', context)
            .attr('tabIndex', '-1')
            .addClass('js-hide-focus');
          $('.product-video .plyr', context)
            .find('*')
            .addBack()
            .attr('tabIndex', '-1')
            .addClass('js-hide-focus');
        });
      } else if ( $newMedia.hasClass('image') ) {
        $( window ).on( "load", function(){
          $('.product-video.videoWrapper iframe', context)
            .attr('tabIndex', '-1')
            .addClass('js-hide-focus');
          $('.product-video .plyr', context)
            .find('*')
            .addBack()
            .attr('tabIndex', '-1')
            .addClass('js-hide-focus');
          $('.shopify-model-viewer-ui__controls-overlay', context)
            .find('*')
            .addBack()
            .attr('tabIndex', '-1')
            .addClass('js-hide-focus');
        });
      }

      /* ignore flex directional arrows on tab */
      $( window ).on( "load", function() {
        $('.flickity-button', context)
          .find('*')
          .addBack()
          .attr('tabIndex', '-1')
          .addClass('js-hide-focus');

        $('.carousel-main.flickity-enabled', context)
          .attr('tabIndex', '-1')
          .addClass('js-hide-focus');
      });
    });

  })();

  (function enlargePhoto() {
    // Create template for Facebook Button
    $.fancybox.defaults.btnTpl.fb = '<button data-fancybox-fb class="fancybox-button fancybox-button--fb" title="Facebook">' +
      '<svg viewBox="0 0 24 24">' +
      '<path d="M22.676 0H1.324C.594 0 0 .593 0 1.324v21.352C0 23.408.593 24 1.324 24h11.494v-9.294h-3.13v-3.62h3.13V8.41c0-3.1 1.894-4.785 4.66-4.785 1.324 0 2.463.097 2.795.14v3.24h-1.92c-1.5 0-1.793.722-1.793 1.772v2.31h3.584l-.465 3.63h-3.12V24h6.115c.733 0 1.325-.592 1.325-1.324V1.324C24 .594 23.408 0 22.676 0"/>' +
      '</svg>' +
      '</button>';

    // Create template for Twitter Button
    $.fancybox.defaults.btnTpl.tw = '<button data-fancybox-tw class="fancybox-button fancybox-button--tw" title="Twitter">' +
      '<svg viewBox="0 0 24 24">' +
      '<path d="M23.954 4.57c-.885.388-1.83.653-2.825.774 1.013-.61 1.793-1.574 2.162-2.723-.95.556-2.005.96-3.127 1.185-.896-.96-2.173-1.56-3.59-1.56-2.718 0-4.92 2.204-4.92 4.918 0 .39.044.765.126 1.124C7.69 8.094 4.067 6.13 1.64 3.16c-.427.723-.666 1.562-.666 2.476 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.06c0 2.386 1.693 4.375 3.946 4.828-.413.11-.85.17-1.296.17-.314 0-.615-.03-.916-.085.63 1.952 2.445 3.376 4.604 3.416-1.68 1.32-3.81 2.105-6.102 2.105-.39 0-.78-.022-1.17-.066 2.19 1.394 4.768 2.21 7.557 2.21 9.054 0 14-7.497 14-13.987 0-.21 0-.42-.016-.63.962-.69 1.8-1.56 2.46-2.548l-.046-.02z"/>' +
      '</svg>' +
      '</button>';

    // Make buttons clickable using event delegation
    $('body').on('click', '[data-fancybox-fb]', function() {
      window.open("https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(window.location.href)+"&t="+encodeURIComponent(document.title), '','left=0,top=0,width=600,height=300,menubar=no,toolbar=no,resizable=yes,scrollbars=yes');
    });

    $('body').on('click', '[data-fancybox-tw]', function() {
      window.open('http://twitter.com/share?url='+encodeURIComponent(window.location.href)+'&text='+encodeURIComponent(document.title), '', 'left=0,top=0,width=600,height=300,menubar=no,toolbar=no,resizable=yes,scrollbars=yes');
    });
    var productFancy = $("[data-fancybox='product-"+ context.dataset.productId +"']");

    productFancy.fancybox({
      loop: true,
      parentEl: '.fancybox-wrapper',
      transitionDuration: 100,
      animationDuration: 500,
      animationEffect: "fade",
      buttons: [
        'fb',
        'tw',
        "zoom",
        "zoom-in-out",
        "fullScreen",
        "slideShow",
        "thumbs",
        "close"
      ],
      infobar: true,
      transitionEffect: "slide",
      thumbs: {
        autoStart: false, // Display thumbnails on opening
        hideOnClose: true, // Hide thumbnail grid when closing animation starts
        parentEl: ".fancybox-container", // Container is injected into this element
        axis: "y" // Vertical (y) or horizontal (x) scrolling
      },
      clickContent: function(current, event) {
        return current.type === "image" ? "next" : false;
      },
      beforeClose: function(instance, slide) {
        $carousel.flickity( 'select', this.index );
      }
     });
  })();

  (function thumbnails() {
    if ( config.thumbPosition == 'bottom' && config.thumbSlider == true ) {
      thumbnailSlider();
    }

    if ( !$carouselNav.length ) return false;

    function thumbnailSlider() {
      $carouselNav.flickity({
        asNavFor: $main,
        wrapAround: false,
        groupCells: true,
        cellAlign: 'left',
        draggable: false,
        contain: true,
        imagesLoaded: true,
        pageDots: false,
        autoPlay: false,
        selectedAttraction: 0.01,
        dragThreshold: 5,
        accessibility: false
      });
    }

    var $carouselNavCells = $carouselNav.find('.carousel-cell', context);
    var $carouselNavCellsImg = $carouselNav.find('.carousel-cell .product-single__thumbnail', context);

    if ( !$carouselNavCells.length ) return false;

    var navTop  = $carouselNav.position().top,
        navCellHeight = $carouselNavCellsImg.height(),
        navHeight = $carouselNav.height();


    /* on thumbnail click and key enter */
    $carouselNav.on( 'click', '.carousel-cell', function(event){
      var index = $( event.currentTarget ).index();
      var $el = $(this);
      var mediaId = $el.data('image-id');

      $carousel.flickity( 'select', index );
    });
    $carouselNav.on( 'keypress', '.carousel-cell', function(event){
      if(event.which == 13){ //Enter key pressed
        var index = $( event.currentTarget ).index();
        var $el = $(this);
        var mediaId = $el.data('image-id');

        $carousel.flickity( 'select', index );
      }
    });

    /* adjust slider thumb position */
    $carousel.on( 'select.flickity', function() {
      // set selected nav cell
      $carouselNav.find('.is-nav-selected').removeClass('is-nav-selected');
      var $selected = $carouselNavCells.eq( flkty.selectedIndex )
        .addClass('is-nav-selected');

        // thumbnail scroll nav
        var scrollY = $selected.position().top +
        $carouselNav.scrollTop() - ( navHeight + navCellHeight ) / 6;

        $carouselNav.animate({
          scrollTop: scrollY + 50
        });

    });

    /* adjust thumbnail sizes */
    if (config.thumbPosition != 'bottom') {
      var thumbWrapper = $('.vertical-carousel .thumb-slider-wrapper',context).width();
      $('#thumb-slider-wrapper .product-single__thumbnails-item', context).css("max-width", thumbWrapper);
      $('#thumb-slider-wrapper .product-single__thumbnails-item img', context).width(thumbWrapper + 20);
      $('#thumb-slider-wrapper .product-single__thumbnails-item img', context).height(thumbWrapper + 20);

      var thumbHeight = $('#thumb-slider-wrapper .product-single__thumbnails-item img', context).width();
      var thumbWrapHeight = (thumbHeight * config.thumbsShown) + 40;
      $('.vertical-carousel .thumb-slider-wrapper .thumb-slider-slides', context).css("max-height", thumbWrapHeight);
    }

    /* on slide change */
    $carousel.on( 'change.flickity', function( event, index ) {
      var $el = $('.carousel-cell', $carouselNav).eq(index),
          mediaId = $el.data('imageId');

      switchMedia(mediaId, $el);
      setActiveThumbnail(mediaId, $el);
    });

    /* on variant change */
    events.on('variantchange:image', function(id) {
      var index = $main.find("[data-image-id=" + id + "]").data('slideIndex'),
          $el = $('.carousel-cell', $carouselNav).eq(index);

      $carousel.flickity( 'select', index );
    });

    /* Media Events */
    var switchMedia = function(mediaId) {
        var $currentMedia = $(
          '[data-product-single-media-wrapper]' +
            ':not(.inactive)',
          $main
        );

        var $newMedia = $(
          '[data-product-single-media-wrapper]' +
            "[data-thumbnail-id='product-template-" +
            mediaId +
            "']",
          $main
        );
        var $otherMedia = $(
          '[data-product-single-media-wrapper]' +
            ":not([data-thumbnail-id='product-template-" +
            mediaId +
            "'])",
          $main
        );

        $currentMedia.trigger('mediaHidden');
        $newMedia.addClass('active-slide').removeClass('inactive').trigger('mediaVisible');
        $otherMedia.removeClass('active-slide').addClass('inactive');
      }
    var setActiveThumbnail = function(mediaId, $el) {
      if (typeof mediaId === 'undefined') {
        mediaId = $(
          '[data-product-single-media-wrapper]:not(.hide)',
          $main
        ).data('media-id');
      }
      var $thumbsWrapper = $('.thumb-slider-wrapper', context);
      var $thumbnailWrappers = $('.product-single__thumbnails-item', $thumbsWrapper);
      var $activeThumbnail = $(".product-single__thumbnails-item[data-image-id='" + mediaId + "']")

      $thumbnailWrappers
        .removeClass('active-slide')
        .removeAttr('aria-current');

      $activeThumbnail.addClass('active-slide');
      $activeThumbnail.attr('aria-current', true);

      var index = $main.find("[data-image-id=" + mediaId + "]").data('slideIndex');
    }

    /* fix when model is first item in gallery and no variant */
    $( document ).ready(function() {
      if ( $( ".carousel-main li", context).first().hasClass( "model-slide" ) ) {
        var $el = $( ".carousel-main li", context).first().find('[data-product-single-media-wrapper]');

        if ($( ".carousel-main li", context).closest('ul.slides.product-image-container').length >= 1) {
         $( ".carousel-main li", context).closest('ul.slides.product-image-container').data('flickity').unbindDrag();
        }
        $el.addClass('active-slide').removeClass('inactive');

        $('.carousel-main', context).on( 'click', '.product-media-container.model', function(){
          $('.shopify-model-viewer-ui .shopify-model-viewer-ui__controls-area').css("opacity", "1");
        });
      }
    });

    /* Editor Events */
    $(document).on('shopify:section:unload', function(event) {
      var $carousel = $main.flickity();
      var isFlickity = true;

      if (isFlickity) {
        $carousel.flickity('destroy');
        if ( config.thumbPosition == 'bottom' && config.thumbSlider == true ) {
          $carouselNav.flickity('destroy');
        }
      }
    });
  })();
}

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);
}

theme.ProductVideo = (function(context, sectionId) {

  var videos = {};

  var hosts = {
    html5: 'html5',
    youtube: 'youtube'
  };

  var selectors = {
    productMediaWrapper: '[data-product-single-media-wrapper]'
  };

  var attributes = {
    enableVideoLooping: 'enable-video-looping',
    videoId: 'video-id'
  };

  function init(videoContainer, sectionId) {
    if (!videoContainer.length) {
      return;
    }

    var videoElement = videoContainer.find('iframe, video')[0];
    var mediaId = videoContainer.data('mediaId');

    if (!videoElement) {
      return;
    }

    videos[mediaId] = {
      mediaId: mediaId,
      sectionId: sectionId,
      host: hostFromVideoElement(videoElement),
      container: videoContainer,
      element: videoElement,
      ready: function() {
        createPlayer(this);
      }
    };

    var video = videos[mediaId];

    switch (video.host) {
      case hosts.html5:
        window.Shopify.loadFeatures([
          {
            name: 'video-ui',
            version: '1.0',
            onLoad: setupPlyrVideos
          }
        ]);
        theme.LibraryLoader.load('plyrShopifyStyles');
        break;
      case hosts.youtube:
        theme.LibraryLoader.load('youtubeSdk', setupYouTubeVideos);
        break;
    }
  }

  function setupPlyrVideos(errors) {
    if (errors) {
      fallbackToNativeVideo();
      return;
    }

    loadVideos(hosts.html5);
  }

  function setupYouTubeVideos() {
    if (!window.YT.Player) return;

    loadVideos(hosts.youtube);
  }

  function createPlayer(video) {
    if (video.player) {
      return;
    }

    var productMediaWrapper = video.container.closest(
      selectors.productMediaWrapper
    );

    var enableLooping = productMediaWrapper.data(attributes.enableVideoLooping);

    switch (video.host) {
      case hosts.html5:
        // eslint-disable-next-line no-undef
        video.player = new Shopify.Plyr(video.element, {
          loop: { active: enableLooping },
          muted: true,
          hideControlsOnPause: true,
          tooltips: { controls: false, seek: true }
        });
        video.player.on('play', event => {
          var mediaId = video.container.data('mediaId');
          var $otherMedia = $(
            '[data-product-single-media-wrapper]' +
              ":not([data-media-id='" +
              mediaId +
              "'])", context);

          $otherMedia.trigger('mediaHidden');
        });
        break;
      case hosts.youtube:
        var videoId = productMediaWrapper.data(attributes.videoId);

        video.player = new YT.Player(video.element, {
          videoId: videoId,
          events: {
            onStateChange: function(event) {
              if (event.data == 1) {
                var mediaId = video.container.data('mediaId');
                var $otherMedia = $(
                  '[data-product-single-media-wrapper]' +
                    ":not([data-media-id='" +
                    mediaId +
                    "'])", context);

                $otherMedia.trigger('mediaHidden');
              }
              if (event.data === 0 && enableLooping) event.target.seekTo(0);
            },
            onReady: function(event) {
              video.player.mute();
            }
          }
        });
        break;
    }

    productMediaWrapper.on('mediaHidden xrLaunch', function() {
      if (!video.player) return;

      if (video.host === hosts.html5) {
        video.player.pause();

        $('.plyr', productMediaWrapper)
          .find('*')
          .addBack()
          .attr('tabIndex', '-1')
          .addClass('js-hide-focus');
      }
      if (video.host === hosts.youtube && video.player.pauseVideo) {
        video.player.pauseVideo();

        $('.product-video.videoWrapper iframe', productMediaWrapper)
          .children()
          .addBack()
          .attr('tabIndex', '-1')
          .removeAttr("data-focus-visible-added")
          .removeClass('focus-visible')
          .addClass('js-hide-focus');
      }

    });

    productMediaWrapper.on('mediaVisible', function() {
      if (theme.Helpers.isTouch()) return;

      if (!video.player) return;

      if (video.host === hosts.html5) {

        if (desktop.matches) {
          video.player.play();
        }

        $('.plyr__controls', productMediaWrapper)
          .children()
          .addBack()
          .attr('tabIndex', '0')
          .removeClass('js-hide-focus');

      }

      if (video.host === hosts.youtube && video.player.playVideo) {
        if (desktop.matches) {
          video.player.playVideo();
        }

        $(".product-video.videoWrapper iframe", productMediaWrapper)
          .removeAttr("tabIndex")
          .removeClass('js-hide-focus');
      }
    });

  }

  function hostFromVideoElement(video) {
    if (video.tagName === 'VIDEO') {
      return hosts.html5;
    }

    if (video.tagName === 'IFRAME') {
      if (
        /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
          video.src
        )
      ) {
        return hosts.youtube;
      }
    }
    return null;
  }

  function loadVideos(host) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.host === host) {
          video.ready();
        }
      }
    }
  }

  function fallbackToNativeVideo() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];

        if (video.nativeVideo) continue;

        if (video.host === hosts.html5) {
          video.element.setAttribute('controls', 'controls');
          video.nativeVideo = true;
        }
      }
    }
  }

  function removeSectionVideos(sectionId) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];

        if (video.sectionId === sectionId) {
          if (video.player) video.player.destroy();
          delete videos[key];
        }
      }
    }
  }

  return {
    init: init,
    hosts: hosts,
    loadVideos: loadVideos,
    removeSectionVideos: removeSectionVideos
  };

})();

theme.ProductModel = (function() {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};

  var selectors = {
    mediaGroup: '[data-product-single-media-group]',
    xrButton: '[data-shopify-xr]'
  };

  function init(modelViewerContainers, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false
    };

    modelViewerContainers.each(function(index) {
      var $modelViewerContainer = $(this);
      var mediaId = $modelViewerContainer.data('media-id');
      var $modelViewerElement = $(
        $modelViewerContainer.find('model-viewer')[0]
      );
      var modelId = $modelViewerElement.data('model-id');

      if (index === 0) {
        var $xrButton = $modelViewerContainer
          .closest(selectors.mediaGroup)
          .find(selectors.xrButton);

        xrButtons[sectionId] = {
          $element: $xrButton,
          defaultId: modelId
        };
      }

      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        $container: $modelViewerContainer,
        $element: $modelViewerElement
      };
    });

    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: setupShopifyXr
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: setupModelViewerUi
      }
    ]);
    theme.LibraryLoader.load('modelViewerUiStyles');
  }

  function setupShopifyXr(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function() {
        setupShopifyXr();
      });
      return;
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];

        if (modelSection.loaded) continue;
        var $modelJson = $('#ModelJson-' + sectionId);

        window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
        modelSection.loaded = true;
      }
    }
    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) return;

    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          var config = {
              controls: [
              'zoom-in',
              'zoom-out',
              'fullscreen',
            ],
            focusOnPlay: false
          };

          model.modelViewerUi = new Shopify.ModelViewerUI(model.$element, config);
        }
        setupModelViewerListeners(model);
      }
    }
  }

  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];

    model.$container.on('mediaVisible', function() {
      xrButton.$element.attr('data-shopify-model3d-id', model.modelId);
      if (theme.Helpers.isTouch()) return;

      var prodContext = $('#shopify-section-' + model.sectionId);

      if (desktop.matches) {
        model.modelViewerUi.play();
      }

      $('.carousel-main', prodContext).trigger('model:start', [model.modelId]);

      $('.shopify-model-viewer-ui__controls-area', model.$container)
        .children()
        .addBack()
        .attr('tabIndex', '0')
        .removeClass('js-hide-focus');

      $('.shopify-model-viewer-ui .shopify-model-viewer-ui__controls-area', model.$container).css("opacity","1");

      $('.shopify-model-viewer-ui__button', model.$container)
        .attr('tabIndex', '0')
        .removeClass('js-hide-focus');

    });
    model.$container
      .on('mediaHidden', function() {
        xrButton.$element.attr('data-shopify-model3d-id', xrButton.defaultId);
        var prodContext = $('#shopify-section-' + model.sectionId);

        if (model.modelViewerUi) {
          model.modelViewerUi.pause();
        }

        $('.carousel-main', prodContext).trigger('model:stop', [model.modelId]);

        $('.shopify-model-viewer-ui__controls-area', model.$container)
          .children()
          .addBack()
          .attr('tabIndex', '-1')
          .addClass('js-hide-focus');

        $('.shopify-model-viewer-ui .shopify-model-viewer-ui__controls-area', model.$container).css("opacity","0");

        $('.shopify-model-viewer-ui__button', model.$container)
          .attr('tabIndex', '-1')
          .addClass('js-hide-focus');
      })
      .on('xrLaunch', function() {
        if (model.modelViewerUi) {
          model.modelViewerUi.pause();
        }
      });
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (model.sectionId === sectionId) {
          models[key].modelViewerUi.destroy();
          delete models[key];
        }
      }
    }
    delete modelJsonSections[sectionId];
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels
  };
})();

theme.Product = (function () {
  function Product(context) {
    var $context = $(context);

    var events = new EventEmitter3();
        events.trigger = events.emit; // alias

    var productJson = context.querySelector('.product-json');

    if ( !productJson ) {
     return false;
    }

    var Product = productJson.innerHTML,
        Product = JSON.parse(Product || '{}');

    var sectionId = context.dataset.sectionId;

    if ( context.querySelector("[data-product-gallery]") ) {
      theme.ProductGallery(context, sectionId, events, Product);
    }

    if ( context.querySelector("[data-product-form]") ) {
      theme.ProductForm(context, events, Product);
    }

    /* Product media */
    var $container = (this.$container = $context);
    this.ajaxEnabled = context.dataset.ajaxEnabled;

    context.querySelectorAll("[data-product-media-type-video]").forEach(function (context, sectionId) {
      var $el = $(context);
      theme.ProductVideo.init($el, sectionId);
    });

    var $modelViewerElements = $('[data-product-media-type-model]', this.$container);

    if ($modelViewerElements.length < 1) return;
      theme.ProductModel.init($modelViewerElements, sectionId);

    var self = this;

    $(document).on('shopify_xr_launch', function() {
      var $currentMedia = $(
        '[data-product-single-media-wrapper]' +
          ':not(.inactive)',
        self.$container
      );

      $currentMedia.trigger('xrLaunch');
    });

  }

  return Product;
})();

theme.ProductRecommendations = (function (context) {
  function ProductRecommendations(container) {

    var loadProductRecommendationsIntoSection = function() {
      // Look for an element with class 'product-recommendations'
      var productRecommendationsSection = document.querySelector(".page-width");
      var recommended_url = productRecommendationsSection.dataset.baseUrl;

      if (productRecommendationsSection === null) { return; }
      // Read product id from data attribute
      var productId = productRecommendationsSection.dataset.productId;

      // Build request URL
      var requestUrl = recommended_url + '?section_id=product-recommendations&limit=12&product_id=' + productId;

      // Create request and submit it using Ajax
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement("div");
          container.innerHTML = request.response;
          productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
        }
      };
      request.send();
    };
    document.addEventListener("shopify:section:load", function(event) {
      if (event.detail.sectionId === "product-recommendations") {
        loadProductRecommendationsIntoSection();
      }
    });
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  }

  return ProductRecommendations;
})();

Events.on("quickview:load", function (container) {
  theme.Product(container);
  if (container.dataset.paymentButton === true ) {
    Shopify.PaymentButton.init()
  }
});

/*============================================================================
  Map Section
==============================================================================*/
theme.Maps = (function() {

  var errors = {
     address_no_results: "Translation missing: en.general.map_errors.address_no_results",
     address_query_limit: "Translation missing: en.general.map_errors.address_query_limit",
     address_error: "Translation missing: en.general.map_errors.address_error",
     auth_error: "Translation missing: en.general.map_errors.auth_error"
  };

  var google_api_loaded = false;

  function Map(container) {

    var events = new EventEmitter3();
    events.trigger = events.emit; // alias

    window.gm_authFailure = function () {
      google_api_loaded = false;

      if ( Shopify.designMode ) {
        events.trigger("gmauthfailure:themeeditor");
      } else {
        events.trigger("gmauthfailure");
      }
    };

    var config = container.querySelector("[data-map-config]").innerHTML,
        config = JSON.parse(config);

    if ( !config.api_key ) {
      return false;
    }

    (function section_container() {
      var element = container;

      events.on("gmauthfailure:themeeditor", error);
      events.on("map:error", error);

      function error() {
        element.classList.add("map-section-load-error");
      }
    })();

    (function background_image() {
      var element = container.querySelector("[data-bg-image]");

      events.on("gmauthfailure", show);

      function show() {
        element.classList.add("show-image");
      }
    })();

    (function overlay() {
      var element = container.querySelector("[data-map-overlay]");

      events.on("gmauthfailure:themeeditor", error);
      events.on("map:error", error);

      function error(message) {
        message = message || errors.auth_error;
        element.innerHTML = '<div class="map-section-error errors text-center">' + message + '</div>';
      }
    })();

    (function map() {
      var element = container.querySelector("[data-map]");

      events.on("ready", geolocate);

      function geolocate() {

        var geocoder = new google.maps.Geocoder();

        geocoder.geocode({ address: config.address }, function(results, status) {

          if ( status == google.maps.GeocoderStatus.OK ) {
            render(results);
          } else {
            error(status);
          }
        });
      }

      function render(results) {
        element.innerHTML = "";

        var map = new google.maps.Map(element, {
          zoom: config.zoom,
          center: results[0].geometry.location,
          draggable: false,
          clickableIcons: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          styles: config.styles,
          disableDefaultUI: true
        });

        var center = map.getCenter();

        new google.maps.Marker({
          map: map,
          position: center
        });

        google.maps.event.addDomListener(window, "resize", $.debounce(250, function () {
          google.maps.event.trigger(map, "resize");
          map.setCenter(center);
        }));

        $(document).on("shopify:section:unload", function () {
          google.maps.event.clearListeners(map, "resize");
        });
      }

      function error(status) {
        var message = errors.address_error;

        switch (status) {
          case 'ZERO_RESULTS':
            message = errors.address_no_results;
            break;
          case 'OVER_QUERY_LIMIT':
            message = errors.address_query_limit;
            break;
          case 'REQUEST_DENIED':
            message = errors.auth_error;
            break;
        }

        if ( Shopify.designMode ) {
          events.trigger("map:error", message);
        }
      }
    })();

    if ( google_api_loaded ) {
      events.trigger("ready");
    } else {
      $.getScript("https://maps.googleapis.com/maps/api/js?key=" + config.api_key, function () {
        google_api_loaded = true;
        events.trigger("ready");
      });
    }
  }

  Map.prototype = _.assignIn({}, Map.prototype, {});

  return Map;
})();

/*======================================================
  Collection Page
========================================================*/
theme.Collection = (function() {
  function Collection(container) {

    var $container = this.$container = $(container);
    // Sidebar Toggle for screens below 980px wide
    var $Sidebar = $("#sidebar");
    $(document).on("click.toggleNav touch.toggleNav", ".show", function(){
      $Sidebar.toggleClass("open");
    });

    (function productQuickView() {
      var products = $('#product-loop .product-index', $container);

      $(products).each(function( index ) {
        var id = $( this ).data('productId');

        var quickView = $('[data-fancybox="quick-view-' + id + '"]');

        quickView.fancybox({
           type : 'ajax',
           toolbar: false,
           infobar: false,
           arrows: false,
           touch: false,
           autoFocus: false,
           iframe : {
            preload: true,
            css : {
              width : '800px'
            }
           },
           baseClass: 'quickview-popup',
           afterShow: function () {
            var context = document.querySelector(".product-quick-view");

             Events.trigger("quickview:load", context);
             // Close fancybox after add to cart
             Events.on("ajaxcart:cartUpdate", function() {
               $.fancybox.close()
             });
           }
         });
      });
     })();

  }
  Collection.prototype = _.assignIn({}, Collection.prototype, {});

  return Collection;
})();

/*======================================================
  Header Section
========================================================*/
var selectors = {
  disclosureLocale: '[data-disclosure-locale]',
  disclosureCurrency: '[data-disclosure-currency]'
};

theme.Header = (function() {
  function Header(container) {
    var $container = this.$container = $(container);

    $(document).ready( function() {
      if ($(window).width() >= 741) {
        $('nav').stickUp();
      }
    });
    $(document).ready( function() {
      $('.shopify-currency-form select').on('change', function() {
        $(this)
          .parents('form')
          .submit();
      });
    });
    $(document).ready( function() {
      $("ul.submenu li").on('mouseenter mouseleave', function (e) {
          if ($('ul', this).length) {
              var elm = $('ul:first', this);
              var off = elm.offset();
              var l = off.left;
              var w = elm.width();
              var docH = $(".page-wrap").height();
              var docW = $(".page-wrap").width();

              var isEntirelyVisible = (l + w <= docW);

              if (!isEntirelyVisible) {
                  $(this).addClass('edge');
              } else {
                  $(this).removeClass('edge');
              }
          }
      });
    });

    if ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPad/i)) || (navigator.userAgent.match(/android/i))) {
      $("nav #main-nav li.dropdown:has(ul)").doubleTapToGo();
      $("nav #main-nav .submenu li.has_sub_menu").doubleTapToGo();
    }

    /* lang and currency disclosure */
    this.$container = $(container);
    this.cache = {};
    this.cacheSelectors();

    if (this.cache.$localeDisclosure.length) {
      this.localeDisclosure = new theme.Disclosure(
        this.cache.$localeDisclosure
      );
    }

    if (this.cache.$currencyDisclosure.length) {
      this.currencyDisclosure = new theme.Disclosure(
        this.cache.$currencyDisclosure
      );
    }
  }
  Header.prototype = _.assignIn({}, Header.prototype, {
    cacheSelectors: function() {
      this.cache = {
        $localeDisclosure: this.$container.find(selectors.disclosureLocale),
        $currencyDisclosure: this.$container.find(selectors.disclosureCurrency)
      };
    },

    onUnload: function() {
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure.unload();
      }

      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure.unload();
      }
    }
  });
  return Header;
})();

/*======================================================
  MobileNav Section
========================================================*/
theme.mobileNav = (function() {
  function mobileNav(container) {

    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');

    $('#accordion').find('.accordion-toggle').click(function(){
      //Expand or collapse this panel
      $(this).toggleClass('open');
      $(this).next().slideToggle('fast');
      //Hide the other panels
      $(".accordion-content").not($(this).next()).slideUp('fast');
      $(".accordion-toggle").not($(this)).removeClass('open');
    });

    $('#accordion').find('.accordion-toggle2').click(function(){
      //Expand or collapse this panel
      $(this).toggleClass('open');
      $(this).next().slideToggle('fast');
      //Hide the other panels
      $(".accordion-content2").not($(this).next()).slideUp('fast');
      $(".accordion-toggle2").not($(this)).removeClass('open');
    });

    var initMobileslideout = function(slideout) {
      var slideout = new Slideout({
        'panel': document.getElementById('panel'),
        'menu': document.getElementById('menu'),
        'padding': 256,
        'tolerance': 70,
        'touch': false
      });
      // Toggle button
      $('.mm-trigger').on('click', function() {
        slideout.toggle();
      });
      function close(eve) {
        eve.preventDefault();
        slideout.close();
      }
      slideout
      .on('beforeopen', function() {
        this.panel.classList.add('panel-open');
      })
      .on('open', function() {
        this.panel.addEventListener('click', close);
      })
      .on('beforeclose', function() {
        this.panel.classList.remove('panel-open');
        this.panel.removeEventListener('click', close);
      });
      $(document).on('shopify:section:select', '#shopify-section-mobile-navigation', function(event) {
        slideout.open();
      });
      $(document).on('shopify:section:deselect', '#shopify-section-mobile-navigation', function(event) {
        slideout.close();
      });
      $(document).on('shopify:section:load', '#shopify-section-header', function(event) {
        $('.mm-trigger').on('click', function() {
          slideout.toggle();
        });
      });
    };
    initMobileslideout($('Slideout'));

  }
  mobileNav.prototype = _.assignIn({}, mobileNav.prototype, {});
  return mobileNav;
})();

/*============================================================================
  Custom Page Modules
==============================================================================*/
theme.CustomPageSlideshow = function (context, events) {

  (function page_slideshow() {
    var speed = $('.flexslider').data('speed');
    var initSlider = function(custom_page_slideshow) {
	    $('.flexslider').flexslider({
	      animation: 'fade',
	      slideshowSpeed: speed,
	      animationSpeed: 600,
	      directionNav: true,
	      controlNav: false,
	      pauseOnHover: true,
	      pauseOnAction: true,
	      nextText: '',
	      prevText: ''
	    });
    };

    initSlider($('.thumbnail-slider'));

    $(document).on('shopify:section:unload', function(event) {
      var target = $(event.target);
      target.find('.flexslider').flexslider('destroy');
      $(document).off('.flexslider');
    });

    $(document).on('shopify:section:load', function(event) {
      initSlider($(event.target).find('.flexslider'));
    });

  })();
}

theme.CustomPageCollection = function (context, events) {
  (function Carousel() {
      var initCarousel = function(Carousel) {
        $('.collection-carousel').owlCarousel({
          itemsCustom : [
            [0, 2],
            [450, 2],
            [600, 2],
            [700, 3],
            [1000, 4],
            [1200, 4],
            [1400, 4],
            [1600, 4]
          ],
          lazyLoad : false,
          pagination : false,
          navigation: true,
          navigationText : false,
          autoPlay : false,
          stopOnHover : true
        });
      };

      initCarousel($('.collection-carousel'));

      $(document).on('shopify:section:unload', function(event) {
        var target = $(event.target);
        target.find('.collection-carousel').owlCarousel("destroy");
        $(document).off('.collection-carousel');
      });

      $(document).on('shopify:section:load', function(event) {
        initCarousel($(event.target).find('.collection-carousel'));
        $('.prod-image').matchHeight({ remove: true });
        setTimeout(heightFix, 500);
        function heightFix() {
        $('.prod-image').matchHeight();
        }
      });

  })();
}

theme.CustomPage = (function () {
  function CustomPage(container) {
    var events = new EventEmitter3();
    events.trigger = events.emit; // alias

    theme.CustomPageSlideshow();
    theme.CustomPageCollection(events);

  }

  CustomPage.prototype = _.assignIn({}, CustomPage.prototype, {});

  return CustomPage;
})();

/*============================================================================
  Footer Section
==============================================================================*/
var selectors = {
  disclosureLocale: '[data-disclosure-locale]',
  disclosureCurrency: '[data-disclosure-currency]'
};

theme.Footer = (function() {
  function Footer(container) {
    this.$container = $(container);
    this.cache = {};
    this.cacheSelectors();

    if (this.cache.$localeDisclosure.length) {
      this.localeDisclosure = new theme.Disclosure(
        this.cache.$localeDisclosure
      );
    }

    if (this.cache.$currencyDisclosure.length) {
      this.currencyDisclosure = new theme.Disclosure(
        this.cache.$currencyDisclosure
      );
    }
  }

  Footer.prototype = _.assignIn({}, Footer.prototype, {
    cacheSelectors: function() {
      this.cache = {
        $localeDisclosure: this.$container.find(selectors.disclosureLocale),
        $currencyDisclosure: this.$container.find(selectors.disclosureCurrency)
      };
    },

    onUnload: function() {
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure.unload();
      }

      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure.unload();
      }
    }
  });

  return Footer;
})();
/*============================================================================
  Global Events
==============================================================================*/
$(document).ready(function(){
  var mobile = window.matchMedia('(max-width: 740px)');
  var tablet = window.matchMedia('(max-width: 979px) and (min-width: 741px)');
  var device = window.matchMedia('(max-width: 980px)');
  var desktop = window.matchMedia('(min-width: 980px)');

  if ( mobile.matches ) {
    Events.trigger("mediaquery:mobile");
  }
  if ( tablet.matches ) {
    Events.trigger("mediaquery:tablet");
  }
  if ( device.matches ) {
    Events.trigger("mediaquery:device");
  }
  if (desktop.matches) {
    Events.trigger("mediaquery:desktop");
  }
  window.addEventListener("resize", function () {
    if ( mobile.matches ) {
      Events.trigger("mediaquery:mobile");
    }
    if ( tablet.matches ) {
      Events.trigger("mediaquery:tablet");
    }
    if ( device.matches ) {
      Events.trigger("mediaquery:device");
    }
    if ( desktop.matches ) {
      Events.trigger("mediaquery:desktop");
    }
  });
  document.addEventListener('shopify:section:select', function(event){
    Events.trigger("editor:section:select", event);
  });
  document.addEventListener('shopify:section:deselect', function(event){
    Events.trigger("editor:section:deselect", event);
  });
  document.addEventListener('shopify:section:load', function(event){
    Events.trigger("editor:section:load", event);
  });
  document.addEventListener('shopify:section:unload', function(event){
    Events.trigger("editor:section:unload", event);
  });
  document.addEventListener('shopify:block:select', function(event){
    Events.trigger("editor:block:select", event);
  });
  document.addEventListener('shopify:block:deselect', function(event){
    Events.trigger("editor:block:deselect", event);
  });
  document.addEventListener('lazyloaded', function(e){
    Events.trigger("lazyLoad:complete");
  });
});

/*======================================================
  Register Sections
========================================================*/
$(document).ready(function() {
  var sections = new theme.Sections();
  sections.register('homepage-products', theme.FeaturedProducts);
  sections.register('slideshow-section', theme.Slideshow);
  sections.register('product-section', theme.Product);
  sections.register('product-recommendations', theme.ProductRecommendations);
  sections.register('header-section', theme.Header);
  sections.register('collection-section', theme.Collection);
  sections.register('mobile-navigation', theme.mobileNav);
  sections.register('map', theme.Maps);
  sections.register('custom-page-section', theme.CustomPage);
  sections.register('footer-section', theme.Footer);
});


/* Log Theme Version */
log = function() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(console);
    return Function.prototype.bind.apply(console.log, args);
}

log("Testament Version 7.2.2 by Underground", {bar: 1})();
